import {t as translateInterface, useLanguage} from './i18n';
import {listMarketBusinesses} from "./data/marketplaceBusinesses";
import {matchesMarket,readSearchMarket,marketCacheKey} from "./utils/market";
import HomeAudience from "./components/HomeAudience";
import HomeBusinessDiscovery, {AppDownloadInvite} from "./components/HomeBusinessDiscovery";
import HomeDiscoveryHero from "./components/HomeDiscoveryHero";
// LOOP AGENDA MADRE WORKER HYDRATION RACE V85 — preserve real worker route/access profile when employees collection is denied or late.
/* LOOP AGENDA MADRE WORKER PERMISSIONS EXACT V80 — calendar worker route carries business logo context. */
/* eslint-disable no-mixed-operators */
import useFavoriteActions from "./hooks/useFavoriteActions";
import useMenuAdminAccess from "./hooks/useMenuAdminAccess";
import "./MainMenu.refinement.css";
import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "./components/Header";
import loopWellnessHeroImage from "./assets/images/loop-wellness-lounge-hero.png";
import loopCategoryBeauty from "./assets/images/categories/loop-category-beauty.png";
import loopCategoryWellness from "./assets/images/categories/loop-category-wellness.png";
import loopCategoryEvents from "./assets/images/categories/loop-category-events.png";
import loopCategoryFitness from "./assets/images/categories/loop-category-fitness.png";
import loopCategoryMore from "./assets/images/categories/loop-category-more.png";
import founderSparkleIcon from "./assets/images/hero/founder-sparkle.svg";
import founderAgendaIcon from "./assets/images/hero/founder-agenda.svg";
import founderClientsIcon from "./assets/images/hero/founder-clients.svg";
import founderWhatsappIcon from "./assets/images/hero/founder-whatsapp.png";
import founderFinanceInventoryIcon from "./assets/images/hero/founder-finance-inventory.svg";
import founderLoyaltyIcon from "./assets/images/hero/founder-loyalty.svg";
import founderShieldIcon from "./assets/images/hero/founder-shield.svg";
import loopAppStoreBadge from "./assets/images/hero/loop-app-store-badge-transparent.png";
import loopGooglePlayBadge from "./assets/images/hero/loop-google-play-badge-transparent.png";
import ServicesGrid from "./components/ServicesGrid";
import ServicesTypeScroll from "./components/ServicesTypeScroll";
import RecommendedGrid from "./components/RecommendedGrid";
import RecommendedScroller from "./components/RecommendedScroller";
import FavoritesGrid from "./components/FavoritesGrid";
import FavoritesScroller from "./components/FavoritesScroller";
import WorkerBusinessesModal from "./components/WorkerBusinessesModal";
import getUserBusinessesAndRoles, { getCachedUserBusinesses } from "./services/userBusinesses";
import { db as defaultDb, auth } from "./firebase";
import fsClient from "./data/firestoreClient";
import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  doc as docRef,
  getDoc,
  onSnapshot,
  orderBy,
  limit,
} from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { readUserLocation } from "./components/PanamaLocationPickerModal";
import { isIosCapacitor } from "./utils/nativeHttp";
import { FirebaseNative } from "./native/firebaseNative";
import { getManualAuth, isManualAuthLikelyValid } from "./utils/manualAuth";
import { businessPublicPath, getBusinessRouteParam } from "./utils/businessSlug";
import { makeUserScopedStorageKey } from "./auth/authStorage";

const MAINMENU_RECOMMENDED_CACHE_KEY = "loop_mainmenu_recommended_v1";
const MAINMENU_FAVORITES_CACHE_KEY = "loop_mainmenu_favorites_docs_v1";
const MAINMENU_CALENDAR_ACCESS_CACHE_KEY = "loop_mainmenu_calendar_access_v2";
const RECOMMENDED_BUSINESSES_LIMIT = 60;
const RECOMMENDED_MIN_DESIRED = 12;
const LOOP_GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.webapp.d9799";
const LOOP_APP_STORE_URL = "https://apps.apple.com/app/loop-reservas/id6758343818";


const LOOP_PLATFORM_ANALYTICS_VISITOR_KEY = "loop_platform_analytics_visitor_id_v1";
const LOOP_PLATFORM_ANALYTICS_SESSION_KEY = "loop_platform_analytics_session_id_v1";

function loopPlatformSafeRandomId(prefix = "loop") {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return `${prefix}_${crypto.randomUUID()}`;
  } catch (_) {}
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

function getLoopPlatformAnalyticsStorageId(key, prefix, storageType = "local") {
  try {
    if (typeof window === "undefined") return loopPlatformSafeRandomId(prefix);
    const store = storageType === "session" ? window.sessionStorage : window.localStorage;
    if (!store) return loopPlatformSafeRandomId(prefix);
    let value = store.getItem(key);
    if (!value) {
      value = loopPlatformSafeRandomId(prefix);
      store.setItem(key, value);
    }
    return value;
  } catch (_) {
    return loopPlatformSafeRandomId(prefix);
  }
}

function getLoopPlatformAnalyticsSource() {
  try {
    if (typeof window === "undefined") return "Directo / desconocido";
    const params = new URLSearchParams(window.location.search || "");
    const explicit = params.get("utm_source") || params.get("source") || params.get("ref") || "";
    if (explicit) return explicit;
    const ref = String(document.referrer || "").trim();
    if (!ref) return "Directo / desconocido";
    try {
      const host = new URL(ref).hostname.replace(/^www\./, "");
      return host || ref;
    } catch (_) {
      return ref.slice(0, 120);
    }
  } catch (_) {
    return "Directo / desconocido";
  }
}

function getLoopPlatformAnalyticsUtm() {
  try {
    if (typeof window === "undefined") return {};
    const params = new URLSearchParams(window.location.search || "");
    return {
      utmSource: params.get("utm_source") || params.get("source") || null,
      utmMedium: params.get("utm_medium") || null,
      utmCampaign: params.get("utm_campaign") || null,
      utmContent: params.get("utm_content") || null,
      utmTerm: params.get("utm_term") || null,
    };
  } catch (_) {
    return {};
  }
}

function getLoopPlatformAnalyticsDevice() {
  try {
    if (typeof window === "undefined") return "unknown";
    const width = window.innerWidth || 0;
    if (width <= 640) return "mobile";
    if (width <= 1024) return "tablet";
    return "desktop";
  } catch (_) {
    return "unknown";
  }
}

async function trackPlatformAnalyticsEventSafe({ db, type, payload = {} }) {
  try {
    if (!db || !type) return;
    const visitorId = getLoopPlatformAnalyticsStorageId(LOOP_PLATFORM_ANALYTICS_VISITOR_KEY, "visitor", "local");
    const sessionId = getLoopPlatformAnalyticsStorageId(LOOP_PLATFORM_ANALYTICS_SESSION_KEY, "session", "session");
    const nowIso = new Date().toISOString();
    const eventPayload = {
      type,
      eventType: type,
      name: type,
      action: type,
      visitorId,
      sessionId,
      source: getLoopPlatformAnalyticsSource(),
      referrer: typeof document !== "undefined" ? document.referrer || null : null,
      url: typeof window !== "undefined" ? window.location.href : "",
      path: typeof window !== "undefined" ? `${window.location.pathname || ""}${window.location.search || ""}` : "",
      device: getLoopPlatformAnalyticsDevice(),
      ...getLoopPlatformAnalyticsUtm(),
      ...payload,
      createdAt: nowIso,
      occurredAt: nowIso,
    };
    if (isIosCapacitor()) {
      await fsClient.addDocToCollectionPath("platformEvents", eventPayload, { db });
      return;
    }
    await addDoc(collection(db, "platformEvents"), eventPayload);
  } catch (err) {
    try { console.warn("[MainMenu] platform analytics skipped", err); } catch (_) {}
  }
}

const LOOP_MAIN_CATEGORIES = [
  {
    label: "Belleza",
    value: "Belleza & Barberías",
    image: loopCategoryBeauty,
    alt: "Belleza y barberías",
  },
  {
    label: "Bienestar",
    value: "Bienestar & Spa",
    image: loopCategoryWellness,
    alt: "Bienestar y spa",
  },
  {
    label: "Eventos",
    value: "Eventos",
    image: loopCategoryEvents,
    alt: "Eventos",
  },
  {
    label: "Fitness",
    value: "Entretenimiento & Fitness",
    image: loopCategoryFitness,
    alt: "Entretenimiento y fitness",
  },
  {
    label: "Más",
    value: "Otros",
    image: loopCategoryMore,
    alt: "Otros servicios",
  },
];

function LoopMainMenuCategories({ onSelect }) {
  const handleSelect = (category) => {
    if (typeof onSelect === "function") {
      onSelect(category.value, category);
    }
  };

  return (
    <div className="discovery-category-list" aria-label={translateInterface("Categorías principales")}>
      {LOOP_MAIN_CATEGORIES.map((category) => (
        <button
          key={category.value}
          type="button"
          className="discovery-category-button"
          onClick={() => handleSelect(category)}
          aria-label={translateInterface(category.alt)}
        >
          <span className="discovery-category-image">
            <img src={category.image} alt="" aria-hidden="true" draggable="false" />
          </span>
          <span className="discovery-category-name">
            {translateInterface(category.label).split("\n").map((line) => (
              <React.Fragment key={line}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </span>
        </button>
      ))}
    </div>
  );
}


const LOOP_BUSINESS_HERO_FEATURES = [
  {
    key: "agenda",
    label: "Agenda",
    mobileLabel: "Agenda",
    description: "Reservas 24/7",
    icon: "calendar",
  },
  {
    key: "clientes",
    label: "Cliente CRM",
    mobileLabel: "Cliente CRM",
    description: "Historial",
    icon: "users",
  },
  {
    key: "marca",
    label: "Perfil online",
    mobileLabel: "Perfil online",
    description: "Servicios",
    icon: "brandProfile",
  },
  {
    key: "whatsapp",
    label: "Recordatorios",
    mobileLabel: "Recordatorios",
    description: "WhatsApp y correo",
    icon: "whatsapp",
  },
  {
    key: "operacion",
    label: "Finanzas e inventario",
    mobileLabel: "Finanzas e inventario",
    description: "",
    icon: "financeInventory",
  },
  {
    key: "loyalty",
    label: "Fidelidad y membresías",
    mobileLabel: "Fidelidad y membresías",
    description: "",
    icon: "loyalty",
  },
];

const LOOP_BUSINESS_HERO_ICON_ASSETS = {
  calendar: founderAgendaIcon,
  users: founderClientsIcon,
  brandProfile: founderSparkleIcon,
  whatsapp: founderWhatsappIcon,
  financeInventory: founderFinanceInventoryIcon,
  loyalty: founderLoyaltyIcon,
};

function LoopBusinessHeroIcon({ type }) {
  const asset = LOOP_BUSINESS_HERO_ICON_ASSETS[type];
  if (asset) {
    return <img className="loop-p6-feature-img" src={asset} alt="" aria-hidden="true" draggable="false" />;
  }

  const common = {
    width: 19,
    height: 19,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
  };

  if (type === "calendar") {
    return (
      <svg {...common}>
        <rect x="4" y="5" width="16" height="15" rx="3" />
        <path d="M8 3v4" />
        <path d="M16 3v4" />
        <path d="M4 10h16" />
        <path d="M8 14h2" />
        <path d="M13 14h3" />
      </svg>
    );
  }

  if (type === "users") {
    return (
      <svg {...common}>
        <path d="M16 19c0-2.2-1.8-4-4-4s-4 1.8-4 4" />
        <circle cx="12" cy="8" r="3" />
        <path d="M20 18c0-1.8-1.2-3.2-2.8-3.8" />
        <path d="M17 6.3a2.7 2.7 0 0 1 0 5.4" />
      </svg>
    );
  }

  if (type === "bell") {
    return (
      <svg {...common}>
        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
        <path d="M10 20a2 2 0 0 0 4 0" />
      </svg>
    );
  }

  if (type === "whatsapp") {
    return (
      <svg {...common} viewBox="0 0 24 24">
        <path d="M20.4 11.8a8.1 8.1 0 0 1-12 7.1L4 20l1.2-4.2A8.1 8.1 0 1 1 20.4 11.8Z" />
        <path d="M9.2 8.6c.2-.5.4-.5.7-.5h.5c.2 0 .4.1.5.4l.6 1.4c.1.3.1.5-.1.7l-.4.5c-.1.2-.1.3 0 .5.5 1 1.4 1.8 2.5 2.3.2.1.4.1.5-.1l.6-.7c.2-.2.4-.2.7-.1l1.4.6c.3.1.4.3.4.6 0 .7-.5 1.4-1.1 1.6-.6.3-1.8.4-3.8-.6-2.8-1.3-4.5-3.8-4.7-5.3-.1-.8.2-1.5.6-1.9.2-.2.4-.3.6-.3Z" />
      </svg>
    );
  }

  if (type === "brandProfile") {
    return (
      <svg {...common}>
        <path d="M5.5 18.5V7.8c0-1.2 1-2.2 2.2-2.2h8.6c1.2 0 2.2 1 2.2 2.2v10.7" />
        <path d="M8.5 9.2h7" />
        <path d="M8.5 12.1h4.2" />
        <path d="M4 18.5h16" />
        <path d="M15.7 13.9l.7 1.4 1.5.2-1.1 1.1.3 1.5-1.4-.7-1.4.7.3-1.5-1.1-1.1 1.5-.2.7-1.4Z" />
      </svg>
    );
  }

  if (type === "financeInventory") {
    return (
      <svg {...common}>
        <circle cx="8.2" cy="8.2" r="4.2" />
        <path d="M8.2 5.9v4.6" />
        <path d="M9.6 6.9c-.4-.3-.9-.5-1.5-.5-.7 0-1.2.3-1.2.8 0 .6.5.8 1.3 1 .8.2 1.5.4 1.5 1 0 .6-.6.9-1.5.9-.7 0-1.3-.2-1.8-.6" />
        <path d="m15.7 9.5 4.3 2.4-4.3 2.4-4.3-2.4 4.3-2.4Z" />
        <path d="M11.4 11.9v4.9l4.3 2.5 4.3-2.5v-4.9" />
        <path d="M15.7 14.4v4.9" />
      </svg>
    );
  }

  if (type === "loyalty") {
    return (
      <svg {...common}>
        <path d="M12 3.6 14.2 8l4.8.7-3.5 3.4.8 4.8L12 14.6 7.7 17l.8-4.8L5 8.7 9.8 8 12 3.6Z" />
        <path d="M5.5 19.5h13" />
        <path d="M8 21h8" />
      </svg>
    );
  }

  if (type === "finance") {
    return (
      <svg {...common}>
        <circle cx="12" cy="12" r="8" />
        <path d="M12 7v10" />
        <path d="M15 9.5c-.7-.7-1.7-1-3-1-1.4 0-2.4.7-2.4 1.8 0 1.3 1.1 1.7 2.6 2 1.7.4 2.8.8 2.8 2 0 1.1-1.1 1.9-2.8 1.9-1.3 0-2.4-.4-3.2-1.2" />
      </svg>
    );
  }

  return (
    <svg {...common}>
      <path d="m12 3 8 4.4-8 4.4-8-4.4L12 3Z" />
      <path d="M4 7.5v9.1L12 21l8-4.4V7.5" />
      <path d="M12 12v9" />
    </svg>
  );
}



function readJsonCache(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw);
    return parsed == null ? fallback : parsed;
  } catch (_) {
    return fallback;
  }
}

function writeJsonCache(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (_) {}
}

function mainMenuUserScopedCacheKey(baseKey, userLike) {
  return makeUserScopedStorageKey(baseKey, userLike || {});
}


// LOOP CALENDAR SELECTOR NAME GUARD V61
function looksLikeCalendarBusinessId(value = "") {
  const text = String(value || "").trim();
  return /^[A-Za-z0-9_-]{16,}$/.test(text) && !/[\sñÑáéíóúÁÉÍÓÚ#&.]/.test(text);
}

function cleanCalendarBusinessName(value, businessId = "") {
  const text = String(value || "").trim();
  const id = String(businessId || "").trim();
  if (!text) return "";
  if (id && text.toLowerCase() === id.toLowerCase()) return "";
  if (looksLikeCalendarBusinessId(text)) return "";
  return text;
}

function pickCalendarBusinessName(item = {}, businessId = "") {
  const candidates = [
    item.businessName,
    item.name,
    item.title,
    item.displayName,
    item.publicName,
    item.business?.name,
    item.business?.businessName,
    item.raw?.businessName,
    item.raw?.name,
    item.raw?.title,
  ];
  for (const value of candidates) {
    const clean = cleanCalendarBusinessName(value, businessId);
    if (clean) return clean;
  }
  return "";
}

function pickCalendarBusinessLogo(item = {}) {
  const candidates = [
    item.businessLogoUrl,
    item.businessLogo,
    item.logoUrl,
    item.logoURL,
    item.logo,
    item.imageUrl,
    item.photoUrl,
    item.business?.logoUrl,
    item.business?.logoURL,
    item.business?.logo,
    item.business?.imageUrl,
    item.raw?.businessLogoUrl,
    item.raw?.businessLogo,
    item.raw?.logoUrl,
    item.raw?.logoURL,
    item.raw?.logo,
    item.raw?.imageUrl,
    item.raw?.business?.logoUrl,
    item.raw?.business?.logo,
  ];

  for (const value of candidates) {
    if (typeof value === "string" && value.trim()) return value.trim();
    if (value && typeof value === "object") {
      const nested = value.url || value.downloadURL || value.src || value.href || "";
      if (typeof nested === "string" && nested.trim()) return nested.trim();
    }
  }

  return "";
}


function pickCalendarWorkerName(item = {}) {
  const candidates = [
    item.workerName,
    item.employeeName,
    item.workerDisplayName,
    item.employeeDisplayName,
    item.displayName,
    item.fullName,
    item.employee?.name,
    item.worker?.name,
    item.raw?.workerName,
    item.raw?.employeeName,
    item.raw?.displayName,
    item.raw?.employee?.name,
    item.raw?.worker?.name,
  ];
  for (const value of candidates) {
    const text = String(value || "").trim();
    if (text) return text;
  }
  return "";
}

function pickCalendarWorkerPhoto(item = {}) {
  const candidates = [
    item.workerPhotoUrl,
    item.employeePhotoUrl,
    item.photoUrl,
    item.photoURL,
    item.imageUrl,
    item.avatarUrl,
    item.profileImageUrl,
    item.profilePhotoUrl,
    item.employee?.photoUrl,
    item.worker?.photoUrl,
    item.raw?.workerPhotoUrl,
    item.raw?.employeePhotoUrl,
    item.raw?.photoUrl,
    item.raw?.imageUrl,
    item.raw?.avatarUrl,
    item.raw?.employee?.photoUrl,
    item.raw?.worker?.photoUrl,
  ];
  for (const value of candidates) {
    if (typeof value === "string" && value.trim()) return value.trim();
    if (value && typeof value === "object") {
      const nested = value.url || value.downloadURL || value.src || value.href || "";
      if (typeof nested === "string" && nested.trim()) return nested.trim();
    }
  }
  return "";
}

function pickCalendarSettings(item = {}) {
  const candidates = [
    item.calendarSettings,
    item.businessCalendarSettings,
    item.agendaSettings,
    item.business?.calendarSettings,
    item.raw?.calendarSettings,
    item.raw?.business?.calendarSettings,
  ];
  for (const value of candidates) {
    if (value && typeof value === "object" && !Array.isArray(value) && Object.keys(value).length > 0) return value;
  }
  return null;
}

function normalizeCalendarAccessEntry(item) {
  if (!item || typeof item !== "object") return null;
  const businessId = String(item.businessId || item.id || item.uid || "").trim();
  if (!businessId) return null;
  const roleRaw = String(item.role || item.calendarRole || item.userRole || "owner").toLowerCase();
  const isWorker = roleRaw.includes("worker") || roleRaw.includes("employee") || roleRaw.includes("trabajador") || Boolean(item.employeeId || item.employeeEmail || item.workerId || item.workerEmail);
  return {
    ...item,
    id: businessId,
    businessId,
    businessName: pickCalendarBusinessName(item, businessId),
    businessLogoUrl: pickCalendarBusinessLogo(item),
    businessLogo: pickCalendarBusinessLogo(item),
    logoUrl: pickCalendarBusinessLogo(item),
    role: isWorker ? "worker" : "owner",
    employeeId: item.employeeId || item.workerId || null,
    employeeEmail: item.employeeEmail || item.workerEmail || item.email || null,
    workerName: pickCalendarWorkerName(item),
    employeeName: pickCalendarWorkerName(item),
    workerPhotoUrl: pickCalendarWorkerPhoto(item),
    employeePhotoUrl: pickCalendarWorkerPhoto(item),
    calendarSettings: pickCalendarSettings(item),
  };
}

function normalizeCalendarAccessList(list) {
  const map = new Map();
  (Array.isArray(list) ? list : []).forEach((item) => {
    const n = normalizeCalendarAccessEntry(item);
    if (!n) return;
    const key = `${n.businessId}::${n.role}::${n.employeeId || n.employeeEmail || "owner"}`;
    if (!map.has(key)) map.set(key, n);
    else {
      const prev = map.get(key) || {};
      map.set(key, {
        ...prev,
        ...n,
        businessName: cleanCalendarBusinessName(n.businessName, n.businessId) || cleanCalendarBusinessName(prev.businessName, prev.businessId || n.businessId) || "",
        businessLogoUrl: n.businessLogoUrl || prev.businessLogoUrl || n.businessLogo || prev.businessLogo || "",
        businessLogo: n.businessLogo || prev.businessLogo || n.businessLogoUrl || prev.businessLogoUrl || "",
        logoUrl: n.logoUrl || prev.logoUrl || n.businessLogoUrl || prev.businessLogoUrl || "",
        workerName: n.workerName || prev.workerName || n.employeeName || prev.employeeName || "",
        employeeName: n.employeeName || prev.employeeName || n.workerName || prev.workerName || "",
        workerPhotoUrl: n.workerPhotoUrl || prev.workerPhotoUrl || n.employeePhotoUrl || prev.employeePhotoUrl || "",
        employeePhotoUrl: n.employeePhotoUrl || prev.employeePhotoUrl || n.workerPhotoUrl || prev.workerPhotoUrl || "",
        calendarSettings: n.calendarSettings || prev.calendarSettings || null,
      });
    }
  });
  return Array.from(map.values());
}

function buildCalendarPathFromAccess(item) {
  const n = normalizeCalendarAccessEntry(item);
  if (!n || !n.businessId) return "";

  // Use businessId as the fastest route param. CalendarSafeRoute can mount instantly
  // from location.state and only resolves slug in the background when needed.
  const base = `/business/${encodeURIComponent(n.businessId)}/calendar`;
  if (n.role === "worker" && n.employeeId) return `${base}?worker=${encodeURIComponent(n.employeeId)}`;
  if (n.role === "worker" && n.employeeEmail) return `${base}?workerEmail=${encodeURIComponent(n.employeeEmail)}`;
  return base;
}

function buildCalendarNavigateState(item) {
  const n = normalizeCalendarAccessEntry(item);
  if (!n) return {};
  return {
    businessId: n.businessId,
    businessName: cleanCalendarBusinessName(n.businessName, n.businessId) || "Cargando negocio...",
    businessLogo: n.businessLogoUrl || n.businessLogo || n.logoUrl || "",
    businessLogoUrl: n.businessLogoUrl || n.businessLogo || n.logoUrl || "",
    logoUrl: n.logoUrl || n.businessLogoUrl || n.businessLogo || "",
    role: n.role || "owner",
    employeeId: n.employeeId || null,
    employeeEmail: n.employeeEmail || null,
    workerName: n.workerName || n.employeeName || "",
    employeeName: n.employeeName || n.workerName || "",
    workerPhotoUrl: n.workerPhotoUrl || n.employeePhotoUrl || "",
    employeePhotoUrl: n.employeePhotoUrl || n.workerPhotoUrl || "",
    calendarSettings: n.calendarSettings || null,
    raw: n.raw || null,
    skipResolve: true,
    fromCalendarAccessCache: true,
  };
}


async function hydrateCalendarAccessNames(list = [], dbUsed = defaultDb) {
  const base = normalizeCalendarAccessList(list);
  const missing = base.filter((item) => item?.businessId && (!cleanCalendarBusinessName(item.businessName, item.businessId) || !pickCalendarBusinessLogo(item)));
  if (!missing.length) return base;

  const metaMap = new Map();
  const uniqueIds = Array.from(new Set(missing.map((item) => String(item.businessId)).filter(Boolean))).slice(0, 25);
  let cursor = 0;
  const concurrency = Math.min(5, uniqueIds.length || 1);

  async function worker() {
    while (cursor < uniqueIds.length) {
      const idx = cursor;
      cursor += 1;
      const businessId = uniqueIds[idx];
      try {
        let data = null;
        if (isIosCapacitor() && fsClient && typeof fsClient.getDocByPath === "function") {
          // eslint-disable-next-line no-await-in-loop
          data = await fsClient.getDocByPath(`businesses/${businessId}`, { db: dbUsed });
        } else {
          // eslint-disable-next-line no-await-in-loop
          const snap = await getDoc(docRef(dbUsed, "businesses", businessId));
          data = snap && snap.exists() ? { id: snap.id, ...(snap.data() || {}) } : null;
        }
        const source = { ...(data || {}), id: businessId, businessId };
        const name = pickCalendarBusinessName(source, businessId);
        const logo = pickCalendarBusinessLogo(source);
        if (name || logo) metaMap.set(businessId, { name, logo });
      } catch (_) {}
    }
  }

  await Promise.all(Array.from({ length: concurrency }, worker));

  return base.map((item) => {
    const meta = metaMap.get(item.businessId) || {};
    const logo = item.businessLogoUrl || item.businessLogo || item.logoUrl || meta.logo || "";
    return {
      ...item,
      businessName: cleanCalendarBusinessName(item.businessName, item.businessId) || meta.name || "",
      businessLogoUrl: logo,
      businessLogo: item.businessLogo || logo,
      logoUrl: item.logoUrl || logo,
    };
  });
}

/* --- helpers --- */
function normalizeName(s) {
  if (!s) return "";
  return String(s)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/gi, "_")
    .toLowerCase();
}

function waitForAuthUser(timeoutMs = 2000) {
  return new Promise((resolve) => {
    try {
      if (auth && auth.currentUser) return resolve(auth.currentUser);
      let unsub = onAuthStateChanged(auth, (u) => {
        if (unsub) unsub();
        resolve(u);
      });
      setTimeout(() => {
        try {
          if (unsub) unsub();
        } catch (_) {}
        resolve(auth && auth.currentUser ? auth.currentUser : null);
      }, timeoutMs);
    } catch (e) {
      resolve(auth && auth.currentUser ? auth.currentUser : null);
    }
  });
}

function loopWithTimeout(promise, timeoutMs = 4500, fallback = null) {
  let timer = null;
  return Promise.race([
    promise,
    new Promise((resolve) => {
      timer = setTimeout(() => resolve(fallback), timeoutMs);
    }),
  ]).finally(() => {
    try { if (timer) clearTimeout(timer); } catch (_) {}
  });
}

function getMenuImage(biz) {
  if (!biz) return null;
  const candidates = [
    biz.logoUrl,
    biz.logo,
    biz.logo_url,
    biz.logoImage,
    biz.logo_img,
    biz.logoPath,
    biz.coverImage,
    biz.mainPhotoUrl,
    biz.photoUrl,
    biz.image,
    biz.img,
    biz.hero,
    biz.templatePhoto,
    biz.templateImage,
  ];
  for (const c of candidates) {
    if (!c) continue;
    if (typeof c === "string" && c.trim()) return c.trim();
    if (c && typeof c === "object" && c.url) return c.url;
  }
  return null;
}


function isPublicBusiness(biz) {
  if (!biz || typeof biz !== "object") return false;
  return (
    biz.visible !== false &&
    biz.hidden !== true &&
    biz.isActive !== false &&
    biz.published !== false
  );
}

function normalizeBusinessForMenu(rawBiz) {
  if (!rawBiz) return rawBiz;
  const biz = { ...rawBiz };
  try {
    const menu = getMenuImage(biz);
    if (menu) {
      biz.menuImage = menu;
      if (!biz.logoUrl) {
        if (typeof menu === "string" && menu.indexOf("http") === 0) biz.logoUrl = menu;
      }
    }
  } catch (e) {}
  return biz;
}


function dedupeBusinessesForMenu(list = []) {
  const seen = new Set();
  const out = [];

  for (const raw of Array.isArray(list) ? list : []) {
    if (!raw) continue;
    const biz = normalizeBusinessForMenu(raw);
    const id = String(biz.id || biz.businessId || biz.uid || biz.slug || biz.name || "").trim();
    const key = id.toLowerCase();
    if (!key || seen.has(key)) continue;
    seen.add(key);
    out.push(biz);
  }

  return out;
}

function extractIdFromFavObject(obj) {
  if (!obj || typeof obj !== "object") return null;
  const tryFields = ["id", "_id", "businessId", "uid", "slug", "ref", "path"];
  for (const f of tryFields) {
    if (f === "ref" && obj.ref && obj.ref.path) return obj.ref.path;
    if (Object.prototype.hasOwnProperty.call(obj, f)) {
      const v = obj[f];
      if (v != null) return String(v);
    }
  }
  try {
    const s = String(obj);
    if (s && s !== "[object Object]") return s;
  } catch (e) {}
  return null;
}

function normalizeFavEntry(entry) {
  if (entry == null) return [];
  let s = typeof entry === "string" ? entry.trim() : String(entry);
  if (!s) return [];
  const variants = new Set();
  variants.add(s);
  variants.add(s.toLowerCase());
  if (s.indexOf("/") !== -1) {
    const parts = s.split("/");
    const last = parts[parts.length - 1];
    if (last) {
      variants.add(last);
      variants.add(last.toLowerCase());
    }
  }
  if (s.indexOf(":") !== -1) {
    const parts = s.split(":");
    const last = parts[parts.length - 1];
    if (last) {
      variants.add(last);
      variants.add(last.toLowerCase());
    }
  }
  const num = Number(s);
  if (!Number.isNaN(num)) variants.add(String(num));
  return Array.from(variants);
}

function buildFavCanonicalSet(favoritesArray, favoritesSet) {
  const out = new Set();
  const addVal = (v) => {
    if (v == null) return;
    if (typeof v === "object") {
      const id = extractIdFromFavObject(v);
      if (id) {
        normalizeFavEntry(id).forEach((x) => out.add(x));
        return;
      }
      try {
        normalizeFavEntry(JSON.stringify(v)).forEach((x) => out.add(x));
      } catch (e) {}
      return;
    }
    normalizeFavEntry(v).forEach((x) => out.add(x));
  };
  if (Array.isArray(favoritesArray)) favoritesArray.forEach(addVal);
  if (favoritesSet && typeof favoritesSet.forEach === "function") {
    try {
      favoritesSet.forEach(addVal);
    } catch (e) {}
  }
  return out;
}




const phaseHomeDiscoveryFontImportsV76 = `
@import url("https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600&family=Inter:wght@400;500;600;700;800&display=swap");
`;

const mainMenuProVisualStyles = `
  /* Phase 1M — Single mobile navigation. The top header owns navigation; no bottom nav reservation. */
  :root { --loop-mobile-nav-height: 0px !important; }
  @media (max-width: 899px) {
    html, body, #root { background: #fff8ee !important; }
    .loop-pro-main { padding-bottom: 0 !important; }
    .loop-natural-footer { padding-bottom: max(18px, env(safe-area-inset-bottom, 0px)) !important; }
    .loop-mobile-section-pad { padding-bottom: 0 !important; }
    .mainmenu-header-only-root { min-height: auto !important; }
  }

  .loop-pro-shell {
    background:
      radial-gradient(circle at top left, rgba(20,184,166,0.13), transparent 34%),
      radial-gradient(circle at top right, rgba(15,118,110,0.10), transparent 30%),
      linear-gradient(180deg, #f8fafc 0%, #ffffff 46%, #f8fafc 100%);
    min-height: 100vh;
  }

  .loop-pro-main {
    padding-bottom: 40px;
  }

  .loop-hero {
    max-width: 1460px;
    margin: 0 auto;
    padding: 34px clamp(18px, 5vw, 70px) 24px;
  }

  .loop-hero-card {
    position: relative;
    overflow: visible;
    border-radius: 0;
    border: 0;
    background: transparent;
    box-shadow: none;
    padding: 0;
  }

  .loop-hero-card::before {
    display: none;
  }

  .loop-hero-grid {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: minmax(0, 1.12fr) minmax(310px, 0.68fr);
    gap: clamp(42px, 7vw, 108px);
    align-items: center;
  }

  .loop-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 9px;
    width: fit-content;
    border: 1px solid rgba(15, 118, 110, 0.16);
    background: rgba(255, 255, 255, 0.74);
    color: #00675f;
    border-radius: 999px;
    padding: 8px 13px;
    font-size: 12px;
    font-weight: 950;
    letter-spacing: 0.02em;
    margin-bottom: 24px;
    box-shadow: 0 10px 26px rgba(15, 23, 42, 0.055);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
  }

  .loop-eyebrow-dot {
    width: 7px;
    height: 7px;
    border-radius: 999px;
    background: #00a896;
    box-shadow: 0 0 0 5px rgba(0, 168, 150, 0.12);
    flex: 0 0 auto;
  }

  .loop-hero-title {
    margin: 0;
    color: #0b1220;
    font-size: clamp(52px, 7vw, 88px);
    line-height: 0.91;
    letter-spacing: -0.082em;
    font-weight: 950;
    max-width: 780px;
  }

  .loop-hero-subtitle {
    max-width: 650px;
    margin: 24px 0 0;
    color: #475569;
    font-size: 18px;
    line-height: 1.52;
    font-weight: 700;
  }

  .loop-hero-note {
    margin-top: 14px;
    color: #64748b;
    font-size: 14px;
    line-height: 1.45;
    font-weight: 750;
  }

  .loop-hero-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 30px;
  }

  .loop-primary-cta,
  .loop-secondary-cta {
    border-radius: 999px;
    min-height: 54px;
    padding: 0 24px;
    font-weight: 950;
    font-size: 15px;
    cursor: pointer;
    transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;
  }

  .loop-primary-cta {
    border: 0;
    background: #0b1220;
    color: #ffffff;
    box-shadow: 0 18px 38px rgba(15, 23, 42, 0.20);
  }

  .loop-secondary-cta {
    background: rgba(255,255,255,0.74);
    color: #0f172a;
    border: 1px solid #e2e8f0;
    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.07);
  }

  .loop-primary-cta:active,
  .loop-secondary-cta:active {
    transform: scale(0.985);
  }

  .loop-hero-stats {
    display: grid;
    gap: 12px;
    padding: 14px;
    border-radius: 34px;
    border: 1px solid rgba(226,232,240,0.88);
    background: rgba(255,255,255,0.70);
    box-shadow: 0 28px 70px rgba(15,23,42,0.10);
    backdrop-filter: blur(18px);
    -webkit-backdrop-filter: blur(18px);
  }

  .loop-stat-card {
    border-radius: 24px;
    border: 1px solid rgba(226,232,240,0.82);
    background: rgba(255,255,255,0.88);
    padding: 18px 18px;
    min-height: 96px;
    display: grid;
    align-content: center;
  }

  .loop-stat-card:first-child {
    background: linear-gradient(135deg, #0b1220 0%, #0f766e 100%);
    border-color: transparent;
  }

  .loop-stat-card:first-child .loop-stat-label,
  .loop-stat-card:first-child .loop-stat-copy {
    color: rgba(255,255,255,0.72);
  }

  .loop-stat-card:first-child .loop-stat-value {
    color: #ffffff;
  }

  .loop-stat-label {
    color: #64748b;
    font-size: 11px;
    font-weight: 950;
    text-transform: uppercase;
    letter-spacing: 0.14em;
  }

  .loop-stat-value {
    margin-top: 8px;
    color: #0f172a;
    font-size: 23px;
    line-height: 1.05;
    font-weight: 950;
    letter-spacing: -0.055em;
  }

  .loop-stat-copy {
    margin-top: 7px;
    color: #64748b;
    font-size: 13px;
    line-height: 1.35;
    font-weight: 700;
  }


  .loop-admin-shortcut {
    margin-top: 18px;
    border: 1px solid rgba(0,103,95,0.18);
    background: #f0fdfa;
    color: #00675f;
    border-radius: 999px;
    min-height: 40px;
    padding: 0 16px;
    font-size: 13px;
    font-weight: 950;
    cursor: pointer;
    box-shadow: 0 10px 24px rgba(0,103,95,0.08);
  }

  .loop-section {
    max-width: 1460px;
    margin: 0 auto;
    padding: 34px clamp(18px, 5vw, 70px);
    border-top: 1px solid rgba(203,213,225,0.85);
  }

  .loop-section-card {
    border-radius: 0;
    background: transparent;
    border: 0;
    box-shadow: none;
    padding: 0;
    overflow: visible;
  }

  .loop-section-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 18px;
    margin-bottom: 26px;
  }

  .loop-section-kicker {
    color: #008878;
    font-size: 12px;
    font-weight: 950;
    text-transform: uppercase;
    letter-spacing: 0.16em;
    margin-bottom: 10px;
  }

  .loop-section-title {
    margin: 0;
    color: #0f172a;
    font-size: clamp(30px, 3.2vw, 42px);
    line-height: 1.02;
    font-weight: 950;
    letter-spacing: -0.055em;
  }

  .loop-section-copy {
    margin: 8px 0 0;
    color: #64748b;
    font-size: 15px;
    line-height: 1.5;
    font-weight: 750;
  }

  .loop-show-more-btn {
    border: 1px solid #e2e8f0;
    background: #fff;
    color: #0f172a;
    border-radius: 999px;
    padding: 11px 16px;
    font-size: 13px;
    font-weight: 950;
    box-shadow: 0 10px 24px rgba(15,23,42,0.06);
  }

  .loop-mobile-section-pad {
    padding-left: 0;
    padding-right: 0;
  }

  .loop-empty-state,
  .loop-error-state {
    color: #64748b;
    background: #ffffff;
    border: 1px dashed #cbd5e1;
    border-radius: 22px;
    padding: 18px;
    font-weight: 750;
  }

  .loop-skeleton-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
  }

  .loop-skeleton-card {
    height: 180px;
    border-radius: 24px;
    background: linear-gradient(90deg, #f1f5f9 0%, #f8fafc 50%, #f1f5f9 100%);
    background-size: 200% 100%;
    animation: loopShimmer 1.3s infinite linear;
  }

  @keyframes loopShimmer {
    from { background-position: 200% 0; }
    to { background-position: -200% 0; }
  }


  .loop-natural-footer {
    max-width: 1460px;
    margin: 10px auto 0;
    padding: 34px clamp(18px, 5vw, 70px) 34px;
    border-top: 1px solid rgba(203,213,225,0.78);
  }

  .loop-natural-footer-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }

  .loop-natural-footer-brand {
    min-width: 0;
  }

  .loop-natural-footer-logo {
    color: #0f172a;
    font-size: 15px;
    font-weight: 950;
    letter-spacing: -0.025em;
  }

  .loop-natural-footer-copy {
    margin: 6px 0 0;
    color: #64748b;
    font-size: 13px;
    font-weight: 650;
    line-height: 1.45;
  }

  .loop-natural-footer-links {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 11px;
    flex-wrap: wrap;
  }

  .loop-natural-footer-meta {
    color: #94a3b8;
    font-size: 13px;
    font-weight: 750;
    white-space: nowrap;
  }

  .loop-natural-footer button:hover {
    color: #00675f !important;
  }


  @media (max-width: 768px) {
    .loop-pro-main {
      padding-bottom: calc(var(--loop-mobile-nav-height, 72px) + 8px);
    }

    .loop-hero {
      padding: 8px 18px 18px;
    }

    .loop-hero-card {
      padding: 0;
    }

    .loop-hero-grid {
      display: block;
    }

    .loop-eyebrow {
      margin-bottom: 18px;
      font-size: 12px;
      padding: 8px 12px;
    }

    .loop-hero-title {
      font-size: 42px;
      letter-spacing: -0.068em;
      line-height: 0.94;
    }

    .loop-hero-subtitle {
      font-size: 15px;
      line-height: 1.48;
      margin-top: 16px;
    }

    .loop-hero-note {
      font-size: 13px;
      margin-top: 12px;
    }

    .loop-hero-actions {
      margin-top: 20px;
      gap: 10px;
    }

    .loop-primary-cta,
    .loop-secondary-cta {
      flex: 1 1 100%;
      min-height: 50px;
    }

    .loop-hero-stats {
      display: none;
    }

    .loop-stat-card {
      min-height: 92px;
      padding: 12px;
      border-radius: 18px;
      text-align: center;
    }

    .loop-stat-label {
      font-size: 9px;
      letter-spacing: 0.08em;
    }

    .loop-stat-value {
      margin-top: 8px;
      font-size: 22px;
    }

    .loop-section {
      padding: 22px 18px;
    }

    .loop-section-card {
      padding: 0;
    }

    .loop-section-head {
      align-items: flex-start;
      margin-bottom: 18px;
    }

    .loop-section-title {
      font-size: 29px;
    }

    .loop-section-copy {
      font-size: 14px;
    }

    .loop-section-head {
      gap: 10px;
    }

    .loop-section + .loop-section {
      margin-top: 0;
    }

    .loop-section-card {
      min-height: 0 !important;
    }

    .loop-mobile-section-pad {
      padding-bottom: 0 !important;
    }


    .loop-skeleton-row {
      grid-template-columns: 1fr;
    }

    .loop-natural-footer {
      margin-top: 0;
      padding: 28px 18px calc(var(--loop-mobile-nav-height, 72px) + 8px);
    }

    .loop-natural-footer-inner {
      align-items: flex-start;
      flex-direction: column;
      gap: 14px;
    }

    .loop-natural-footer-links {
      justify-content: flex-start;
      gap: 10px;
    }

    .loop-natural-footer-meta {
      font-size: 12px;
    }

  }


  /* =========================================================
     FINAL MINIMAL EARLY ACCESS HERO
     Clean web + mobile top section. No right-side cards.
     ========================================================= */
  .loop-pro-main {
    background: #ffffff !important;
  }

  .loop-hero.loop-hero-minimal {
    max-width: 1460px !important;
    margin: 0 auto !important;
    padding: clamp(38px, 4.8vw, 68px) clamp(18px, 5vw, 70px) clamp(34px, 4vw, 54px) !important;
    border-bottom: 1px solid rgba(203, 213, 225, 0.72) !important;
  }

  .loop-hero-card-minimal {
    width: 100% !important;
    max-width: none !important;
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    padding: 0 !important;
  }

  .loop-hero-content-minimal {
    width: min(760px, 100%) !important;
    margin-left: 0 !important;
  }

  .loop-eyebrow-minimal {
    display: inline-flex !important;
    align-items: center !important;
    gap: 10px !important;
    width: fit-content !important;
    margin-bottom: clamp(22px, 2.6vw, 32px) !important;
    padding: 8px 15px !important;
    border-radius: 999px !important;
    border: 1px solid rgba(226, 232, 240, 0.9) !important;
    background: rgba(241, 248, 247, 0.9) !important;
    color: #00675f !important;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04) !important;
    font-size: 12px !important;
    font-weight: 950 !important;
    letter-spacing: 0.11em !important;
    text-transform: uppercase !important;
  }

  .loop-eyebrow-minimal .loop-eyebrow-dot {
    width: 9px !important;
    height: 9px !important;
    border-radius: 999px !important;
    background: #00675f !important;
    box-shadow: 0 0 0 6px rgba(0, 103, 95, 0.08) !important;
  }

  .loop-hero-title-minimal {
    margin: 0 !important;
    max-width: 780px !important;
    color: #07111f !important;
    font-size: clamp(56px, 5.1vw, 82px) !important;
    line-height: 0.95 !important;
    letter-spacing: -0.078em !important;
    font-weight: 950 !important;
  }

  .loop-title-dot {
    color: #00675f !important;
  }

  .loop-hero-subtitle-minimal {
    max-width: 610px !important;
    margin: clamp(20px, 2.1vw, 28px) 0 0 !important;
    color: #667085 !important;
    font-size: clamp(17px, 1.25vw, 20px) !important;
    line-height: 1.55 !important;
    font-weight: 500 !important;
    letter-spacing: -0.012em !important;
  }

  .loop-hero-actions-minimal {
    margin-top: clamp(26px, 2.8vw, 36px) !important;
    display: flex !important;
    gap: 12px !important;
  }

  .loop-primary-cta-minimal {
    min-height: 54px !important;
    padding: 0 28px 0 30px !important;
    border-radius: 999px !important;
    border: 0 !important;
    background: linear-gradient(135deg, #00675f 0%, #00897f 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 14px 32px rgba(0, 103, 95, 0.18) !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 14px !important;
    font-size: 16px !important;
    font-weight: 900 !important;
    letter-spacing: -0.02em !important;
    white-space: nowrap !important;
  }

  .loop-primary-cta-minimal:active {
    transform: scale(0.985) !important;
  }

  .loop-cta-arrow {
    font-size: 28px !important;
    line-height: 1 !important;
    transform: translateY(-1px) !important;
  }

  .loop-hero-access-note {
    margin-top: clamp(26px, 3vw, 38px) !important;
    display: flex !important;
    align-items: center !important;
    gap: 14px !important;
    color: #0f172a !important;
  }

  .loop-hero-lock {
    width: 46px !important;
    height: 46px !important;
    border-radius: 999px !important;
    background: #f3f7f7 !important;
    color: #475569 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    border: 1px solid #eef2f1 !important;
    flex: 0 0 auto !important;
  }

  .loop-hero-access-copy {
    display: grid !important;
    gap: 4px !important;
    color: #667085 !important;
    font-size: 15px !important;
    line-height: 1.35 !important;
    font-weight: 500 !important;
  }

  .loop-hero-access-copy strong {
    color: #0f172a !important;
    font-weight: 850 !important;
  }



  @media (min-width: 769px) {
    .loop-hero.loop-hero-minimal {
    max-width: 1460px !important;
    margin: 0 auto !important;
    padding: clamp(38px, 4.8vw, 68px) clamp(18px, 5vw, 70px) clamp(34px, 4vw, 54px) !important;
    border-bottom: 1px solid rgba(203, 213, 225, 0.72) !important;
  }
  }

  @media (max-width: 768px) {
    .loop-hero.loop-hero-minimal {
      padding: 26px 18px 32px !important;
      border-bottom: 1px solid rgba(203, 213, 225, 0.76) !important;
    }

    .loop-hero-content-minimal {
    width: min(760px, 100%) !important;
    margin-left: 0 !important;
  }

    .loop-eyebrow-minimal {
    display: inline-flex !important;
    align-items: center !important;
    gap: 10px !important;
    width: fit-content !important;
    margin-bottom: clamp(22px, 2.6vw, 32px) !important;
    padding: 8px 15px !important;
    border-radius: 999px !important;
    border: 1px solid rgba(226, 232, 240, 0.9) !important;
    background: rgba(241, 248, 247, 0.9) !important;
    color: #00675f !important;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04) !important;
    font-size: 12px !important;
    font-weight: 950 !important;
    letter-spacing: 0.11em !important;
    text-transform: uppercase !important;
  }

    .loop-hero-title-minimal {
    margin: 0 !important;
    max-width: 780px !important;
    color: #07111f !important;
    font-size: clamp(56px, 5.1vw, 82px) !important;
    line-height: 0.95 !important;
    letter-spacing: -0.078em !important;
    font-weight: 950 !important;
  }

    .loop-hero-subtitle-minimal {
    max-width: 610px !important;
    margin: clamp(20px, 2.1vw, 28px) 0 0 !important;
    color: #667085 !important;
    font-size: clamp(17px, 1.25vw, 20px) !important;
    line-height: 1.55 !important;
    font-weight: 500 !important;
    letter-spacing: -0.012em !important;
  }

    .loop-hero-actions-minimal {
    margin-top: clamp(26px, 2.8vw, 36px) !important;
    display: flex !important;
    gap: 12px !important;
  }

    .loop-primary-cta-minimal {
    min-height: 54px !important;
    padding: 0 28px 0 30px !important;
    border-radius: 999px !important;
    border: 0 !important;
    background: linear-gradient(135deg, #00675f 0%, #00897f 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 14px 32px rgba(0, 103, 95, 0.18) !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 14px !important;
    font-size: 16px !important;
    font-weight: 900 !important;
    letter-spacing: -0.02em !important;
    white-space: nowrap !important;
  }

    .loop-hero-access-note {
    margin-top: clamp(26px, 3vw, 38px) !important;
    display: flex !important;
    align-items: center !important;
    gap: 14px !important;
    color: #0f172a !important;
  }

    .loop-hero-lock {
    width: 46px !important;
    height: 46px !important;
    border-radius: 999px !important;
    background: #f3f7f7 !important;
    color: #475569 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    border: 1px solid #eef2f1 !important;
    flex: 0 0 auto !important;
  }

    .loop-hero-access-copy {
    display: grid !important;
    gap: 4px !important;
    color: #667085 !important;
    font-size: 15px !important;
    line-height: 1.35 !important;
    font-weight: 500 !important;
  }
  }

  @media (max-width: 420px) {
    .loop-hero.loop-hero-minimal {
    max-width: 1460px !important;
    margin: 0 auto !important;
    padding: clamp(38px, 4.8vw, 68px) clamp(18px, 5vw, 70px) clamp(34px, 4vw, 54px) !important;
    border-bottom: 1px solid rgba(203, 213, 225, 0.72) !important;
  }

    .loop-hero-title-minimal {
    margin: 0 !important;
    max-width: 780px !important;
    color: #07111f !important;
    font-size: clamp(56px, 5.1vw, 82px) !important;
    line-height: 0.95 !important;
    letter-spacing: -0.078em !important;
    font-weight: 950 !important;
  }

    .loop-hero-subtitle-minimal {
    max-width: 610px !important;
    margin: clamp(20px, 2.1vw, 28px) 0 0 !important;
    color: #667085 !important;
    font-size: clamp(17px, 1.25vw, 20px) !important;
    line-height: 1.55 !important;
    font-weight: 500 !important;
    letter-spacing: -0.012em !important;
  }

    .loop-primary-cta-minimal {
    min-height: 54px !important;
    padding: 0 28px 0 30px !important;
    border-radius: 999px !important;
    border: 0 !important;
    background: linear-gradient(135deg, #00675f 0%, #00897f 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 14px 32px rgba(0, 103, 95, 0.18) !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 14px !important;
    font-size: 16px !important;
    font-weight: 900 !important;
    letter-spacing: -0.02em !important;
    white-space: nowrap !important;
  }
  }

  /* =========================================================
     COMPACT HERO OVERRIDE
     Makes the early-access hero cleaner on desktop so categories
     are visible sooner when users land on the home page.
     ========================================================= */
  @media (min-width: 900px) {
    .loop-hero.loop-hero-minimal {
      padding: 48px clamp(18px, 5vw, 70px) 38px !important;
      min-height: auto !important;
    }

    .loop-hero-card-minimal {
      width: 100% !important;
    }

    .loop-hero-content-minimal {
      width: 100% !important;
      max-width: 1200px !important;
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) minmax(300px, 380px) !important;
      column-gap: clamp(34px, 5vw, 72px) !important;
      row-gap: 14px !important;
      align-items: center !important;
    }

    .loop-eyebrow-minimal {
      grid-column: 1 / 2 !important;
      grid-row: 1 !important;
      margin-bottom: 16px !important;
    }

    .loop-hero-title-minimal {
      grid-column: 1 / 2 !important;
      grid-row: 2 !important;
      font-size: clamp(54px, 5vw, 76px) !important;
      line-height: 0.93 !important;
      max-width: 720px !important;
    }

    .loop-hero-subtitle-minimal {
      grid-column: 1 / 2 !important;
      grid-row: 3 !important;
      margin-top: 14px !important;
      max-width: 640px !important;
      font-size: clamp(16px, 1.1vw, 18px) !important;
      line-height: 1.48 !important;
    }

    .loop-hero-actions-minimal {
      grid-column: 2 / 3 !important;
      grid-row: 2 !important;
      margin-top: 0 !important;
      align-self: end !important;
      justify-self: start !important;
    }

    .loop-primary-cta-minimal {
      min-height: 52px !important;
      padding: 0 26px !important;
      box-shadow: 0 14px 30px rgba(0, 103, 95, 0.16) !important;
    }

    .loop-hero-access-note {
      grid-column: 2 / 3 !important;
      grid-row: 3 !important;
      margin-top: 0 !important;
      align-self: start !important;
    }

    .loop-hero-lock {
      width: 44px !important;
      height: 44px !important;
    }

    .loop-section {
      padding-top: 30px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-hero.loop-hero-minimal {
      padding: 24px 18px 30px !important;
    }

    .loop-hero-content-minimal {
      width: 100% !important;
      display: block !important;
    }

    .loop-hero-title-minimal {
      font-size: clamp(42px, 12vw, 58px) !important;
      line-height: 0.94 !important;
    }

    .loop-hero-subtitle-minimal {
      font-size: 15px !important;
      line-height: 1.48 !important;
      margin-top: 16px !important;
    }

    .loop-hero-actions-minimal {
      margin-top: 20px !important;
    }

    .loop-primary-cta-minimal {
      width: 100% !important;
      min-height: 52px !important;
    }

    .loop-hero-access-note {
      margin-top: 22px !important;
    }
  }


  /* =========================================================
     LOOP HOME PREMIUM DISCOVERY HERO - FINAL OVERRIDE
     Premium marketplace fold: compact hero, stronger hierarchy,
     categories visible sooner, subtle motion, no logic changes.
     ========================================================= */

  .loop-pro-shell {
    background:
      radial-gradient(circle at 10% 8%, rgba(0, 137, 127, 0.10), transparent 28%),
      radial-gradient(circle at 92% 22%, rgba(0, 103, 95, 0.08), transparent 34%),
      linear-gradient(180deg, #ffffff 0%, #f8fbfb 48%, #ffffff 100%) !important;
  }

  .loop-pro-main {
    background: transparent !important;
  }

  .loop-hero.loop-hero-minimal {
    max-width: 1500px !important;
    margin: 0 auto !important;
    padding: clamp(34px, 4vw, 54px) clamp(22px, 5vw, 72px) clamp(28px, 3.3vw, 42px) !important;
    border-bottom: 0 !important;
    min-height: auto !important;
  }

  .loop-hero-card-minimal {
    width: 100% !important;
    position: relative !important;
    overflow: visible !important;
  }

  .loop-hero-content-minimal {
    width: 100% !important;
    max-width: none !important;
    margin: 0 !important;
    display: grid !important;
    grid-template-columns: minmax(0, 0.9fr) minmax(340px, 0.72fr) !important;
    column-gap: clamp(34px, 5vw, 78px) !important;
    row-gap: 16px !important;
    align-items: center !important;
    position: relative !important;
  }

  .loop-eyebrow-minimal {
    grid-column: 1 / 2 !important;
    grid-row: 1 !important;
    margin: 0 0 14px !important;
    padding: 7px 14px !important;
    border-radius: 999px !important;
    background: rgba(240, 253, 250, 0.86) !important;
    border: 1px solid rgba(0, 103, 95, 0.14) !important;
    color: #00675f !important;
    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.045) !important;
    backdrop-filter: blur(14px) !important;
    -webkit-backdrop-filter: blur(14px) !important;
    font-size: 11.5px !important;
    line-height: 1 !important;
    letter-spacing: 0.13em !important;
  }

  .loop-eyebrow-minimal .loop-eyebrow-dot {
    width: 8px !important;
    height: 8px !important;
    background: #00897f !important;
    box-shadow: 0 0 0 6px rgba(0, 137, 127, 0.10) !important;
  }

  .loop-hero-title-minimal {
    grid-column: 1 / 2 !important;
    grid-row: 2 !important;
    max-width: 760px !important;
    margin: 0 !important;
    color: #07111f !important;
    font-size: clamp(58px, 5.7vw, 90px) !important;
    line-height: 0.88 !important;
    letter-spacing: -0.086em !important;
    font-weight: 950 !important;
    text-wrap: balance !important;
  }

  .loop-title-dot {
    color: #00897f !important;
  }

  .loop-hero-subtitle-minimal {
    grid-column: 1 / 2 !important;
    grid-row: 3 !important;
    max-width: 590px !important;
    margin: 14px 0 0 !important;
    color: #667085 !important;
    font-size: clamp(16px, 1.1vw, 18px) !important;
    line-height: 1.48 !important;
    font-weight: 650 !important;
    letter-spacing: -0.012em !important;
  }

  .loop-hero-actions-minimal {
    grid-column: 1 / 2 !important;
    grid-row: 4 !important;
    margin: 24px 0 0 !important;
    display: flex !important;
    gap: 12px !important;
    align-items: center !important;
    flex-wrap: wrap !important;
  }

  .loop-primary-cta-minimal {
    min-height: 58px !important;
    padding: 0 30px !important;
    border-radius: 999px !important;
    border: 0 !important;
    background:
      radial-gradient(circle at 20% 0%, rgba(255,255,255,0.22), transparent 32%),
      linear-gradient(135deg, #00675f 0%, #00897f 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 18px 38px rgba(0, 103, 95, 0.22) !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 13px !important;
    font-size: 15.5px !important;
    font-weight: 950 !important;
    letter-spacing: -0.018em !important;
    transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease !important;
  }

  .loop-primary-cta-minimal:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 22px 48px rgba(0, 103, 95, 0.27) !important;
    filter: saturate(1.04) !important;
  }

  .loop-primary-cta-minimal:active {
    transform: translateY(0) scale(0.985) !important;
  }

  .loop-cta-arrow {
    font-size: 24px !important;
    transform: translateY(-1px) !important;
  }

  .loop-hero-access-note {
    grid-column: 1 / 2 !important;
    grid-row: 5 !important;
    margin: 26px 0 0 !important;
    display: inline-flex !important;
    width: fit-content !important;
    align-items: center !important;
    gap: 14px !important;
    color: #0f172a !important;
  }

  .loop-hero-lock {
    width: 45px !important;
    height: 45px !important;
    border-radius: 999px !important;
    background: rgba(240, 253, 250, 0.86) !important;
    color: #00675f !important;
    border: 1px solid rgba(0, 103, 95, 0.12) !important;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05) !important;
  }

  .loop-hero-access-copy {
    color: #667085 !important;
    font-size: 14.5px !important;
    line-height: 1.34 !important;
    font-weight: 650 !important;
  }

  .loop-hero-access-copy strong {
    color: #0b1220 !important;
    font-weight: 900 !important;
  }

  .loop-hero-visual,
  .loop-hero-stats,
  .loop-hero-mockup,
  .loop-dashboard-mockup {
    grid-column: 2 / 3 !important;
    grid-row: 1 / 6 !important;
    align-self: center !important;
    justify-self: end !important;
    width: min(100%, 620px) !important;
    max-height: 430px !important;
    transform: scale(0.88) translateX(22px) !important;
    transform-origin: center right !important;
    opacity: 0.96 !important;
    filter: drop-shadow(0 30px 70px rgba(15, 23, 42, 0.12)) !important;
  }

  .loop-hero-stats {
    opacity: 0.86 !important;
  }

  .loop-section {
    max-width: 1500px !important;
    margin: 0 auto !important;
    padding: 18px clamp(22px, 5vw, 72px) 34px !important;
    border-top: 0 !important;
  }

  .loop-section-card {
    border-radius: 34px !important;
    background:
      radial-gradient(circle at 5% 0%, rgba(0, 137, 127, 0.08), transparent 30%),
      linear-gradient(180deg, rgba(255,255,255,0.88), rgba(248,251,251,0.92)) !important;
    border: 1px solid rgba(226, 232, 240, 0.84) !important;
    box-shadow: 0 24px 70px rgba(15, 23, 42, 0.055) !important;
    padding: clamp(26px, 3.2vw, 42px) clamp(22px, 4vw, 56px) !important;
    overflow: hidden !important;
  }

  .loop-section-head {
    margin-bottom: 24px !important;
    align-items: flex-start !important;
  }

  .loop-section-kicker {
    color: #008878 !important;
    font-size: 12px !important;
    letter-spacing: 0.16em !important;
    margin-bottom: 12px !important;
  }

  .loop-section-title {
    max-width: 560px !important;
    font-size: clamp(34px, 3.4vw, 50px) !important;
    line-height: 0.98 !important;
    letter-spacing: -0.07em !important;
    color: #0b1220 !important;
  }

  .loop-section-copy {
    color: #667085 !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    margin-top: 10px !important;
  }

  .loop-section-card button,
  .loop-section-card [role="button"] {
    transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease !important;
  }

  .loop-section-card button:hover,
  .loop-section-card [role="button"]:hover {
    transform: translateY(-3px) !important;
    filter: saturate(1.04) !important;
  }

  .loop-natural-footer {
    border-top: 0 !important;
    padding-top: 18px !important;
  }

  @media (min-width: 900px) and (max-height: 820px) {
    .loop-hero.loop-hero-minimal {
      padding-top: 28px !important;
      padding-bottom: 24px !important;
    }

    .loop-hero-title-minimal {
      font-size: clamp(52px, 5.1vw, 78px) !important;
    }

    .loop-hero-subtitle-minimal {
      margin-top: 10px !important;
    }

    .loop-hero-actions-minimal {
      margin-top: 18px !important;
    }

    .loop-hero-access-note {
      margin-top: 18px !important;
    }

    .loop-section {
      padding-top: 10px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-hero.loop-hero-minimal {
      padding: 22px 18px 20px !important;
      border-bottom: 0 !important;
    }

    .loop-hero-content-minimal {
      display: block !important;
      width: 100% !important;
      max-width: none !important;
    }

    .loop-eyebrow-minimal {
      margin-bottom: 16px !important;
      padding: 7px 12px !important;
      font-size: 11px !important;
      letter-spacing: 0.11em !important;
    }

    .loop-hero-title-minimal {
      max-width: 100% !important;
      font-size: clamp(42px, 12.4vw, 58px) !important;
      line-height: 0.92 !important;
      letter-spacing: -0.074em !important;
    }

    .loop-hero-subtitle-minimal {
      margin-top: 14px !important;
      max-width: 100% !important;
      font-size: 15px !important;
      line-height: 1.46 !important;
    }

    .loop-hero-actions-minimal {
      margin-top: 18px !important;
    }

    .loop-primary-cta-minimal {
      width: 100% !important;
      min-height: 52px !important;
      font-size: 15px !important;
      padding: 0 18px !important;
    }

    .loop-hero-access-note {
      margin-top: 18px !important;
      gap: 12px !important;
    }

    .loop-hero-lock {
      width: 42px !important;
      height: 42px !important;
    }

    .loop-hero-access-copy {
      font-size: 13.5px !important;
    }

    .loop-hero-visual,
    .loop-hero-stats,
    .loop-hero-mockup,
    .loop-dashboard-mockup {
      display: none !important;
    }

    .loop-section {
      padding: 8px 14px 22px !important;
    }

    .loop-section-card {
      border-radius: 28px !important;
      padding: 24px 18px !important;
      box-shadow: 0 18px 48px rgba(15, 23, 42, 0.055) !important;
    }

    .loop-section-head {
      margin-bottom: 18px !important;
    }

    .loop-section-title {
      font-size: clamp(30px, 9vw, 40px) !important;
      line-height: 1.0 !important;
    }

    .loop-section-copy {
      font-size: 14px !important;
    }
  }

  @media (max-width: 420px) {
    .loop-hero.loop-hero-minimal {
      padding: 18px 16px 18px !important;
    }

    .loop-hero-title-minimal {
      font-size: clamp(39px, 12.2vw, 51px) !important;
    }

    .loop-section {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }

    .loop-section-card {
      padding-left: 15px !important;
      padding-right: 15px !important;
    }
  }



  /* =========================================================
     FINAL MINIMAL SECTIONS OVERRIDE
     Removes boxed sections and returns to clean editorial sections
     separated by subtle premium divider lines.
     ========================================================= */

  .loop-pro-shell {
    background:
      radial-gradient(circle at 8% 4%, rgba(0, 137, 127, 0.075), transparent 26%),
      radial-gradient(circle at 95% 16%, rgba(15, 118, 110, 0.05), transparent 30%),
      linear-gradient(180deg, #ffffff 0%, #fbfdfd 42%, #ffffff 100%) !important;
  }

  .loop-pro-main {
    background: transparent !important;
  }

  .loop-section {
    max-width: 1500px !important;
    margin: 0 auto !important;
    padding: 42px clamp(22px, 5vw, 72px) 44px !important;
    border-top: 1px solid rgba(203, 213, 225, 0.68) !important;
    position: relative !important;
  }

  .loop-section:first-of-type {
    border-top: 1px solid rgba(203, 213, 225, 0.58) !important;
  }

  .loop-section-card {
    border-radius: 0 !important;
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    padding: 0 !important;
    overflow: visible !important;
  }

  .loop-section-card::before,
  .loop-section-card::after {
    display: none !important;
  }

  .loop-section-head {
    margin-bottom: 26px !important;
    align-items: flex-end !important;
  }

  .loop-section-kicker {
    color: #008878 !important;
    font-size: 12px !important;
    letter-spacing: 0.17em !important;
    margin-bottom: 12px !important;
  }

  .loop-section-title {
    max-width: 680px !important;
    color: #0b1220 !important;
    font-size: clamp(34px, 3.45vw, 52px) !important;
    line-height: .98 !important;
    letter-spacing: -0.073em !important;
  }

  .loop-section-copy {
    color: #667085 !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    margin-top: 10px !important;
  }

  .loop-show-more-btn {
    border: 1px solid rgba(226, 232, 240, 0.92) !important;
    background: rgba(255, 255, 255, 0.78) !important;
    box-shadow: 0 10px 26px rgba(15, 23, 42, 0.045) !important;
    backdrop-filter: blur(12px) !important;
    -webkit-backdrop-filter: blur(12px) !important;
  }

  .loop-empty-state,
  .loop-error-state {
    background: rgba(255, 255, 255, 0.72) !important;
    border: 1px dashed rgba(148, 163, 184, 0.5) !important;
    box-shadow: none !important;
  }

  .loop-natural-footer {
    max-width: 1500px !important;
    border-top: 1px solid rgba(203, 213, 225, 0.64) !important;
    margin-top: 0 !important;
  }

  @media (min-width: 900px) {
    .loop-section {
      padding-top: 44px !important;
      padding-bottom: 46px !important;
    }

    .loop-hero.loop-hero-minimal {
      border-bottom: 0 !important;
      padding-bottom: 44px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-section {
      padding: 28px 18px 30px !important;
      border-top: 1px solid rgba(203, 213, 225, 0.72) !important;
    }

    .loop-section-card {
      padding: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
    }

    .loop-section-head {
      margin-bottom: 20px !important;
      align-items: flex-start !important;
    }

    .loop-section-title {
      font-size: clamp(30px, 9vw, 42px) !important;
      line-height: 1 !important;
    }

    .loop-section-copy {
      font-size: 14px !important;
    }
  }



  /* =========================================================
     FINAL SOFT SECTION DIVIDERS + ELEGANT CATEGORY SPACING
     ========================================================= */

  .loop-section {
    border-top: 0 !important;
  }

  .loop-section::before {
    content: "" !important;
    position: absolute !important;
    top: 0 !important;
    left: clamp(22px, 5vw, 72px) !important;
    right: clamp(22px, 5vw, 72px) !important;
    height: 1px !important;
    background:
      linear-gradient(
        90deg,
        transparent 0%,
        rgba(148, 163, 184, 0.18) 12%,
        rgba(0, 137, 127, 0.26) 50%,
        rgba(148, 163, 184, 0.18) 88%,
        transparent 100%
      ) !important;
    box-shadow:
      0 1px 0 rgba(255,255,255,0.88),
      0 18px 42px rgba(0,103,95,0.06) !important;
    pointer-events: none !important;
  }

  .loop-section::after {
    content: "" !important;
    position: absolute !important;
    top: -22px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: min(760px, 70vw) !important;
    height: 44px !important;
    background:
      radial-gradient(ellipse at center, rgba(0,137,127,0.055), transparent 68%) !important;
    pointer-events: none !important;
  }

  #loop-services-section {
    padding-top: 48px !important;
    padding-bottom: 52px !important;
  }

  #loop-services-section .loop-section-head {
    margin-bottom: 38px !important;
  }

  #loop-services-section .loop-section-card > *:not(.loop-section-head) {
    padding-top: 6px !important;
  }

  #loop-services-section button,
  #loop-services-section [role="button"],
  #loop-services-section a {
    transition: transform 160ms ease, filter 160ms ease, box-shadow 160ms ease !important;
  }

  #loop-services-section button:hover,
  #loop-services-section [role="button"]:hover,
  #loop-services-section a:hover {
    transform: translateY(-3px) !important;
  }

  /* Make category rows breathe even if the inner component uses flex/grid */
  #loop-services-section .loop-section-card > div:last-child,
  #loop-services-section .loop-mobile-section-pad {
    gap: clamp(22px, 3.2vw, 42px) !important;
  }

  #loop-services-section .loop-section-card > div:last-child > *,
  #loop-services-section .loop-mobile-section-pad > * {
    margin-inline: clamp(6px, 1.1vw, 14px) !important;
  }

  @media (min-width: 900px) {
    #loop-services-section {
      padding-top: 52px !important;
    }

    #loop-services-section .loop-section-title {
      margin-bottom: 2px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-section::before {
      left: 18px !important;
      right: 18px !important;
    }

    .loop-section::after {
      width: 86vw !important;
      top: -18px !important;
    }

    #loop-services-section {
      padding-top: 34px !important;
      padding-bottom: 36px !important;
    }

    #loop-services-section .loop-section-head {
      margin-bottom: 26px !important;
    }

    #loop-services-section .loop-section-card > div:last-child > *,
    #loop-services-section .loop-mobile-section-pad > * {
      margin-inline: 4px !important;
    }
  }



  /* =========================================================
     FULL WIDTH ELEGANT FADE DIVIDER
     ========================================================= */

  .loop-section::before {
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    height: 1px !important;

    background:
      linear-gradient(
        90deg,
        rgba(255,255,255,0) 0%,
        rgba(203,213,225,0.16) 8%,
        rgba(148,163,184,0.22) 18%,
        rgba(0,137,127,0.18) 34%,
        rgba(0,137,127,0.26) 50%,
        rgba(0,137,127,0.18) 66%,
        rgba(148,163,184,0.22) 82%,
        rgba(203,213,225,0.16) 92%,
        rgba(255,255,255,0) 100%
      ) !important;

    box-shadow:
      0 1px 0 rgba(255,255,255,0.82),
      0 14px 40px rgba(0,103,95,0.05),
      0 0 28px rgba(0,137,127,0.045) !important;

    opacity: .96 !important;
  }

  .loop-section::after {
    width: min(1200px, 96vw) !important;
    height: 52px !important;

    background:
      radial-gradient(
        ellipse at center,
        rgba(0,137,127,0.07) 0%,
        rgba(0,137,127,0.03) 34%,
        rgba(255,255,255,0) 74%
      ) !important;

    filter: blur(2px) !important;
    opacity: .95 !important;
  }

  @media (max-width: 899px) {
    .loop-section::after {
      width: 100vw !important;
      height: 44px !important;
    }
  }



  

  #loop-services-section {
    padding-top: 56px !important;
    padding-bottom: 62px !important;
  }

  #loop-services-section .loop-section-head {
    margin-bottom: 44px !important;
  }


  @media (max-width: 899px) {
    #loop-services-section {
      padding-top: 38px !important;
      padding-bottom: 42px !important;
    }

    #loop-services-section .loop-section-head {
      margin-bottom: 28px !important;
    }

  }



  

  #loop-services-section .loop-section-card {
    max-width: 1120px !important;
    margin: 0 auto !important;
  }

  #loop-services-section .loop-section-head {
    max-width: 1120px !important;
    margin-left: auto !important;
    margin-right: auto !important;
    margin-bottom: 44px !important;
  }



  /* =========================================================
     FINAL FIX - CATEGORY ICONS DISTRIBUTED ONLY
     Keeps section title aligned with the rest of homepage titles.
     Only spreads the category icons horizontally.
     ========================================================= */

  #loop-services-section .loop-section-card {
    width: 100% !important;
    max-width: none !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  #loop-services-section .loop-section-head {
    width: 100% !important;
    max-width: none !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-bottom: 34px !important;
    text-align: left !important;
  }

  #loop-services-section .loop-section-head > div,
  #loop-services-section .loop-section-kicker,
  #loop-services-section .loop-section-title,
  #loop-services-section .loop-section-copy {
    text-align: left !important;
    margin-left: 0 !important;
  }

  @media (max-width: 899px) {
    #loop-services-section .loop-section-head {
      margin-bottom: 26px !important;
    }

  }



  /* =========================================================
     HOMEPAGE PREMIUM BRANDING REFRESH - CHATGPT FINAL
     Goal:
     - Smaller/cleaner hero fold
     - CTA and access note to the right on desktop
     - Categories closer to hero
     - Category icons spread evenly across the section
     ========================================================= */

  @media (min-width: 900px) {
    .loop-hero.loop-hero-minimal {
      max-width: 1460px !important;
      padding: 30px clamp(22px, 5vw, 72px) 26px !important;
      margin: 0 auto !important;
      border-bottom: 0 !important;
    }

    .loop-hero-card-minimal {
      width: 100% !important;
      padding: 0 !important;
    }

    .loop-hero-content-minimal {
      width: 100% !important;
      max-width: 1180px !important;
      margin: 0 auto !important;
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) minmax(300px, 360px) !important;
      column-gap: clamp(34px, 5vw, 74px) !important;
      row-gap: 12px !important;
      align-items: center !important;
    }

    .loop-eyebrow-minimal {
      grid-column: 1 / 2 !important;
      grid-row: 1 !important;
      margin: 0 0 12px !important;
      padding: 7px 13px !important;
      font-size: 11px !important;
      letter-spacing: 0.13em !important;
    }

    .loop-hero-title-minimal {
      grid-column: 1 / 2 !important;
      grid-row: 2 / 4 !important;
      max-width: 650px !important;
      font-size: clamp(50px, 4.5vw, 72px) !important;
      line-height: 0.91 !important;
      letter-spacing: -0.08em !important;
    }

    .loop-hero-subtitle-minimal {
      grid-column: 1 / 2 !important;
      grid-row: 4 !important;
      max-width: 540px !important;
      margin: 16px 0 0 !important;
      font-size: clamp(14px, 1vw, 16px) !important;
      line-height: 1.5 !important;
      font-weight: 700 !important;
    }

    .loop-hero-actions-minimal {
      grid-column: 2 / 3 !important;
      grid-row: 2 !important;
      justify-self: start !important;
      align-self: end !important;
      margin: 0 !important;
      display: flex !important;
      width: 100% !important;
    }

    .loop-primary-cta-minimal {
      width: auto !important;
      min-height: 50px !important;
      padding: 0 22px !important;
      font-size: 14px !important;
      box-shadow: 0 14px 28px rgba(0, 103, 95, 0.16) !important;
    }

    .loop-cta-arrow {
      font-size: 22px !important;
    }

    .loop-hero-access-note {
      grid-column: 2 / 3 !important;
      grid-row: 3 / 5 !important;
      align-self: start !important;
      width: 100% !important;
      margin: 14px 0 0 !important;
      padding: 14px 16px !important;
      border: 1px solid rgba(226, 232, 240, 0.88) !important;
      border-radius: 22px !important;
      background: rgba(255,255,255,0.72) !important;
      box-shadow: 0 12px 30px rgba(15,23,42,0.045) !important;
      backdrop-filter: blur(14px) !important;
      -webkit-backdrop-filter: blur(14px) !important;
    }

    .loop-hero-lock {
      width: 40px !important;
      height: 40px !important;
    }

    .loop-hero-access-copy {
      font-size: 13px !important;
      line-height: 1.35 !important;
    }

    .loop-hero-access-copy strong {
      font-size: 13px !important;
      line-height: 1.3 !important;
    }

    #loop-services-section {
      padding-top: 22px !important;
      padding-bottom: 36px !important;
    }

    #loop-services-section .loop-section-head {
      margin-bottom: 26px !important;
    }

    #loop-services-section .loop-section-title {
      font-size: clamp(30px, 2.7vw, 42px) !important;
      line-height: 0.98 !important;
    }

    #loop-services-section .loop-section-copy {
      margin-top: 6px !important;
      font-size: 13px !important;
    }


    .loop-section {
      padding-left: clamp(22px, 5vw, 72px) !important;
      padding-right: clamp(22px, 5vw, 72px) !important;
    }
  }

  @media (min-width: 900px) and (max-height: 820px) {
    .loop-hero.loop-hero-minimal {
      padding-top: 24px !important;
      padding-bottom: 20px !important;
    }

    .loop-hero-title-minimal {
      font-size: clamp(46px, 4.2vw, 66px) !important;
    }

    .loop-hero-subtitle-minimal {
      margin-top: 12px !important;
    }

    #loop-services-section {
      padding-top: 18px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-hero.loop-hero-minimal {
      padding: 20px 18px 18px !important;
    }

    .loop-hero-title-minimal {
      font-size: clamp(39px, 11vw, 54px) !important;
      line-height: .93 !important;
    }

    .loop-hero-subtitle-minimal {
      margin-top: 14px !important;
      font-size: 14.5px !important;
    }

    .loop-hero-actions-minimal {
      margin-top: 18px !important;
    }

    .loop-hero-access-note {
      margin-top: 16px !important;
      padding: 12px 0 0 !important;
      border-top: 1px solid rgba(226,232,240,.8) !important;
    }

    #loop-services-section {
      padding-top: 24px !important;
    }

  }


  /* =========================================================
     FIX CATEGORIES HORIZONTAL ROW
     Previous override accidentally let ServicesGrid stack items vertically.
     This forces ONLY the category item layer into a horizontal row.
     ========================================================= */

  @media (min-width: 900px) {
    #loop-services-section .loop-section-card {
      width: 100% !important;
      max-width: none !important;
    }

    #loop-services-section .loop-section-head {
      width: 100% !important;
      max-width: none !important;
      margin-bottom: 28px !important;
      text-align: left !important;
    }

  }



  /* =========================================================
     FINAL FIX: HERO ALIGNMENT + TRUE 5-COLUMN CATEGORIES
     - No carousel/scroll on desktop
     - Categories use full horizontal row
     - Hero left edge aligns with section titles
     ========================================================= */

  @media (min-width: 900px) {
    .loop-hero.loop-hero-minimal,
    .loop-section {
      max-width: 1460px !important;
      padding-left: clamp(22px, 5vw, 72px) !important;
      padding-right: clamp(22px, 5vw, 72px) !important;
    }

    .loop-hero.loop-hero-minimal {
      padding-top: 28px !important;
      padding-bottom: 26px !important;
    }

    .loop-hero-card-minimal,
    .loop-hero-content-minimal {
      width: 100% !important;
      max-width: none !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }

    .loop-hero-content-minimal {
      display: grid !important;
      grid-template-columns: minmax(0,1fr) minmax(300px,360px) !important;
      column-gap: clamp(32px, 5vw, 72px) !important;
      align-items: center !important;
    }

    .loop-eyebrow-minimal,
    .loop-hero-title-minimal,
    .loop-hero-subtitle-minimal {
      justify-self: start !important;
      text-align: left !important;
      margin-left: 0 !important;
    }

    .loop-hero-title-minimal {
      max-width: 650px !important;
      font-size: clamp(50px, 4.5vw, 72px) !important;
      line-height: .91 !important;
    }

    #loop-services-section {
      padding-top: 18px !important;
      padding-bottom: 34px !important;
    }

    #loop-services-section .loop-section-head {
      margin-bottom: 26px !important;
    }

  }


  /* =========================================================
     LOOP FINAL CATEGORY + FOOTER POLISH
     - Bigger category images, no double frame
     - Categories distributed across full section
     - Footer has only one divider line
     ========================================================= */

  #loop-services-section .loop-section-head {
    margin-bottom: 24px !important;
  }


  .loop-natural-footer {
    margin-top: 0 !important;
    border-top: 0 !important;
    padding-top: 28px !important;
  }

  .loop-section:last-of-type {
    padding-bottom: 26px !important;
    border-bottom: 1px solid rgba(203,213,225,0.78) !important;
  }


  /* =========================================================
     FINAL MOBILE CATEGORIES CLEANUP
     Removes the oversized mobile category carousel feeling.
     Header keeps only the “Categorías” kicker and cards stay compact.
     ========================================================= */

  #loop-services-section .loop-section-title,
  #loop-services-section .loop-section-copy {
    display: none !important;
  }

  #loop-services-section .loop-section-head {
    margin-bottom: 18px !important;
  }

  @media (max-width: 899px) {
    #loop-services-section {
      padding: 26px 18px 30px !important;
    }

    #loop-services-section .loop-section-head {
      margin-bottom: 14px !important;
    }

    #loop-services-section .loop-section-kicker {
      margin-bottom: 0 !important;
      font-size: 12px !important;
      letter-spacing: 0.18em !important;
    }

  }



  /* =========================================================
     LOOP CATEGORIES V4 HARD OVERRIDE
     Keeps legacy category CSS from forcing grid/oversized cards.
     ========================================================= */
  @media (max-width: 899px) {
    #loop-services-section {
      padding: 22px 0 30px !important;
      overflow: hidden !important;
    }

    #loop-services-section .loop-section-head {
      margin: 0 18px 14px !important;
      padding: 0 !important;
    }

    #loop-services-section .loop-section-title,
    #loop-services-section .loop-section-copy {
      display: none !important;
    }

  }


  /* =========================================================
     ELEGANT CATEGORY SPREAD OVERRIDE
     Makes homepage categories breathe across the horizontal line.
     ========================================================= */

  #loop-services-section .loop-mobile-section-pad,
  #loop-services-section .loop-section-card > div:last-child {
    width: 100% !important;
  }

  #loop-services-section .loop-mobile-section-pad > div,
  #loop-services-section .loop-section-card > div:last-child > div {
    width: 100% !important;
  }

  #loop-services-section [class*="services"],
  #loop-services-section [class*="Services"],
  #loop-services-section [class*="category"],
  #loop-services-section [class*="Category"] {
    scroll-behavior: smooth !important;
  }

  @media (min-width: 900px) {
    #loop-services-section .loop-mobile-section-pad {
      display: flex !important;
      justify-content: center !important;
    }

    #loop-services-section .loop-mobile-section-pad > * {
      width: 100% !important;
    }

    #loop-services-section .loop-mobile-section-pad > * > *,
    #loop-services-section .loop-section-card > div:last-child > * > * {
      justify-content: space-between !important;
      gap: clamp(34px, 5vw, 86px) !important;
    }

    #loop-services-section button,
    #loop-services-section a,
    #loop-services-section [role="button"] {
      flex: 0 0 auto !important;
    }
  }

  @media (min-width: 1100px) {
    #loop-services-section .loop-mobile-section-pad > * > *,
    #loop-services-section .loop-section-card > div:last-child > * > * {
      padding-left: clamp(12px, 2vw, 34px) !important;
      padding-right: clamp(12px, 2vw, 34px) !important;
    }
  }

  @media (max-width: 899px) {
    #loop-services-section .loop-mobile-section-pad {
      overflow-x: auto !important;
      overflow-y: hidden !important;
      -webkit-overflow-scrolling: touch !important;
      scrollbar-width: none !important;
      padding-bottom: 4px !important;
    }

    #loop-services-section .loop-mobile-section-pad::-webkit-scrollbar {
      display: none !important;
    }

    #loop-services-section .loop-mobile-section-pad > * > *,
    #loop-services-section .loop-section-card > div:last-child > * > * {
      justify-content: flex-start !important;
      gap: 24px !important;
      min-width: max-content !important;
    }

    #loop-services-section button,
    #loop-services-section a,
    #loop-services-section [role="button"] {
      flex: 0 0 auto !important;
    }
  }




  /* =========================================================
     LOOP WEB HERO CAROUSEL — Early Access + Mobile App
     Web only; native app keeps original single early-access experience.
     ========================================================= */

  .loop-web-hero-carousel {
    max-width: 1500px !important;
    margin: 0 auto !important;
    padding: clamp(28px, 3.6vw, 48px) clamp(22px, 5vw, 72px) clamp(22px, 3vw, 38px) !important;
    border-bottom: 0 !important;
  }

  .loop-web-carousel-shell {
    position: relative !important;
    overflow: hidden !important;
    border-radius: 32px !important;
    background:
      radial-gradient(circle at 5% 0%, rgba(0,137,127,.08), transparent 30%),
      linear-gradient(135deg, rgba(240,253,250,.86), rgba(255,255,255,.96)) !important;
    border: 1px solid rgba(226,232,240,.92) !important;
    box-shadow: 0 24px 70px rgba(15,23,42,.075) !important;
  }

  .loop-web-carousel-track {
    display: flex !important;
    width: 100% !important;
    transition: transform 420ms cubic-bezier(.22,.9,.22,1) !important;
  }

  .loop-web-carousel-slide {
    min-width: 100% !important;
    display: grid !important;
    grid-template-columns: minmax(0, 1.05fr) minmax(280px, .7fr) !important;
    gap: clamp(24px, 4vw, 58px) !important;
    align-items: center !important;
    padding: clamp(28px, 4vw, 52px) clamp(28px, 5vw, 66px) !important;
    min-height: 360px !important;
  }

  .loop-web-carousel-slide.is-mobile-app {
    grid-template-columns: minmax(0, .9fr) minmax(310px, .88fr) !important;
  }

  .loop-web-hero-copy {
    min-width: 0 !important;
  }

  .loop-web-hero-copy .loop-eyebrow-minimal {
    margin-bottom: 18px !important;
  }

  .loop-web-hero-title {
    margin: 0 !important;
    color: #07111f !important;
    font-size: clamp(46px, 5.2vw, 78px) !important;
    line-height: .92 !important;
    letter-spacing: -.078em !important;
    font-weight: 950 !important;
    max-width: 720px !important;
    text-wrap: balance !important;
  }

  .loop-web-hero-subtitle {
    max-width: 610px !important;
    margin: 18px 0 0 !important;
    color: #667085 !important;
    font-size: clamp(16px, 1.12vw, 18px) !important;
    line-height: 1.5 !important;
    font-weight: 650 !important;
    letter-spacing: -.012em !important;
  }

  .loop-web-hero-actions {
    margin-top: 26px !important;
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 12px !important;
    align-items: center !important;
  }

  .loop-web-hero-visual {
    position: relative !important;
    min-height: 250px !important;
    display: grid !important;
    place-items: center !important;
  }

  .loop-panama-map {
    width: min(360px, 100%) !important;
    height: 230px !important;
    border-radius: 38px !important;
    background:
      radial-gradient(circle at 60% 32%, rgba(0,137,127,.16), transparent 28%),
      linear-gradient(135deg, rgba(0,103,95,.08), rgba(255,255,255,.18)) !important;
    position: relative !important;
    overflow: hidden !important;
  }

  .loop-panama-map::before {
    content: "" !important;
    position: absolute !important;
    inset: 64px 28px 42px !important;
    background: rgba(0,137,127,.14) !important;
    clip-path: polygon(3% 50%, 18% 42%, 31% 48%, 45% 32%, 58% 46%, 74% 39%, 92% 51%, 82% 67%, 63% 59%, 48% 72%, 33% 60%, 17% 66%) !important;
    filter: blur(.2px) !important;
  }

  .loop-panama-pin {
    position: absolute !important;
    right: 74px !important;
    top: 48px !important;
    width: 86px !important;
    height: 86px !important;
    border-radius: 999px 999px 999px 20px !important;
    transform: rotate(45deg) !important;
    background: linear-gradient(135deg, #00675f, #00a896) !important;
    box-shadow: 0 22px 44px rgba(0,103,95,.22) !important;
  }

  .loop-panama-pin::after {
    content: "" !important;
    position: absolute !important;
    width: 31px !important;
    height: 31px !important;
    border-radius: 999px !important;
    background: white !important;
    left: 27px !important;
    top: 27px !important;
    box-shadow: inset 0 0 0 10px rgba(0,137,127,.92) !important;
  }

  .loop-app-phones {
    position: relative !important;
    width: min(390px, 100%) !important;
    height: 292px !important;
  }

  .loop-app-phone {
    position: absolute !important;
    top: 8px !important;
    width: 142px !important;
    height: 272px !important;
    border-radius: 30px !important;
    background: #fff !important;
    border: 8px solid #111827 !important;
    box-shadow: 0 26px 56px rgba(15,23,42,.22) !important;
    overflow: hidden !important;
  }

  .loop-app-phone.one {
    left: 72px !important;
    transform: rotate(-6deg) !important;
    z-index: 2 !important;
  }

  .loop-app-phone.two {
    right: 48px !important;
    top: 26px !important;
    transform: rotate(7deg) scale(.92) !important;
    opacity: .92 !important;
    z-index: 1 !important;
  }

  .loop-phone-notch {
    width: 50px !important;
    height: 13px !important;
    border-radius: 999px !important;
    background: #111827 !important;
    margin: 7px auto 8px !important;
  }

  .loop-phone-ui {
    padding: 9px !important;
    display: grid !important;
    gap: 8px !important;
  }

  .loop-phone-greeting {
    color: #0f172a !important;
    font-size: 11px !important;
    font-weight: 950 !important;
  }

  .loop-phone-search {
    height: 24px !important;
    border-radius: 999px !important;
    background: #f8fafc !important;
    border: 1px solid #e2e8f0 !important;
  }

  .loop-phone-icons {
    display: grid !important;
    grid-template-columns: repeat(4, 1fr) !important;
    gap: 5px !important;
  }

  .loop-phone-icons span {
    height: 25px !important;
    border-radius: 10px !important;
    background: #ecfdf5 !important;
  }

  .loop-phone-card {
    height: 78px !important;
    border-radius: 16px !important;
    background:
      linear-gradient(135deg, rgba(0,137,127,.16), transparent),
      #f8fafc !important;
    border: 1px solid #e2e8f0 !important;
  }

  .loop-store-buttons {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 10px !important;
    margin-top: 24px !important;
  }

  .loop-store-button {
    min-height: 46px !important;
    border: 0 !important;
    border-radius: 12px !important;
    background: #0b1220 !important;
    color: #fff !important;
    padding: 0 14px !important;
    display: inline-flex !important;
    align-items: center !important;
    gap: 10px !important;
    font-weight: 950 !important;
    cursor: pointer !important;
    box-shadow: 0 14px 28px rgba(15,23,42,.18) !important;
  }

  .loop-store-button small {
    display: block !important;
    font-size: 9px !important;
    line-height: 1 !important;
    opacity: .78 !important;
    text-align: left !important;
  }

  .loop-store-button strong {
    display: block !important;
    font-size: 15px !important;
    line-height: 1.05 !important;
    text-align: left !important;
  }

  .loop-carousel-arrow {
    position: absolute !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    width: 44px !important;
    height: 44px !important;
    border-radius: 999px !important;
    border: 1px solid rgba(226,232,240,.92) !important;
    background: rgba(255,255,255,.88) !important;
    color: #0f172a !important;
    box-shadow: 0 14px 30px rgba(15,23,42,.10) !important;
    font-size: 26px !important;
    font-weight: 850 !important;
    cursor: pointer !important;
    z-index: 4 !important;
  }

  .loop-carousel-arrow.left {
    left: 14px !important;
  }

  .loop-carousel-arrow.right {
    right: 14px !important;
  }

  .loop-carousel-dots {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 10px !important;
    margin-top: 16px !important;
  }

  .loop-carousel-dot {
    width: 9px !important;
    height: 9px !important;
    border-radius: 999px !important;
    border: 0 !important;
    background: #cbd5e1 !important;
    padding: 0 !important;
    cursor: pointer !important;
  }

  .loop-carousel-dot.is-active {
    background: #00897f !important;
    box-shadow: 0 0 0 6px rgba(0,137,127,.10) !important;
  }

  .loop-primary-cta-minimal {
    min-height: 62px !important;
    padding: 0 34px !important;
    font-size: 16px !important;
  }

  .loop-hero-access-note {
    margin-top: 20px !important;
    padding: 14px 16px !important;
    border-radius: 20px !important;
    border: 1px solid rgba(0,103,95,.12) !important;
    background: rgba(255,255,255,.72) !important;
    box-shadow: 0 12px 28px rgba(15,23,42,.05) !important;
  }

  .loop-hero-access-copy {
    font-size: 13.5px !important;
  }

  .loop-hero-lock {
    width: 40px !important;
    height: 40px !important;
  }

  @media (max-width: 899px) {
    .loop-web-hero-carousel {
      padding: 18px 14px 22px !important;
    }

    .loop-web-carousel-shell {
      border-radius: 28px !important;
    }

    .loop-web-carousel-slide,
    .loop-web-carousel-slide.is-mobile-app {
      grid-template-columns: 1fr !important;
      min-height: auto !important;
      gap: 18px !important;
      padding: 24px 18px 26px !important;
    }

    .loop-web-hero-title {
      font-size: clamp(38px, 10.6vw, 54px) !important;
      line-height: .94 !important;
    }

    .loop-web-hero-subtitle {
      font-size: 15px !important;
      margin-top: 14px !important;
    }

    .loop-web-hero-visual {
      min-height: 190px !important;
      order: 2 !important;
    }

    .loop-panama-map {
      height: 180px !important;
    }

    .loop-app-phones {
      height: 220px !important;
    }

    .loop-app-phone {
      width: 112px !important;
      height: 212px !important;
      border-width: 6px !important;
      border-radius: 24px !important;
    }

    .loop-app-phone.one {
      left: calc(50% - 118px) !important;
    }

    .loop-app-phone.two {
      right: calc(50% - 118px) !important;
    }

    .loop-carousel-arrow {
      width: 38px !important;
      height: 38px !important;
      font-size: 22px !important;
    }

    .loop-carousel-arrow.left {
      left: 6px !important;
    }

    .loop-carousel-arrow.right {
      right: 6px !important;
    }

    .loop-store-button {
      flex: 1 1 145px !important;
      justify-content: center !important;
    }
  }


  /* =========================================================
     FINAL HERO CAROUSEL POLISH — Loop Premium Warm/Green
     Full-width card, no side arrows, no phone/map illustration.
     ========================================================= */

  .loop-web-hero-final {
    width: 100% !important;
    max-width: none !important;
    padding: 34px clamp(22px, 3vw, 42px) 22px !important;
    margin: 0 !important;
  }

  .loop-web-hero-final .loop-web-carousel-shell {
    width: 100% !important;
    max-width: none !important;
    margin: 0 auto !important;
    border-radius: 32px !important;
    overflow: hidden !important;
    background:
      radial-gradient(circle at 8% 12%, rgba(0, 137, 127, 0.085), transparent 32%),
      radial-gradient(circle at 94% 96%, rgba(0, 137, 127, 0.12), transparent 38%),
      linear-gradient(135deg, rgba(248, 253, 252, 0.96) 0%, rgba(255,255,255,0.98) 52%, rgba(235, 250, 247, 0.9) 100%) !important;
    border: 1px solid rgba(218, 229, 228, 0.9) !important;
    box-shadow: 0 24px 70px rgba(15, 23, 42, 0.07) !important;
  }

  .loop-web-hero-final .loop-web-carousel-slide {
    min-height: 392px !important;
    grid-template-columns: minmax(0, 0.95fr) minmax(380px, 0.78fr) !important;
    gap: clamp(34px, 5vw, 78px) !important;
    padding: clamp(42px, 5vw, 68px) clamp(42px, 6vw, 78px) !important;
    align-items: center !important;
  }

  .loop-web-hero-final .loop-web-hero-copy {
    max-width: 760px !important;
  }

  .loop-web-hero-final .loop-web-hero-title {
    font-size: clamp(56px, 5.4vw, 86px) !important;
    line-height: 0.9 !important;
    letter-spacing: -0.082em !important;
    max-width: 760px !important;
  }

  .loop-web-hero-final .loop-web-hero-subtitle {
    max-width: 620px !important;
    margin-top: 22px !important;
    font-size: clamp(17px, 1.15vw, 19px) !important;
    line-height: 1.48 !important;
    color: #667085 !important;
    font-weight: 700 !important;
  }

  .loop-web-hero-final .loop-web-hero-right-panel {
    display: grid !important;
    gap: 18px !important;
    align-content: center !important;
    justify-content: stretch !important;
    width: 100% !important;
    max-width: 650px !important;
    margin-left: auto !important;
    position: relative !important;
  }

  .loop-web-hero-final .loop-web-hero-right-panel::before {
    content: "" !important;
    position: absolute !important;
    left: -34px !important;
    top: 8% !important;
    bottom: 8% !important;
    width: 1px !important;
    background: linear-gradient(180deg, transparent, rgba(148,163,184,.34), transparent) !important;
  }

  .loop-premium-early-card {
    width: 100% !important;
    min-height: 138px !important;
    border: 0 !important;
    border-radius: 24px !important;
    padding: 24px 28px !important;
    cursor: pointer !important;
    display: grid !important;
    grid-template-columns: 54px minmax(0, 1fr) auto !important;
    gap: 18px !important;
    align-items: center !important;
    text-align: left !important;
    color: #ffffff !important;
    background:
      radial-gradient(circle at 8% 0%, rgba(255,255,255,.16), transparent 34%),
      linear-gradient(135deg, #005c55 0%, #007f74 55%, #008d81 100%) !important;
    box-shadow:
      0 22px 48px rgba(0, 103, 95, 0.22),
      inset 0 1px 0 rgba(255,255,255,.18) !important;
    transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease !important;
  }

  .loop-premium-early-card:hover {
    transform: translateY(-3px) !important;
    box-shadow:
      0 28px 58px rgba(0, 103, 95, 0.28),
      inset 0 1px 0 rgba(255,255,255,.22) !important;
    filter: saturate(1.04) !important;
  }

  .loop-premium-early-card:active {
    transform: translateY(0) scale(.99) !important;
  }

  .loop-premium-icon {
    width: 54px !important;
    height: 54px !important;
    border-radius: 16px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: rgba(255,255,255,.1) !important;
    border: 1px solid rgba(255,255,255,.18) !important;
    color: #ffffff !important;
  }

  .loop-premium-copy {
    min-width: 0 !important;
    display: grid !important;
    gap: 8px !important;
  }

  .loop-premium-copy strong {
    font-size: 20px !important;
    line-height: 1.1 !important;
    font-weight: 950 !important;
    letter-spacing: -0.035em !important;
    color: #ffffff !important;
  }

  .loop-premium-copy small {
    font-size: 14px !important;
    line-height: 1.45 !important;
    font-weight: 750 !important;
    color: rgba(255,255,255,.86) !important;
  }

  .loop-premium-arrow {
    font-size: 34px !important;
    line-height: 1 !important;
    color: #ffffff !important;
    transform: translateY(-1px) !important;
  }

  .loop-premium-access-card {
    min-height: 118px !important;
    border-radius: 24px !important;
    padding: 22px 24px !important;
    display: grid !important;
    grid-template-columns: 54px minmax(0, 1fr) !important;
    gap: 18px !important;
    align-items: center !important;
    background: rgba(255,255,255,.78) !important;
    border: 1px solid rgba(0,103,95,.12) !important;
    box-shadow:
      0 16px 40px rgba(15,23,42,.055),
      inset 0 1px 0 rgba(255,255,255,.9) !important;
    backdrop-filter: blur(16px) !important;
    -webkit-backdrop-filter: blur(16px) !important;
  }

  .loop-premium-lock {
    width: 54px !important;
    height: 54px !important;
    border-radius: 999px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: rgba(0,137,127,.10) !important;
    border: 1px solid rgba(0,103,95,.12) !important;
    color: #00675f !important;
  }

  .loop-premium-access-card strong {
    display: block !important;
    color: #0f172a !important;
    font-size: 17px !important;
    line-height: 1.25 !important;
    font-weight: 950 !important;
    letter-spacing: -.025em !important;
  }

  .loop-premium-access-card small {
    display: block !important;
    margin-top: 8px !important;
    color: #00675f !important;
    font-size: 14px !important;
    line-height: 1.25 !important;
    font-weight: 850 !important;
  }

  .loop-mobile-store-card {
    border-radius: 26px !important;
    padding: 26px !important;
    background: rgba(255,255,255,.78) !important;
    border: 1px solid rgba(0,103,95,.12) !important;
    box-shadow: 0 18px 46px rgba(15,23,42,.06) !important;
    display: grid !important;
    gap: 10px !important;
  }

  .loop-mobile-store-kicker {
    color: #00675f !important;
    font-size: 11px !important;
    font-weight: 950 !important;
    letter-spacing: .13em !important;
    text-transform: uppercase !important;
  }

  .loop-mobile-store-card > strong {
    color: #0f172a !important;
    font-size: 26px !important;
    line-height: 1.05 !important;
    letter-spacing: -.055em !important;
    font-weight: 950 !important;
  }

  .loop-mobile-store-card > small {
    color: #667085 !important;
    font-size: 14px !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
  }

  .loop-web-hero-final .loop-store-buttons {
    margin-top: 14px !important;
  }

  .loop-web-hero-final .loop-carousel-arrow,
  .loop-web-hero-final .loop-panama-map,
  .loop-web-hero-final .loop-app-phones,
  .loop-web-hero-final .loop-web-hero-visual {
    display: none !important;
  }

  .loop-web-hero-final .loop-carousel-dots {
    margin-top: 18px !important;
  }

  .loop-web-hero-final .loop-carousel-dot {
    width: 10px !important;
    height: 10px !important;
    border-radius: 999px !important;
    background: #cbd5e1 !important;
    transition: width .2s ease, background .2s ease, box-shadow .2s ease !important;
  }

  .loop-web-hero-final .loop-carousel-dot.is-active {
    width: 28px !important;
    background: #00897f !important;
    box-shadow: 0 0 0 5px rgba(0,137,127,.10) !important;
  }

  @media (max-width: 899px) {
    .loop-web-hero-final {
      padding: 18px 14px 18px !important;
    }

    .loop-web-hero-final .loop-web-carousel-shell {
      border-radius: 28px !important;
    }

    .loop-web-hero-final .loop-web-carousel-slide {
      grid-template-columns: 1fr !important;
      min-height: auto !important;
      gap: 24px !important;
      padding: 28px 20px 30px !important;
    }

    .loop-web-hero-final .loop-web-hero-title {
      font-size: clamp(40px, 11vw, 56px) !important;
      line-height: .94 !important;
    }

    .loop-web-hero-final .loop-web-hero-subtitle {
      font-size: 15px !important;
      margin-top: 16px !important;
    }

    .loop-web-hero-final .loop-web-hero-right-panel {
      max-width: none !important;
      margin-left: 0 !important;
      gap: 12px !important;
    }

    .loop-web-hero-final .loop-web-hero-right-panel::before {
      display: none !important;
    }

    .loop-premium-early-card,
    .loop-premium-access-card {
      min-height: auto !important;
      border-radius: 22px !important;
      padding: 18px !important;
    }

    .loop-premium-early-card {
      grid-template-columns: 46px minmax(0, 1fr) auto !important;
    }

    .loop-premium-access-card {
      grid-template-columns: 46px minmax(0, 1fr) !important;
    }

    .loop-premium-icon,
    .loop-premium-lock {
      width: 46px !important;
      height: 46px !important;
    }

    .loop-premium-copy strong {
      font-size: 17px !important;
    }

    .loop-premium-copy small,
    .loop-premium-access-card small {
      font-size: 13px !important;
    }

    .loop-premium-access-card strong {
      font-size: 15px !important;
    }
  }


  /* =========================================================
     LOOP MAIN MENU — CLEAN CATEGORY WRAPPER POLICY
     MainMenu must not own category carousel layout.
     ServicesTypeScroll owns desktop + mobile carousel.
     ========================================================= */

  #loop-services-section {
    overflow: visible !important;
  }

  #loop-services-section .loop-section-card {
    overflow: visible !important;
  }


  @media (max-width: 899px) {
    #loop-services-section {
      overflow: visible !important;
    }

    #loop-services-section .loop-section-card {
      overflow: visible !important;
    }

  }


  /* CATEGORY CAROUSEL SAFE WRAPPER — final clean policy */
  #loop-services-section,
  #loop-services-section .loop-section-card {
    overflow: visible !important;
  }

  #loop-services-section .loop-categories-visual-wrap {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    transform: none !important;
    touch-action: auto !important;
  }

  #loop-services-section .loop-categories-visual-wrap > .loop-category-carousel-v4-root {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    transform: none !important;
  }

  @media (max-width: 899px) {
    #loop-services-section .loop-categories-visual-wrap {
      overflow: visible !important;
    }
  }


  /* =========================================================
     LOOP MAIN MENU V2 — PREMIUM MARKETPLACE DIRECTION
     Appended last so it wins old experiments without changing logic.
     ========================================================= */

  :root {
    --loop-v2-page-max: 1560px;
    --loop-v2-side-pad: clamp(22px, 4.8vw, 72px);
    --loop-v2-teal: #00675f;
    --loop-v2-teal-2: #00897f;
    --loop-v2-ink: #07111f;
    --loop-v2-muted: #667085;
    --loop-v2-line: rgba(203, 213, 225, .56);
    --loop-v2-shadow: 0 26px 80px rgba(15, 23, 42, .075);
  }

  .loop-pro-shell {
    background:
      radial-gradient(circle at 8% 6%, rgba(0,137,127,.08), transparent 28%),
      radial-gradient(circle at 96% 18%, rgba(0,103,95,.06), transparent 34%),
      linear-gradient(180deg, #ffffff 0%, #fbfdfd 48%, #ffffff 100%) !important;
  }

  /* HERO becomes a premium lifestyle card */
  .loop-web-hero-carousel.loop-web-hero-final {
    max-width: var(--loop-v2-page-max) !important;
    margin: 28px auto 0 !important;
    padding: 0 var(--loop-v2-side-pad) !important;
  }

  .loop-web-carousel-shell {
    border-radius: 34px !important;
    overflow: hidden !important;
    min-height: clamp(330px, 29vw, 430px) !important;
    border: 1px solid rgba(0,103,95,.12) !important;
    box-shadow: var(--loop-v2-shadow) !important;
    background:
      linear-gradient(90deg, rgba(246,253,251,.98) 0%, rgba(246,253,251,.88) 39%, rgba(246,253,251,.60) 64%, rgba(246,253,251,.28) 100%),
      url("/loop-hero-bg.svg") center right / cover no-repeat,
      linear-gradient(135deg, #eefbf8 0%, #ffffff 50%, #dff7f2 100%) !important;
    position: relative !important;
  }

  .loop-web-carousel-shell::after {
    content: "" !important;
    position: absolute !important;
    inset: 0 !important;
    pointer-events: none !important;
    background:
      radial-gradient(circle at 18% 10%, rgba(0,137,127,.09), transparent 32%),
      linear-gradient(180deg, rgba(255,255,255,0) 60%, rgba(255,255,255,.20) 100%) !important;
  }

  .loop-web-carousel-track {
    height: 100% !important;
    min-height: inherit !important;
    position: relative !important;
    z-index: 1 !important;
  }

  .loop-web-carousel-slide {
    min-height: clamp(330px, 29vw, 430px) !important;
    padding: clamp(44px, 5vw, 74px) clamp(42px, 5vw, 88px) !important;
    box-sizing: border-box !important;
    display: grid !important;
    grid-template-columns: minmax(0, .95fr) minmax(340px, .62fr) !important;
    align-items: center !important;
    gap: clamp(34px, 5vw, 80px) !important;
  }

  .loop-web-hero-copy {
    max-width: 680px !important;
  }

  .loop-web-hero-title {
    color: var(--loop-v2-ink) !important;
    font-size: clamp(56px, 5vw, 86px) !important;
    line-height: .9 !important;
    letter-spacing: -.086em !important;
    font-weight: 950 !important;
    margin: 0 !important;
    text-wrap: balance !important;
  }

  .loop-web-hero-subtitle {
    max-width: 560px !important;
    margin-top: 20px !important;
    color: var(--loop-v2-muted) !important;
    font-size: clamp(16px, 1.12vw, 19px) !important;
    line-height: 1.52 !important;
    font-weight: 700 !important;
  }

  .loop-web-hero-right-panel {
    justify-self: end !important;
    width: min(100%, 430px) !important;
    display: grid !important;
    gap: 18px !important;
  }

  .loop-premium-early-card {
    min-height: 90px !important;
    border-radius: 24px !important;
    padding: 20px 22px !important;
    background:
      radial-gradient(circle at 20% 0%, rgba(255,255,255,.20), transparent 36%),
      linear-gradient(135deg, #00675f 0%, #00897f 100%) !important;
    color: #ffffff !important;
    border: 0 !important;
    box-shadow: 0 24px 58px rgba(0,103,95,.23) !important;
  }

  .loop-premium-access-card {
    min-height: 92px !important;
    border-radius: 24px !important;
    padding: 20px 22px !important;
    background: rgba(255,255,255,.76) !important;
    border: 1px solid rgba(226,232,240,.86) !important;
    box-shadow: 0 18px 44px rgba(15,23,42,.07) !important;
    backdrop-filter: blur(16px) !important;
    -webkit-backdrop-filter: blur(16px) !important;
  }

  .loop-carousel-dots {
    margin: 16px auto 0 !important;
  }

  /* Categories closer to hero, centered, more premium */
  #loop-services-section {
    max-width: var(--loop-v2-page-max) !important;
    padding: 34px var(--loop-v2-side-pad) 44px !important;
  }

  #loop-services-section::before,
  #loop-services-section::after {
    display: none !important;
  }

  #loop-services-section .loop-section-head {
    justify-content: center !important;
    text-align: center !important;
    margin-bottom: 28px !important;
  }

  #loop-services-section .loop-section-kicker {
    text-align: center !important;
    margin-left: auto !important;
    margin-right: auto !important;
    color: var(--loop-v2-teal-2) !important;
  }

  #loop-services-section .loop-categories-visual-wrap {
    max-width: 900px !important;
    margin: 0 auto !important;
  }

  #loop-services-section .loop-category-carousel-v4 {
    justify-content: center !important;
    gap: clamp(26px, 4vw, 58px) !important;
    padding: 0 !important;
  }

  #loop-services-section .loop-category-carousel-v4-card {
    width: 138px !important;
    min-width: 138px !important;
    max-width: 138px !important;
    min-height: 146px !important;
    padding: 8px 8px 10px !important;
  }

  #loop-services-section .loop-category-carousel-v4-image {
    width: 100px !important;
    height: 100px !important;
    min-width: 100px !important;
    min-height: 100px !important;
    max-width: 100px !important;
    max-height: 100px !important;
    border-radius: 24px !important;
    background:
      radial-gradient(circle at 24% 16%, rgba(255,255,255,.72), transparent 42%),
      linear-gradient(135deg, rgba(224,242,241,.96), rgba(208,235,232,.92)) !important;
    box-shadow: 0 18px 34px rgba(15, 23, 42, .07) !important;
  }

  #loop-services-section .loop-category-carousel-v4-label {
    font-size: 12px !important;
    line-height: 1.18 !important;
    font-weight: 950 !important;
  }

  /* Marketplace sections feel more editorial */
  .loop-section:not(#loop-services-section) {
    max-width: var(--loop-v2-page-max) !important;
    padding: 42px var(--loop-v2-side-pad) 54px !important;
  }

  .loop-section:not(#loop-services-section)::before {
    left: var(--loop-v2-side-pad) !important;
    right: var(--loop-v2-side-pad) !important;
    width: auto !important;
    opacity: .75 !important;
  }

  .loop-section-head {
    margin-bottom: 28px !important;
  }

  .loop-section-title {
    font-size: clamp(36px, 3.1vw, 54px) !important;
    line-height: .97 !important;
    letter-spacing: -.075em !important;
  }

  .loop-section-copy {
    font-size: 15.5px !important;
    color: var(--loop-v2-muted) !important;
  }

  /* Web business rails become more visual and less tiny */
  @media (min-width: 900px) {
    .loop-section:not(#loop-services-section) [aria-label*="Negocios"] > *,
    .loop-section:not(#loop-services-section) [aria-label*="favoritos"] > * {
      scroll-padding-left: 4px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-web-hero-carousel.loop-web-hero-final {
      margin-top: 0 !important;
      padding: 0 !important;
    }

    .loop-web-carousel-shell {
      border-radius: 0 0 28px 28px !important;
      min-height: auto !important;
      border-left: 0 !important;
      border-right: 0 !important;
      background:
        linear-gradient(180deg, rgba(246,253,251,.98), rgba(246,253,251,.92)),
        url("/loop-hero-bg.svg") center right / cover no-repeat !important;
      box-shadow: 0 18px 45px rgba(15,23,42,.06) !important;
    }

    .loop-web-carousel-slide {
      display: block !important;
      min-height: auto !important;
      padding: 24px 18px 28px !important;
    }

    .loop-web-hero-title {
      font-size: clamp(40px, 11vw, 54px) !important;
      line-height: .93 !important;
    }

    .loop-web-hero-subtitle {
      margin-top: 14px !important;
      font-size: 14.5px !important;
    }

    .loop-web-hero-right-panel {
      width: 100% !important;
      margin-top: 22px !important;
    }

    .loop-premium-early-card {
      min-height: 74px !important;
      border-radius: 22px !important;
      padding: 16px !important;
    }

    .loop-premium-access-card {
      min-height: 74px !important;
      border-radius: 22px !important;
      padding: 16px !important;
    }

    #loop-services-section {
      padding: 30px 14px 30px !important;
    }

    #loop-services-section .loop-section-head {
      justify-content: flex-start !important;
      text-align: left !important;
      margin-bottom: 20px !important;
      padding-left: 4px !important;
    }

    #loop-services-section .loop-section-kicker {
      text-align: left !important;
      margin-left: 0 !important;
    }

    #loop-services-section .loop-categories-visual-wrap {
      max-width: 100% !important;
      margin: 0 !important;
    }

    .loop-section:not(#loop-services-section) {
      padding: 32px 18px 38px !important;
    }
  }


  /* =========================================================
     LOOP MAIN MENU V2.2 — LUXURY WELLNESS / PREMIUM STARTUP
     Final layer: more editorial hero, cleaner spacing, cinematic marketplace.
     ========================================================= */

  :root {
    --loop-lux-max: 1580px;
    --loop-lux-pad: clamp(26px, 4.8vw, 76px);
    --loop-lux-ink: #07111f;
    --loop-lux-muted: #667085;
    --loop-lux-teal: #00675f;
    --loop-lux-teal2: #00897f;
    --loop-lux-shadow: 0 30px 90px rgba(15, 23, 42, .085);
  }

  .loop-pro-shell {
    background:
      radial-gradient(circle at 10% 4%, rgba(0,137,127,.055), transparent 28%),
      radial-gradient(circle at 96% 18%, rgba(0,103,95,.045), transparent 34%),
      linear-gradient(180deg, #fffdfa 0%, #fbfdfc 42%, #ffffff 100%) !important;
  }

  .loop-web-hero-carousel.loop-web-hero-final {
    max-width: var(--loop-lux-max) !important;
    margin: 24px auto 0 !important;
    padding: 0 var(--loop-lux-pad) !important;
  }

  .loop-web-carousel-shell {
    min-height: clamp(360px, 30vw, 468px) !important;
    border-radius: 34px !important;
    border: 1px solid rgba(0,103,95,.12) !important;
    box-shadow: var(--loop-lux-shadow) !important;
    background:
      linear-gradient(90deg, rgba(251,255,253,.98) 0%, rgba(251,255,253,.88) 36%, rgba(251,255,253,.58) 58%, rgba(251,255,253,.24) 100%),
      url("/loop-hero-luxury-wellness.svg") center right / cover no-repeat,
      linear-gradient(135deg, #f4fbf8 0%, #ffffff 52%, #e4f6f1 100%) !important;
  }

  .loop-web-carousel-slide {
    min-height: clamp(360px, 30vw, 468px) !important;
    padding: clamp(48px, 5vw, 82px) clamp(46px, 5.4vw, 96px) !important;
    grid-template-columns: minmax(0, .88fr) minmax(360px, .64fr) !important;
    gap: clamp(42px, 6vw, 96px) !important;
  }

  .loop-web-hero-title {
    max-width: 680px !important;
    font-size: clamp(58px, 5.3vw, 88px) !important;
    line-height: .89 !important;
    letter-spacing: -.088em !important;
  }

  .loop-web-hero-subtitle {
    max-width: 550px !important;
    margin-top: 20px !important;
    font-size: clamp(16px, 1.08vw, 18.5px) !important;
    line-height: 1.54 !important;
    font-weight: 680 !important;
  }

  .loop-web-hero-copy::after {
    content: "Únete a los primeros en transformar tu experiencia." !important;
    display: inline-flex !important;
    margin-top: 24px !important;
    padding-left: 82px !important;
    min-height: 34px !important;
    align-items: center !important;
    color: #667085 !important;
    font-size: 13.5px !important;
    font-weight: 700 !important;
    background:
      radial-gradient(circle at 13px 50%, #ffffff 0 12px, transparent 13px),
      radial-gradient(circle at 31px 50%, #f1d7ce 0 12px, transparent 13px),
      radial-gradient(circle at 49px 50%, #d8eee9 0 12px, transparent 13px),
      radial-gradient(circle at 67px 50%, #ffffff 0 12px, transparent 13px) !important;
  }

  .loop-web-hero-right-panel {
    width: min(100%, 430px) !important;
    transform: translateY(2px) !important;
  }

  .loop-premium-early-card,
  .loop-premium-access-card {
    border-radius: 24px !important;
  }

  .loop-premium-early-card {
    min-height: 88px !important;
    box-shadow: 0 26px 62px rgba(0,103,95,.24) !important;
  }

  .loop-premium-access-card {
    background: rgba(255,255,255,.78) !important;
    box-shadow: 0 20px 54px rgba(15,23,42,.075) !important;
  }

  .loop-carousel-dots {
    margin-top: 14px !important;
  }

  #loop-services-section {
    padding-top: 34px !important;
    padding-bottom: 44px !important;
  }

  #loop-services-section .loop-section-head {
    justify-content: center !important;
    text-align: center !important;
    margin-bottom: 30px !important;
  }

  #loop-services-section .loop-section-kicker {
    font-size: 12px !important;
    letter-spacing: .18em !important;
  }

  #loop-services-section .loop-categories-visual-wrap {
    max-width: 970px !important;
  }

  #loop-services-section .loop-category-carousel-v4 {
    gap: clamp(30px, 4.3vw, 66px) !important;
  }

  #loop-services-section .loop-category-carousel-v4-image {
    width: 112px !important;
    height: 112px !important;
    min-width: 112px !important;
    min-height: 112px !important;
    max-width: 112px !important;
    max-height: 112px !important;
    border-radius: 26px !important;
  }

  #loop-services-section .loop-category-carousel-v4-img {
    max-width: 112px !important;
    max-height: 112px !important;
  }

  .loop-section:not(#loop-services-section) {
    max-width: var(--loop-lux-max) !important;
    padding: 46px var(--loop-lux-pad) 60px !important;
  }

  .loop-section-title {
    font-size: clamp(38px, 3.2vw, 56px) !important;
    letter-spacing: -.08em !important;
  }

  .loop-section-copy {
    color: var(--loop-lux-muted) !important;
    font-weight: 700 !important;
  }

  .loop-show-more-btn {
    color: var(--loop-lux-teal) !important;
    border: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  @media (min-width: 900px) {
    .loop-section:not(#loop-services-section) .loop-section-head {
      margin-bottom: 30px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-web-hero-carousel.loop-web-hero-final {
      margin-top: 0 !important;
      padding: 0 !important;
    }

    .loop-web-carousel-shell {
      border-radius: 0 0 30px 30px !important;
      min-height: auto !important;
      background:
        linear-gradient(180deg, rgba(251,255,253,.99), rgba(251,255,253,.92)),
        url("/loop-hero-luxury-wellness.svg") center right / cover no-repeat !important;
    }

    .loop-web-carousel-slide {
      display: block !important;
      min-height: auto !important;
      padding: 24px 18px 28px !important;
    }

    .loop-web-hero-copy::after {
      margin-top: 16px !important;
      padding-left: 0 !important;
      background: none !important;
      font-size: 13px !important;
    }

    .loop-web-hero-title {
      font-size: clamp(40px, 11vw, 54px) !important;
    }

    .loop-web-hero-right-panel {
      margin-top: 20px !important;
      width: 100% !important;
    }

    #loop-services-section {
      padding: 28px 14px 30px !important;
    }

    #loop-services-section .loop-section-head {
      justify-content: flex-start !important;
      text-align: left !important;
      margin-bottom: 20px !important;
    }

    #loop-services-section .loop-section-kicker {
      text-align: left !important;
      margin-left: 0 !important;
    }

    #loop-services-section .loop-categories-visual-wrap {
      max-width: 100% !important;
    }

    .loop-section:not(#loop-services-section) {
      padding: 32px 18px 42px !important;
    }
  }


  /* =========================================================
     LOOP MAIN MENU V2.1 — FIXED LAUNCH HERO + TIGHTER LUXURY FOLD
     ========================================================= */

  .loop-web-carousel-track {
    transform: translateX(0%) !important;
  }

  .loop-web-carousel-slide.loop-web-slide-mobile {
    display: none !important;
  }

  .loop-carousel-dots {
    display: none !important;
  }

  .loop-web-hero-carousel.loop-web-hero-final {
    margin-top: 20px !important;
  }

  .loop-web-carousel-shell {
    min-height: clamp(330px, 27vw, 430px) !important;
    background:
      linear-gradient(90deg, rgba(251,255,253,.98) 0%, rgba(251,255,253,.84) 34%, rgba(251,255,253,.52) 55%, rgba(251,255,253,.16) 100%),
      url("/loop-hero-luxury-wellness.svg") center right / cover no-repeat,
      linear-gradient(135deg, #f4fbf8 0%, #ffffff 52%, #e4f6f1 100%) !important;
  }

  .loop-web-carousel-slide {
    min-height: clamp(330px, 27vw, 430px) !important;
    padding: clamp(38px, 4.4vw, 66px) clamp(44px, 5.2vw, 90px) !important;
  }

  .loop-web-hero-title {
    font-size: clamp(54px, 4.75vw, 80px) !important;
  }

  .loop-web-hero-subtitle {
    margin-top: 18px !important;
  }

  .loop-web-hero-copy::after {
    margin-top: 20px !important;
  }

  .loop-web-hero-right-panel {
    transform: translateY(0) !important;
  }

  .loop-premium-early-card {
    min-height: 82px !important;
  }

  .loop-premium-access-card {
    min-height: 82px !important;
  }

  #loop-services-section {
    padding-top: 24px !important;
    padding-bottom: 34px !important;
  }

  #loop-services-section .loop-section-head {
    margin-bottom: 22px !important;
  }

  #loop-services-section .loop-category-carousel-v4-image {
    width: 104px !important;
    height: 104px !important;
    min-width: 104px !important;
    min-height: 104px !important;
    max-width: 104px !important;
    max-height: 104px !important;
  }

  #loop-services-section .loop-category-carousel-v4-img {
    max-width: 104px !important;
    max-height: 104px !important;
  }

  .loop-section:not(#loop-services-section) {
    padding-top: 38px !important;
  }

  @media (min-width: 900px) {
    .loop-section:not(#loop-services-section) .loop-section-head {
      margin-bottom: 24px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-web-carousel-shell {
      background:
        linear-gradient(180deg, rgba(251,255,253,.99), rgba(251,255,253,.91)),
        url("/loop-hero-luxury-wellness.svg") center right / cover no-repeat !important;
    }

    .loop-web-carousel-slide {
      padding: 22px 18px 24px !important;
    }

    #loop-services-section {
      padding-top: 22px !important;
    }
  }

  /* =========================================================
     LOOP PHASE 3 — CALM LUXURY CURATED MARKETPLACE
     Direction: 75% calm luxury, 25% premium social energy.
     ========================================================= */

  :root {
    --loop-calm-max: 1640px;
    --loop-calm-pad: clamp(28px, 5vw, 84px);
    --loop-calm-ink: #07111f;
    --loop-calm-muted: #687385;
    --loop-calm-teal: #00675f;
    --loop-calm-teal2: #00897f;
    --loop-calm-warm: #f7f1e8;
    --loop-calm-line: rgba(197, 184, 162, .28);
  }

  .loop-pro-shell {
    background:
      radial-gradient(circle at 11% 5%, rgba(0,103,95,.055), transparent 28%),
      radial-gradient(circle at 91% 15%, rgba(189,161,125,.105), transparent 34%),
      linear-gradient(180deg, #fffdfa 0%, #fbf8f2 33%, #ffffff 68%) !important;
  }

  .loop-pro-main { background: transparent !important; }

  .loop-web-hero-carousel.loop-web-hero-final {
    max-width: var(--loop-calm-max) !important;
    margin: 24px auto 0 !important;
    padding: 0 var(--loop-calm-pad) !important;
  }

  .loop-web-carousel-track { transform: translateX(0%) !important; }
  .loop-web-carousel-slide.loop-web-slide-mobile { display: none !important; }
  .loop-carousel-dots { display: none !important; }

  .loop-web-carousel-shell {
    min-height: clamp(410px, 34vw, 540px) !important;
    border-radius: 34px !important;
    border: 1px solid rgba(120, 100, 72, .16) !important;
    box-shadow: 0 34px 100px rgba(64, 51, 36, .115) !important;
    background:
      linear-gradient(90deg, rgba(255,253,249,.98) 0%, rgba(255,253,249,.92) 32%, rgba(255,253,249,.58) 54%, rgba(255,253,249,.16) 100%),
      url("/loop-calm-luxury-hero.svg") center right / cover no-repeat,
      linear-gradient(135deg, #f6efe5 0%, #fffdfa 48%, #e5f4ef 100%) !important;
  }

  .loop-web-carousel-shell::before {
    content: "" !important;
    position: absolute !important;
    inset: 0 !important;
    background:
      radial-gradient(circle at 14% 24%, rgba(0,137,127,.09), transparent 26%),
      linear-gradient(180deg, rgba(255,255,255,0), rgba(255,255,255,.13)) !important;
    pointer-events: none !important;
    z-index: 0 !important;
  }

  .loop-web-carousel-track {
    position: relative !important;
    z-index: 1 !important;
  }

  .loop-web-carousel-slide {
    min-height: clamp(410px, 34vw, 540px) !important;
    padding: clamp(56px, 6vw, 96px) clamp(50px, 6vw, 112px) !important;
    grid-template-columns: minmax(0, .9fr) minmax(350px, .62fr) !important;
    gap: clamp(42px, 6vw, 96px) !important;
  }

  .loop-web-hero-title {
    max-width: 680px !important;
    color: var(--loop-calm-ink) !important;
    font-size: clamp(58px, 5.15vw, 88px) !important;
    line-height: .9 !important;
    letter-spacing: -.087em !important;
  }

  .loop-web-hero-subtitle {
    max-width: 560px !important;
    margin-top: 20px !important;
    color: #5f6b7d !important;
    font-size: clamp(16px, 1.08vw, 18.5px) !important;
    line-height: 1.56 !important;
    font-weight: 700 !important;
  }

  .loop-web-hero-copy::after {
    content: "Curamos negocios modernos para que reserves con confianza." !important;
    display: inline-flex !important;
    align-items: center !important;
    margin-top: 24px !important;
    padding: 9px 14px 9px 42px !important;
    border-radius: 999px !important;
    color: #5f6b7d !important;
    font-size: 13.5px !important;
    font-weight: 750 !important;
    background:
      radial-gradient(circle at 18px 50%, #00675f 0 4px, rgba(0,103,95,.10) 5px 11px, transparent 12px),
      rgba(255,255,255,.60) !important;
    border: 1px solid rgba(226,232,240,.64) !important;
    box-shadow: 0 14px 34px rgba(64,51,36,.055) !important;
    backdrop-filter: blur(12px) !important;
  }

  .loop-web-hero-carousel.loop-web-hero-final::before {
    content: "Disponible en iOS & Android";
    display: inline-flex;
    align-items: center;
    gap: 8px;
    position: absolute;
    z-index: 3;
    margin-left: calc(var(--loop-calm-pad) + 18px);
    margin-top: 18px;
    padding: 7px 12px;
    border-radius: 999px;
    color: #00675f;
    background: rgba(255,255,255,.72);
    border: 1px solid rgba(0,103,95,.12);
    box-shadow: 0 14px 34px rgba(64,51,36,.06);
    font-size: 11px;
    font-weight: 950;
    letter-spacing: .11em;
    text-transform: uppercase;
    backdrop-filter: blur(12px);
  }

  .loop-premium-early-card {
    min-height: 86px !important;
    border-radius: 24px !important;
    background:
      radial-gradient(circle at 20% 0%, rgba(255,255,255,.24), transparent 35%),
      linear-gradient(135deg, #00675f 0%, #00897f 100%) !important;
    box-shadow: 0 28px 68px rgba(0,103,95,.22) !important;
  }

  .loop-premium-access-card {
    min-height: 84px !important;
    border-radius: 24px !important;
    background: rgba(255,255,255,.74) !important;
    border: 1px solid rgba(255,255,255,.80) !important;
    box-shadow: 0 22px 56px rgba(64,51,36,.09) !important;
  }

  #loop-services-section {
    max-width: var(--loop-calm-max) !important;
    padding: 36px var(--loop-calm-pad) 48px !important;
    border-top: 0 !important;
  }

  #loop-services-section .loop-section-head {
    justify-content: center !important;
    text-align: center !important;
    margin-bottom: 28px !important;
  }

  #loop-services-section .loop-section-kicker {
    color: var(--loop-calm-teal) !important;
    font-size: 12px !important;
    letter-spacing: .18em !important;
  }

  #loop-services-section .loop-categories-visual-wrap {
    max-width: 990px !important;
    margin: 0 auto !important;
  }

  #loop-services-section .loop-category-carousel-v4 {
    justify-content: center !important;
    gap: clamp(30px, 4.2vw, 68px) !important;
  }

  #loop-services-section .loop-category-carousel-v4-image {
    width: 110px !important;
    height: 110px !important;
    min-width: 110px !important;
    min-height: 110px !important;
    max-width: 110px !important;
    max-height: 110px !important;
    border-radius: 28px !important;
    background:
      radial-gradient(circle at 28% 18%, rgba(255,255,255,.76), transparent 42%),
      linear-gradient(135deg, #eef7f3 0%, #d9ebe5 100%) !important;
    box-shadow: 0 20px 44px rgba(64,51,36,.085) !important;
  }

  .loop-section:not(#loop-services-section) {
    max-width: var(--loop-calm-max) !important;
    padding: 50px var(--loop-calm-pad) 66px !important;
    border-top: 1px solid var(--loop-calm-line) !important;
  }

  .loop-section-title {
    font-size: clamp(40px, 3.25vw, 58px) !important;
    line-height: .96 !important;
    letter-spacing: -.082em !important;
  }

  .loop-section-copy {
    color: #667085 !important;
    font-size: 15.5px !important;
    font-weight: 720 !important;
  }

  @media (max-width: 899px) {
    .loop-web-hero-carousel.loop-web-hero-final {
      margin-top: 0 !important;
      padding: 0 !important;
    }

    .loop-web-hero-carousel.loop-web-hero-final::before {
      position: relative !important;
      margin: 14px 18px -2px !important;
    }

    .loop-web-carousel-shell {
      border-radius: 0 0 30px 30px !important;
      min-height: auto !important;
      background:
        linear-gradient(180deg, rgba(255,253,249,.99), rgba(255,253,249,.92)),
        url("/loop-calm-luxury-hero.svg") center right / cover no-repeat !important;
    }

    .loop-web-carousel-slide {
      display: block !important;
      min-height: auto !important;
      padding: 26px 18px 28px !important;
    }

    .loop-web-hero-copy::after {
      margin-top: 16px !important;
      padding-left: 38px !important;
      font-size: 12px !important;
    }

    .loop-web-hero-title {
      font-size: clamp(40px, 11vw, 56px) !important;
    }

    .loop-web-hero-right-panel {
      width: 100% !important;
      margin-top: 22px !important;
    }

    #loop-services-section {
      padding: 30px 14px 34px !important;
    }

    .loop-section:not(#loop-services-section) {
      padding: 34px 18px 46px !important;
    }
  }

  /* =========================================================
     LOOP PHASE 3A — SOHO HOUSE LUXURY REDESIGN
     Radical visual layer: warm luxury, minimal clean, curated.
     ========================================================= */

  :root {
    --loop-soho-max: 1680px;
    --loop-soho-pad: clamp(30px, 5.2vw, 92px);
    --loop-soho-ivory: #fffaf2;
    --loop-soho-sand: #efe2d0;
    --loop-soho-charcoal: #14110d;
    --loop-soho-teal: #00675f;
    --loop-soho-line: rgba(112, 93, 66, .18);
  }

  body:not(.is-mobile-app) .mainmenu-root {
    background:
      radial-gradient(circle at 14% 3%, rgba(0,103,95,.055), transparent 26%),
      radial-gradient(circle at 90% 12%, rgba(178,142,94,.16), transparent 36%),
      linear-gradient(180deg, #fffaf2 0%, #f7efe3 34%, #fffdf8 72%, #ffffff 100%) !important;
  }

  .loop-pro-shell, .loop-pro-main { background: transparent !important; }

  .loop-web-hero-carousel.loop-web-hero-final {
    max-width: var(--loop-soho-max) !important;
    margin: 30px auto 0 !important;
    padding: 0 var(--loop-soho-pad) !important;
    position: relative !important;
  }

  .loop-web-carousel-track { transform: translateX(0%) !important; }
  .loop-web-carousel-slide.loop-web-slide-mobile, .loop-carousel-dots { display: none !important; }

  .loop-web-hero-carousel.loop-web-hero-final::before {
    content: "Disponible en iOS & Android";
    position: absolute !important;
    z-index: 5 !important;
    top: 24px !important;
    left: calc(var(--loop-soho-pad) + 24px) !important;
    display: inline-flex !important;
    padding: 8px 13px !important;
    border-radius: 999px !important;
    color: #2e4f43 !important;
    background: rgba(255,250,242,.76) !important;
    border: 1px solid rgba(112,93,66,.16) !important;
    box-shadow: 0 18px 44px rgba(48,37,24,.09) !important;
    font-size: 11px !important;
    font-weight: 950 !important;
    letter-spacing: .12em !important;
    text-transform: uppercase !important;
    backdrop-filter: blur(14px) !important;
  }

  .loop-web-carousel-shell {
    min-height: clamp(500px, 41vw, 650px) !important;
    border-radius: 42px !important;
    border: 1px solid rgba(112,93,66,.18) !important;
    box-shadow: 0 42px 110px rgba(48,37,24,.16) !important;
    background:
      linear-gradient(90deg, rgba(255,250,242,.98) 0%, rgba(255,250,242,.92) 30%, rgba(255,250,242,.50) 52%, rgba(255,250,242,.10) 100%),
      url("/loop-soho-luxury-hero.svg") center right / cover no-repeat,
      linear-gradient(135deg, #f3e6d5 0%, #fffaf2 48%, #dcebe3 100%) !important;
  }

  .loop-web-carousel-slide {
    min-height: clamp(500px, 41vw, 650px) !important;
    padding: clamp(88px, 7vw, 126px) clamp(56px, 6.8vw, 126px) clamp(58px, 5vw, 88px) !important;
    grid-template-columns: minmax(0, .74fr) minmax(350px, .54fr) !important;
    gap: clamp(42px, 7vw, 120px) !important;
  }

  .loop-web-hero-title {
    max-width: 660px !important;
    color: var(--loop-soho-charcoal) !important;
    font-size: clamp(66px, 5.8vw, 104px) !important;
    line-height: .86 !important;
    letter-spacing: -.095em !important;
  }

  .loop-web-hero-subtitle {
    max-width: 520px !important;
    margin-top: 28px !important;
    color: #645849 !important;
    font-size: clamp(17px, 1.12vw, 19px) !important;
    line-height: 1.62 !important;
    font-weight: 620 !important;
  }

  .loop-web-hero-copy::after {
    content: "Una selección curada de experiencias modernas para reservar con confianza." !important;
    display: inline-flex !important;
    max-width: 455px !important;
    margin-top: 30px !important;
    padding: 12px 16px 12px 44px !important;
    border-radius: 999px !important;
    color: #5f5345 !important;
    background:
      radial-gradient(circle at 19px 50%, #00675f 0 4px, rgba(0,103,95,.12) 5px 12px, transparent 13px),
      rgba(255,250,242,.68) !important;
    border: 1px solid rgba(112,93,66,.16) !important;
    box-shadow: 0 18px 44px rgba(48,37,24,.07) !important;
    font-size: 13px !important;
    font-weight: 740 !important;
    backdrop-filter: blur(14px) !important;
  }

  .loop-premium-early-card {
    min-height: 88px !important;
    border-radius: 26px !important;
    background: linear-gradient(135deg, #1f4c42 0%, #00675f 100%) !important;
    box-shadow: 0 30px 76px rgba(31,76,66,.28) !important;
  }

  .loop-premium-access-card {
    min-height: 88px !important;
    border-radius: 26px !important;
    background: rgba(255,250,242,.76) !important;
    border: 1px solid rgba(255,255,255,.72) !important;
    box-shadow: 0 24px 64px rgba(48,37,24,.12) !important;
  }

  #loop-services-section {
    max-width: var(--loop-soho-max) !important;
    padding: 42px var(--loop-soho-pad) 58px !important;
    border-top: 0 !important;
  }

  #loop-services-section .loop-section-head {
    justify-content: center !important;
    text-align: center !important;
    margin-bottom: 34px !important;
  }

  #loop-services-section .loop-section-kicker {
    color: #6e604f !important;
    font-size: 11px !important;
    letter-spacing: .22em !important;
  }

  #loop-services-section .loop-category-carousel-v4-card {
    width: 154px !important;
    min-width: 154px !important;
    max-width: 154px !important;
    min-height: 176px !important;
    padding: 12px 10px 14px !important;
    border-radius: 32px !important;
    background: rgba(255,250,242,.56) !important;
    border: 1px solid rgba(112,93,66,.14) !important;
    box-shadow: 0 18px 54px rgba(48,37,24,.08) !important;
    backdrop-filter: blur(14px) !important;
  }

  #loop-services-section .loop-category-carousel-v4-image {
    width: 112px !important;
    height: 112px !important;
    min-width: 112px !important;
    min-height: 112px !important;
    max-width: 112px !important;
    max-height: 112px !important;
    border-radius: 30px !important;
    background: linear-gradient(135deg, #f7efe3 0%, #dcebe3 100%) !important;
    box-shadow: none !important;
  }

  .loop-section:not(#loop-services-section) {
    max-width: var(--loop-soho-max) !important;
    padding: 62px var(--loop-soho-pad) 78px !important;
    border-top: 1px solid var(--loop-soho-line) !important;
  }

  .loop-section-title {
    color: var(--loop-soho-charcoal) !important;
    font-size: clamp(44px, 3.5vw, 64px) !important;
    line-height: .92 !important;
    letter-spacing: -.088em !important;
  }

  .loop-section-copy { color: #7a6b5b !important; }

  @media (max-width: 899px) {
    .loop-web-hero-carousel.loop-web-hero-final { margin: 0 !important; padding: 0 !important; }
    .loop-web-hero-carousel.loop-web-hero-final::before { position: relative !important; top: auto !important; left: auto !important; margin: 14px 18px -2px !important; }
    .loop-web-carousel-shell {
      min-height: auto !important;
      border-radius: 0 0 34px 34px !important;
      background:
        linear-gradient(180deg, rgba(255,250,242,.99), rgba(255,250,242,.88)),
        url("/loop-soho-luxury-hero.svg") center right / cover no-repeat !important;
    }
    .loop-web-carousel-slide { display: block !important; min-height: auto !important; padding: 28px 18px 30px !important; }
    .loop-web-hero-title { font-size: clamp(42px, 11vw, 58px) !important; line-height: .92 !important; }
    .loop-web-hero-subtitle { margin-top: 16px !important; font-size: 14.8px !important; line-height: 1.5 !important; }
    .loop-web-hero-copy::after { margin-top: 18px !important; padding: 10px 12px 10px 40px !important; font-size: 12.5px !important; }
    .loop-web-hero-right-panel { width: 100% !important; margin-top: 22px !important; }
    #loop-services-section { padding: 30px 14px 38px !important; }
    .loop-section:not(#loop-services-section) { padding: 36px 18px 48px !important; }
    .loop-section-title { font-size: 34px !important; letter-spacing: -.066em !important; }
  }

  /* LOOP PHASE 3B DIRECT FIX — target current visible minimal hero classes */
  :root {
    --loop-direct-max: 1540px;
    --loop-direct-pad: clamp(20px, 4.6vw, 66px);
    --loop-direct-ink: #15120e;
    --loop-direct-muted: #706452;
    --loop-direct-green: #00675f;
    --loop-direct-line: rgba(116, 96, 68, .14);
  }

  body:not(.is-mobile-app) .mainmenu-root,
  body:not(.is-mobile-app) .loop-pro-shell,
  body:not(.is-mobile-app) .loop-pro-main {
    background:
      radial-gradient(circle at 12% 0%, rgba(0, 103, 95, .045), transparent 26%),
      radial-gradient(circle at 92% 5%, rgba(176, 141, 92, .10), transparent 34%),
      linear-gradient(180deg, #fffaf2 0%, #fbf5ec 38%, #ffffff 100%) !important;
  }

  .loop-hero.loop-hero-minimal {
    max-width: var(--loop-direct-max) !important;
    margin: 0 auto !important;
    padding: clamp(28px, 3.6vw, 46px) var(--loop-direct-pad) clamp(24px, 3vw, 38px) !important;
    border-bottom: 0 !important;
    background:
      radial-gradient(circle at 78% 18%, rgba(221, 198, 168, .20), transparent 34%),
      linear-gradient(135deg, rgba(255,250,242,.72), rgba(247,239,228,.34)) !important;
    border-radius: 0 0 28px 28px !important;
    box-shadow: none !important;
  }

  .loop-hero-card-minimal,
  .loop-hero-content-minimal {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
  }

  .loop-hero-content-minimal {
    width: min(650px, 100%) !important;
    margin-left: 0 !important;
  }

  .loop-eyebrow-minimal {
    margin-bottom: 16px !important;
    padding: 6px 11px !important;
    border: 1px solid rgba(116,96,68,.13) !important;
    background: rgba(255,250,242,.62) !important;
    color: #315c50 !important;
    box-shadow: 0 8px 22px rgba(48,37,24,.035) !important;
    font-size: 10.5px !important;
    letter-spacing: .11em !important;
  }

  .loop-hero-title-minimal {
    max-width: 660px !important;
    color: var(--loop-direct-ink) !important;
    font-size: clamp(42px, 4.25vw, 66px) !important;
    line-height: .94 !important;
    letter-spacing: -.068em !important;
    font-weight: 930 !important;
  }

  .loop-hero-subtitle-minimal {
    max-width: 540px !important;
    margin-top: 16px !important;
    color: var(--loop-direct-muted) !important;
    font-size: clamp(15px, 1.05vw, 17px) !important;
    line-height: 1.52 !important;
    font-weight: 540 !important;
  }

  .loop-hero-actions-minimal { margin-top: 20px !important; gap: 10px !important; }

  .loop-primary-cta-minimal {
    min-height: 46px !important;
    padding: 0 22px !important;
    background: linear-gradient(135deg, #285a4f 0%, #00675f 100%) !important;
    box-shadow: 0 12px 28px rgba(0,103,95,.14) !important;
    font-size: 14px !important;
    font-weight: 820 !important;
  }

  .loop-hero-access-note { margin-top: 18px !important; gap: 10px !important; }
  .loop-hero-lock { width: 38px !important; height: 38px !important; background: rgba(255,250,242,.62) !important; border: 1px solid rgba(116,96,68,.11) !important; }
  .loop-hero-access-copy { color: #756855 !important; font-size: 13.5px !important; }

  #loop-services-section {
    max-width: var(--loop-direct-max) !important;
    padding: 18px var(--loop-direct-pad) 34px !important;
    border-top: 0 !important;
  }

  #loop-services-section .loop-section-head {
    margin-bottom: 20px !important;
    justify-content: center !important;
    text-align: center !important;
  }

  #loop-services-section .loop-category-carousel-v4 {
    justify-content: center !important;
    gap: clamp(20px, 3.4vw, 44px) !important;
  }

  #loop-services-section .loop-category-carousel-v4-card {
    width: 134px !important;
    min-width: 134px !important;
    max-width: 134px !important;
    min-height: 142px !important;
    padding: 8px 7px 10px !important;
    border-radius: 26px !important;
    background: linear-gradient(180deg, rgba(255,250,242,.50), rgba(247,239,228,.30)) !important;
    border: 1px solid rgba(116,96,68,.095) !important;
    box-shadow: 0 10px 30px rgba(48,37,24,.040) !important;
    backdrop-filter: blur(10px) !important;
  }

  #loop-services-section .loop-category-carousel-v4-image {
    width: 92px !important;
    height: 92px !important;
    min-width: 92px !important;
    min-height: 92px !important;
    max-width: 92px !important;
    max-height: 92px !important;
    border-radius: 22px !important;
    background: linear-gradient(135deg, #f8f1e7 0%, #e4efe9 100%) !important;
    box-shadow: none !important;
  }

  #loop-services-section .loop-category-carousel-v4-img {
    max-width: 92px !important;
    max-height: 92px !important;
    filter: saturate(.92) contrast(.98) !important;
  }

  .loop-section:not(#loop-services-section) {
    max-width: var(--loop-direct-max) !important;
    padding: 38px var(--loop-direct-pad) 54px !important;
    border-top: 1px solid var(--loop-direct-line) !important;
  }

  @media (max-width: 768px) {
    .loop-hero.loop-hero-minimal { padding: 20px 18px 24px !important; border-radius: 0 0 24px 24px !important; }
    .loop-hero-title-minimal { font-size: clamp(35px, 9vw, 44px) !important; line-height: .95 !important; }
    .loop-hero-subtitle-minimal { margin-top: 12px !important; font-size: 14px !important; }
    #loop-services-section { padding: 18px 14px 28px !important; }
    #loop-services-section .loop-section-head { justify-content: flex-start !important; text-align: left !important; margin-bottom: 16px !important; padding-left: 4px !important; }
    #loop-services-section .loop-category-carousel-v4-card { width: 126px !important; min-width: 126px !important; max-width: 126px !important; min-height: 138px !important; }
  }

  /* LOOP PHASE 4A — EDITORIAL LUXURY ARCHITECTURE */
  :root{
    --loop4a-max:1520px;--loop4a-pad:clamp(22px,4.6vw,68px);
    --loop4a-ink:#14120e;--loop4a-muted:#6f6455;--loop4a-cream:#fff8ee;
    --loop4a-line:rgba(109,91,64,.14);--loop4a-emerald:#134f47;--loop4a-emerald2:#1d6b61;
  }
  body:not(.is-mobile-app) .mainmenu-root,
  body:not(.is-mobile-app) .loop-pro-shell,
  body:not(.is-mobile-app) .loop-pro-main{
    background:radial-gradient(circle at 9% -3%,rgba(19,79,71,.18),transparent 27%),
    radial-gradient(circle at 92% 0%,rgba(190,152,96,.20),transparent 34%),
    linear-gradient(180deg,#fff8ee 0%,#f4eadc 38%,#fffaf4 72%,#fff 100%)!important;
    color:var(--loop4a-ink)!important;
  }
  .loop-hero.loop-hero-minimal{
    max-width:var(--loop4a-max)!important;margin:0 auto!important;
    padding:clamp(30px,3.2vw,44px) var(--loop4a-pad) clamp(22px,2.5vw,34px)!important;
    border-bottom:0!important;border-radius:0 0 34px 34px!important;
    background:linear-gradient(135deg,rgba(255,248,238,.84) 0%,rgba(245,234,217,.54) 52%,rgba(224,238,231,.42) 100%)!important;
    box-shadow:0 24px 70px rgba(54,41,25,.075)!important;
  }
  .loop-hero-card-minimal{background:transparent!important;border:0!important;box-shadow:none!important;padding:0!important}
  .loop-hero-content-minimal{
    width:100%!important;max-width:none!important;display:grid!important;
    grid-template-columns:minmax(0,.92fr) minmax(300px,.48fr)!important;
    column-gap:clamp(34px,6vw,92px)!important;row-gap:12px!important;align-items:center!important;
  }
  .loop-eyebrow-minimal{
    grid-column:1/2!important;grid-row:1!important;margin:0 0 14px!important;padding:7px 12px!important;
    border-radius:999px!important;border:1px solid rgba(109,91,64,.16)!important;
    background:rgba(255,248,238,.72)!important;color:var(--loop4a-emerald)!important;
    box-shadow:0 10px 24px rgba(54,41,25,.05)!important;font-size:10.5px!important;font-weight:920!important;
    letter-spacing:.12em!important;text-transform:uppercase!important;backdrop-filter:blur(12px)!important;
  }
  .loop-eyebrow-minimal .loop-eyebrow-dot{width:7px!important;height:7px!important;background:var(--loop4a-emerald)!important;box-shadow:0 0 0 5px rgba(19,79,71,.08)!important}
  .loop-hero-title-minimal{
    grid-column:1/2!important;grid-row:2!important;max-width:690px!important;margin:0!important;color:var(--loop4a-ink)!important;
    font-size:clamp(42px,4.35vw,68px)!important;line-height:.91!important;letter-spacing:-.078em!important;font-weight:930!important;
  }
  .loop-title-dot{color:var(--loop4a-emerald)!important}
  .loop-hero-subtitle-minimal{
    grid-column:1/2!important;grid-row:3!important;max-width:560px!important;margin:14px 0 0!important;color:var(--loop4a-muted)!important;
    font-size:clamp(14.5px,1.02vw,16.5px)!important;line-height:1.52!important;font-weight:520!important;
  }
  .loop-hero-actions-minimal{grid-column:2/3!important;grid-row:2!important;margin:0!important;align-self:end!important;justify-self:start!important}
  .loop-primary-cta-minimal{
    min-height:46px!important;padding:0 22px!important;border-radius:999px!important;
    background:linear-gradient(135deg,#143f38 0%,#13594f 100%)!important;color:#fff8ee!important;
    box-shadow:0 14px 32px rgba(19,79,71,.18)!important;font-size:13.8px!important;font-weight:820!important;
  }
  .loop-hero-access-note{grid-column:2/3!important;grid-row:3!important;margin:0!important;align-self:start!important;gap:10px!important}
  .loop-hero-lock{width:36px!important;height:36px!important;background:rgba(255,248,238,.66)!important;border:1px solid rgba(109,91,64,.12)!important;color:var(--loop4a-emerald)!important}
  .loop-hero-access-copy{color:#796c5b!important;font-size:12.8px!important;line-height:1.3!important;font-weight:510!important}
  #loop-services-section{max-width:var(--loop4a-max)!important;padding:20px var(--loop4a-pad) 42px!important;border-top:0!important}
  #loop-services-section .loop-section-head{margin-bottom:20px!important;align-items:center!important;justify-content:center!important;text-align:center!important}
  #loop-services-section .loop-category-carousel-v4{justify-content:center!important;gap:clamp(18px,3vw,38px)!important}
  #loop-services-section .loop-category-carousel-v4-card{
    width:128px!important;min-width:128px!important;max-width:128px!important;min-height:130px!important;
    padding:8px 7px 10px!important;border-radius:28px!important;
    background:linear-gradient(180deg,rgba(255,248,238,.64),rgba(244,233,217,.42))!important;
    border:1px solid rgba(109,91,64,.12)!important;box-shadow:0 16px 42px rgba(54,41,25,.055)!important;backdrop-filter:blur(14px)!important;
  }
  #loop-services-section .loop-category-carousel-v4-image{
    width:84px!important;height:84px!important;min-width:84px!important;min-height:84px!important;max-width:84px!important;max-height:84px!important;
    border-radius:24px!important;background:linear-gradient(135deg,#fbf3e7 0%,#e5efe9 100%)!important;box-shadow:inset 0 0 0 1px rgba(255,255,255,.42)!important;
  }
  #loop-services-section .loop-category-carousel-v4-img{max-width:84px!important;max-height:84px!important;filter:saturate(.90) contrast(.98)!important}
  .loop-section:not(#loop-services-section){max-width:var(--loop4a-max)!important;padding:44px var(--loop4a-pad) 64px!important;border-top:1px solid var(--loop4a-line)!important}
  .loop-section-title{color:var(--loop4a-ink)!important;font-size:clamp(34px,2.8vw,50px)!important;line-height:.95!important;letter-spacing:-.074em!important;font-weight:920!important}
  .loop-section-copy{color:#776a58!important;font-weight:560!important;font-size:14.8px!important}
  @media(max-width:899px){
    .loop-hero.loop-hero-minimal{padding:22px 18px 24px!important;border-radius:0 0 26px 26px!important}
    .loop-hero-content-minimal{display:block!important}
    .loop-hero-title-minimal{font-size:clamp(34px,9.3vw,45px)!important;line-height:.94!important;letter-spacing:-.060em!important}
    .loop-hero-subtitle-minimal{margin-top:12px!important;font-size:14px!important;line-height:1.45!important}
    .loop-hero-actions-minimal{margin-top:18px!important;width:100%!important}
    .loop-primary-cta-minimal{width:100%!important;min-height:44px!important}
    .loop-hero-access-note{margin-top:14px!important}
    #loop-services-section{padding:18px 14px 30px!important}
    #loop-services-section .loop-section-head{justify-content:flex-start!important;text-align:left!important;margin-bottom:16px!important;padding-left:4px!important}
    #loop-services-section .loop-category-carousel-v4-card{width:118px!important;min-width:118px!important;max-width:118px!important;min-height:126px!important}
    #loop-services-section .loop-category-carousel-v4-image{width:78px!important;height:78px!important;min-width:78px!important;min-height:78px!important;max-width:78px!important;max-height:78px!important}
    .loop-section:not(#loop-services-section){padding:32px 18px 44px!important}
    .loop-section-title{font-size:30px!important}
  }

  /* =========================================================
     LOOP PHASE 5 — MAINMENU V2 REAL REBUILD
     Structural V5 hero + editorial luxury system.
     40% Soho House, 30% Apple, 20% Aesop, 10% Wellness Hotel.
     ========================================================= */

  :root {
    --loop-v5-emerald: #134f47;
    --loop-v5-emerald-2: #1d6b61;
    --loop-v5-emerald-3: #0f3f39;
    --loop-v5-cream: #fff8ee;
    --loop-v5-warm: #f2e5d2;
    --loop-v5-ink: #14120e;
    --loop-v5-muted: #766a58;
    --loop-v5-line: rgba(108, 88, 61, .145);
    --loop-v5-max: 1540px;
    --loop-v5-pad: clamp(22px, 4.5vw, 70px);
  }

  .loop-pro-shell,
  .loop-pro-main {
    background:
      radial-gradient(circle at 8% -4%, rgba(19, 79, 71, .16), transparent 26%),
      radial-gradient(circle at 92% 2%, rgba(174, 134, 82, .20), transparent 34%),
      linear-gradient(180deg, #fff8ee 0%, #f5eadb 38%, #fffaf4 72%, #ffffff 100%) !important;
  }

  .loop-v5-hero {
    max-width: var(--loop-v5-max);
    margin: 0 auto;
    padding: clamp(26px, 3.4vw, 46px) var(--loop-v5-pad) 26px;
  }

  .loop-v5-hero-shell {
    position: relative;
    overflow: hidden;
    min-height: clamp(360px, 31vw, 470px);
    border-radius: 38px;
    border: 1px solid rgba(108, 88, 61, .14);
    background:
      radial-gradient(circle at 78% 28%, rgba(255, 248, 238, .90), transparent 24%),
      radial-gradient(circle at 90% 78%, rgba(19, 79, 71, .15), transparent 36%),
      linear-gradient(135deg, rgba(255, 248, 238, .96) 0%, rgba(244, 231, 211, .68) 52%, rgba(222, 238, 231, .62) 100%);
    box-shadow: 0 30px 86px rgba(54, 41, 25, .115);
    display: grid;
    grid-template-columns: minmax(0, .92fr) minmax(360px, .62fr);
    align-items: center;
    gap: clamp(28px, 5vw, 82px);
    padding: clamp(42px, 5.2vw, 78px) clamp(34px, 5.2vw, 84px);
  }

  .loop-v5-hero-shell::before {
    content: "";
    position: absolute;
    inset: -20% -10% auto auto;
    width: min(54vw, 740px);
    height: min(46vw, 620px);
    background:
      radial-gradient(circle at 50% 50%, rgba(19,79,71,.18), transparent 34%),
      radial-gradient(circle at 62% 35%, rgba(194,157,105,.24), transparent 32%);
    filter: blur(26px);
    opacity: .88;
    pointer-events: none;
  }

  .loop-v5-copy,
  .loop-v5-visual {
    position: relative;
    z-index: 1;
  }

  .loop-v5-kicker {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    width: fit-content;
    padding: 8px 13px;
    border-radius: 999px;
    border: 1px solid rgba(108, 88, 61, .15);
    background: rgba(255, 248, 238, .68);
    color: var(--loop-v5-emerald);
    box-shadow: 0 12px 28px rgba(54, 41, 25, .055);
    font-size: 11px;
    font-weight: 920;
    letter-spacing: .13em;
    text-transform: uppercase;
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
  }

  .loop-v5-kicker span {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: var(--loop-v5-emerald);
    box-shadow: 0 0 0 6px rgba(19, 79, 71, .08);
  }

  .loop-v5-title {
    max-width: 740px;
    margin: 24px 0 0;
    color: var(--loop-v5-ink);
    font-size: clamp(48px, 5.2vw, 84px);
    line-height: .90;
    letter-spacing: -.085em;
    font-weight: 950;
  }

  .loop-v5-title span {
    color: var(--loop-v5-emerald);
  }

  .loop-v5-subtitle {
    max-width: 570px;
    margin: 22px 0 0;
    color: var(--loop-v5-muted);
    font-size: clamp(16px, 1.05vw, 18px);
    line-height: 1.58;
    font-weight: 580;
    letter-spacing: -.012em;
  }

  .loop-v5-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 28px;
  }

  .loop-v5-primary,
  .loop-v5-secondary {
    min-height: 48px;
    border-radius: 999px;
    padding: 0 22px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    font-weight: 860;
    font-size: 14px;
    transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease;
  }

  .loop-v5-primary {
    border: 0;
    color: #fff8ee;
    background: linear-gradient(135deg, #103f39 0%, #155a51 100%);
    box-shadow: 0 16px 36px rgba(19, 79, 71, .20);
  }

  .loop-v5-secondary {
    color: #34564d;
    border: 1px solid rgba(108, 88, 61, .16);
    background: rgba(255, 248, 238, .68);
    box-shadow: 0 12px 30px rgba(54, 41, 25, .055);
  }

  .loop-v5-primary:hover,
  .loop-v5-secondary:hover {
    transform: translateY(-2px);
  }

  .loop-v5-visual {
    min-height: 300px;
    display: grid;
    place-items: center;
  }

  .loop-v5-orb {
    position: absolute;
    border-radius: 999px;
    filter: blur(1px);
  }

  .loop-v5-orb-a {
    width: 270px;
    height: 270px;
    right: 16%;
    top: 8%;
    background: radial-gradient(circle, rgba(19,79,71,.20), rgba(19,79,71,.02) 64%, transparent 70%);
  }

  .loop-v5-orb-b {
    width: 190px;
    height: 190px;
    right: 2%;
    bottom: 6%;
    background: radial-gradient(circle, rgba(194,157,105,.26), rgba(194,157,105,.02) 66%, transparent 72%);
  }

  .loop-v5-panel {
    position: absolute;
    display: flex;
    align-items: center;
    gap: 14px;
    border: 1px solid rgba(255, 248, 238, .64);
    background: rgba(255, 248, 238, .68);
    box-shadow: 0 22px 64px rgba(54, 41, 25, .13);
    backdrop-filter: blur(22px);
    -webkit-backdrop-filter: blur(22px);
  }

  .loop-v5-panel-main {
    right: 4%;
    top: 22%;
    width: min(100%, 380px);
    border-radius: 28px;
    padding: 22px;
  }

  .loop-v5-panel-soft {
    right: 22%;
    bottom: 18%;
    width: min(100%, 330px);
    border-radius: 999px;
    padding: 16px 20px;
  }

  .loop-v5-panel-icon {
    width: 48px;
    height: 48px;
    border-radius: 17px;
    display: grid;
    place-items: center;
    color: var(--loop-v5-emerald);
    background: rgba(19,79,71,.08);
    border: 1px solid rgba(19,79,71,.10);
    flex: 0 0 auto;
  }

  .loop-v5-panel strong {
    display: block;
    color: var(--loop-v5-ink);
    font-size: 17px;
    line-height: 1.15;
    font-weight: 900;
    letter-spacing: -.035em;
  }

  .loop-v5-panel small {
    display: block;
    margin-top: 5px;
    color: var(--loop-v5-muted);
    font-size: 13px;
    line-height: 1.35;
    font-weight: 600;
  }

  .loop-v5-dot {
    width: 12px;
    height: 12px;
    border-radius: 999px;
    background: var(--loop-v5-emerald);
    box-shadow: 0 0 0 7px rgba(19,79,71,.08);
    flex: 0 0 auto;
  }

  #loop-services-section {
    max-width: var(--loop-v5-max) !important;
    padding: 16px var(--loop-v5-pad) 42px !important;
    border-top: 0 !important;
  }

  #loop-services-section .loop-section-head {
    justify-content: center !important;
    text-align: center !important;
    margin-bottom: 22px !important;
  }

  #loop-services-section .loop-section-kicker,
  .loop-section-kicker {
    color: var(--loop-v5-emerald) !important;
    letter-spacing: .19em !important;
  }

  .loop-section {
    max-width: var(--loop-v5-max) !important;
    padding: 46px var(--loop-v5-pad) 64px !important;
    border-top: 1px solid var(--loop-v5-line) !important;
  }

  .loop-section-title {
    color: var(--loop-v5-ink) !important;
    font-size: clamp(34px, 3vw, 54px) !important;
    line-height: .95 !important;
    letter-spacing: -.078em !important;
  }

  .loop-section-copy {
    color: var(--loop-v5-muted) !important;
    font-weight: 580 !important;
  }

  .loop-natural-footer {
    max-width: var(--loop-v5-max) !important;
    border-top: 1px solid var(--loop-v5-line) !important;
    color: var(--loop-v5-muted) !important;
  }

  @media (max-width: 899px) {
    .loop-v5-hero {
      padding: 0 0 20px;
    }

    .loop-v5-hero-shell {
      min-height: auto;
      border-radius: 0 0 28px 28px;
      border-left: 0;
      border-right: 0;
      grid-template-columns: 1fr;
      gap: 22px;
      padding: 28px 18px 24px;
      box-shadow: 0 16px 48px rgba(54, 41, 25, .08);
    }

    .loop-v5-title {
      font-size: clamp(38px, 10.2vw, 50px);
      line-height: .93;
      letter-spacing: -.066em;
      margin-top: 18px;
    }

    .loop-v5-subtitle {
      font-size: 14.4px;
      line-height: 1.48;
      margin-top: 14px;
    }

    .loop-v5-actions {
      margin-top: 18px;
    }

    .loop-v5-primary,
    .loop-v5-secondary {
      width: 100%;
      min-height: 46px;
    }

    .loop-v5-visual {
      display: none;
    }

    #loop-services-section {
      padding: 18px 14px 30px !important;
    }

    #loop-services-section .loop-section-head {
      justify-content: flex-start !important;
      text-align: left !important;
      padding-left: 4px !important;
    }

    .loop-section {
      padding: 34px 18px 44px !important;
    }

    .loop-section-title {
      font-size: 32px !important;
    }
  }

  /* =========================================================
     LOOP PHASE 5B — COMPACT HERO + CLEAR PANAMA MESSAGE
     Main goals:
     - hero ~45% shorter
     - clear "Loop está llegando a Panamá"
     - wellness image integrated on right
     - right side only CTA + app availability
     - less dead space before categories
     ========================================================= */

  :root {
    --loop-v5b-emerald: #134f47;
    --loop-v5b-emerald-2: #1d6b61;
    --loop-v5b-cream: #fff8ee;
    --loop-v5b-warm: #f3e6d4;
    --loop-v5b-ink: #14120e;
    --loop-v5b-muted: #756958;
    --loop-v5b-line: rgba(108, 88, 61, .145);
    --loop-v5b-max: 1540px;
    --loop-v5b-pad: clamp(20px, 4vw, 62px);
  }

  .loop-pro-shell,
  .loop-pro-main {
    background:
      radial-gradient(circle at 10% -6%, rgba(19, 79, 71, .12), transparent 25%),
      radial-gradient(circle at 92% 0%, rgba(184, 145, 91, .18), transparent 34%),
      linear-gradient(180deg, #fff8ee 0%, #f4eadc 36%, #fffaf4 72%, #ffffff 100%) !important;
  }

  .loop-v5-hero.loop-v5b-hero {
    max-width: var(--loop-v5b-max) !important;
    margin: 0 auto !important;
    padding: clamp(18px, 2.2vw, 30px) var(--loop-v5b-pad) 14px !important;
  }

  .loop-v5-hero-shell.loop-v5b-hero-shell {
    min-height: clamp(265px, 23vw, 340px) !important;
    border-radius: 30px !important;
    padding: clamp(30px, 3.8vw, 52px) clamp(30px, 4.4vw, 68px) !important;
    grid-template-columns: minmax(0, .82fr) minmax(320px, .52fr) !important;
    gap: clamp(26px, 4vw, 66px) !important;
    background:
      linear-gradient(90deg, rgba(255,248,238,.98) 0%, rgba(255,248,238,.91) 36%, rgba(255,248,238,.54) 58%, rgba(255,248,238,.18) 100%),
      linear-gradient(135deg, rgba(255,248,238,.96) 0%, rgba(244,231,211,.66) 52%, rgba(222,238,231,.54) 100%) !important;
    box-shadow: 0 22px 64px rgba(54, 41, 25, .10) !important;
    border: 1px solid rgba(108, 88, 61, .13) !important;
  }

  .loop-v5-hero-shell.loop-v5b-hero-shell::before {
    display: none !important;
  }

  .loop-v5b-copy {
    max-width: 680px !important;
  }

  .loop-v5-kicker {
    padding: 7px 12px !important;
    font-size: 10.5px !important;
    letter-spacing: .13em !important;
    background: rgba(255,248,238,.72) !important;
    border-color: rgba(108, 88, 61, .15) !important;
    color: var(--loop-v5b-emerald) !important;
  }

  .loop-v5-title.loop-v5b-title {
    max-width: 620px !important;
    margin-top: 18px !important;
    font-size: clamp(46px, 4.7vw, 72px) !important;
    line-height: .90 !important;
    letter-spacing: -.082em !important;
    color: var(--loop-v5b-ink) !important;
  }

  .loop-v5-title.loop-v5b-title span {
    color: var(--loop-v5b-emerald) !important;
  }

  .loop-v5-subtitle.loop-v5b-subtitle {
    max-width: 560px !important;
    margin-top: 16px !important;
    font-size: clamp(14.5px, 1vw, 16.5px) !important;
    line-height: 1.50 !important;
    color: var(--loop-v5b-muted) !important;
    font-weight: 580 !important;
  }

  .loop-v5b-visual {
    min-height: 220px !important;
    position: relative !important;
    display: grid !important;
    align-items: center !important;
    justify-items: end !important;
  }

  .loop-v5b-photo {
    position: absolute !important;
    inset: -26px -44px -26px 2% !important;
    border-radius: 28px !important;
    background:
      linear-gradient(90deg, rgba(255,248,238,.10), rgba(255,248,238,.70)),
      url("/loop-v5b-wellness-hero.png") center / cover no-repeat !important;
    opacity: .62 !important;
    filter: saturate(.90) contrast(.96) brightness(1.06) !important;
    mask-image: linear-gradient(90deg, transparent 0%, black 18%, black 100%);
    -webkit-mask-image: linear-gradient(90deg, transparent 0%, black 18%, black 100%);
  }

  .loop-v5b-cta-card {
    position: relative !important;
    z-index: 2 !important;
    width: min(100%, 360px) !important;
    border-radius: 28px !important;
    padding: 22px !important;
    border: 1px solid rgba(255,248,238,.70) !important;
    background: rgba(255,248,238,.72) !important;
    box-shadow: 0 22px 62px rgba(54, 41, 25, .13) !important;
    backdrop-filter: blur(20px) saturate(1.04) !important;
    -webkit-backdrop-filter: blur(20px) saturate(1.04) !important;
  }

  .loop-v5b-cta-copy strong {
    display: block !important;
    color: var(--loop-v5b-ink) !important;
    font-size: 18px !important;
    line-height: 1.12 !important;
    font-weight: 920 !important;
    letter-spacing: -.04em !important;
  }

  .loop-v5b-cta-copy span {
    display: block !important;
    margin-top: 6px !important;
    color: var(--loop-v5b-muted) !important;
    font-size: 13px !important;
    line-height: 1.35 !important;
    font-weight: 610 !important;
  }

  .loop-v5b-primary,
  .loop-v5b-store {
    width: 100% !important;
    min-height: 44px !important;
    margin-top: 14px !important;
    border-radius: 999px !important;
    font-size: 13.5px !important;
  }

  .loop-v5b-primary {
    background: linear-gradient(135deg, #103f39 0%, #155a51 100%) !important;
    color: #fff8ee !important;
    box-shadow: 0 14px 30px rgba(19,79,71,.18) !important;
  }

  .loop-v5b-store {
    margin-top: 10px !important;
    background: rgba(255,248,238,.78) !important;
    border: 1px solid rgba(108, 88, 61, .14) !important;
    color: var(--loop-v5b-emerald) !important;
    box-shadow: none !important;
  }

  #loop-services-section {
    padding-top: 10px !important;
    padding-bottom: 30px !important;
  }

  #loop-services-section .loop-section-head {
    margin-bottom: 16px !important;
  }

  #loop-services-section .loop-category-carousel-v4-card {
    width: 118px !important;
    min-width: 118px !important;
    max-width: 118px !important;
    min-height: 124px !important;
    border-radius: 26px !important;
    background: rgba(255,248,238,.46) !important;
    box-shadow: 0 12px 32px rgba(54, 41, 25, .045) !important;
  }

  #loop-services-section .loop-category-carousel-v4-image {
    width: 76px !important;
    height: 76px !important;
    min-width: 76px !important;
    min-height: 76px !important;
    max-width: 76px !important;
    max-height: 76px !important;
    border-radius: 22px !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  #loop-services-section .loop-category-carousel-v4-img {
    max-width: 76px !important;
    max-height: 76px !important;
    object-fit: contain !important;
    filter: saturate(.98) contrast(1) !important;
  }

  #loop-services-section .loop-category-carousel-v4-label {
    margin-top: 7px !important;
    font-size: 10.8px !important;
    line-height: 1.08 !important;
  }

  @media (max-width: 899px) {
    .loop-v5-hero.loop-v5b-hero {
      padding: 0 0 10px !important;
    }

    .loop-v5-hero-shell.loop-v5b-hero-shell {
      min-height: auto !important;
      border-radius: 0 0 26px 26px !important;
      border-left: 0 !important;
      border-right: 0 !important;
      display: block !important;
      padding: 24px 18px 20px !important;
      background:
        linear-gradient(180deg, rgba(255,248,238,.96) 0%, rgba(255,248,238,.89) 62%, rgba(225,238,232,.58) 100%),
        url("/loop-v5b-wellness-hero.png") center right / cover no-repeat !important;
    }

    .loop-v5-title.loop-v5b-title {
      margin-top: 16px !important;
      font-size: clamp(36px, 9.5vw, 47px) !important;
      line-height: .93 !important;
    }

    .loop-v5-subtitle.loop-v5b-subtitle {
      margin-top: 12px !important;
      font-size: 14px !important;
      line-height: 1.45 !important;
      max-width: 94% !important;
    }

    .loop-v5b-visual {
      display: block !important;
      min-height: auto !important;
      margin-top: 16px !important;
    }

    .loop-v5b-photo {
      display: none !important;
    }

    .loop-v5b-cta-card {
      width: 100% !important;
      border-radius: 22px !important;
      padding: 16px !important;
    }

    .loop-v5b-cta-copy strong {
      font-size: 15.5px !important;
    }

    .loop-v5b-cta-copy span {
      font-size: 12.5px !important;
    }

    #loop-services-section {
      padding-top: 12px !important;
      padding-bottom: 24px !important;
    }

    #loop-services-section .loop-category-carousel-v4-card {
      width: 112px !important;
      min-width: 112px !important;
      max-width: 112px !important;
      min-height: 120px !important;
    }

    #loop-services-section .loop-category-carousel-v4-image {
      width: 72px !important;
      height: 72px !important;
      min-width: 72px !important;
      min-height: 72px !important;
      max-width: 72px !important;
      max-height: 72px !important;
    }
  }

  /* =========================================================
     LOOP PHASE 5C — CLEAN HERO VISUAL + FIXED CATEGORY ICONS
     ========================================================= */

  .loop-v5b-photo {
    background:
      radial-gradient(circle at 68% 30%, rgba(255,248,238,.88) 0%, rgba(255,248,238,.64) 26%, transparent 48%),
      radial-gradient(circle at 52% 64%, rgba(19,79,71,.18) 0%, rgba(19,79,71,.06) 35%, transparent 64%),
      radial-gradient(circle at 80% 76%, rgba(184,145,91,.20) 0%, rgba(184,145,91,.06) 38%, transparent 68%),
      linear-gradient(135deg, rgba(255,248,238,.18), rgba(226,238,232,.42)) !important;
    opacity: 1 !important;
    filter: none !important;
  }

  .loop-v5b-photo::before {
    content: "" !important;
    position: absolute !important;
    right: 7% !important;
    bottom: 6% !important;
    width: 210px !important;
    height: 210px !important;
    border-radius: 999px !important;
    background:
      radial-gradient(circle at 50% 50%, rgba(19,79,71,.16), transparent 58%) !important;
  }

  .loop-v5b-photo::after {
    content: "" !important;
    position: absolute !important;
    right: 18% !important;
    top: 18% !important;
    width: 210px !important;
    height: 130px !important;
    border-radius: 999px !important;
    border: 1px solid rgba(108,88,61,.12) !important;
    background: rgba(255,248,238,.22) !important;
    box-shadow: 0 22px 54px rgba(54,41,25,.08) !important;
    transform: rotate(-8deg) !important;
  }

  .loop-v5b-cta-card {
    background: rgba(255,248,238,.82) !important;
  }

  .loop-v5b-cta-copy strong {
    font-size: 17px !important;
  }

  .loop-v5b-cta-copy span {
    max-width: 280px !important;
  }

  #loop-services-section .loop-category-carousel-v4-card {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
  }

  #loop-services-section .loop-category-carousel-v4-image {
    width: 86px !important;
    height: 86px !important;
    min-width: 86px !important;
    min-height: 86px !important;
    max-width: 86px !important;
    max-height: 86px !important;
    border-radius: 24px !important;
    background:
      radial-gradient(circle at 32% 18%, rgba(255,255,255,.72), transparent 42%),
      linear-gradient(135deg, #edf7f2 0%, #dceee8 100%) !important;
    box-shadow: inset 0 0 0 1px rgba(255,255,255,.56), 0 12px 30px rgba(54,41,25,.055) !important;
    overflow: hidden !important;
  }

  #loop-services-section .loop-category-carousel-v4-img {
    width: 86px !important;
    height: 86px !important;
    max-width: 86px !important;
    max-height: 86px !important;
    object-fit: contain !important;
    padding: 0 !important;
    filter: saturate(.98) contrast(1) !important;
  }

  @media (max-width: 899px) {
    .loop-v5b-photo,
    .loop-v5b-photo::before,
    .loop-v5b-photo::after {
      display: none !important;
    }

    #loop-services-section .loop-category-carousel-v4-image {
      width: 82px !important;
      height: 82px !important;
      min-width: 82px !important;
      min-height: 82px !important;
      max-width: 82px !important;
      max-height: 82px !important;
    }

    #loop-services-section .loop-category-carousel-v4-img {
      width: 82px !important;
      height: 82px !important;
      max-width: 82px !important;
      max-height: 82px !important;
    }
  }


  /* =========================================================
     LOOP PREMIUM SERVICE ICONS — forced from MainMenu
     This avoids ServicesTypeScroll route/name issues.
     ========================================================= */

  #loop-services-section .loop-category-carousel-v4-image {
    position: relative !important;
    background-size: contain !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-color: transparent !important;
    box-shadow: none !important;
    overflow: visible !important;
  }

  #loop-services-section .loop-category-carousel-v4-img {
    opacity: 0 !important;
    visibility: hidden !important;
  }

  #loop-services-section .loop-category-carousel-v4-card:nth-child(1) .loop-category-carousel-v4-image {
    background-image: url("/assets/images/Servicios/loop-premium-belleza.svg") !important;
  }

  #loop-services-section .loop-category-carousel-v4-card:nth-child(2) .loop-category-carousel-v4-image {
    background-image: url("/assets/images/Servicios/loop-premium-bienestar.svg") !important;
  }

  #loop-services-section .loop-category-carousel-v4-card:nth-child(3) .loop-category-carousel-v4-image {
    background-image: url("/assets/images/Servicios/loop-premium-eventos.svg") !important;
  }

  #loop-services-section .loop-category-carousel-v4-card:nth-child(4) .loop-category-carousel-v4-image {
    background-image: url("/assets/images/Servicios/loop-premium-fitness.svg") !important;
  }

  #loop-services-section .loop-category-carousel-v4-card:nth-child(5) .loop-category-carousel-v4-image {
    background-image: url("/assets/images/Servicios/loop-premium-otros.svg") !important;
  }

  #loop-services-section .loop-category-carousel-v4-card:nth-child(6) .loop-category-carousel-v4-image {
    background-image: url("/assets/images/Servicios/loop-premium-settings.svg") !important;
  }

  #loop-services-section .loop-category-carousel-v4-card:nth-child(7) .loop-category-carousel-v4-image {
    background-image: url("/assets/images/Servicios/loop-premium-limpieza.svg") !important;
  }

  #loop-services-section .loop-category-carousel-v4-card {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
  }

  #loop-services-section .loop-category-carousel-v4-image {
    width: 92px !important;
    height: 92px !important;
    min-width: 92px !important;
    min-height: 92px !important;
    max-width: 92px !important;
    max-height: 92px !important;
    border-radius: 28px !important;
  }

  #loop-services-section .loop-category-carousel-v4-label {
    margin-top: 10px !important;
  }

  @media (max-width: 899px) {
    #loop-services-section .loop-category-carousel-v4-image {
      width: 86px !important;
      height: 86px !important;
      min-width: 86px !important;
      min-height: 86px !important;
      max-width: 86px !important;
      max-height: 86px !important;
    }
  }



  /* =========================================================
     LOOP PHASE 5D — COMPACT HERO + EDITORIAL CARDS
     45% Soho House + 35% Apple + 20% Wellness Hotel.
     Goals:
     - hero 10-15% shorter
     - CTA card thinner and more elegant
     - app availability as subtle badge
     - category tiles calmer and more premium
     - business cards feel editorial/luxury, not generic marketplace
     ========================================================= */

  :root {
    --loop5d-emerald: #134f47;
    --loop5d-emerald-2: #17665c;
    --loop5d-ink: #14120e;
    --loop5d-muted: #766a58;
    --loop5d-cream: #fff8ee;
    --loop5d-warm: #f3e6d4;
    --loop5d-line: rgba(108,88,61,.13);
  }

  .loop-v5-hero.loop-v5b-hero {
    padding-top: clamp(14px, 1.7vw, 24px) !important;
    padding-bottom: 8px !important;
  }

  .loop-v5-hero-shell.loop-v5b-hero-shell {
    min-height: clamp(220px, 18.5vw, 292px) !important;
    border-radius: 28px !important;
    padding: clamp(24px, 3vw, 42px) clamp(28px, 4vw, 60px) !important;
    box-shadow: 0 18px 52px rgba(54, 41, 25, .085) !important;
  }

  .loop-v5-title.loop-v5b-title {
    max-width: 610px !important;
    margin-top: 14px !important;
    font-size: clamp(42px, 4.25vw, 66px) !important;
    line-height: .90 !important;
    letter-spacing: -.080em !important;
  }

  .loop-v5-subtitle.loop-v5b-subtitle {
    max-width: 560px !important;
    margin-top: 12px !important;
    font-size: clamp(14px, .96vw, 15.8px) !important;
    line-height: 1.44 !important;
    color: var(--loop5d-muted) !important;
  }

  .loop-v5-kicker {
    padding: 6px 11px !important;
    font-size: 10px !important;
  }

  .loop-v5b-visual {
    min-height: 174px !important;
  }

  .loop-v5b-cta-card {
    width: min(100%, 328px) !important;
    border-radius: 24px !important;
    padding: 18px !important;
    background: rgba(255,248,238,.78) !important;
    box-shadow: 0 18px 50px rgba(54, 41, 25, .105) !important;
  }

  .loop-v5b-cta-copy strong {
    font-size: 16px !important;
    letter-spacing: -.035em !important;
  }

  .loop-v5b-cta-copy span {
    margin-top: 5px !important;
    font-size: 12.2px !important;
    line-height: 1.32 !important;
    color: #807360 !important;
  }

  .loop-v5b-primary {
    min-height: 39px !important;
    margin-top: 12px !important;
    font-size: 12.8px !important;
    padding: 0 16px !important;
    box-shadow: 0 12px 26px rgba(19,79,71,.16) !important;
  }

  .loop-v5b-store {
    width: fit-content !important;
    min-height: 28px !important;
    margin-top: 10px !important;
    padding: 0 12px !important;
    border-radius: 999px !important;
    font-size: 11px !important;
    letter-spacing: .04em !important;
    text-transform: uppercase !important;
    background: rgba(255,248,238,.62) !important;
    color: #315a52 !important;
    border: 1px solid rgba(108,88,61,.12) !important;
  }

  #loop-services-section {
    padding-top: 6px !important;
    padding-bottom: 22px !important;
  }

  #loop-services-section .loop-section-head {
    margin-bottom: 12px !important;
  }

  #loop-services-section .loop-section-kicker {
    font-size: 10.5px !important;
    letter-spacing: .18em !important;
    color: #285c53 !important;
  }

  #loop-services-section .loop-category-carousel-v4 {
    gap: clamp(18px, 3.2vw, 42px) !important;
  }

  #loop-services-section .loop-category-carousel-v4-card {
    width: 108px !important;
    min-width: 108px !important;
    max-width: 108px !important;
    min-height: 118px !important;
    padding: 0 !important;
  }

  #loop-services-section .loop-category-carousel-v4-image {
    width: 82px !important;
    height: 82px !important;
    min-width: 82px !important;
    min-height: 82px !important;
    max-width: 82px !important;
    max-height: 82px !important;
    border-radius: 25px !important;
    filter: drop-shadow(0 13px 22px rgba(54,41,25,.045)) !important;
  }

  #loop-services-section .loop-category-carousel-v4-label {
    margin-top: 11px !important;
    color: #17130f !important;
    font-size: 10.6px !important;
    line-height: 1.1 !important;
    font-weight: 760 !important;
    letter-spacing: -.01em !important;
  }

  .loop-section:not(#loop-services-section) {
    padding-top: 34px !important;
    padding-bottom: 48px !important;
  }

  .loop-section-title {
    font-size: clamp(32px, 2.75vw, 46px) !important;
    letter-spacing: -.074em !important;
  }

  .loop-section-copy {
    font-size: 14.2px !important;
    color: #7a6e5e !important;
  }

  .loop-carousel-shell {
    margin-top: 4px !important;
  }

  @media (max-width: 899px) {
    .loop-v5-hero.loop-v5b-hero {
      padding-bottom: 8px !important;
    }

    .loop-v5-hero-shell.loop-v5b-hero-shell {
      padding: 22px 18px 18px !important;
      border-radius: 0 0 24px 24px !important;
    }

    .loop-v5-title.loop-v5b-title {
      font-size: clamp(34px, 8.8vw, 43px) !important;
      line-height: .94 !important;
      margin-top: 13px !important;
    }

    .loop-v5-subtitle.loop-v5b-subtitle {
      font-size: 13.5px !important;
      max-width: 100% !important;
    }

    .loop-v5b-visual {
      margin-top: 13px !important;
    }

    .loop-v5b-cta-card {
      padding: 14px !important;
      border-radius: 20px !important;
    }

    .loop-v5b-primary {
      min-height: 40px !important;
    }

    #loop-services-section {
      padding-top: 8px !important;
      padding-bottom: 20px !important;
    }

    #loop-services-section .loop-category-carousel-v4-card {
      width: 104px !important;
      min-width: 104px !important;
      max-width: 104px !important;
    }

    #loop-services-section .loop-category-carousel-v4-image {
      width: 78px !important;
      height: 78px !important;
      min-width: 78px !important;
      min-height: 78px !important;
      max-width: 78px !important;
      max-height: 78px !important;
    }

    .loop-section:not(#loop-services-section) {
      padding-top: 28px !important;
      padding-bottom: 38px !important;
    }
  }



  /* LOOP PHASE 6 — FULL HERO BACKGROUND MOCKUP MATCH */
  :root{--loop-p6-emerald:#073f37;--loop-p6-emerald-2:#0d554c;--loop-p6-cream:#fff5e8;--loop-p6-ink:#17120c;--loop-p6-pad:clamp(20px,5vw,72px)}
  .loop-pro-shell,.loop-pro-main{background:linear-gradient(180deg,#fff7ec 0%,#f2e2cb 50%,#fff8ee 100%)!important}
  .loop-p6-hero{position:relative!important;margin:0!important;width:100%!important;min-height:clamp(430px,40vw,610px)!important;background:linear-gradient(90deg,rgba(4,30,25,.72) 0%,rgba(4,30,25,.46) 26%,rgba(4,30,25,.16) 52%,rgba(4,30,25,.30) 100%),url("/assets/images/loop-phase6-hero-bg.jpg") center/cover no-repeat!important;overflow:hidden!important;border-bottom:1px solid rgba(255,245,232,.55)!important}
  .loop-p6-hero:before{content:""!important;position:absolute!important;inset:0!important;background:radial-gradient(circle at 24% 45%,rgba(255,255,255,.18),transparent 24%),linear-gradient(180deg,rgba(0,0,0,.12),rgba(0,0,0,.26))!important;pointer-events:none!important}
  .loop-p6-hero-overlay{position:relative!important;z-index:1!important;width:min(100%,1540px)!important;min-height:inherit!important;margin:0 auto!important;padding:clamp(54px,7vw,116px) var(--loop-p6-pad) clamp(46px,5.2vw,80px)!important;display:grid!important;grid-template-columns:minmax(0,.92fr) minmax(360px,450px)!important;gap:clamp(38px,7vw,110px)!important;align-items:center!important}
  .loop-p6-kicker{display:inline-flex!important;align-items:center!important;gap:10px!important;width:fit-content!important;padding:8px 13px!important;border-radius:999px!important;background:rgba(255,248,238,.94)!important;border:1px solid rgba(255,255,255,.72)!important;color:#0d554c!important;font-size:11px!important;font-weight:900!important;letter-spacing:.14em!important;text-transform:uppercase!important;box-shadow:0 16px 32px rgba(0,0,0,.12)!important;backdrop-filter:blur(16px)!important}
  .loop-p6-kicker span{width:8px!important;height:8px!important;border-radius:999px!important;background:#0d554c!important;box-shadow:0 0 0 6px rgba(13,85,76,.10)!important}
  .loop-p6-title{margin:22px 0 0!important;max-width:780px!important;color:#fff8ee!important;text-shadow:0 4px 18px rgba(0,0,0,.22)!important;font-size:clamp(56px,6vw,94px)!important;line-height:.91!important;letter-spacing:-.078em!important;font-weight:950!important}
  .loop-p6-title span{color:#0f7f72!important;text-shadow:none!important}
  .loop-p6-subtitle{max-width:760px!important;margin:24px 0 0!important;color:rgba(255,248,238,.94)!important;text-shadow:0 3px 14px rgba(0,0,0,.22)!important;font-size:clamp(17px,1.45vw,22px)!important;line-height:1.48!important;font-weight:640!important}
  .loop-p6-cta-card{justify-self:end!important;width:min(100%,420px)!important;border-radius:34px!important;padding:28px!important;background:rgba(255,248,238,.94)!important;border:1px solid rgba(255,255,255,.70)!important;box-shadow:0 28px 70px rgba(0,0,0,.20)!important;backdrop-filter:blur(18px) saturate(1.06)!important}
  .loop-p6-cta-card strong{display:block!important;color:#17120c!important;font-size:21px!important;line-height:1.15!important;font-weight:930!important;letter-spacing:-.04em!important}
  .loop-p6-cta-card p{margin:10px 0 0!important;color:#514636!important;font-size:15px!important;line-height:1.45!important;font-weight:560!important}
  .loop-p6-primary{width:100%!important;min-height:58px!important;margin-top:22px!important;border:0!important;border-radius:999px!important;background:linear-gradient(135deg,#073f37 0%,#0d554c 100%)!important;color:#fff8ee!important;font-size:16px!important;font-weight:900!important;cursor:pointer!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:12px!important;box-shadow:0 16px 34px rgba(7,63,55,.28)!important}
  .loop-p6-store-row{margin-top:14px!important;display:grid!important;grid-template-columns:1fr 1fr!important;gap:10px!important}
  .loop-p6-store-btn{min-height:52px!important;border:0!important;border-radius:999px!important;background:linear-gradient(135deg,#0a463d 0%,#0e6258 100%)!important;color:#fff8ee!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:9px!important;font-size:15px!important;font-weight:900!important;cursor:pointer!important;box-shadow:0 12px 26px rgba(7,63,55,.20)!important}
  .loop-p6-apple{font-size:24px!important;line-height:1!important}.loop-p6-android{font-size:18px!important;line-height:1!important}
  #loop-services-section{padding-top:30px!important;padding-bottom:42px!important;background:linear-gradient(180deg,#fff5e8 0%,#f5e6d2 100%)!important;max-width:none!important}
  #loop-services-section .loop-section-card{width:min(100%,1180px)!important;margin:0 auto!important;background:transparent!important;border:0!important;box-shadow:none!important;padding:0!important}
  #loop-services-section .loop-section-head{justify-content:center!important;text-align:center!important;margin-bottom:26px!important}
  #loop-services-section .loop-section-kicker{color:#0d554c!important;font-size:12px!important;letter-spacing:.20em!important;font-weight:900!important}
  #loop-services-section .loop-category-carousel-v4{justify-content:center!important;gap:clamp(28px,5vw,78px)!important}
  #loop-services-section .loop-category-carousel-v4-card{width:132px!important;min-width:132px!important;max-width:132px!important;min-height:150px!important;padding:0!important;background:transparent!important;border:0!important;box-shadow:none!important}
  #loop-services-section .loop-category-carousel-v4-image{width:106px!important;height:106px!important;min-width:106px!important;min-height:106px!important;max-width:106px!important;max-height:106px!important;border-radius:28px!important;background-size:contain!important;background-position:center!important;background-repeat:no-repeat!important;background-color:transparent!important;box-shadow:none!important}
  #loop-services-section .loop-category-carousel-v4-img{opacity:0!important;visibility:hidden!important}
  #loop-services-section .loop-category-carousel-v4-card:nth-child(1) .loop-category-carousel-v4-image{background-image:url("/assets/images/Servicios/loop-p6-belleza.svg")!important}
  #loop-services-section .loop-category-carousel-v4-card:nth-child(2) .loop-category-carousel-v4-image{background-image:url("/assets/images/Servicios/loop-p6-bienestar.svg")!important}
  #loop-services-section .loop-category-carousel-v4-card:nth-child(3) .loop-category-carousel-v4-image{background-image:url("/assets/images/Servicios/loop-p6-eventos.svg")!important}
  #loop-services-section .loop-category-carousel-v4-card:nth-child(4) .loop-category-carousel-v4-image{background-image:url("/assets/images/Servicios/loop-p6-fitness.svg")!important}
  #loop-services-section .loop-category-carousel-v4-card:nth-child(5) .loop-category-carousel-v4-image{background-image:url("/assets/images/Servicios/loop-p6-otros.svg")!important}
  #loop-services-section .loop-category-carousel-v4-label{margin-top:12px!important;color:#17120c!important;font-size:13px!important;line-height:1.13!important;font-weight:850!important;letter-spacing:-.02em!important}
  .loop-section:not(#loop-services-section){background:#fff8ee!important;max-width:none!important;padding:48px var(--loop-p6-pad) 58px!important;border-top:1px solid rgba(96,73,45,.16)!important}
  .loop-section:not(#loop-services-section) .loop-section-card{width:min(100%,1450px)!important;margin:0 auto!important;background:transparent!important;border:0!important;box-shadow:none!important;padding:0!important}
  .loop-section-title{color:#17120c!important;font-size:clamp(34px,3.2vw,52px)!important;line-height:.96!important;letter-spacing:-.068em!important}
  .loop-section-copy{color:#5d5141!important;font-size:15px!important;font-weight:560!important}
  @media(max-width:899px){.loop-p6-hero{min-height:auto!important;background-position:center top!important}.loop-p6-hero-overlay{display:block!important;padding:34px 18px 28px!important}.loop-p6-title{margin-top:18px!important;font-size:clamp(42px,12vw,58px)!important;line-height:.92!important}.loop-p6-subtitle{font-size:15px!important;line-height:1.45!important;margin-top:18px!important}.loop-p6-cta-card{margin-top:26px!important;width:100%!important;border-radius:26px!important;padding:20px!important}.loop-p6-store-row{grid-template-columns:1fr!important}#loop-services-section{padding-top:24px!important;padding-bottom:28px!important}#loop-services-section .loop-category-carousel-v4{justify-content:flex-start!important;gap:18px!important}#loop-services-section .loop-category-carousel-v4-card{width:116px!important;min-width:116px!important;max-width:116px!important;min-height:140px!important}#loop-services-section .loop-category-carousel-v4-image{width:92px!important;height:92px!important;min-width:92px!important;min-height:92px!important;max-width:92px!important;max-height:92px!important}}



  /* LOOP PHASE 6B — REFINED MOCKUP MATCH */
  .loop-pro-shell,.loop-pro-main{background:#fff5e8!important}
  .loop-p6-hero{min-height:clamp(360px,32vw,515px)!important;background:linear-gradient(90deg,rgba(4,30,25,.64) 0%,rgba(4,30,25,.38) 31%,rgba(4,30,25,.06) 58%,rgba(4,30,25,.22) 100%),url("/assets/images/loop-phase6b-hero-bg.jpg") center/cover no-repeat!important}
  .loop-p6-hero::before{background:radial-gradient(circle at 30% 43%,rgba(255,255,255,.10),transparent 22%),linear-gradient(180deg,rgba(0,0,0,.04),rgba(0,0,0,.20))!important}
  .loop-p6-hero-overlay{padding:clamp(38px,5vw,76px) var(--loop-p6-pad) clamp(34px,4.4vw,60px)!important;grid-template-columns:minmax(0,.92fr) minmax(340px,420px)!important}
  .loop-p6-title{font-size:clamp(54px,5.4vw,86px)!important;line-height:.90!important}.loop-p6-subtitle{max-width:720px!important;margin-top:20px!important;font-size:clamp(16px,1.28vw,20px)!important}
  .loop-p6-cta-card{width:min(100%,395px)!important;border-radius:32px!important;padding:25px!important}.loop-p6-primary{min-height:54px!important;margin-top:18px!important}.loop-p6-store-row{grid-template-columns:1fr 1fr!important;gap:10px!important}.loop-p6-store-btn{min-height:48px!important;gap:8px!important;font-size:14px!important}
  .loop-p6-platform-icon{width:21px!important;height:21px!important;display:inline-block!important;background:currentColor!important;flex:0 0 auto!important}.loop-p6-apple{-webkit-mask:url("/assets/icons/apple.svg") center/contain no-repeat!important;mask:url("/assets/icons/apple.svg") center/contain no-repeat!important}.loop-p6-android{-webkit-mask:url("/assets/icons/android.svg") center/contain no-repeat!important;mask:url("/assets/icons/android.svg") center/contain no-repeat!important}
  #loop-services-section,.loop-section:not(#loop-services-section),.loop-natural-footer{background:#fff5e8!important}#loop-services-section{padding-top:28px!important;padding-bottom:36px!important}.loop-section:not(#loop-services-section){border-top:1px solid rgba(96,73,45,.15)!important}
  #loop-services-section .loop-category-carousel-v4-image{width:110px!important;height:110px!important;min-width:110px!important;min-height:110px!important;max-width:110px!important;max-height:110px!important;background-size:contain!important;background-color:transparent!important}#loop-services-section .loop-category-carousel-v4-img{display:none!important}
  @media(max-width:899px){.loop-p6-hero{min-height:auto!important;background-position:center!important}.loop-p6-hero-overlay{padding:30px 18px 26px!important}.loop-p6-title{font-size:clamp(40px,11vw,54px)!important}.loop-p6-cta-card{margin-top:22px!important}.loop-p6-store-row{grid-template-columns:1fr 1fr!important}#loop-services-section .loop-category-carousel-v4-image{width:92px!important;height:92px!important;min-width:92px!important;min-height:92px!important;max-width:92px!important;max-height:92px!important}}



  /* =========================================================
     LOOP PHASE 6C — POINT-BY-POINT FIX
     Decisive override for:
     1. shorter hero
     2. visible lifestyle background
     3. unified cream background
     4. visible category icons via ServicesTypeScroll
     5. SVG iOS/Android icons
     ========================================================= */

  .loop-pro-shell,
  .loop-pro-main {
    background: #fff5e8 !important;
  }

  .loop-p6-hero {
    min-height: clamp(330px, 29vw, 470px) !important;
    background:
      linear-gradient(90deg, rgba(4,30,25,.50) 0%, rgba(4,30,25,.28) 34%, rgba(4,30,25,.06) 60%, rgba(4,30,25,.18) 100%),
      url("/assets/images/loop-phase6c-hero-bg.jpg") center / cover no-repeat !important;
  }

  .loop-p6-hero::before {
    background:
      radial-gradient(circle at 27% 44%, rgba(255,255,255,.08), transparent 22%),
      linear-gradient(180deg, rgba(0,0,0,.02), rgba(0,0,0,.15)) !important;
  }

  .loop-p6-hero-overlay {
    min-height: inherit !important;
    padding: clamp(32px, 4.4vw, 66px) var(--loop-p6-pad) clamp(30px, 3.8vw, 52px) !important;
    grid-template-columns: minmax(0,.92fr) minmax(320px,390px) !important;
    gap: clamp(34px, 6vw, 88px) !important;
  }

  .loop-p6-title {
    font-size: clamp(50px, 5vw, 78px) !important;
    line-height: .90 !important;
  }

  .loop-p6-subtitle {
    max-width: 720px !important;
    margin-top: 18px !important;
    font-size: clamp(15px, 1.14vw, 18px) !important;
    line-height: 1.44 !important;
  }

  .loop-p6-kicker {
    padding: 7px 12px !important;
    font-size: 10.5px !important;
  }

  .loop-p6-cta-card {
    width: min(100%, 374px) !important;
    border-radius: 28px !important;
    padding: 22px !important;
  }

  .loop-p6-cta-card strong {
    font-size: 19px !important;
  }

  .loop-p6-cta-card p {
    font-size: 13.5px !important;
    margin-top: 8px !important;
  }

  .loop-p6-primary {
    min-height: 50px !important;
    margin-top: 17px !important;
    font-size: 14.5px !important;
  }

  .loop-p6-store-row {
    margin-top: 11px !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 9px !important;
  }

  .loop-p6-store-btn {
    min-height: 44px !important;
    font-size: 13px !important;
    gap: 8px !important;
  }

  .loop-p6-platform-icon {
    width: 20px !important;
    height: 20px !important;
    display: inline-block !important;
    background: currentColor !important;
    flex: 0 0 auto !important;
  }

  .loop-p6-apple {
    -webkit-mask: url("/assets/icons/apple.svg") center / contain no-repeat !important;
    mask: url("/assets/icons/apple.svg") center / contain no-repeat !important;
  }

  .loop-p6-android {
    -webkit-mask: url("/assets/icons/android.svg") center / contain no-repeat !important;
    mask: url("/assets/icons/android.svg") center / contain no-repeat !important;
  }

  #loop-services-section,
  .loop-section:not(#loop-services-section),
  .loop-natural-footer {
    background: #fff5e8 !important;
  }

  #loop-services-section {
    padding-top: 26px !important;
    padding-bottom: 34px !important;
  }

  .loop-section:not(#loop-services-section) {
    border-top: 1px solid rgba(96,73,45,.15) !important;
  }

  #loop-services-section .loop-category-carousel-v4-card {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
  }

  #loop-services-section .loop-category-carousel-v4-image {
    width: 112px !important;
    height: 112px !important;
    min-width: 112px !important;
    min-height: 112px !important;
    max-width: 112px !important;
    max-height: 112px !important;
    background: transparent !important;
    box-shadow: none !important;
    overflow: visible !important;
  }

  #loop-services-section .loop-category-carousel-v4-img,
  #loop-services-section .loop-category-carousel-v4-image img {
    display: block !important;
    opacity: 1 !important;
    visibility: visible !important;
    width: 112px !important;
    height: 112px !important;
    min-width: 112px !important;
    min-height: 112px !important;
    max-width: 112px !important;
    max-height: 112px !important;
    object-fit: contain !important;
  }

  #loop-services-section .loop-category-carousel-v4-label {
    margin-top: 12px !important;
  }

  @media (max-width: 899px) {
    .loop-p6-hero {
      min-height: auto !important;
      background-position: center !important;
    }

    .loop-p6-hero-overlay {
      display: block !important;
      padding: 28px 18px 25px !important;
    }

    .loop-p6-title {
      font-size: clamp(38px, 10.5vw, 52px) !important;
    }

    .loop-p6-subtitle {
      font-size: 14.5px !important;
    }

    .loop-p6-cta-card {
      margin-top: 22px !important;
      width: 100% !important;
      border-radius: 24px !important;
      padding: 18px !important;
    }

    .loop-p6-store-row {
      grid-template-columns: 1fr 1fr !important;
    }

    #loop-services-section .loop-category-carousel-v4-image,
    #loop-services-section .loop-category-carousel-v4-img,
    #loop-services-section .loop-category-carousel-v4-image img {
      width: 92px !important;
      height: 92px !important;
      min-width: 92px !important;
      min-height: 92px !important;
      max-width: 92px !important;
      max-height: 92px !important;
    }
  }


  /* =========================================================
     LOOP MAIN MENU — NATURAL FOOTER + NO BOTTOM GAP FIX
     Fixes:
     1) Removes the empty white space after the footer.
     2) Makes footer feel part of the page, not a separate box.
     Scope: MainMenu footer only.
     ========================================================= */

  body {
    background: #fff5e8 !important;
  }

  .loop-pro-shell,
  .loop-pro-main {
    background: #fff5e8 !important;
  }

  .loop-pro-main {
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
    min-height: auto !important;
  }

  .loop-natural-footer {
    width: 100% !important;
    max-width: none !important;
    margin: 0 !important;

    padding:
      28px
      clamp(22px, 5vw, 72px)
      max(24px, env(safe-area-inset-bottom, 0px)) !important;

    background: #fff5e8 !important;
    background-image: none !important;

    border-top: 1px solid rgba(96, 73, 45, .12) !important;
    border-left: 0 !important;
    border-right: 0 !important;
    border-bottom: 0 !important;

    border-radius: 0 !important;
    box-shadow: none !important;
    outline: 0 !important;

    box-sizing: border-box !important;
  }

  .loop-natural-footer-inner {
    width: min(100%, 1450px) !important;
    max-width: 1450px !important;
    margin: 0 auto !important;

    padding: 0 !important;
    background: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;

    display: grid !important;
    grid-template-columns: minmax(260px, 1fr) auto minmax(130px, .45fr) !important;
    align-items: center !important;
    gap: 24px !important;
  }

  .loop-natural-footer-brand,
  .loop-natural-footer-links,
  .loop-natural-footer-meta {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
  }

  .loop-natural-footer-links {
    justify-self: center !important;
  }

  .loop-natural-footer-meta {
    justify-self: end !important;
  }

  .loop-natural-footer-logo {
    color: #17120c !important;
  }

  .loop-natural-footer-copy,
  .loop-natural-footer-meta {
    color: #6f6250 !important;
  }

  .loop-natural-footer button {
    background: transparent !important;
    box-shadow: none !important;
  }

  /* Prevent any last child margin from creating a fake blank band below footer. */
  .loop-pro-main > *:last-child,
  .loop-pro-shell > *:last-child {
    margin-bottom: 0 !important;
  }

  @media (max-width: 899px) {
    .loop-pro-main {
      padding-bottom: 0 !important;
    }

    .loop-natural-footer {
      padding:
        24px
        18px
        calc(var(--loop-mobile-nav-height, 72px) + max(env(safe-area-inset-bottom, 0px), 12px)) !important;
    }

    .loop-natural-footer-inner {
      display: flex !important;
      align-items: flex-start !important;
      flex-direction: column !important;
      gap: 14px !important;
      margin: 0 !important;
      width: 100% !important;
      max-width: none !important;
    }

    .loop-natural-footer-links {
      justify-content: flex-start !important;
      justify-self: start !important;
    }

    .loop-natural-footer-meta {
      justify-self: start !important;
    }
  }


  /* =========================================================
     LOOP MAIN MENU — FOOTER ORGANIC BLEND FIX
     Removes the visual "footer box" / double cream tone.
     Keeps layout, typography and content exactly as-is.
     ========================================================= */

  .loop-natural-footer {
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;

    box-shadow: none !important;
    border-radius: 0 !important;
    outline: 0 !important;

    /* Keep it as part of the page, not as its own card/surface */
    isolation: auto !important;
  }

  .loop-natural-footer::before,
  .loop-natural-footer::after {
    display: none !important;
    content: none !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .loop-natural-footer-inner {
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;

    border: 0 !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    outline: 0 !important;

    padding: 0 !important;
  }

  .loop-natural-footer-inner::before,
  .loop-natural-footer-inner::after {
    display: none !important;
    content: none !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .loop-natural-footer-brand,
  .loop-natural-footer-links,
  .loop-natural-footer-meta {
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;
    border: 0 !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  }

  .loop-natural-footer button,
  .loop-natural-footer a {
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  }

  /* The page and footer must share the exact same final background. */
  .loop-pro-shell,
  .loop-pro-main,
  .loop-natural-footer {
    background-color: #fff5e8 !important;
  }

  .loop-pro-shell {
    background-image:
      radial-gradient(circle at 8% 4%, rgba(0, 137, 127, 0.045), transparent 28%),
      radial-gradient(circle at 95% 16%, rgba(15, 118, 110, 0.028), transparent 32%),
      linear-gradient(180deg, #fffaf4 0%, #fff5e8 68%, #fff5e8 100%) !important;
  }

  .loop-pro-main {
    background-image: none !important;
  }

  /* Keep only a subtle divider line, not a rectangular footer surface. */
  .loop-natural-footer {
    border-top: 1px solid rgba(96, 73, 45, .10) !important;
    margin-top: 0 !important;
  }


  /* =========================================================
     LOOP MAIN MENU — FOOTER NO RECTANGLE FINAL
     Removes the visible cream rectangle around the footer.
     Keeps text, layout and positioning the same.
     ========================================================= */

  html,
  body,
  #root,
  .loop-pro-shell,
  .loop-pro-main {
    background-color: #fff8ef !important;
  }

  .loop-pro-shell {
    background-image:
      radial-gradient(circle at 8% 4%, rgba(0, 137, 127, 0.04), transparent 28%),
      radial-gradient(circle at 95% 16%, rgba(15, 118, 110, 0.026), transparent 32%),
      linear-gradient(180deg, #fffaf4 0%, #fff8ef 62%, #fff8ef 100%) !important;
  }

  .loop-pro-main {
    background: transparent !important;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }

  .loop-natural-footer {
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;

    border: 0 !important;
    border-top: 0 !important;
    border-bottom: 0 !important;
    box-shadow: none !important;
    outline: 0 !important;
    border-radius: 0 !important;

    max-width: 1500px !important;
    margin: 0 auto !important;
    padding-top: 26px !important;
    padding-bottom: 26px !important;

    position: relative !important;
    overflow: visible !important;
  }

  .loop-natural-footer::before,
  .loop-natural-footer::after {
    display: none !important;
    content: none !important;
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
  }

  .loop-natural-footer-inner {
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;

    border: 0 !important;
    box-shadow: none !important;
    outline: 0 !important;
    border-radius: 0 !important;

    padding: 0 !important;
    margin: 0 !important;
  }

  .loop-natural-footer-inner::before,
  .loop-natural-footer-inner::after {
    display: none !important;
    content: none !important;
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
  }

  .loop-natural-footer-brand,
  .loop-natural-footer-links,
  .loop-natural-footer-meta,
  .loop-natural-footer-logo,
  .loop-natural-footer-copy {
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;
    border: 0 !important;
    box-shadow: none !important;
    outline: 0 !important;
  }

  .loop-natural-footer button,
  .loop-natural-footer a,
  .loop-natural-footer span,
  .loop-natural-footer strong,
  .loop-natural-footer div {
    background-color: transparent !important;
    background-image: none !important;
    box-shadow: none !important;
  }

  /* Some previous footer fixes created the rectangle by forcing a footer background.
     This neutralizes those rules without changing the footer content layout. */
  .loop-pro-shell .loop-natural-footer,
  .loop-pro-main .loop-natural-footer,
  footer.loop-natural-footer {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
  }

  @media (max-width: 899px) {
    .loop-natural-footer {
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
      padding-bottom: calc(var(--loop-mobile-nav-height, 72px) + max(env(safe-area-inset-bottom, 0px), 12px)) !important;
    }
  }

  /* =========================================================
     LOOP FOOTER V2.1 — COMPACT LEGAL FOOTER
     Smaller, same cream background as the home page, legal links only.
     ========================================================= */

  .loop-natural-footer.loop-natural-footer-v2 {
    width: 100% !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 22px clamp(18px, 5vw, 72px) 18px !important;
    background: #fff5e8 !important;
    background-color: #fff5e8 !important;
    background-image: none !important;
    border: 0 !important;
    border-top: 1px solid rgba(96, 73, 45, 0.12) !important;
    box-shadow: none !important;
    color: #17120c !important;
  }

  .loop-natural-footer.loop-natural-footer-v2::before,
  .loop-natural-footer.loop-natural-footer-v2::after {
    display: none !important;
    content: none !important;
  }

  .loop-footer-v2-inner {
    width: min(100%, 1360px) !important;
    margin: 0 auto !important;
    padding: 0 !important;
    display: grid !important;
    grid-template-columns: minmax(260px, 1fr) auto !important;
    align-items: center !important;
    gap: 22px !important;
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
  }

  .loop-footer-v2-brand {
    min-width: 0 !important;
    display: grid !important;
    gap: 5px !important;
  }

  .loop-footer-v2-brandline {
    display: block !important;
  }

  .loop-footer-v2-mark,
  .loop-footer-v2-badge,
  .loop-footer-v2-note,
  .loop-footer-v2-column h3 {
    display: none !important;
  }

  .loop-footer-v2-logo {
    margin: 0 !important;
    color: #17120c !important;
    font-size: 14px !important;
    line-height: 1.15 !important;
    font-weight: 950 !important;
    letter-spacing: -0.025em !important;
  }

  .loop-footer-v2-copy {
    margin: 0 !important;
    max-width: 520px !important;
    color: #6f6356 !important;
    font-size: 12.5px !important;
    line-height: 1.38 !important;
    font-weight: 720 !important;
    letter-spacing: -0.005em !important;
  }

  .loop-footer-v2-columns {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 12px !important;
    flex-wrap: wrap !important;
    width: auto !important;
    min-width: 0 !important;
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
  }

  .loop-footer-v2-column {
    display: contents !important;
  }

  .loop-footer-v2-links {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 6px !important;
    flex-wrap: wrap !important;
  }

  .loop-footer-v2-links button {
    appearance: none !important;
    margin: 0 !important;
    padding: 8px 10px !important;
    border: 1px solid rgba(96, 73, 45, 0.10) !important;
    border-radius: 999px !important;
    background: rgba(255, 250, 244, 0.58) !important;
    color: #6f6356 !important;
    font-size: 12.5px !important;
    line-height: 1 !important;
    font-weight: 850 !important;
    letter-spacing: -0.008em !important;
    text-align: center !important;
    cursor: pointer !important;
    transition: color 150ms ease, border-color 150ms ease, background 150ms ease !important;
  }

  .loop-footer-v2-links button:hover {
    color: #00675f !important;
    border-color: rgba(0, 103, 95, 0.18) !important;
    background: rgba(255, 250, 244, 0.86) !important;
    transform: none !important;
  }

  .loop-footer-v2-bottom {
    width: min(100%, 1360px) !important;
    margin: 14px auto 0 !important;
    padding-top: 12px !important;
    border-top: 1px solid rgba(96, 73, 45, 0.08) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 14px !important;
    color: rgba(91, 74, 56, 0.70) !important;
    font-size: 12px !important;
    line-height: 1.3 !important;
    font-weight: 760 !important;
  }

  .loop-footer-v2-contact {
    width: fit-content !important;
    color: #00675f !important;
    text-decoration: none !important;
    font-size: 12px !important;
    line-height: 1.2 !important;
    font-weight: 900 !important;
    letter-spacing: -0.005em !important;
  }

  .loop-footer-v2-contact:hover {
    text-decoration: underline !important;
  }

  @media (max-width: 760px) {
    .loop-natural-footer.loop-natural-footer-v2 {
      padding: 20px 18px calc(max(env(safe-area-inset-bottom, 0px), 10px) + 18px) !important;
    }

    .loop-footer-v2-inner {
      grid-template-columns: 1fr !important;
      align-items: start !important;
      gap: 14px !important;
    }

    .loop-footer-v2-columns,
    .loop-footer-v2-links {
      justify-content: flex-start !important;
      gap: 6px !important;
    }

    .loop-footer-v2-links button {
      padding: 8px 9px !important;
      font-size: 12px !important;
    }

    .loop-footer-v2-bottom {
      align-items: flex-start !important;
      flex-direction: column !important;
      gap: 7px !important;
      margin-top: 14px !important;
      padding-top: 11px !important;
      font-size: 11.8px !important;
    }
  }


`;




function LoopNaturalFooter({ navigate }) {
  useLanguage();
  const year = new Date().getFullYear();

  const legalLinks = [
    { label: "Soporte", onClick: () => navigate("/soporte") },
    { label: "Privacidad", onClick: () => navigate("/privacidad") },
    { label: "Términos", onClick: () => navigate("/terminos") },
    { label: "Política de pagos", onClick: () => navigate("/politica-de-pagos") },
  ];

  return (
    <footer className="loop-natural-footer loop-natural-footer-v2" aria-label={translateInterface("Footer de Loop Reservas")}>
      <div className="loop-footer-v2-inner">
        <div className="loop-footer-v2-brand">
          <div className="loop-footer-v2-brandline">
            <div className="loop-footer-v2-logo">Loop Reservas</div>
          </div>

          <p className="loop-footer-v2-copy">
            {translateInterface('Reserva servicios locales de forma simple, rápida y segura.')}
          </p>
        </div>

        <nav className="loop-footer-v2-columns" aria-label={translateInterface("Enlaces legales de Loop")}>
          <div className="loop-footer-v2-column">
            <h3>Legal</h3>
            <div className="loop-footer-v2-links">
              {legalLinks.map((link) => (
                <button type="button" key={translateInterface(link.label)} onClick={link.onClick}>
                  {translateInterface(link.label)}
                </button>
              ))}
            </div>
          </div>
        </nav>
      </div>

      <div className="loop-footer-v2-bottom">
        <span>© {year} Loop Software S.A.</span>
        <a className="loop-footer-v2-contact" href="mailto:soporte@loopreservas.com">
          soporte@loopreservas.com
        </a>
      </div>
    </footer>
  );
}


function BottomNavIcon({ type }) {
  const common = {
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };

  if (type === "search") {
    return <svg {...common}><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>;
  }
  if (type === "calendar") {
    return <svg {...common}><path d="M8 2v4" /><path d="M16 2v4" /><path d="M3.5 9.5h17" /><path d="M5.5 5h13A2.5 2.5 0 0 1 21 7.5v11A2.5 2.5 0 0 1 18.5 21h-13A2.5 2.5 0 0 1 3 18.5v-11A2.5 2.5 0 0 1 5.5 5Z" /></svg>;
  }
  if (type === "bookings") {
    return <svg {...common}><path d="M6.5 4.5A2.5 2.5 0 0 1 9 2h6a2.5 2.5 0 0 1 2.5 2.5V21L12 17.8 6.5 21V4.5Z" /></svg>;
  }
  return <svg {...common}><path d="M20 21a8 8 0 1 0-16 0" /><circle cx="12" cy="7" r="4" /></svg>;
}

function MobileBottomNav({ navigate, location, isLoggedIn, onOpenCalendar, onShowMyBookings, onOpenProfileSheet }) {
  const path = location?.pathname || "/";
  const navRef = useRef(null);

  useEffect(() => {
    const updateNavHeight = () => {
      try {
        const nav = navRef.current;
        if (!nav || typeof document === "undefined") return;

        const rect = nav.getBoundingClientRect();
        const measured = Math.ceil(rect.height || 72);

        // Keep a sane range: enough for Android/iOS, but never creates a huge white gap.
        const clamped = Math.max(66, Math.min(measured, 92));
        document.documentElement.style.setProperty("--loop-mobile-nav-height", "0px");
      } catch (_) {}
    };

    updateNavHeight();

    try {
      window.addEventListener("resize", updateNavHeight);
      window.addEventListener("orientationchange", updateNavHeight);
      if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", updateNavHeight);
        window.visualViewport.addEventListener("scroll", updateNavHeight);
      }
    } catch (_) {}

    const timeout = setTimeout(updateNavHeight, 250);

    return () => {
      clearTimeout(timeout);
      try {
        window.removeEventListener("resize", updateNavHeight);
        window.removeEventListener("orientationchange", updateNavHeight);
        if (window.visualViewport) {
          window.visualViewport.removeEventListener("resize", updateNavHeight);
          window.visualViewport.removeEventListener("scroll", updateNavHeight);
        }
      } catch (_) {}
    };
  }, []);

  const navStyle = {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9998,
    paddingTop: 8,
    paddingLeft: 14,
    paddingRight: 14,
    paddingBottom: "max(8px, env(safe-area-inset-bottom, 0px))",
    background: "#ffffff",
    borderTop: "1px solid rgba(226,232,240,0.92)",
    boxShadow: "0 -12px 30px rgba(15,23,42,0.08)",
    overflow: "visible",
  };

  const innerStyle = {
    display: "grid",
    gridTemplateColumns: isLoggedIn ? "repeat(4, 1fr)" : "1fr 1.45fr",
    gap: 2,
    maxWidth: 520,
    margin: "0 auto",
  };

  const buttonStyle = (active) => ({
    appearance: "none",
    border: 0,
    background: active ? "rgba(0,103,95,0.07)" : "transparent",
    color: active ? "#00675f" : "#64748b",
    minHeight: 46,
    borderRadius: 16,
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 3,
    fontSize: 11.5,
    fontWeight: 850,
    letterSpacing: "-0.01em",
    cursor: "pointer",
    padding: 0,
    lineHeight: 1.1,
  });

  const openSearch = () => {
    try { window.dispatchEvent(new Event("loop-open-mobile-search")); } catch (_) {}
  };

  const openCalendar = () => {
    if (!isLoggedIn) {
      navigate("/login?from=%2Fopen-calendar");
      return;
    }
    if (typeof onOpenCalendar === "function") {
      onOpenCalendar(null);
      return;
    }
    navigate("/open-calendar");
  };

  const openBookings = () => {
    if (!isLoggedIn) {
      navigate("/login?from=%2Fmy-bookings");
      return;
    }
    if (typeof onShowMyBookings === "function") {
      onShowMyBookings();
      return;
    }
    navigate("/my-bookings");
  };

  const openProfile = () => {
    if (!isLoggedIn) {
      navigate("/login");
      return;
    }
    if (typeof onOpenProfileSheet === "function") onOpenProfileSheet();
  };

  return (
    <nav ref={navRef} style={navStyle} aria-label={translateInterface("Navegación principal mobile")}>
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: -36,
          height: "calc(36px + env(safe-area-inset-bottom, 0px))",
          background: "#ffffff",
          zIndex: -1,
          pointerEvents: "none",
        }}
      />

      <div style={innerStyle}>
        <button type="button" onClick={openSearch} style={buttonStyle(path === "/")}>
          <BottomNavIcon type="search" />
          <span>{translateInterface("Buscar")}</span>
        </button>

        {isLoggedIn ? (
          <>
            <button type="button" onClick={openCalendar} style={buttonStyle(path.includes("calendar") || path === "/open-calendar")}>
              <BottomNavIcon type="calendar" />
              <span>{translateInterface("Calendario")}</span>
            </button>

            <button type="button" onClick={openBookings} style={buttonStyle(path.includes("my-bookings"))}>
              <BottomNavIcon type="bookings" />
              <span>{translateInterface("Reservas")}</span>
            </button>

            <button type="button" onClick={openProfile} style={buttonStyle(path.includes("profile") || path.includes("owner-businesses"))}>
              <BottomNavIcon type="profile" />
              <span>{translateInterface("Perfil")}</span>
            </button>
          </>
        ) : (
          <button
            type="button"
            onClick={() => navigate("/login")}
            style={{
              ...buttonStyle(false),
              flexDirection: "row",
              gap: 8,
              background: "linear-gradient(135deg, #00675f, #00897f)",
              color: "#ffffff",
              boxShadow: "0 12px 26px rgba(0,103,95,0.22)",
              fontSize: 13,
            }}
          >
            <BottomNavIcon type="profile" />
            <span>{translateInterface("Conectarse")}</span>
          </button>
        )}
      </div>
    </nav>
  );
}

function MobileProfileSheet({ open, onClose, userName, userEmail, navigate, onShowMyBookings, onShowMyLoyalty, onOpenCalendar, onShowUserProfile, onAdminManage, onShowPending, onCreateBusiness, onLogout, canManageBusinesses = false, canOpenCalendar = false, canAdminPlatform = false }) {
  useLanguage();
  const dialogRef = useRef(null);
  useEffect(() => {
    if (!open) return;
    const previous = document.activeElement;
    dialogRef.current?.querySelector('button')?.focus();
    return () => previous?.focus?.();
  }, [open]);
  if (!open) return null;

  const initial = (userName && String(userName).trim()[0]) || (userEmail && String(userEmail).trim()[0]) || "U";

  const run = (fn, fallbackPath) => {
    try { onClose(); } catch (_) {}
    try {
      if (typeof fn === "function") {
        fn();
        return;
      }
      if (fallbackPath) navigate(fallbackPath);
    } catch (_) {
      if (fallbackPath) {
        try { navigate(fallbackPath); } catch (e) {}
      }
    }
  };

  const Icon = ({ type }) => {
    const common = {
      width: 20,
      height: 20,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2.05,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": true,
    };

    if (type === "bookings") return <svg {...common}><path d="M6.5 4.5A2.5 2.5 0 0 1 9 2h6a2.5 2.5 0 0 1 2.5 2.5V21L12 17.8 6.5 21V4.5Z" /></svg>;
    if (type === "rating") return <svg {...common}><path d="M12 17.3 6.8 20l1-5.8-4.2-4.1 5.8-.8L12 4l2.6 5.3 5.8.8-4.2 4.1 1 5.8L12 17.3Z" /></svg>;
    if (type === "calendar") return <svg {...common}><path d="M8 2v4" /><path d="M16 2v4" /><path d="M3.5 9.5h17" /><path d="M5.5 5h13A2.5 2.5 0 0 1 21 7.5v11A2.5 2.5 0 0 1 18.5 21h-13A2.5 2.5 0 0 1 3 18.5v-11A2.5 2.5 0 0 1 5.5 5Z" /></svg>;
    if (type === "business") return <svg {...common}><path d="M3 21h18" /><path d="M5 21V7l7-4 7 4v14" /><path d="M9 21v-6h6v6" /></svg>;
    if (type === "admin") return <svg {...common}><path d="M12 3l8 4v6c0 5-3.5 7.5-8 8-4.5-.5-8-3-8-8V7l8-4Z" /><path d="M9 12l2 2 4-4" /></svg>;
    if (type === "logout") return <svg {...common}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" /></svg>;
    return <svg {...common}><path d="M20 21a8 8 0 1 0-16 0" /><circle cx="12" cy="7" r="4" /></svg>;
  };

  const iconBox = {
    width: 42,
    height: 42,
    borderRadius: 16,
    background: "rgba(0,103,95,0.08)",
    color: "#00675f",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 auto",
  };

  const rowStyle = {
    width: "100%",
    minHeight: 58,
    border: 0,
    background: "transparent",
    borderRadius: 18,
    padding: "9px 10px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    textAlign: "left",
    cursor: "pointer",
  };

  const rows = [
    { key: "profile", label: "Mi perfil", desc: "Cuenta y datos personales", icon: "profile", onClick: () => run(onShowUserProfile, "/profile") },
    ...(canAdminPlatform
      ? [
        { key: "owner-console", label: "Loop Admin", desc: "Administración de la plataforma", icon: "admin", onClick: () => run(null, "/owner-console") },
        { key: "early-access-admin", label: "Negocios interesados", desc: "Solicitudes de acceso", icon: "admin", onClick: () => run(null, "/admin/early-access") },
      ]
      : []),
    { key: "bookings", label: "Mis reservas", desc: "Activas e historial", icon: "bookings", onClick: () => run(onShowMyBookings, "/my-bookings") },
    { key: "loyalty", label: "Mis beneficios", desc: "Membresías, sellos y recompensas", icon: "rating", onClick: () => run(onShowMyLoyalty, "/my-benefits") },
    { key: "ratings", label: "Calificar servicios", desc: "Servicios completados por valorar", icon: "rating", onClick: () => run(onShowPending, "/calificar-servicios") },
    ...(canOpenCalendar ? [{ key: "calendar", label: "Calendario", desc: "Agenda y disponibilidad", icon: "calendar", onClick: () => run(onOpenCalendar, "/open-calendar") }] : []),
    { key: "business", label: "Crear negocio", desc: "Publica tus servicios", icon: "business", onClick: () => run(onCreateBusiness, "/new-business") },
  ];

  if (canManageBusinesses) {
    rows.splice(3, 0, { key: "admin", label: "Mi negocio", desc: "Servicios, equipo y agenda", icon: "admin", onClick: () => run(onAdminManage, "/owner-businesses") });
  }

  return (
    <div ref={dialogRef} onKeyDown={event => {
      if (event.key === "Escape") { event.preventDefault(); onClose(); }
      if (event.key === "Tab") {
        const buttons = [...(dialogRef.current?.querySelectorAll('button:not(:disabled)') || [])];
        const first = buttons[0], last = buttons[buttons.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    }} role="dialog" aria-modal="true" aria-label={translateInterface("Menú de perfil")} style={{ position: "fixed", inset: 0, zIndex: 10050 }}>
      <button type="button" aria-label={translateInterface("Cerrar menú de perfil")} onClick={onClose} style={{ position: "absolute", inset: 0, border: 0, background: "rgba(15,23,42,0.32)", backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)", padding: 0, margin: 0 }} />

      <div style={{ position: "absolute", left: 10, right: 10, bottom: "calc(max(env(safe-area-inset-bottom, 0px), 10px) + 10px)", borderRadius: 28, background: "#ffffff", border: "1px solid rgba(226,232,240,0.96)", boxShadow: "0 28px 90px rgba(15,23,42,0.28)", maxHeight: "calc(100dvh - 40px)", overflowY: "auto", overscrollBehavior: "contain" }}>
        <div style={{ padding: "10px 0 6px", display: "flex", justifyContent: "center" }}>
          <div aria-hidden="true" style={{ width: 42, height: 5, borderRadius: 999, background: "#cbd5e1" }} />
        </div>

        <div style={{ padding: "10px 18px 15px", borderBottom: "1px solid #f1f5f9" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 48, height: 48, borderRadius: 999, background: "linear-gradient(135deg, #00675f, #0f766e)", color: "#ffffff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 950, fontSize: 17, boxShadow: "0 14px 30px rgba(0,103,95,0.22)", flex: "0 0 auto" }}>
              {String(initial).toUpperCase()}
            </div>

            <div style={{ minWidth: 0, flex: 1 }}>
              <div style={{ color: "#0f172a", fontSize: 17, fontWeight: 950, letterSpacing: "-0.025em", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {userName || "Mi cuenta"}
              </div>
              <div style={{ color: "#64748b", fontSize: 13, fontWeight: 700, marginTop: 2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {userEmail || "Loop Reservas"}
              </div>
            </div>
          </div>
        </div>

        <div style={{ padding: 8 }}>
          {rows.map((item) => (
            <button key={item.key} type="button" onClick={item.onClick} style={rowStyle}>
              <span style={iconBox}><Icon type={item.icon} /></span>
              <span style={{ minWidth: 0, flex: 1 }}>
                <span style={{ display: "block", color: "#0f172a", fontSize: 14.5, fontWeight: 900 }}>{translateInterface(item.label)}</span>
                <span style={{ display: "block", color: "#64748b", fontSize: 12.5, fontWeight: 650, marginTop: 2 }}>{translateInterface(item.desc)}</span>
              </span>
              <span style={{ color: "#cbd5e1", fontWeight: 900 }}>›</span>
            </button>
          ))}

          <div style={{ height: 1, background: "#f1f5f9", margin: "8px 10px" }} />

          <button type="button" onClick={() => run(onLogout, "/login")} style={rowStyle}>
            <span style={{ ...iconBox, background: "#fef2f2", color: "#dc2626" }}><Icon type="logout" /></span>
            <span style={{ color: "#dc2626", fontSize: 14.5, fontWeight: 900 }}>{translateInterface("Cerrar sesión")}</span>
          </button>
        </div>
      </div>
    </div>
  );
}


/* -------------------- Main component -------------------- */
const categoryTextClipFix = `


  #loop-services-section {
    padding-bottom: 66px !important;
  }

  /* PHASE 6H — CATEGORY ICONS ONLY
     Keeps current hero untouched and renders clean imported PNG icons. */
  #loop-services-section .loop-categories-visual-wrap {
    width: 100% !important;
  }

  #loop-services-section .loop-direct-categories {
    width: min(100%, 1120px) !important;
    margin: 0 auto !important;
    display: flex !important;
    align-items: flex-start !important;
    justify-content: center !important;
    gap: clamp(30px, 6vw, 78px) !important;
    flex-wrap: nowrap !important;
  }

  #loop-services-section .loop-direct-category-card {
    appearance: none !important;
    -webkit-appearance: none !important;
    border: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
    width: 132px !important;
    min-width: 132px !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: flex-start !important;
    cursor: pointer !important;
    text-align: center !important;
    overflow: visible !important;
  }

  #loop-services-section .loop-direct-category-icon {
    width: 112px !important;
    height: 112px !important;
    min-width: 112px !important;
    min-height: 112px !important;
    border-radius: 30px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    overflow: visible !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  #loop-services-section .loop-direct-category-icon img {
    display: block !important;
    width: 112px !important;
    height: 112px !important;
    max-width: 112px !important;
    max-height: 112px !important;
    object-fit: contain !important;
    object-position: center !important;
    opacity: 1 !important;
    visibility: visible !important;
    transform: none !important;
    filter: none !important;
  }

  #loop-services-section .loop-direct-category-label {
    margin-top: 12px !important;
    display: block !important;
    color: #0f172a !important;
    font-size: 14px !important;
    line-height: 1.12 !important;
    font-weight: 900 !important;
    letter-spacing: -0.035em !important;
    text-align: center !important;
    white-space: normal !important;
  }

  #loop-services-section .loop-direct-category-card:hover .loop-direct-category-icon img {
    transform: translateY(-2px) !important;
  }

  @media (max-width: 899px) {
    #loop-services-section .loop-direct-categories {
      justify-content: flex-start !important;
      gap: 16px !important;
      overflow-x: auto !important;
      padding: 0 4px 6px !important;
      -webkit-overflow-scrolling: touch !important;
      scrollbar-width: none !important;
    }

    #loop-services-section .loop-direct-categories::-webkit-scrollbar {
      display: none !important;
    }

    #loop-services-section .loop-direct-category-card {
      width: 104px !important;
      min-width: 104px !important;
    }

    #loop-services-section .loop-direct-category-icon,
    #loop-services-section .loop-direct-category-icon img {
      width: 92px !important;
      height: 92px !important;
      min-width: 92px !important;
      min-height: 92px !important;
      max-width: 92px !important;
      max-height: 92px !important;
    }

    #loop-services-section .loop-direct-category-label {
      font-size: 12.5px !important;
      line-height: 1.12 !important;
    }
  }

`;


/* =========================================================
   PHASE 6D — HERO BACKGROUND ONLY / CONNECTED TO IMAGE
   This keeps the full MainMenu logic intact and only overrides
   the hero visual so it uses the premium wellness lounge image.
   Asset path: public/assets/images/loop-wellness-lounge-hero.png
   ========================================================= */
const phase6dHeroConnectedToImage = `
  :root {
    --loop-p6-pad: clamp(20px, 5vw, 72px);
    --loop-p6-cream: #fff8ee;
    --loop-p6-green: #07584f;
    --loop-p6-green-2: #0c6f63;
  }

  .loop-pro-main {
    background: #fff8ee !important;
  }

  .loop-p6-hero {
    position: relative !important;
    width: 100% !important;
    margin: 0 !important;
    min-height: clamp(340px, 32vw, 500px) !important;
    overflow: hidden !important;
    border-bottom: 1px solid rgba(255, 248, 238, 0.78) !important;
    background:
      linear-gradient(
        90deg,
        rgba(4, 26, 22, 0.74) 0%,
        rgba(4, 26, 22, 0.54) 30%,
        rgba(4, 26, 22, 0.18) 56%,
        rgba(4, 26, 22, 0.28) 100%
      ),
      url("/assets/images/loop-wellness-lounge-hero.png") center center / cover no-repeat !important;
  }

  .loop-p6-hero::before {
    content: "" !important;
    position: absolute !important;
    inset: 0 !important;
    pointer-events: none !important;
    background:
      radial-gradient(circle at 35% 35%, rgba(255, 248, 238, 0.10), transparent 26%),
      linear-gradient(180deg, rgba(0,0,0,0.03), rgba(0,0,0,0.18)) !important;
  }

  .loop-p6-hero-overlay {
    position: relative !important;
    z-index: 1 !important;
    width: min(100%, 1540px) !important;
    min-height: inherit !important;
    margin: 0 auto !important;
    padding: clamp(38px, 4.8vw, 72px) var(--loop-p6-pad) clamp(34px, 4vw, 58px) !important;
    display: grid !important;
    grid-template-columns: minmax(0, 0.95fr) minmax(330px, 400px) !important;
    gap: clamp(36px, 6vw, 96px) !important;
    align-items: center !important;
  }

  .loop-p6-kicker {
    display: inline-flex !important;
    align-items: center !important;
    gap: 10px !important;
    width: fit-content !important;
    padding: 8px 14px !important;
    border-radius: 999px !important;
    background: rgba(255, 248, 238, 0.94) !important;
    border: 1px solid rgba(255, 255, 255, 0.74) !important;
    color: #07584f !important;
    font-size: 11px !important;
    font-weight: 950 !important;
    letter-spacing: 0.14em !important;
    text-transform: uppercase !important;
    box-shadow: 0 16px 32px rgba(0, 0, 0, 0.12) !important;
    backdrop-filter: blur(16px) !important;
    -webkit-backdrop-filter: blur(16px) !important;
  }

  .loop-p6-kicker span {
    width: 8px !important;
    height: 8px !important;
    border-radius: 999px !important;
    background: #07584f !important;
    box-shadow: 0 0 0 6px rgba(7, 88, 79, 0.11) !important;
  }

  .loop-p6-title {
    margin: 22px 0 0 !important;
    max-width: 780px !important;
    color: #fff8ee !important;
    text-shadow: 0 5px 22px rgba(0, 0, 0, 0.30) !important;
    font-size: clamp(52px, 5.5vw, 86px) !important;
    line-height: 0.90 !important;
    letter-spacing: -0.082em !important;
    font-weight: 950 !important;
  }

  .loop-p6-title span {
    color: #0fa08f !important;
    text-shadow: none !important;
  }

  .loop-p6-subtitle {
    max-width: 710px !important;
    margin: 22px 0 0 !important;
    color: rgba(255, 248, 238, 0.94) !important;
    text-shadow: 0 3px 14px rgba(0, 0, 0, 0.28) !important;
    font-size: clamp(16px, 1.2vw, 20px) !important;
    line-height: 1.48 !important;
    font-weight: 660 !important;
  }

  .loop-p6-cta-card {
    justify-self: end !important;
    width: min(100%, 390px) !important;
    border-radius: 32px !important;
    padding: 26px !important;
    background: rgba(255, 248, 238, 0.94) !important;
    border: 1px solid rgba(255, 255, 255, 0.72) !important;
    box-shadow: 0 28px 70px rgba(0, 0, 0, 0.20) !important;
    backdrop-filter: blur(18px) saturate(1.06) !important;
    -webkit-backdrop-filter: blur(18px) saturate(1.06) !important;
  }

  .loop-p6-cta-card strong {
    display: block !important;
    color: #17120c !important;
    font-size: 21px !important;
    line-height: 1.15 !important;
    font-weight: 950 !important;
    letter-spacing: -0.04em !important;
  }

  .loop-p6-cta-card p {
    margin: 10px 0 0 !important;
    color: #514636 !important;
    font-size: 15px !important;
    line-height: 1.45 !important;
    font-weight: 560 !important;
  }

  .loop-p6-primary {
    width: 100% !important;
    min-height: 54px !important;
    margin-top: 20px !important;
    border: 0 !important;
    border-radius: 999px !important;
    background: linear-gradient(135deg, #07584f 0%, #0c6f63 100%) !important;
    color: #fff8ee !important;
    font-size: 16px !important;
    font-weight: 900 !important;
    cursor: pointer !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 12px !important;
    box-shadow: 0 16px 34px rgba(7, 88, 79, 0.28) !important;
  }

  .loop-p6-store-row {
    margin-top: 14px !important;
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 10px !important;
  }

  .loop-p6-store-btn {
    min-height: 48px !important;
    border: 0 !important;
    border-radius: 999px !important;
    background: linear-gradient(135deg, #07584f 0%, #0c6f63 100%) !important;
    color: #fff8ee !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 9px !important;
    font-size: 14px !important;
    font-weight: 900 !important;
    cursor: pointer !important;
    box-shadow: 0 12px 26px rgba(7, 88, 79, 0.20) !important;
  }

  .loop-p6-platform-icon {
    width: 21px !important;
    height: 21px !important;
    display: inline-block !important;
    background: currentColor !important;
    flex: 0 0 auto !important;
  }

  .loop-p6-apple {
    -webkit-mask: url("/assets/icons/apple.svg") center / contain no-repeat !important;
    mask: url("/assets/icons/apple.svg") center / contain no-repeat !important;
  }

  .loop-p6-android {
    -webkit-mask: url("/assets/icons/android.svg") center / contain no-repeat !important;
    mask: url("/assets/icons/android.svg") center / contain no-repeat !important;
  }

  #loop-services-section {
    background: #fff8ee !important;
    max-width: none !important;
    padding-top: 26px !important;
    padding-bottom: 50px !important;
    border-top: 0 !important;
  }

  .loop-section:not(#loop-services-section) {
    background: #fff8ee !important;
  }

  @media (min-width: 1200px) {
    .loop-p6-hero {
      min-height: 490px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-hero {
      min-height: auto !important;
      background-position: center top !important;
    }

    .loop-p6-hero-overlay {
      display: block !important;
      padding: 34px 18px 28px !important;
    }

    .loop-p6-title {
      margin-top: 18px !important;
      font-size: clamp(42px, 12vw, 58px) !important;
      line-height: 0.92 !important;
    }

    .loop-p6-subtitle {
      font-size: 15px !important;
      line-height: 1.45 !important;
      margin-top: 18px !important;
    }

    .loop-p6-cta-card {
      margin-top: 26px !important;
      width: 100% !important;
      border-radius: 26px !important;
      padding: 20px !important;
      box-sizing: border-box !important;
    }

    .loop-p6-store-row {
      grid-template-columns: 1fr 1fr !important;
    }

    #loop-services-section {
      padding-top: 24px !important;
      padding-bottom: 28px !important;
    }
  }


  /* PHASE 6D FIX — force the React-bundled image to load */
  .loop-p6-hero {
    background-image:
      linear-gradient(
        90deg,
        rgba(4, 26, 22, 0.74) 0%,
        rgba(4, 26, 22, 0.54) 30%,
        rgba(4, 26, 22, 0.18) 56%,
        rgba(4, 26, 22, 0.28) 100%
      ),
      var(--loop-hero-image, url("/assets/images/loop-wellness-lounge-hero.png")) !important;
    background-size: auto, cover !important;
    background-position: center center, center center !important;
    background-repeat: no-repeat, no-repeat !important;
    background-color: #2e3832 !important;
  }

  /* LOOP PHASE 6F — CATEGORY ICON FIX + COMPACT HERO */
  @media (min-width: 900px) {
    .loop-p6-hero { min-height: clamp(285px, 25vw, 365px) !important; background-position: center center !important; }
    .loop-p6-hero-overlay { padding-top: clamp(26px, 3.4vw, 48px) !important; padding-bottom: clamp(24px, 3vw, 42px) !important; }
    .loop-p6-title { margin-top: 14px !important; font-size: clamp(46px, 4.7vw, 74px) !important; line-height: .90 !important; }
    .loop-p6-subtitle { margin-top: 14px !important; font-size: clamp(15px, 1.05vw, 18px) !important; line-height: 1.44 !important; max-width: 680px !important; }
    .loop-p6-cta-card { padding: 22px !important; border-radius: 28px !important; width: min(100%, 375px) !important; }
    .loop-p6-primary { min-height: 50px !important; margin-top: 16px !important; }
    .loop-p6-store-btn { min-height: 44px !important; }
    #loop-services-section { padding-top: 22px !important; padding-bottom: 34px !important; }
  }
  #loop-services-section .loop-category-carousel-v4-image { width:110px!important;height:110px!important;min-width:110px!important;min-height:110px!important;max-width:110px!important;max-height:110px!important;border-radius:28px!important;overflow:visible!important;background-color:transparent!important;background-size:100% 100%!important;background-position:center!important;background-repeat:no-repeat!important;box-shadow:0 16px 34px rgba(15,23,42,.06)!important; }
  #loop-services-section .loop-category-carousel-v4-image img,#loop-services-section .loop-category-carousel-v4-img,#loop-services-section .service-image-box img,#loop-services-section .service-image-box svg{opacity:0!important;visibility:hidden!important;display:none!important;}
  #loop-services-section .loop-category-carousel-v4-card:nth-child(1) .loop-category-carousel-v4-image,#loop-services-section .loop-category-carousel-v4-card:nth-child(1) .service-image-box{background-image:url("/assets/images/Servicios/loop-cat-belleza-barberias.png")!important;}
  #loop-services-section .loop-category-carousel-v4-card:nth-child(2) .loop-category-carousel-v4-image,#loop-services-section .loop-category-carousel-v4-card:nth-child(2) .service-image-box{background-image:url("/assets/images/Servicios/loop-cat-bienestar-spa.png")!important;}
  #loop-services-section .loop-category-carousel-v4-card:nth-child(3) .loop-category-carousel-v4-image,#loop-services-section .loop-category-carousel-v4-card:nth-child(3) .service-image-box{background-image:url("/assets/images/Servicios/loop-cat-eventos.png")!important;}
  #loop-services-section .loop-category-carousel-v4-card:nth-child(4) .loop-category-carousel-v4-image,#loop-services-section .loop-category-carousel-v4-card:nth-child(4) .service-image-box{background-image:url("/assets/images/Servicios/loop-cat-fitness.png")!important;}
  #loop-services-section .loop-category-carousel-v4-card:nth-child(5) .loop-category-carousel-v4-image,#loop-services-section .loop-category-carousel-v4-card:nth-child(5) .service-image-box{background-image:url("/assets/images/Servicios/loop-cat-otros.png")!important;}
  @media(max-width:899px){.loop-p6-hero-overlay{padding-top:24px!important;padding-bottom:22px!important;}#loop-services-section .loop-category-carousel-v4-image{width:92px!important;height:92px!important;min-width:92px!important;min-height:92px!important;max-width:92px!important;max-height:92px!important;border-radius:24px!important;}}


  /* =========================================================
     PHASE 6I — CATEGORIES TIGHT LABEL + STORE ICON IMAGES
     Keeps hero size unchanged. Only fixes category vertical gap
     and makes iOS/Android use real image icons.
     ========================================================= */

  #loop-services-section .loop-direct-categories {
    align-items: flex-start !important;
  }

  #loop-services-section .loop-direct-category-card {
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
    display: inline-flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: flex-start !important;
    gap: 8px !important;
  }

  #loop-services-section .loop-direct-category-icon {
    margin: 0 !important;
    flex: 0 0 auto !important;
  }

  #loop-services-section .loop-direct-category-label {
    margin: 0 !important;
    padding: 0 !important;
    transform: none !important;
    position: relative !important;
    top: auto !important;
    display: block !important;
  }

  .loop-p6-store-btn {
    gap: 10px !important;
  }

  .loop-p6-platform-img {
    width: 20px !important;
    height: 20px !important;
    display: inline-block !important;
    object-fit: contain !important;
    object-position: center !important;
    flex: 0 0 auto !important;
    filter: brightness(0) invert(1) !important;
  }

  @media (max-width: 899px) {
    #loop-services-section .loop-direct-category-card {
      gap: 7px !important;
    }

    .loop-p6-platform-img {
      width: 18px !important;
      height: 18px !important;
    }
  }

`;



const phase6jTightCategoriesAndCards = `
  /* =========================================================
     PHASE 6J — CATEGORY GAP + 4 BUSINESS CARDS PER ROW
     IMPORTANT: This does NOT touch hero sizing.
     ========================================================= */

  #loop-services-section .loop-direct-categories {
    align-items: flex-start !important;
  }

  #loop-services-section .loop-direct-category-card {
    position: relative !important;
    height: 160px !important;
    min-height: 160px !important;
    max-height: 160px !important;
    display: block !important;
    padding: 0 !important;
    margin: 0 !important;
    overflow: visible !important;
  }

  #loop-services-section .loop-direct-category-icon {
    position: absolute !important;
    top: 0 !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    margin: 0 !important;
  }

  #loop-services-section .loop-direct-category-label {
    position: absolute !important;
    top: 118px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: 132px !important;
    margin: 0 !important;
    padding: 0 !important;
    display: block !important;
    line-height: 1.08 !important;
  }

  @media (max-width: 899px) {
    #loop-services-section .loop-direct-category-card {
      height: 132px !important;
      min-height: 132px !important;
      max-height: 132px !important;
    }

    #loop-services-section .loop-direct-category-label {
      top: 98px !important;
      width: 104px !important;
      line-height: 1.08 !important;
    }
  }
`;


const phase6mMobileCarouselRestore = `
  /* =========================================================
     PHASE 6M — MOBILE-ONLY CATEGORY CAROUSEL RESTORE
     - Desktop/web stays untouched.
     - Mobile categories return to horizontal carousel.
     - Uses transparent category PNGs so no white boxes appear.
     - Business card desktop sizes are restored in MainMenuBusinessCard.
     ========================================================= */

  @media (max-width: 899px) {
    #loop-services-section .loop-categories-visual-wrap {
      width: 100% !important;
      max-width: none !important;
      overflow: visible !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }

    #loop-services-section .loop-direct-categories {
      width: calc(100% + 28px) !important;
      max-width: none !important;
      margin-left: -14px !important;
      margin-right: -14px !important;
      padding: 0 14px 10px !important;
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      align-items: flex-start !important;
      justify-content: flex-start !important;
      gap: 18px !important;
      overflow-x: auto !important;
      overflow-y: visible !important;
      -webkit-overflow-scrolling: touch !important;
      scroll-snap-type: x proximity !important;
      scrollbar-width: none !important;
      overscroll-behavior-x: contain !important;
    }

    #loop-services-section .loop-direct-categories::-webkit-scrollbar {
      display: none !important;
    }

    #loop-services-section .loop-direct-category-card {
      flex: 0 0 108px !important;
      width: 108px !important;
      min-width: 108px !important;
      max-width: 108px !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      display: inline-flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: flex-start !important;
      gap: 7px !important;
      padding: 0 !important;
      margin: 0 !important;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
      overflow: visible !important;
      scroll-snap-align: start !important;
      text-align: center !important;
    }

    #loop-services-section .loop-direct-category-icon {
      position: static !important;
      transform: none !important;
      margin: 0 !important;
      width: 96px !important;
      height: 96px !important;
      min-width: 96px !important;
      min-height: 96px !important;
      max-width: 96px !important;
      max-height: 96px !important;
      border-radius: 26px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      overflow: visible !important;
      background: transparent !important;
      box-shadow: none !important;
      flex: 0 0 auto !important;
    }

    #loop-services-section .loop-direct-category-icon img {
      display: block !important;
      width: 96px !important;
      height: 96px !important;
      min-width: 96px !important;
      min-height: 96px !important;
      max-width: 96px !important;
      max-height: 96px !important;
      object-fit: contain !important;
      object-position: center !important;
      background: transparent !important;
      opacity: 1 !important;
      visibility: visible !important;
      filter: none !important;
      transform: none !important;
    }

    #loop-services-section .loop-direct-category-label {
      position: static !important;
      transform: none !important;
      top: auto !important;
      left: auto !important;
      width: 108px !important;
      margin: 0 !important;
      padding: 0 !important;
      display: block !important;
      color: #0f172a !important;
      font-size: 13px !important;
      line-height: 1.08 !important;
      font-weight: 900 !important;
      letter-spacing: -0.035em !important;
      text-align: center !important;
      white-space: normal !important;
    }
  }

  @media (max-width: 420px) {
    #loop-services-section .loop-direct-categories {
      gap: 16px !important;
      padding-left: 14px !important;
      padding-right: 14px !important;
    }

    #loop-services-section .loop-direct-category-card {
      flex-basis: 104px !important;
      width: 104px !important;
      min-width: 104px !important;
      max-width: 104px !important;
    }

    #loop-services-section .loop-direct-category-icon,
    #loop-services-section .loop-direct-category-icon img {
      width: 92px !important;
      height: 92px !important;
      min-width: 92px !important;
      min-height: 92px !important;
      max-width: 92px !important;
      max-height: 92px !important;
    }

    #loop-services-section .loop-direct-category-label {
      width: 104px !important;
      font-size: 12.5px !important;
    }
  }
`;

const phase6nMobileHeroHalfAndCards = `
  /* =========================================================
     PHASE 6N — MOBILE ONLY POLISH
     Desktop/web stays untouched.
     - Hero mobile/app reduced to roughly half the previous visual height.
     - iOS/Android buttons hidden on mobile/app.
     - CTA card becomes a compact CTA block, not a large panel.
     - Business cards are smaller only on mobile/app via MainMenuBusinessCard.
     ========================================================= */

  @media (max-width: 899px) {
    .loop-p6-hero {
      min-height: 430px !important;
      max-height: 430px !important;
      overflow: hidden !important;
      background-position: center center !important;
    }

    .loop-p6-hero::before {
      background:
        linear-gradient(90deg, rgba(4,30,25,.56) 0%, rgba(4,30,25,.34) 44%, rgba(4,30,25,.12) 100%),
        linear-gradient(180deg, rgba(0,0,0,.06), rgba(0,0,0,.18)) !important;
    }

    .loop-p6-hero-overlay {
      min-height: 430px !important;
      height: 430px !important;
      display: flex !important;
      flex-direction: column !important;
      justify-content: center !important;
      align-items: stretch !important;
      padding: 22px 18px 24px !important;
      gap: 0 !important;
    }

    .loop-p6-kicker {
      padding: 7px 12px !important;
      font-size: 10px !important;
      letter-spacing: .12em !important;
      margin: 0 0 12px !important;
      transform: scale(.92) !important;
      transform-origin: left center !important;
    }

    .loop-p6-title {
      margin-top: 0 !important;
      max-width: 94% !important;
      font-size: clamp(34px, 9.2vw, 44px) !important;
      line-height: .91 !important;
      letter-spacing: -.075em !important;
    }

    .loop-p6-subtitle {
      max-width: 94% !important;
      margin-top: 12px !important;
      font-size: 13.5px !important;
      line-height: 1.34 !important;
      font-weight: 690 !important;
    }

    .loop-p6-cta-card {
      width: 100% !important;
      margin-top: 16px !important;
      padding: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      backdrop-filter: none !important;
      -webkit-backdrop-filter: none !important;
    }

    .loop-p6-cta-card > strong,
    .loop-p6-cta-card > p,
    .loop-p6-store-row {
      display: none !important;
    }

    .loop-p6-primary {
      width: 100% !important;
      min-height: 48px !important;
      margin-top: 0 !important;
      border-radius: 999px !important;
      font-size: 14.5px !important;
      box-shadow: 0 14px 30px rgba(7,63,55,.25) !important;
    }

    #loop-services-section {
      padding-top: 28px !important;
    }
  }

  @media (max-width: 420px) {
    .loop-p6-hero,
    .loop-p6-hero-overlay {
      min-height: 405px !important;
      max-height: 405px !important;
      height: 405px !important;
    }

    .loop-p6-title {
      font-size: clamp(32px, 9.8vw, 40px) !important;
    }

    .loop-p6-subtitle {
      font-size: 13px !important;
      line-height: 1.32 !important;
    }
  }

  body.is-mobile-app .loop-p6-store-row {
    display: none !important;
  }
`;


const phase7MobileOnlyFinalPolish = `
  /* =========================================================
     PHASE 7 — MOBILE ONLY FINAL POLISH
     IMPORTANT: every rule is scoped to mobile/app only.
     Desktop/web stays untouched.
     ========================================================= */

  @media (max-width: 899px) {
    .loop-p6-hero {
      min-height: 348px !important;
      max-height: 348px !important;
      height: 348px !important;
      overflow: hidden !important;
      background-position: center center !important;
    }

    .loop-p6-hero-overlay {
      min-height: 348px !important;
      height: 348px !important;
      padding: 16px 18px 18px !important;
      display: flex !important;
      flex-direction: column !important;
      justify-content: center !important;
      gap: 0 !important;
    }

    .loop-p6-kicker {
      margin: 0 0 10px !important;
      padding: 6px 10px !important;
      font-size: 9.5px !important;
      letter-spacing: .12em !important;
      transform: none !important;
    }

    .loop-p6-title {
      max-width: 94% !important;
      margin: 0 !important;
      font-size: clamp(31px, 8.8vw, 38px) !important;
      line-height: .91 !important;
      letter-spacing: -.074em !important;
    }

    .loop-p6-subtitle {
      max-width: 96% !important;
      margin-top: 10px !important;
      font-size: 12.4px !important;
      line-height: 1.32 !important;
      font-weight: 700 !important;
    }

    .loop-p6-cta-card {
      width: 100% !important;
      margin-top: 14px !important;
      padding: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      backdrop-filter: none !important;
      -webkit-backdrop-filter: none !important;
    }

    .loop-p6-cta-card > strong,
    .loop-p6-cta-card > p,
    .loop-p6-store-row {
      display: none !important;
    }

    .loop-p6-primary {
      width: 100% !important;
      min-height: 44px !important;
      margin-top: 0 !important;
      border-radius: 999px !important;
      font-size: 13.5px !important;
      box-shadow: 0 12px 26px rgba(7,63,55,.24) !important;
    }

    #loop-services-section {
      padding-top: 24px !important;
      padding-bottom: 28px !important;
    }

    #loop-services-section .loop-section-head {
      margin-bottom: 20px !important;
    }

    .loop-section {
      padding-top: 30px !important;
      padding-bottom: 34px !important;
    }
  }

  @media (max-width: 420px) {
    .loop-p6-hero,
    .loop-p6-hero-overlay {
      min-height: 330px !important;
      max-height: 330px !important;
      height: 330px !important;
    }

    .loop-p6-hero-overlay {
      padding: 14px 17px 16px !important;
    }

    .loop-p6-title {
      font-size: clamp(29px, 8.5vw, 35px) !important;
    }

    .loop-p6-subtitle {
      font-size: 12px !important;
      line-height: 1.30 !important;
    }

    .loop-p6-primary {
      min-height: 42px !important;
      font-size: 13px !important;
    }
  }

  body.is-mobile-app .loop-p6-store-row {
    display: none !important;
  }
`;


const phase7cCategoryNoWhiteFrameSafety = `
  /* =========================================================
     PHASE 7C — CATEGORY ICON SINGLE SOURCE + NO WHITE FRAME
     Web + mobile. Only category icon presentation.
     ========================================================= */

  #loop-services-section .loop-direct-category-icon {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    overflow: hidden !important;
  }

  #loop-services-section .loop-direct-category-icon img {
    background: transparent !important;
    object-fit: cover !important;
    object-position: center center !important;
    transform: scale(1.035) !important;
    transform-origin: center center !important;
  }
`;



const phase7dMobileOnlyVisualPush = `
  /* =========================================================
     PHASE 7D — MOBILE APP ONLY VISUAL PUSH
     Desktop/web stays untouched.
     Goal: closer to the compact mobile vision.
     ========================================================= */

  body.is-mobile-app .loop-pro-main {
    padding-bottom: calc(var(--loop-mobile-nav-height, 72px) + 4px) !important;
  }

  @media (max-width: 899px) {
    body.is-mobile-app .loop-p6-hero {
      min-height: 266px !important;
      height: 266px !important;
      max-height: 266px !important;
      overflow: hidden !important;
      background-position: center center !important;
    }

    body.is-mobile-app .loop-p6-hero::before {
      background:
        linear-gradient(90deg, rgba(4,30,25,.68) 0%, rgba(4,30,25,.42) 42%, rgba(4,30,25,.16) 100%),
        linear-gradient(180deg, rgba(0,0,0,.03), rgba(0,0,0,.14)) !important;
    }

    body.is-mobile-app .loop-p6-hero-overlay {
      min-height: 266px !important;
      height: 266px !important;
      padding: 10px 18px 12px !important;
      display: flex !important;
      flex-direction: column !important;
      justify-content: center !important;
      gap: 0 !important;
    }

    body.is-mobile-app .loop-p6-kicker {
      margin: 0 0 8px !important;
      padding: 5px 9px !important;
      font-size: 8.8px !important;
      letter-spacing: .115em !important;
      line-height: 1 !important;
      transform: none !important;
    }

    body.is-mobile-app .loop-p6-kicker-dot,
    body.is-mobile-app .loop-eyebrow-dot {
      width: 7px !important;
      height: 7px !important;
    }

    body.is-mobile-app .loop-p6-title {
      max-width: 92% !important;
      margin: 0 !important;
      font-size: clamp(27px, 7.6vw, 33px) !important;
      line-height: .90 !important;
      letter-spacing: -.074em !important;
    }

    body.is-mobile-app .loop-p6-subtitle {
      max-width: 88% !important;
      margin-top: 8px !important;
      font-size: 11.3px !important;
      line-height: 1.28 !important;
      font-weight: 720 !important;
    }

    body.is-mobile-app .loop-p6-cta-card {
      width: 100% !important;
      margin-top: 12px !important;
      padding: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      backdrop-filter: none !important;
      -webkit-backdrop-filter: none !important;
    }

    body.is-mobile-app .loop-p6-cta-card > strong,
    body.is-mobile-app .loop-p6-cta-card > p,
    body.is-mobile-app .loop-p6-store-row {
      display: none !important;
    }

    body.is-mobile-app .loop-p6-primary {
      width: 100% !important;
      min-height: 37px !important;
      height: 37px !important;
      margin: 0 !important;
      border-radius: 999px !important;
      font-size: 12.5px !important;
      letter-spacing: -.015em !important;
      box-shadow: 0 10px 24px rgba(7,63,55,.24) !important;
    }

    body.is-mobile-app .loop-p6-primary .loop-cta-arrow,
    body.is-mobile-app .loop-p6-primary span {
      font-size: 18px !important;
    }

    body.is-mobile-app #loop-services-section {
      padding-top: 20px !important;
      padding-bottom: 24px !important;
    }

    body.is-mobile-app #loop-services-section .loop-section-card {
      padding: 0 !important;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
      border-radius: 0 !important;
    }

    body.is-mobile-app #loop-services-section .loop-section-head {
      margin-bottom: 14px !important;
      justify-content: flex-start !important;
    }

    body.is-mobile-app #loop-services-section .loop-section-kicker,
    body.is-mobile-app .loop-section-kicker {
      font-size: 11px !important;
      letter-spacing: .22em !important;
      margin-bottom: 0 !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-categories {
      display: flex !important;
      flex-wrap: nowrap !important;
      justify-content: flex-start !important;
      align-items: flex-start !important;
      gap: 13px !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      -webkit-overflow-scrolling: touch !important;
      scrollbar-width: none !important;
      padding: 0 2px 2px !important;
      margin: 0 !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-categories::-webkit-scrollbar {
      display: none !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-category-card {
      flex: 0 0 60px !important;
      width: 60px !important;
      min-width: 60px !important;
      max-width: 60px !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      padding: 0 !important;
      margin: 0 !important;
      gap: 6px !important;
      display: inline-flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: flex-start !important;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
      overflow: visible !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-category-icon {
      width: 56px !important;
      height: 56px !important;
      min-width: 56px !important;
      min-height: 56px !important;
      max-width: 56px !important;
      max-height: 56px !important;
      border-radius: 18px !important;
      margin: 0 !important;
      padding: 0 !important;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
      overflow: hidden !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-category-icon img {
      width: 48px !important;
      height: 48px !important;
      max-width: 48px !important;
      max-height: 48px !important;
      object-fit: contain !important;
      object-position: center center !important;
      display: block !important;
      background: transparent !important;
      transform: none !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-category-label {
      width: 68px !important;
      margin: 0 !important;
      padding: 0 !important;
      color: #0f172a !important;
      font-size: 9.4px !important;
      line-height: 1.08 !important;
      font-weight: 950 !important;
      letter-spacing: -.045em !important;
      text-align: center !important;
      white-space: normal !important;
      display: block !important;
    }

    body.is-mobile-app .loop-section:not(#loop-services-section) {
      padding-top: 30px !important;
      padding-bottom: 30px !important;
    }

    body.is-mobile-app .loop-section-head {
      margin-bottom: 16px !important;
    }

    body.is-mobile-app .loop-section-title {
      font-size: 29px !important;
      line-height: .98 !important;
      letter-spacing: -.07em !important;
    }

    body.is-mobile-app .loop-section-copy {
      font-size: 13.5px !important;
      line-height: 1.35 !important;
      margin-top: 7px !important;
    }

    body.is-mobile-app .loop-natural-footer {
      padding-top: 24px !important;
      padding-bottom: calc(var(--loop-mobile-nav-height, 72px) + 14px) !important;
    }
  }

  @media (max-width: 420px) {
    body.is-mobile-app .loop-p6-hero,
    body.is-mobile-app .loop-p6-hero-overlay {
      min-height: 256px !important;
      height: 256px !important;
      max-height: 256px !important;
    }

    body.is-mobile-app .loop-p6-hero-overlay {
      padding: 9px 18px 11px !important;
    }

    body.is-mobile-app .loop-p6-title {
      font-size: clamp(25px, 7.7vw, 31px) !important;
    }

    body.is-mobile-app .loop-p6-subtitle {
      font-size: 10.8px !important;
      line-height: 1.25 !important;
    }

    body.is-mobile-app .loop-p6-primary {
      min-height: 38px !important;
      height: 38px !important;
      font-size: 12px !important;
    }
  }
`;


const phase7fMobileCategoryFitAndHeroTweak = `
  /* =========================================================
     PHASE 7F — MOBILE ONLY FINAL TWEAK
     - Desktop/web untouched.
     - Hero slightly shorter.
     - Category icon containers stay same size, inner artwork smaller.
     ========================================================= */
  @media (max-width: 899px) {
    body.is-mobile-app .loop-p6-hero,
    body.is-mobile-app .loop-p6-hero-overlay {
      min-height: 266px !important;
      height: 266px !important;
      max-height: 266px !important;
    }

    body.is-mobile-app .loop-p6-hero-overlay {
      padding-top: 10px !important;
      padding-bottom: 12px !important;
    }

    body.is-mobile-app .loop-p6-primary {
      min-height: 37px !important;
      height: 37px !important;
      font-size: 12px !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-category-icon,
    body.is-mobile-app #loop-services-section .loop-category-carousel-v4-image {
      width: 56px !important;
      height: 56px !important;
      min-width: 56px !important;
      min-height: 56px !important;
      max-width: 56px !important;
      max-height: 56px !important;
      border-radius: 18px !important;
      overflow: visible !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      background: transparent !important;
      box-shadow: none !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-category-icon img,
    body.is-mobile-app #loop-services-section .loop-category-carousel-v4-img,
    body.is-mobile-app #loop-services-section .loop-category-carousel-v4-image img {
      width: 48px !important;
      height: 48px !important;
      max-width: 48px !important;
      max-height: 48px !important;
      object-fit: contain !important;
      object-position: center center !important;
      transform: none !important;
      opacity: 1 !important;
      visibility: visible !important;
      display: block !important;
      background: transparent !important;
    }
  }

  @media (max-width: 420px) {
    body.is-mobile-app .loop-p6-hero,
    body.is-mobile-app .loop-p6-hero-overlay {
      min-height: 256px !important;
      height: 256px !important;
      max-height: 256px !important;
    }
  }
`;


const phase7gMobileCategoriesAndHeroRefine = `
  /* =========================================================
     PHASE 7G — MOBILE ONLY CATEGORY + HERO REFINEMENT
     - Keeps web/desktop untouched.
     - Fixes category icons so each tile is independent, not cropped/overlapped.
     - Makes the mobile hero slightly shorter/elegant.
     ========================================================= */
  @media (max-width: 899px) {
    body.is-mobile-app .loop-p6-hero,
    body.is-mobile-app .loop-p6-hero-overlay {
      min-height: 242px !important;
      height: 242px !important;
      max-height: 242px !important;
    }

    body.is-mobile-app .loop-p6-hero-overlay {
      padding-top: 8px !important;
      padding-bottom: 10px !important;
    }

    body.is-mobile-app .loop-p6-eyebrow {
      margin-bottom: 9px !important;
      transform: scale(.94) !important;
      transform-origin: left center !important;
    }

    body.is-mobile-app .loop-p6-title {
      font-size: clamp(30px, 8.8vw, 38px) !important;
      line-height: .94 !important;
      letter-spacing: -.062em !important;
    }

    body.is-mobile-app .loop-p6-subtitle {
      margin-top: 10px !important;
      font-size: 12.6px !important;
      line-height: 1.36 !important;
      max-width: 94% !important;
    }

    body.is-mobile-app .loop-p6-primary {
      margin-top: 12px !important;
      min-height: 38px !important;
      height: 38px !important;
      border-radius: 999px !important;
      font-size: 12.4px !important;
      max-width: 100% !important;
    }

    body.is-mobile-app #loop-services-section {
      padding-top: 22px !important;
      padding-bottom: 24px !important;
      overflow: hidden !important;
    }

    body.is-mobile-app #loop-services-section .loop-section-head {
      margin-bottom: 16px !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-categories {
      width: 100% !important;
      max-width: 100% !important;
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      align-items: flex-start !important;
      justify-content: space-between !important;
      gap: 0 !important;
      overflow: visible !important;
      padding: 0 !important;
      margin: 0 auto !important;
      box-sizing: border-box !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-category-card {
      flex: 0 0 58px !important;
      width: 58px !important;
      min-width: 58px !important;
      max-width: 58px !important;
      min-height: 88px !important;
      padding: 0 !important;
      margin: 0 !important;
      gap: 6px !important;
      display: inline-flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: flex-start !important;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
      overflow: visible !important;
      box-sizing: border-box !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-category-icon {
      width: 52px !important;
      height: 52px !important;
      min-width: 52px !important;
      min-height: 52px !important;
      max-width: 52px !important;
      max-height: 52px !important;
      flex: 0 0 52px !important;
      border-radius: 16px !important;
      margin: 0 auto !important;
      padding: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
      overflow: hidden !important;
      box-sizing: border-box !important;
      isolation: isolate !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-category-icon > img {
      position: static !important;
      display: block !important;
      width: 52px !important;
      height: 52px !important;
      min-width: 0 !important;
      min-height: 0 !important;
      max-width: 52px !important;
      max-height: 52px !important;
      flex: 0 0 auto !important;
      object-fit: contain !important;
      object-position: center center !important;
      border-radius: 16px !important;
      transform: none !important;
      background: transparent !important;
      opacity: 1 !important;
      visibility: visible !important;
      box-sizing: border-box !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-category-label {
      width: 64px !important;
      max-width: 64px !important;
      min-height: 24px !important;
      margin: 0 auto !important;
      padding: 0 !important;
      color: #0f172a !important;
      font-size: 8.9px !important;
      line-height: 1.08 !important;
      font-weight: 950 !important;
      letter-spacing: -.05em !important;
      text-align: center !important;
      overflow: visible !important;
      white-space: normal !important;
    }
  }

  @media (max-width: 420px) {
    body.is-mobile-app .loop-p6-hero,
    body.is-mobile-app .loop-p6-hero-overlay {
      min-height: 232px !important;
      height: 232px !important;
      max-height: 232px !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-category-card {
      flex-basis: 57px !important;
      width: 57px !important;
      min-width: 57px !important;
      max-width: 57px !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-category-icon,
    body.is-mobile-app #loop-services-section .loop-direct-category-icon > img {
      width: 50px !important;
      height: 50px !important;
      min-width: 50px !important;
      min-height: 50px !important;
      max-width: 50px !important;
      max-height: 50px !important;
      flex-basis: 50px !important;
    }

    body.is-mobile-app #loop-services-section .loop-direct-category-label {
      font-size: 8.6px !important;
      width: 62px !important;
      max-width: 62px !important;
    }
  }
`;


const phase8MainMenuTabletIpadPolish = `
  /* =========================================================
     PHASE 8 — MAIN MENU TABLET / IPAD RESPONSIVE POLISH
     Scope: 769px–1180px only. Desktop and mobile stay intact.
     ========================================================= */

  @media (min-width: 769px) and (max-width: 1180px) {
    .mainmenu-root.has-full-content,
    .loop-pro-shell,
    .loop-pro-main {
      overflow-x: hidden !important;
    }

    .loop-pro-main {
      padding-bottom: 36px !important;
    }

    /* Hero: compact 2-column tablet fold */
    .loop-p6-hero {
      width: calc(100% - 40px) !important;
      max-width: 1040px !important;
      min-height: 330px !important;
      margin: 20px auto 18px !important;
      border-radius: 34px !important;
      background-position: center center !important;
    }

    .loop-p6-hero-overlay {
      min-height: 330px !important;
      padding: 30px 32px !important;
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) minmax(260px, 330px) !important;
      align-items: center !important;
      gap: 28px !important;
    }

    .loop-p6-hero-copy {
      max-width: 610px !important;
    }

    .loop-p6-kicker {
      margin-bottom: 13px !important;
      padding: 7px 12px !important;
      font-size: 11px !important;
      letter-spacing: .12em !important;
    }

    .loop-p6-title {
      font-size: clamp(42px, 6.1vw, 66px) !important;
      line-height: .88 !important;
      letter-spacing: -.082em !important;
      max-width: 620px !important;
    }

    .loop-p6-subtitle {
      max-width: 560px !important;
      margin-top: 14px !important;
      font-size: 15px !important;
      line-height: 1.44 !important;
    }

    .loop-p6-cta-card {
      width: 100% !important;
      max-width: 330px !important;
      justify-self: end !important;
      padding: 18px !important;
      border-radius: 26px !important;
      box-shadow: 0 18px 46px rgba(15, 23, 42, .12) !important;
    }

    .loop-p6-cta-card strong {
      font-size: 20px !important;
      line-height: 1.02 !important;
      letter-spacing: -.05em !important;
    }

    .loop-p6-cta-card p {
      margin-top: 7px !important;
      font-size: 13px !important;
      line-height: 1.35 !important;
    }

    .loop-p6-primary {
      min-height: 46px !important;
      border-radius: 16px !important;
      font-size: 13.5px !important;
      padding: 0 16px !important;
      margin-top: 14px !important;
    }

    .loop-p6-store-row {
      gap: 8px !important;
      margin-top: 10px !important;
    }

    .loop-p6-store-btn {
      min-height: 38px !important;
      border-radius: 14px !important;
      font-size: 12px !important;
    }

    .loop-p6-platform-img {
      width: 16px !important;
      height: 16px !important;
    }

    /* Sections: tablet spacing, not desktop-heavy */
    .loop-section {
      max-width: 1040px !important;
      padding: 30px 28px 34px !important;
    }

    .loop-section-head {
      margin-bottom: 22px !important;
      gap: 14px !important;
      align-items: flex-end !important;
    }

    .loop-section-kicker {
      font-size: 11px !important;
      margin-bottom: 9px !important;
    }

    .loop-section-title {
      max-width: 610px !important;
      font-size: clamp(30px, 4.4vw, 44px) !important;
      line-height: .98 !important;
      letter-spacing: -.068em !important;
    }

    .loop-section-copy {
      max-width: 600px !important;
      font-size: 14px !important;
      line-height: 1.45 !important;
    }

    .loop-show-more-btn {
      min-height: 40px !important;
      padding: 0 14px !important;
      font-size: 12.5px !important;
      white-space: nowrap !important;
    }

    /* Categories: 5 elegant columns on iPad/tablet */
    #loop-services-section {
      padding-top: 34px !important;
      padding-bottom: 38px !important;
    }

    #loop-services-section .loop-section-head {
      margin-bottom: 24px !important;
    }

    .loop-direct-categories {
      width: 100% !important;
      display: grid !important;
      grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
      gap: clamp(10px, 1.6vw, 18px) !important;
      align-items: start !important;
      overflow: visible !important;
      padding: 0 !important;
    }

    .loop-direct-category-card {
      width: 100% !important;
      min-width: 0 !important;
      padding: 0 !important;
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: flex-start !important;
      gap: 7px !important;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
    }

    .loop-direct-category-icon {
      width: clamp(74px, 9.2vw, 104px) !important;
      height: clamp(74px, 9.2vw, 104px) !important;
      border-radius: 26px !important;
      overflow: hidden !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      background: transparent !important;
      box-shadow: none !important;
    }

    .loop-direct-category-icon img {
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important;
      object-position: center !important;
      display: block !important;
    }

    .loop-direct-category-label {
      min-height: 32px !important;
      color: #0f172a !important;
      font-size: clamp(11.5px, 1.42vw, 13.5px) !important;
      line-height: 1.05 !important;
      letter-spacing: -.025em !important;
      font-weight: 900 !important;
      text-align: center !important;
      display: block !important;
    }

    /* Business carousels/grids: medium touch-friendly cards */
    .loop-mobile-section-pad {
      overflow: visible !important;
    }

    .loop-section-card > .loop-mobile-section-pad,
    .loop-section-card > div:not(.loop-section-head) {
      max-width: 100% !important;
    }

    .recommended-scroller,
    .favorites-scroller,
    .recommended-grid,
    .favorites-grid,
    [class*="RecommendedScroller"],
    [class*="FavoritesScroller"] {
      max-width: 100% !important;
    }

    .loop-section-card img {
      -webkit-user-drag: none !important;
    }

    /* Touch behavior: horizontal sections should feel native */
    .loop-section-card [style*="overflow-x"],
    .loop-section-card [class*="scroller"],
    .loop-section-card [class*="Scroller"],
    .loop-section-card [class*="carousel"],
    .loop-section-card [class*="Carousel"] {
      -webkit-overflow-scrolling: touch !important;
      scroll-snap-type: x proximity !important;
    }

    .loop-section-card [class*="business-card"],
    .loop-section-card [class*="BusinessCard"],
    .loop-section-card [class*="recommended"],
    .loop-section-card [class*="favorite"] {
      scroll-snap-align: start !important;
    }

    /* Footer: compact but still desktop-like */
    .loop-natural-footer {
      max-width: 1040px !important;
      padding: 28px 28px 32px !important;
    }

    .loop-natural-footer-inner {
      gap: 18px !important;
      align-items: flex-start !important;
    }

    .loop-natural-footer-copy {
      max-width: 420px !important;
    }
  }

  /* Smaller tablets / iPad portrait: keep it elegant and not cramped */
  @media (min-width: 769px) and (max-width: 920px) {
    .loop-p6-hero {
      width: calc(100% - 32px) !important;
      min-height: auto !important;
      margin-top: 16px !important;
    }

    .loop-p6-hero-overlay {
      min-height: auto !important;
      grid-template-columns: 1fr !important;
      gap: 18px !important;
      padding: 28px !important;
    }

    .loop-p6-title {
      font-size: clamp(44px, 8.5vw, 62px) !important;
      max-width: 680px !important;
    }

    .loop-p6-subtitle {
      max-width: 620px !important;
      font-size: 15.5px !important;
    }

    .loop-p6-cta-card {
      max-width: 100% !important;
      justify-self: stretch !important;
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) auto !important;
      column-gap: 18px !important;
      row-gap: 10px !important;
      align-items: center !important;
      padding: 16px 18px !important;
    }

    .loop-p6-cta-card strong,
    .loop-p6-cta-card p {
      grid-column: 1 / 2 !important;
    }

    .loop-p6-primary {
      grid-column: 2 / 3 !important;
      grid-row: 1 / 3 !important;
      min-width: 210px !important;
      margin-top: 0 !important;
    }

    .loop-p6-store-row {
      grid-column: 1 / -1 !important;
      max-width: 360px !important;
    }

    .loop-section {
      padding-left: 22px !important;
      padding-right: 22px !important;
    }

    .loop-direct-categories {
      grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
      gap: 8px !important;
    }

    .loop-direct-category-icon {
      width: clamp(68px, 11vw, 92px) !important;
      height: clamp(68px, 11vw, 92px) !important;
      border-radius: 23px !important;
    }

    .loop-direct-category-label {
      font-size: 11.5px !important;
    }
  }
`;


const phase1QMobileHeaderHeroSeamFix = `
  /* =========================================================
     PHASE 1Q — MOBILE HEADER/HERO SEAM HOTFIX
     Removes the white/gray gap between the emerald header and hero.
     Keeps desktop untouched.
     ========================================================= */
  @media (max-width: 899px) {
    html, body, #root {
      background: #fff8ee !important;
    }

    .mainmenu-root.has-full-content,
    .mainmenu-root,
    .loop-pro-shell,
    .loop-pro-main {
      margin-top: 0 !important;
      padding-top: 0 !important;
    }

    .loop-pro-main {
      display: block !important;
      background: #fff8ee !important;
      padding-bottom: 0 !important;
    }

    .loop-p6-hero {
      margin: 0 !important;
      margin-top: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
      border-radius: 0 !important;
      border-top: 0 !important;
      transform: none !important;
    }

    .loop-p6-hero-overlay {
      margin-top: 0 !important;
      padding-top: 18px !important;
    }

    .loop-p6-kicker {
      margin-top: 0 !important;
    }

    .mainmenu-header-only-root {
      margin: 0 !important;
      padding: 0 !important;
      min-height: auto !important;
      background: #fff8ee !important;
    }

    header#app-main-header + main.loop-pro-main,
    #app-main-header + .loop-pro-main,
    .loop-mobile-header-v2 + main.loop-pro-main {
      margin-top: 0 !important;
      padding-top: 0 !important;
    }
  }
`;



const phase1SMobileHeaderSeamFinal = `
  /* =========================================================
     PHASE 1S — FINAL MOBILE HEADER/HERO SEAM LOCK
     Removes the gray/white strip under the emerald header in mobile browser/tablet.
     ========================================================= */
  @media (max-width: 899px) {
    #app-main-header.loop-mobile-header-v2 ~ main.loop-pro-main,
    #app-main-header.loop-mobile-header-v2 ~ .loop-pro-main,
    .mainmenu-root.has-full-content > main.loop-pro-main {
      margin-top: 0 !important;
      padding-top: 0 !important;
      border-top: 0 !important;
      background: #fff8ee !important;
    }

    .loop-mobile-spacer-v2,
    #app-main-header.loop-mobile-header-v2 + .loop-mobile-spacer-v2 {
      display: none !important;
      height: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
    }

    .loop-p6-hero {
      margin-top: 0 !important;
      border-top: 0 !important;
      transform: translateY(0) !important;
    }

    .loop-p6-hero-overlay {
      margin-top: 0 !important;
    }
  }
`;


const phase1VHeroTopPaddingFix = `
  /* =========================================================
     PHASE 1V — REAL HEADER/HERO GAP FIX
     Runtime diagnosis showed there is no DOM spacer: hero starts at header bottom.
     The visible strip is the top padding inside .loop-p6-hero-overlay.
     ========================================================= */
  @media (max-width: 1024px) {
    .mainmenu-root.has-full-content,
    .mainmenu-root.has-full-content .loop-pro-shell,
    .mainmenu-root.has-full-content main.loop-pro-main {
      margin-top: 0 !important;
      padding-top: 0 !important;
      border-top: 0 !important;
    }

    .mainmenu-root.has-full-content .loop-p6-hero {
      margin-top: -1px !important;
      border-top: 0 !important;
      background-position: center top !important;
    }

    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      padding-top: 10px !important;
      margin-top: 0 !important;
    }

    .mainmenu-root.has-full-content .loop-p6-kicker {
      margin-top: 0 !important;
    }
  }

  @media (max-width: 520px) {
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      padding-top: 8px !important;
    }
  }
`;


const phaseBusinessHeroV2 = `
  /* =========================================================
     LOOP BUSINESS HERO V2 — compact founder offer
     Keeps the current hero footprint, switches CTA to create business,
     and communicates the 5-month offer + concrete business benefits.
     ========================================================= */
  .loop-p6-hero {
    min-height: clamp(340px, 31vw, 455px) !important;
    background:
      linear-gradient(90deg, rgba(4,30,25,.74) 0%, rgba(4,30,25,.52) 31%, rgba(4,30,25,.18) 56%, rgba(4,30,25,.26) 100%),
      var(--loop-hero-image, url("/assets/images/loop-phase6-hero-bg.jpg")) center/cover no-repeat !important;
    border-bottom: 1px solid rgba(255,245,232,.55) !important;
  }

  .loop-p6-hero:before {
    background:
      radial-gradient(circle at 18% 46%, rgba(255,255,255,.15), transparent 28%),
      linear-gradient(180deg, rgba(0,0,0,.06), rgba(0,0,0,.18)) !important;
  }

  .loop-p6-hero-overlay {
    width: min(100%, 1500px) !important;
    min-height: clamp(340px, 31vw, 455px) !important;
    padding: clamp(34px, 4.2vw, 54px) clamp(22px, 5vw, 72px) clamp(30px, 3.6vw, 46px) !important;
    grid-template-columns: minmax(0, 1fr) minmax(320px, 390px) !important;
    gap: clamp(34px, 6vw, 82px) !important;
  }

  .loop-p6-hero-copy {
    max-width: 720px !important;
  }

  .loop-p6-kicker {
    padding: 8px 14px !important;
    margin: 0 0 18px !important;
    color: #073f37 !important;
    background: rgba(255, 248, 238, 0.94) !important;
    border: 1px solid rgba(255, 255, 255, 0.78) !important;
    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08) !important;
    font-size: 11px !important;
    letter-spacing: .14em !important;
  }

  .loop-p6-title {
    max-width: 720px !important;
    margin: 0 !important;
    color: #fff8ee !important;
    text-shadow: 0 4px 18px rgba(0,0,0,.23) !important;
    font-size: clamp(38px, 3.7vw, 58px) !important;
    line-height: .98 !important;
    letter-spacing: -.068em !important;
  }

  .loop-p6-title span {
    color: #00a896 !important;
    text-shadow: none !important;
  }

  .loop-p6-offer-line {
    max-width: 660px !important;
    margin: clamp(14px, 1.5vw, 18px) 0 0 !important;
    color: rgba(255, 248, 238, 0.94) !important;
    text-shadow: 0 3px 14px rgba(0,0,0,.22) !important;
    font-size: clamp(15px, 1.08vw, 17px) !important;
    line-height: 1.42 !important;
    font-weight: 760 !important;
    letter-spacing: -0.012em !important;
  }

  .loop-p6-offer-line strong {
    color: #ffffff !important;
    font-weight: 950 !important;
    text-decoration: underline !important;
    text-decoration-color: rgba(0, 168, 150, 0.95) !important;
    text-decoration-thickness: 4px !important;
    text-underline-offset: 5px !important;
  }

  .loop-p6-subtitle {
    display: none !important;
  }

  .loop-p6-hero-actions {
    margin-top: clamp(18px, 2vw, 24px) !important;
    display: grid !important;
    gap: 14px !important;
    justify-items: start !important;
  }

  .loop-p6-main-create {
    width: auto !important;
    min-width: min(100%, 360px) !important;
    min-height: 54px !important;
    margin-top: 0 !important;
    padding: 0 30px !important;
    background: linear-gradient(135deg, #00675f 0%, #00897f 100%) !important;
    color: #fff8ee !important;
    box-shadow: 0 18px 36px rgba(0, 103, 95, 0.22) !important;
    font-size: 15.5px !important;
  }

  .loop-p6-platform-block {
    display: grid !important;
    gap: 8px !important;
  }

  .loop-p6-platform-copy {
    color: rgba(255,248,238,.94) !important;
    font-size: 14px !important;
    line-height: 1.25 !important;
    font-weight: 760 !important;
    text-shadow: 0 3px 12px rgba(0,0,0,.18) !important;
  }

  .loop-p6-store-row.loop-p6-store-row-left {
    margin-top: 0 !important;
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
  }

  .loop-p6-store-row-left .loop-p6-store-btn {
    min-height: 40px !important;
    min-width: 132px !important;
    padding: 0 16px !important;
    border: 1px solid rgba(255, 248, 238, 0.44) !important;
    background: rgba(255, 248, 238, 0.14) !important;
    color: #fff8ee !important;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.10) !important;
    backdrop-filter: blur(14px) !important;
    -webkit-backdrop-filter: blur(14px) !important;
    font-size: 13.5px !important;
  }

  .loop-p6-platform-img {
    width: 18px !important;
    height: 18px !important;
    object-fit: contain !important;
  }

  .loop-p6-benefit-card {
    justify-self: end !important;
    width: min(100%, 380px) !important;
    padding: 22px 24px !important;
    border-radius: 30px !important;
    background: rgba(255, 248, 238, 0.92) !important;
    border: 1px solid rgba(255, 255, 255, 0.74) !important;
    box-shadow: 0 24px 58px rgba(15, 23, 42, 0.13) !important;
  }

  .loop-p6-benefit-head {
    display: flex !important;
    align-items: center !important;
    gap: 14px !important;
    padding-bottom: 15px !important;
    border-bottom: 1px solid rgba(17, 18, 12, 0.10) !important;
  }

  .loop-p6-benefit-head strong {
    margin: 0 !important;
    color: #073f37 !important;
    font-size: 20px !important;
    line-height: 1.15 !important;
    letter-spacing: -.04em !important;
  }

  .loop-p6-benefit-mark {
    width: 48px !important;
    height: 48px !important;
    border-radius: 999px !important;
    display: grid !important;
    place-items: center !important;
    flex: 0 0 auto !important;
    background: linear-gradient(135deg, #00675f, #00897f) !important;
    color: #fff8ee !important;
    box-shadow: 0 14px 26px rgba(0, 103, 95, 0.18) !important;
    font-size: 20px !important;
  }

  .loop-p6-benefits-list {
    display: grid !important;
  }

  .loop-p6-benefit-row {
    display: grid !important;
    grid-template-columns: 38px minmax(0, 1fr) !important;
    align-items: center !important;
    gap: 13px !important;
    min-height: 58px !important;
    border-bottom: 1px solid rgba(17, 18, 12, 0.075) !important;
    color: #123f39 !important;
    font-size: 15px !important;
    font-weight: 850 !important;
    line-height: 1.2 !important;
  }

  .loop-p6-benefit-row:last-child {
    border-bottom: 0 !important;
  }

  .loop-p6-benefit-icon {
    width: 34px !important;
    height: 34px !important;
    border-radius: 999px !important;
    display: grid !important;
    place-items: center !important;
    background: rgba(0, 103, 95, 0.08) !important;
    color: #00675f !important;
  }

  @media (min-width: 900px) and (max-height: 820px) {
    .loop-p6-hero,
    .loop-p6-hero-overlay {
      min-height: 332px !important;
    }

    .loop-p6-hero-overlay {
      padding-top: 30px !important;
      padding-bottom: 28px !important;
    }

    .loop-p6-title {
      font-size: clamp(39px, 3.8vw, 58px) !important;
    }

    .loop-p6-benefit-row {
      min-height: 50px !important;
    }

    .loop-p6-benefit-card {
      padding: 18px 21px !important;
    }
  }

  @media (min-width: 769px) and (max-width: 1180px) {
    .loop-p6-hero,
    .loop-p6-hero-overlay {
      min-height: 330px !important;
    }

    .loop-p6-hero {
      width: calc(100% - 40px) !important;
      max-width: 1040px !important;
      margin: 20px auto 18px !important;
      border-radius: 34px !important;
    }

    .loop-p6-hero-overlay {
      padding: 28px 30px !important;
      grid-template-columns: minmax(0, 1fr) minmax(260px, 330px) !important;
      gap: 28px !important;
    }

    .loop-p6-title {
      font-size: clamp(38px, 5.6vw, 56px) !important;
      max-width: 580px !important;
    }

    .loop-p6-benefit-card {
      max-width: 330px !important;
      padding: 17px !important;
      border-radius: 26px !important;
    }

    .loop-p6-benefit-head strong {
      font-size: 17px !important;
    }

    .loop-p6-benefit-row {
      min-height: 48px !important;
      font-size: 13px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-hero {
      min-height: auto !important;
      background:
        linear-gradient(180deg, rgba(4,30,25,.70) 0%, rgba(4,30,25,.56) 54%, rgba(4,30,25,.38) 100%),
        var(--loop-hero-image, url("/assets/images/loop-phase6-hero-bg.jpg")) center/cover no-repeat !important;
    }

    .loop-p6-hero-overlay {
      min-height: auto !important;
      padding: 20px 18px 18px !important;
      display: grid !important;
      grid-template-columns: 1fr !important;
      gap: 14px !important;
    }

    .loop-p6-title {
      font-size: clamp(29px, 8.2vw, 40px) !important;
      line-height: .98 !important;
      letter-spacing: -.06em !important;
      max-width: 100% !important;
    }

    .loop-p6-offer-line {
      max-width: 100% !important;
      margin-top: 12px !important;
      font-size: 13.5px !important;
      line-height: 1.38 !important;
    }

    .loop-p6-offer-line strong {
      text-decoration-thickness: 3px !important;
      text-underline-offset: 4px !important;
    }

    .loop-p6-kicker {
      max-width: 100% !important;
      font-size: 9.8px !important;
      letter-spacing: .105em !important;
      padding: 7px 10px !important;
      margin-bottom: 13px !important;
    }

    .loop-p6-hero-actions {
      margin-top: 16px !important;
    }

    .loop-p6-main-create {
      width: 100% !important;
      min-width: 0 !important;
      min-height: 48px !important;
      font-size: 14px !important;
    }

    .loop-p6-store-row.loop-p6-store-row-left {
      display: grid !important;
      grid-template-columns: 1fr 1fr !important;
      width: 100% !important;
    }

    .loop-p6-store-row-left .loop-p6-store-btn {
      min-width: 0 !important;
      width: 100% !important;
      min-height: 40px !important;
    }

    .loop-p6-benefit-card {
      justify-self: stretch !important;
      width: 100% !important;
      padding: 14px !important;
      border-radius: 24px !important;
    }

    .loop-p6-benefit-head {
      padding-bottom: 10px !important;
    }

    .loop-p6-benefit-mark {
      width: 38px !important;
      height: 38px !important;
    }

    .loop-p6-benefit-head strong {
      font-size: 16px !important;
    }

    .loop-p6-benefits-list {
      grid-template-columns: 1fr 1fr !important;
      gap: 0 10px !important;
    }

    .loop-p6-benefit-row {
      min-height: 42px !important;
      grid-template-columns: 30px minmax(0, 1fr) !important;
      gap: 8px !important;
      font-size: 12.5px !important;
    }

    .loop-p6-benefit-icon {
      width: 28px !important;
      height: 28px !important;
    }
  }

  @media (max-width: 480px) {
    .loop-p6-benefits-list {
      grid-template-columns: 1fr !important;
    }

    .loop-p6-benefit-row {
      min-height: 41px !important;
    }

    .loop-p6-platform-copy {
      font-size: 12.5px !important;
    }
  }
`;

const phaseMobileHeroBenefitsAndUnifiedCategories = `
  /* =========================================================
     LOOP MOBILE HERO BENEFITS + UNIFIED CATEGORY STRIP
     Shows the business benefits on mobile without making the hero huge,
     and makes Chrome mobile use the same compact category feeling as app.
     ========================================================= */

  @media (max-width: 899px) {
    .loop-p6-hero {
      background:
        linear-gradient(180deg, rgba(4,30,25,.74) 0%, rgba(4,30,25,.58) 52%, rgba(4,30,25,.42) 100%),
        var(--loop-hero-image, url("/assets/images/loop-phase6-hero-bg.jpg")) center/cover no-repeat !important;
    }

    .loop-p6-hero-overlay {
      padding: 16px 14px 14px !important;
      gap: 10px !important;
    }

    .loop-p6-title {
      font-size: clamp(27px, 7.35vw, 37px) !important;
      line-height: .98 !important;
      letter-spacing: -.058em !important;
      max-width: 100% !important;
    }

    .loop-p6-offer-line {
      margin-top: 9px !important;
      font-size: 12.6px !important;
      line-height: 1.32 !important;
    }

    .loop-p6-hero-actions {
      margin-top: 12px !important;
      gap: 9px !important;
    }

    .loop-p6-main-create {
      min-height: 44px !important;
      height: 44px !important;
      border-radius: 999px !important;
      font-size: 13.5px !important;
    }

    .loop-p6-platform-block {
      gap: 6px !important;
    }

    .loop-p6-platform-copy {
      font-size: 12.2px !important;
      line-height: 1.2 !important;
    }

    .loop-p6-store-row.loop-p6-store-row-left {
      grid-template-columns: 1fr 1fr !important;
      gap: 8px !important;
      width: 100% !important;
    }

    .loop-p6-store-row-left .loop-p6-store-btn {
      min-height: 36px !important;
      height: 36px !important;
      border-radius: 999px !important;
      font-size: 12.4px !important;
      padding: 0 10px !important;
    }

    .loop-p6-platform-img {
      width: 15px !important;
      height: 15px !important;
    }

    .loop-p6-benefit-card {
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      justify-self: stretch !important;
      width: 100% !important;
      max-width: none !important;
      margin: 10px 0 0 !important;
      padding: 10px !important;
      border-radius: 20px !important;
      background: rgba(255, 248, 238, 0.92) !important;
      border: 1px solid rgba(255,255,255,.62) !important;
      box-shadow: 0 14px 30px rgba(0,0,0,.13) !important;
      backdrop-filter: blur(14px) saturate(1.03) !important;
      -webkit-backdrop-filter: blur(14px) saturate(1.03) !important;
    }

    .loop-p6-benefit-head {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      padding: 0 0 8px !important;
      margin: 0 !important;
      border-bottom: 0 !important;
    }

    .loop-p6-benefit-mark {
      width: 24px !important;
      height: 24px !important;
      min-width: 24px !important;
      font-size: 12px !important;
      box-shadow: 0 8px 18px rgba(0,103,95,.16) !important;
    }

    .loop-p6-benefit-head strong {
      display: block !important;
      color: #073f37 !important;
      font-size: 12.7px !important;
      line-height: 1.05 !important;
      letter-spacing: -.02em !important;
      font-weight: 950 !important;
    }

    .loop-p6-benefits-list {
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 7px !important;
    }

    .loop-p6-benefit-row {
      min-height: 33px !important;
      display: grid !important;
      grid-template-columns: 22px minmax(0, 1fr) !important;
      align-items: center !important;
      gap: 6px !important;
      padding: 5px 7px !important;
      border: 1px solid rgba(0,103,95,.10) !important;
      border-radius: 14px !important;
      background: rgba(255,255,255,.54) !important;
      color: #073f37 !important;
      font-size: 10.9px !important;
      line-height: 1.08 !important;
      font-weight: 900 !important;
      letter-spacing: -.02em !important;
    }

    .loop-p6-benefit-row:nth-child(3) {
      grid-column: 1 / -1 !important;
    }

    .loop-p6-benefit-icon {
      width: 22px !important;
      height: 22px !important;
      min-width: 22px !important;
      background: rgba(0, 103, 95, 0.08) !important;
      color: #00675f !important;
    }

    .loop-p6-benefit-icon svg {
      width: 13.5px !important;
      height: 13.5px !important;
    }

    /* Unify web mobile categories with the tighter native-app style. */
    #loop-services-section {
      padding: 16px 10px 18px !important;
      overflow: hidden !important;
    }

    #loop-services-section .loop-section-card {
      padding: 0 !important;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
      overflow: visible !important;
    }

    #loop-services-section .loop-section-head {
      margin-bottom: 14px !important;
      justify-content: center !important;
      text-align: center !important;
    }

    #loop-services-section .loop-section-kicker {
      width: 100% !important;
      text-align: center !important;
      font-size: 11px !important;
      letter-spacing: .22em !important;
      margin-bottom: 0 !important;
    }

    #loop-services-section .loop-categories-visual-wrap {
      width: 100% !important;
      overflow: visible !important;
    }

    #loop-services-section .loop-direct-categories {
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 auto !important;
      padding: 0 2px 2px !important;
      display: flex !important;
      flex-wrap: nowrap !important;
      justify-content: space-between !important;
      align-items: flex-start !important;
      gap: 0 !important;
      overflow: visible !important;
      scrollbar-width: none !important;
      -webkit-overflow-scrolling: touch !important;
    }

    #loop-services-section .loop-direct-categories::-webkit-scrollbar {
      display: none !important;
    }

    #loop-services-section .loop-direct-category-card {
      flex: 0 0 19.2% !important;
      width: 19.2% !important;
      min-width: 0 !important;
      max-width: 19.2% !important;
      height: auto !important;
      min-height: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      gap: 6px !important;
      display: inline-flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: flex-start !important;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
      overflow: visible !important;
    }

    #loop-services-section .loop-direct-category-icon {
      width: 56px !important;
      height: 56px !important;
      min-width: 56px !important;
      min-height: 56px !important;
      max-width: 56px !important;
      max-height: 56px !important;
      flex: 0 0 56px !important;
      border-radius: 18px !important;
      margin: 0 auto !important;
      padding: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
      overflow: hidden !important;
    }

    #loop-services-section .loop-direct-category-icon > img,
    #loop-services-section .loop-direct-category-icon img {
      position: static !important;
      display: block !important;
      width: 56px !important;
      height: 56px !important;
      min-width: 0 !important;
      min-height: 0 !important;
      max-width: 56px !important;
      max-height: 56px !important;
      object-fit: contain !important;
      object-position: center center !important;
      border-radius: 18px !important;
      transform: none !important;
      opacity: 1 !important;
      visibility: visible !important;
    }

    #loop-services-section .loop-direct-category-label {
      width: 64px !important;
      max-width: 64px !important;
      min-height: 24px !important;
      margin: 0 auto !important;
      padding: 0 !important;
      color: #0f172a !important;
      font-size: 8.9px !important;
      line-height: 1.08 !important;
      font-weight: 950 !important;
      letter-spacing: -.05em !important;
      text-align: center !important;
      white-space: normal !important;
      overflow: visible !important;
    }
  }

  @media (max-width: 420px) {
    #loop-services-section .loop-direct-category-icon,
    #loop-services-section .loop-direct-category-icon > img,
    #loop-services-section .loop-direct-category-icon img {
      width: 50px !important;
      height: 50px !important;
      min-width: 50px !important;
      min-height: 50px !important;
      max-width: 50px !important;
      max-height: 50px !important;
      flex-basis: 50px !important;
      border-radius: 16px !important;
    }

    #loop-services-section .loop-direct-category-label {
      width: 62px !important;
      max-width: 62px !important;
      font-size: 8.6px !important;
    }

    .loop-p6-title {
      font-size: clamp(26px, 7.1vw, 34px) !important;
    }
  }

  @media (max-width: 360px) {
    .loop-p6-benefit-row {
      font-size: 10.3px !important;
      padding-left: 5px !important;
      padding-right: 5px !important;
    }

    #loop-services-section .loop-direct-category-icon,
    #loop-services-section .loop-direct-category-icon > img,
    #loop-services-section .loop-direct-category-icon img {
      width: 46px !important;
      height: 46px !important;
      min-width: 46px !important;
      min-height: 46px !important;
      max-width: 46px !important;
      max-height: 46px !important;
      flex-basis: 46px !important;
    }

    #loop-services-section .loop-direct-category-label {
      width: 58px !important;
      max-width: 58px !important;
      font-size: 8.1px !important;
    }
  }

  /* Same visual contract inside the native mobile shell. */
  body.is-mobile-app .loop-p6-benefit-card {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    margin-top: 10px !important;
    padding: 10px !important;
    border-radius: 20px !important;
    background: rgba(255, 248, 238, 0.92) !important;
    border: 1px solid rgba(255,255,255,.62) !important;
    box-shadow: 0 14px 30px rgba(0,0,0,.13) !important;
  }

  body.is-mobile-app .loop-p6-benefit-head,
  body.is-mobile-app .loop-p6-benefits-list,
  body.is-mobile-app .loop-p6-benefit-row {
    display: grid !important;
  }

  body.is-mobile-app .loop-p6-benefit-head {
    display: flex !important;
  }
`;



const phaseHomeBenefitsCardV3 = `
  /* =========================================================
     LOOP HOME BENEFITS CARD V3
     Turns the desktop benefits box into a founder-access offer,
     with compact value copy and a cleaner premium card.
     Mobile keeps the chip rail from phaseMobileBenefitRailV2.
     ========================================================= */

  .loop-p6-benefit-card {
    width: min(100%, 392px) !important;
    padding: 20px !important;
    border-radius: 31px !important;
    background:
      radial-gradient(circle at 8% 0%, rgba(0, 137, 127, 0.12), transparent 34%),
      rgba(255, 248, 238, 0.94) !important;
    border: 1px solid rgba(255, 255, 255, 0.78) !important;
    box-shadow: 0 28px 64px rgba(15, 23, 42, 0.16) !important;
  }

  .loop-p6-benefit-head {
    gap: 13px !important;
    align-items: flex-start !important;
    padding-bottom: 16px !important;
    margin-bottom: 14px !important;
    border-bottom: 1px solid rgba(7, 63, 55, 0.10) !important;
  }

  .loop-p6-benefit-mark {
    width: 46px !important;
    height: 46px !important;
    font-size: 18px !important;
    box-shadow: 0 15px 28px rgba(0, 103, 95, 0.20) !important;
  }

  .loop-p6-benefit-head-copy {
    display: grid !important;
    gap: 4px !important;
    min-width: 0 !important;
  }

  .loop-p6-benefit-head-copy strong,
  .loop-p6-benefit-head strong {
    color: #073f37 !important;
    font-size: 22px !important;
    line-height: 1.02 !important;
    letter-spacing: -0.055em !important;
    font-weight: 950 !important;
  }

  .loop-p6-benefit-head-copy em {
    display: block !important;
    max-width: 250px !important;
    color: rgba(7, 63, 55, 0.72) !important;
    font-style: normal !important;
    font-size: 13.4px !important;
    line-height: 1.28 !important;
    font-weight: 760 !important;
    letter-spacing: -0.012em !important;
  }

  .loop-p6-benefits-list {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 10px !important;
  }

  .loop-p6-benefit-row {
    min-height: 78px !important;
    grid-template-columns: 32px minmax(0, 1fr) !important;
    align-items: flex-start !important;
    gap: 10px !important;
    padding: 13px 12px !important;
    border-radius: 19px !important;
    border: 1px solid rgba(0, 103, 95, 0.09) !important;
    background: rgba(255, 255, 255, 0.48) !important;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.52) !important;
  }

  .loop-p6-benefit-row:nth-child(3) {
    grid-column: 1 / -1 !important;
    min-height: 68px !important;
    background: rgba(0, 137, 127, 0.08) !important;
    border-color: rgba(0, 103, 95, 0.13) !important;
  }

  .loop-p6-benefit-row:last-child {
    border-bottom: 1px solid rgba(0, 103, 95, 0.09) !important;
  }

  .loop-p6-benefit-icon {
    width: 31px !important;
    height: 31px !important;
    min-width: 31px !important;
    background: rgba(0, 103, 95, 0.08) !important;
    color: #00675f !important;
  }

  .loop-p6-benefit-icon svg {
    width: 16px !important;
    height: 16px !important;
    stroke-width: 2.25 !important;
  }

  .loop-p6-benefit-copy {
    display: grid !important;
    gap: 4px !important;
    min-width: 0 !important;
  }

  .loop-p6-benefit-copy strong {
    color: #073f37 !important;
    font-size: 13.4px !important;
    line-height: 1.08 !important;
    font-weight: 950 !important;
    letter-spacing: -0.025em !important;
  }

  .loop-p6-benefit-copy em {
    color: rgba(7, 63, 55, 0.60) !important;
    font-style: normal !important;
    font-size: 11.4px !important;
    line-height: 1.18 !important;
    font-weight: 760 !important;
    letter-spacing: -0.01em !important;
  }

  .loop-p6-benefit-foot {
    margin-top: 14px !important;
    min-height: 35px !important;
    padding: 0 13px !important;
    border-radius: 999px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: #073f37 !important;
    background: rgba(0, 103, 95, 0.075) !important;
    border: 1px solid rgba(0, 103, 95, 0.10) !important;
    font-size: 12px !important;
    font-weight: 900 !important;
    letter-spacing: -0.01em !important;
  }

  @media (min-width: 900px) and (max-height: 820px) {
    .loop-p6-benefit-card {
      padding: 17px !important;
      border-radius: 28px !important;
    }

    .loop-p6-benefit-head {
      padding-bottom: 12px !important;
      margin-bottom: 11px !important;
    }

    .loop-p6-benefits-list {
      gap: 8px !important;
    }

    .loop-p6-benefit-row {
      min-height: 66px !important;
      padding: 10px 10px !important;
      border-radius: 16px !important;
    }

    .loop-p6-benefit-row:nth-child(3) {
      min-height: 58px !important;
    }

    .loop-p6-benefit-foot {
      margin-top: 11px !important;
    }
  }

  @media (min-width: 769px) and (max-width: 1180px) {
    .loop-p6-benefit-card {
      max-width: 340px !important;
      padding: 16px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: 18px !important;
    }

    .loop-p6-benefit-head-copy em {
      font-size: 12px !important;
    }

    .loop-p6-benefit-row {
      min-height: 62px !important;
      padding: 10px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 12px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.5px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-benefit-foot {
      display: none !important;
    }
  }
`;

const phaseMobileBenefitRailV2 = `
  /* =========================================================
     LOOP HOME MOBILE BENEFIT RAIL V2
     Desktop keeps the full benefits card. Mobile uses compact
     chips inside the hero so categories never cover the benefits.
     ========================================================= */

  .loop-p6-mobile-benefit-rail {
    display: none !important;
  }

  @media (max-width: 899px) {
    .loop-p6-hero {
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      overflow: visible !important;
    }

    .loop-p6-hero-overlay {
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      display: block !important;
      padding: 14px 14px 15px !important;
    }

    .loop-p6-hero-copy {
      width: 100% !important;
      max-width: 100% !important;
    }

    .loop-p6-benefit-card,
    body.is-mobile-app .loop-p6-benefit-card {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      height: 0 !important;
      min-height: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      overflow: hidden !important;
    }

    .loop-p6-mobile-benefit-rail {
      display: block !important;
      width: 100% !important;
      margin: 11px 0 0 !important;
      padding: 10px !important;
      border-radius: 18px !important;
      border: 1px solid rgba(255, 248, 238, 0.24) !important;
      background: rgba(255, 248, 238, 0.15) !important;
      box-shadow: 0 12px 26px rgba(0, 0, 0, 0.10) !important;
      backdrop-filter: blur(14px) saturate(1.04) !important;
      -webkit-backdrop-filter: blur(14px) saturate(1.04) !important;
    }

    .loop-p6-mobile-benefit-title {
      color: #fff8ee !important;
      font-size: 11.2px !important;
      line-height: 1.1 !important;
      font-weight: 950 !important;
      letter-spacing: -0.01em !important;
      text-shadow: 0 2px 10px rgba(0,0,0,.18) !important;
    }

    .loop-p6-mobile-benefit-chips {
      display: flex !important;
      flex-wrap: wrap !important;
      align-items: center !important;
      gap: 7px !important;
      margin-top: 8px !important;
    }

    .loop-p6-mobile-benefit-chip {
      min-height: 30px !important;
      padding: 0 9px !important;
      border-radius: 999px !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 5px !important;
      border: 1px solid rgba(255, 248, 238, 0.25) !important;
      background: rgba(255, 248, 238, 0.18) !important;
      color: #fff8ee !important;
      box-shadow: inset 0 1px 0 rgba(255,255,255,.12) !important;
      font-size: 10.9px !important;
      line-height: 1 !important;
      font-weight: 900 !important;
      white-space: nowrap !important;
      text-shadow: 0 2px 10px rgba(0,0,0,.16) !important;
    }

    .loop-p6-mobile-benefit-chip svg {
      width: 13px !important;
      height: 13px !important;
      flex: 0 0 13px !important;
      stroke-width: 2.3 !important;
    }

    .loop-p6-hero + #loop-services-section,
    #loop-services-section {
      position: relative !important;
      z-index: 1 !important;
      margin-top: 0 !important;
      transform: none !important;
      padding-top: 18px !important;
      overflow: visible !important;
    }

    #loop-services-section .loop-section-card {
      transform: none !important;
      margin-top: 0 !important;
    }
  }

  @media (max-width: 420px) {
    .loop-p6-mobile-benefit-rail {
      margin-top: 10px !important;
      padding: 9px !important;
      border-radius: 17px !important;
    }

    .loop-p6-mobile-benefit-chips {
      gap: 6px !important;
    }

    .loop-p6-mobile-benefit-chip {
      min-height: 28px !important;
      padding: 0 8px !important;
      font-size: 10.4px !important;
      gap: 4px !important;
    }

    .loop-p6-mobile-benefit-chip svg {
      width: 12px !important;
      height: 12px !important;
      flex-basis: 12px !important;
    }
  }

  @media (max-width: 360px) {
    .loop-p6-mobile-benefit-chip {
      font-size: 10px !important;
      padding: 0 7px !important;
    }
  }
`;

const phaseHomeFounderCardFinal = `
  /* =========================================================
     LOOP HOME FOUNDER CARD FINAL
     Premium founder-access card inspired by the final concept:
     two top benefits, highlighted WhatsApp band, and two bottom
     cards with Finanzas+Inventario and Fidelidad+Membresías.
     ========================================================= */

  @media (min-width: 900px) {
    .loop-p6-hero-overlay {
      grid-template-columns: minmax(0, 1fr) minmax(420px, 520px) !important;
      gap: clamp(28px, 4.8vw, 70px) !important;
    }

    .loop-p6-benefit-card {
      justify-self: end !important;
      width: min(100%, 520px) !important;
      padding: clamp(26px, 2.8vw, 36px) !important;
      border-radius: 36px !important;
      background:
        radial-gradient(circle at 12% 0%, rgba(255, 255, 255, 0.82), transparent 28%),
        linear-gradient(180deg, rgba(255, 251, 244, 0.985) 0%, rgba(255, 247, 235, 0.955) 100%) !important;
      border: 1px solid rgba(231, 202, 157, 0.62) !important;
      box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.72),
        0 32px 78px rgba(10, 20, 18, 0.18) !important;
      backdrop-filter: blur(18px) saturate(1.04) !important;
      -webkit-backdrop-filter: blur(18px) saturate(1.04) !important;
    }

    .loop-p6-benefit-head {
      display: grid !important;
      grid-template-columns: 72px minmax(0, 1fr) !important;
      align-items: start !important;
      gap: 22px !important;
      padding: 0 0 22px !important;
      margin: 0 !important;
      border-bottom: 0 !important;
    }

    .loop-p6-benefit-mark {
      width: 64px !important;
      height: 64px !important;
      border-radius: 999px !important;
      display: grid !important;
      place-items: center !important;
      background:
        radial-gradient(circle at 30% 18%, rgba(255, 255, 255, 0.20), transparent 38%),
        linear-gradient(135deg, #073f37 0%, #00897f 100%) !important;
      color: #fff8ee !important;
      box-shadow: 0 16px 32px rgba(0, 103, 95, 0.20) !important;
      font-size: 25px !important;
      line-height: 1 !important;
    }

    .loop-p6-benefit-head-copy {
      display: grid !important;
      gap: 13px !important;
      min-width: 0 !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      display: grid !important;
      gap: 0 !important;
      color: #073f37 !important;
      font-family: Georgia, 'Times New Roman', serif !important;
      font-size: clamp(38px, 3.5vw, 54px) !important;
      line-height: 0.86 !important;
      letter-spacing: -0.058em !important;
      font-weight: 700 !important;
    }

    .loop-p6-benefit-head-copy em {
      display: block !important;
      max-width: 330px !important;
      color: rgba(7, 63, 55, 0.72) !important;
      font-style: normal !important;
      font-size: 18px !important;
      line-height: 1.25 !important;
      font-weight: 520 !important;
      letter-spacing: -0.018em !important;
    }

    .loop-p6-benefit-head-copy em b {
      display: block !important;
      color: #073f37 !important;
      font-size: 23px !important;
      font-weight: 900 !important;
      letter-spacing: -0.03em !important;
      margin-bottom: 2px !important;
    }

    .loop-p6-benefits-list {
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 12px 14px !important;
      margin-top: 6px !important;
    }

    .loop-p6-benefit-row {
      display: grid !important;
      grid-template-columns: 50px minmax(0, 1fr) !important;
      align-items: center !important;
      gap: 14px !important;
      min-height: 88px !important;
      padding: 15px 17px !important;
      border-radius: 22px !important;
      border: 1px solid rgba(184, 143, 82, 0.30) !important;
      background: rgba(255, 252, 246, 0.58) !important;
      color: #073f37 !important;
      box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.72),
        0 10px 28px rgba(15, 23, 42, 0.035) !important;
    }

    .loop-p6-benefit-row-whatsapp {
      grid-column: 1 / -1 !important;
      min-height: 104px !important;
      grid-template-columns: 64px minmax(0, 1fr) !important;
      padding: 20px 24px !important;
      border-color: rgba(0, 103, 95, 0.18) !important;
      background:
        radial-gradient(circle at 94% 22%, rgba(0, 103, 95, 0.10), transparent 24%),
        linear-gradient(135deg, rgba(221, 238, 228, 0.94) 0%, rgba(235, 245, 238, 0.86) 100%) !important;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.62) !important;
      position: relative !important;
      overflow: hidden !important;
    }

    .loop-p6-benefit-row-whatsapp::after {
      content: "" !important;
      position: absolute !important;
      right: 18px !important;
      top: 18px !important;
      width: 92px !important;
      height: 70px !important;
      opacity: 0.14 !important;
      background:
        radial-gradient(circle at 70% 35%, transparent 0 11px, #00675f 12px 13px, transparent 14px),
        repeating-radial-gradient(circle at 80% 42%, transparent 0 12px, rgba(0, 103, 95, 0.55) 13px 14px, transparent 15px 22px) !important;
      pointer-events: none !important;
    }

    .loop-p6-benefit-icon {
      width: 48px !important;
      height: 48px !important;
      min-width: 48px !important;
      border-radius: 18px !important;
      display: grid !important;
      place-items: center !important;
      background: rgba(0, 103, 95, 0.09) !important;
      color: #00675f !important;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.64) !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon {
      width: 58px !important;
      height: 58px !important;
      min-width: 58px !important;
      border-radius: 999px !important;
      color: #fff8ee !important;
      background:
        radial-gradient(circle at 28% 18%, rgba(255,255,255,0.22), transparent 36%),
        linear-gradient(135deg, #00675f 0%, #00897f 100%) !important;
      box-shadow: 0 14px 30px rgba(0, 103, 95, 0.20) !important;
      z-index: 1 !important;
    }

    .loop-p6-benefit-icon svg {
      width: 23px !important;
      height: 23px !important;
      stroke-width: 2.05 !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon svg {
      width: 29px !important;
      height: 29px !important;
    }

    .loop-p6-benefit-copy {
      display: grid !important;
      gap: 5px !important;
      min-width: 0 !important;
      position: relative !important;
      z-index: 1 !important;
    }

    .loop-p6-benefit-copy strong {
      color: #073f37 !important;
      font-size: 17px !important;
      line-height: 1.08 !important;
      font-weight: 930 !important;
      letter-spacing: -0.028em !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong {
      font-size: 19px !important;
      letter-spacing: -0.035em !important;
    }

    .loop-p6-benefit-copy em {
      color: rgba(7, 63, 55, 0.66) !important;
      font-style: normal !important;
      font-size: 14px !important;
      line-height: 1.22 !important;
      font-weight: 560 !important;
      letter-spacing: -0.01em !important;
    }

    .loop-p6-benefit-foot {
      margin: 24px auto 0 !important;
      padding-top: 0 !important;
      min-height: 26px !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 10px !important;
      width: 100% !important;
      color: rgba(7, 63, 55, 0.82) !important;
      background: transparent !important;
      border: 0 !important;
      font-size: 16px !important;
      font-weight: 560 !important;
      letter-spacing: -0.018em !important;
    }

    .loop-p6-benefit-foot-icon {
      display: inline-grid !important;
      place-items: center !important;
      color: #00675f !important;
      flex: 0 0 auto !important;
    }
  }

  @media (min-width: 900px) and (max-height: 820px) {
    .loop-p6-hero-overlay {
      grid-template-columns: minmax(0, 1fr) minmax(380px, 470px) !important;
    }

    .loop-p6-benefit-card {
      width: min(100%, 470px) !important;
      padding: 23px !important;
      border-radius: 32px !important;
    }

    .loop-p6-benefit-head {
      grid-template-columns: 58px minmax(0, 1fr) !important;
      gap: 18px !important;
      padding-bottom: 16px !important;
    }

    .loop-p6-benefit-mark {
      width: 54px !important;
      height: 54px !important;
      font-size: 22px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: 42px !important;
    }

    .loop-p6-benefit-head-copy em {
      font-size: 15px !important;
      line-height: 1.2 !important;
    }

    .loop-p6-benefit-head-copy em b {
      font-size: 19px !important;
    }

    .loop-p6-benefits-list {
      gap: 9px !important;
    }

    .loop-p6-benefit-row {
      min-height: 72px !important;
      padding: 12px 14px !important;
      border-radius: 18px !important;
      grid-template-columns: 40px minmax(0, 1fr) !important;
    }

    .loop-p6-benefit-row-whatsapp {
      min-height: 78px !important;
      grid-template-columns: 48px minmax(0, 1fr) !important;
      padding: 12px 16px !important;
    }

    .loop-p6-benefit-icon {
      width: 39px !important;
      height: 39px !important;
      min-width: 39px !important;
      border-radius: 15px !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon {
      width: 45px !important;
      height: 45px !important;
      min-width: 45px !important;
    }

    .loop-p6-benefit-icon svg {
      width: 19px !important;
      height: 19px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 14px !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong {
      font-size: 16px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 12px !important;
    }

    .loop-p6-benefit-foot {
      margin-top: 16px !important;
      font-size: 14px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-hero-overlay {
      grid-template-columns: minmax(0, 1fr) minmax(340px, 430px) !important;
      gap: 28px !important;
    }

    .loop-p6-benefit-card {
      width: min(100%, 430px) !important;
      padding: 22px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: 38px !important;
    }

    .loop-p6-benefit-row {
      min-height: 70px !important;
      padding: 11px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 13px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 11px !important;
    }
  }
`;

const phaseHomeFounderAssetCardFinal = `
  /* =========================================================
     LOOP HOME FOUNDER CARD ASSET FINAL
     Rebuilds the card closer to the reference concept with
     asset-based icons, refined typography, and smaller badges.
     ========================================================= */

  @media (min-width: 900px) {
    .loop-p6-hero-overlay {
      grid-template-columns: minmax(0, 1fr) minmax(455px, 570px) !important;
      gap: clamp(34px, 4.8vw, 78px) !important;
      align-items: center !important;
    }

    .loop-p6-benefit-card {
      width: min(100%, 560px) !important;
      padding: 38px 40px 32px !important;
      border-radius: 42px !important;
      background:
        radial-gradient(circle at 18% 6%, rgba(255,255,255,0.96), transparent 34%),
        linear-gradient(180deg, rgba(255, 251, 243, 0.99), rgba(255, 246, 232, 0.97)) !important;
      border: 1.4px solid rgba(190, 146, 79, 0.54) !important;
      box-shadow:
        inset 0 0 0 1px rgba(255,255,255,0.70),
        0 30px 72px rgba(9, 18, 17, 0.20) !important;
      overflow: hidden !important;
      position: relative !important;
    }

    .loop-p6-benefit-card::before {
      content: "" !important;
      position: absolute !important;
      inset: 5px !important;
      border-radius: 37px !important;
      border: 1px solid rgba(190, 146, 79, 0.28) !important;
      pointer-events: none !important;
    }

    .loop-p6-benefit-head {
      display: grid !important;
      grid-template-columns: 80px minmax(0, 1fr) !important;
      gap: 22px !important;
      align-items: start !important;
      padding: 0 0 26px !important;
      margin: 0 !important;
      position: relative !important;
      z-index: 1 !important;
    }

    .loop-p6-benefit-mark {
      width: 74px !important;
      height: 74px !important;
      min-width: 74px !important;
      background: transparent !important;
      box-shadow: none !important;
      border: 0 !important;
      display: grid !important;
      place-items: center !important;
    }

    .loop-p6-founder-sparkle-img {
      width: 74px !important;
      height: 74px !important;
      display: block !important;
      object-fit: contain !important;
    }

    .loop-p6-benefit-head-copy {
      display: grid !important;
      gap: 16px !important;
      min-width: 0 !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      color: #123f39 !important;
      font-family: "Playfair Display", "Cormorant Garamond", Georgia, "Times New Roman", serif !important;
      font-size: clamp(54px, 4.6vw, 70px) !important;
      line-height: 0.78 !important;
      letter-spacing: -0.055em !important;
      font-weight: 520 !important;
      text-rendering: geometricPrecision !important;
    }

    .loop-p6-benefit-head-copy::after {
      content: "" !important;
      width: 44px !important;
      height: 2px !important;
      border-radius: 999px !important;
      background: rgba(178, 132, 57, 0.70) !important;
      margin-top: -4px !important;
      order: 2 !important;
    }

    .loop-p6-benefit-head-copy em {
      order: 3 !important;
      display: block !important;
      color: rgba(18, 63, 57, 0.82) !important;
      font-style: normal !important;
      font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
      font-size: 17px !important;
      line-height: 1.35 !important;
      font-weight: 480 !important;
      letter-spacing: -0.018em !important;
      max-width: 340px !important;
    }

    .loop-p6-benefit-head-copy em b {
      display: block !important;
      color: #123f39 !important;
      font-size: 24px !important;
      line-height: 1.1 !important;
      font-weight: 800 !important;
      letter-spacing: -0.03em !important;
      margin: 0 0 4px !important;
    }

    .loop-p6-benefits-list {
      position: relative !important;
      z-index: 1 !important;
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 12px 14px !important;
      margin-top: 2px !important;
    }

    .loop-p6-benefit-row {
      display: grid !important;
      grid-template-columns: 56px minmax(0, 1fr) !important;
      align-items: center !important;
      gap: 12px !important;
      min-height: 92px !important;
      padding: 16px 18px !important;
      border-radius: 22px !important;
      border: 1px solid rgba(190, 146, 79, 0.34) !important;
      background: rgba(255, 251, 244, 0.52) !important;
      box-shadow: none !important;
    }

    .loop-p6-benefit-row-whatsapp {
      grid-column: 1 / -1 !important;
      grid-template-columns: 70px minmax(0, 1fr) !important;
      min-height: 112px !important;
      padding: 20px 28px !important;
      border-radius: 22px !important;
      border-color: rgba(18, 63, 57, 0.18) !important;
      background:
        radial-gradient(circle at 96% 18%, rgba(0, 103, 95, 0.10), transparent 26%),
        linear-gradient(135deg, rgba(222, 235, 226, 0.96), rgba(236, 244, 235, 0.92)) !important;
      overflow: hidden !important;
      position: relative !important;
    }

    .loop-p6-benefit-row-whatsapp::after {
      content: "" !important;
      position: absolute !important;
      right: 18px !important;
      top: 17px !important;
      width: 98px !important;
      height: 74px !important;
      opacity: 0.16 !important;
      background:
        radial-gradient(circle at 76% 34%, transparent 0 14px, rgba(18,63,57,0.62) 15px 16px, transparent 17px),
        repeating-radial-gradient(circle at 80% 42%, transparent 0 13px, rgba(18, 63, 57, 0.44) 14px 15px, transparent 16px 24px) !important;
      pointer-events: none !important;
    }

    .loop-p6-benefit-icon {
      width: 56px !important;
      height: 56px !important;
      min-width: 56px !important;
      border-radius: 0 !important;
      background: transparent !important;
      color: inherit !important;
      box-shadow: none !important;
      display: grid !important;
      place-items: center !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon {
      width: 66px !important;
      height: 66px !important;
      min-width: 66px !important;
      background: transparent !important;
      box-shadow: none !important;
      border-radius: 0 !important;
      z-index: 1 !important;
    }

    .loop-p6-feature-img {
      width: 54px !important;
      height: 54px !important;
      object-fit: contain !important;
      display: block !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-feature-img {
      width: 64px !important;
      height: 64px !important;
    }

    .loop-p6-benefit-copy {
      display: grid !important;
      gap: 5px !important;
      min-width: 0 !important;
      position: relative !important;
      z-index: 1 !important;
    }

    .loop-p6-benefit-copy strong {
      color: #123f39 !important;
      font-family: "Playfair Display", "Cormorant Garamond", Georgia, "Times New Roman", serif !important;
      font-size: 19px !important;
      line-height: 1.02 !important;
      font-weight: 680 !important;
      letter-spacing: -0.035em !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong {
      font-size: 21px !important;
      font-weight: 680 !important;
      letter-spacing: -0.038em !important;
    }

    .loop-p6-benefit-copy em {
      color: rgba(18, 63, 57, 0.74) !important;
      font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
      font-style: normal !important;
      font-size: 14px !important;
      line-height: 1.24 !important;
      font-weight: 470 !important;
      letter-spacing: -0.01em !important;
    }

    .loop-p6-benefit-foot {
      position: relative !important;
      z-index: 1 !important;
      margin: 28px auto 0 !important;
      padding: 0 !important;
      min-height: 30px !important;
      width: 100% !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 10px !important;
      color: rgba(18, 63, 57, 0.78) !important;
      border: 0 !important;
      background: transparent !important;
      font-size: 16px !important;
      font-weight: 480 !important;
      letter-spacing: -0.018em !important;
    }

    .loop-p6-benefit-foot-icon {
      width: 22px !important;
      height: 22px !important;
      display: inline-grid !important;
      place-items: center !important;
    }

    .loop-p6-shield-img {
      width: 22px !important;
      height: 22px !important;
      object-fit: contain !important;
      display: block !important;
    }
  }

  @media (min-width: 900px) and (max-height: 820px) {
    .loop-p6-hero-overlay {
      grid-template-columns: minmax(0, 1fr) minmax(405px, 500px) !important;
    }

    .loop-p6-benefit-card {
      width: min(100%, 500px) !important;
      padding: 28px 30px 25px !important;
      border-radius: 36px !important;
    }

    .loop-p6-benefit-card::before {
      border-radius: 31px !important;
    }

    .loop-p6-benefit-head {
      grid-template-columns: 64px minmax(0, 1fr) !important;
      gap: 18px !important;
      padding-bottom: 18px !important;
    }

    .loop-p6-benefit-mark,
    .loop-p6-founder-sparkle-img {
      width: 60px !important;
      height: 60px !important;
      min-width: 60px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: 48px !important;
    }

    .loop-p6-benefit-head-copy em b {
      font-size: 20px !important;
    }

    .loop-p6-benefit-head-copy em {
      font-size: 14px !important;
    }

    .loop-p6-benefits-list {
      gap: 9px 11px !important;
    }

    .loop-p6-benefit-row {
      min-height: 72px !important;
      grid-template-columns: 46px minmax(0, 1fr) !important;
      padding: 12px 14px !important;
      border-radius: 18px !important;
    }

    .loop-p6-benefit-row-whatsapp {
      min-height: 82px !important;
      grid-template-columns: 54px minmax(0, 1fr) !important;
      padding: 13px 18px !important;
    }

    .loop-p6-benefit-icon,
    .loop-p6-feature-img {
      width: 44px !important;
      height: 44px !important;
      min-width: 44px !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
    .loop-p6-benefit-row-whatsapp .loop-p6-feature-img {
      width: 52px !important;
      height: 52px !important;
      min-width: 52px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 15.5px !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong {
      font-size: 17px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 12px !important;
    }

    .loop-p6-benefit-foot {
      margin-top: 18px !important;
      font-size: 14px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-hero-overlay {
      grid-template-columns: minmax(0, 1fr) minmax(365px, 455px) !important;
      gap: 28px !important;
    }

    .loop-p6-benefit-card {
      width: min(100%, 455px) !important;
      padding: 25px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: 42px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 14.5px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 11.5px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-feature-img {
      width: 14px !important;
      height: 14px !important;
      object-fit: contain !important;
      display: block !important;
    }
  }
`;


const phaseHomeFounderCardRedLineFit = `
  /* =========================================================
     LOOP HOME FOUNDER CARD RED-LINE FIT
     Desktop-only compression so the founder card stays inside
     the visual hero band marked by the red guide lines.
     Keeps the asset icons, but reduces card, type, rows and
     icon sizes instead of simply scaling the whole screenshot.
     ========================================================= */

  @media (min-width: 900px) {
    .loop-p6-hero-overlay {
      grid-template-columns: minmax(0, 1fr) minmax(392px, 500px) !important;
      gap: clamp(24px, 4.2vw, 58px) !important;
      align-items: center !important;
    }

    .loop-p6-benefit-card {
      width: min(100%, 500px) !important;
      padding: 26px 30px 22px !important;
      border-radius: 34px !important;
      align-self: center !important;
      justify-self: end !important;
      box-shadow:
        inset 0 0 0 1px rgba(255,255,255,0.72),
        0 24px 58px rgba(9, 18, 17, 0.18) !important;
    }

    .loop-p6-benefit-card::before {
      inset: 4px !important;
      border-radius: 30px !important;
    }

    .loop-p6-benefit-head {
      grid-template-columns: 56px minmax(0, 1fr) !important;
      gap: 16px !important;
      padding: 0 0 14px !important;
      align-items: start !important;
    }

    .loop-p6-benefit-mark,
    .loop-p6-founder-sparkle-img {
      width: 54px !important;
      height: 54px !important;
      min-width: 54px !important;
    }

    .loop-p6-benefit-head-copy {
      gap: 9px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: clamp(39px, 3.45vw, 50px) !important;
      line-height: 0.80 !important;
      letter-spacing: -0.052em !important;
      font-weight: 520 !important;
    }

    .loop-p6-benefit-head-copy::after {
      width: 34px !important;
      height: 1.5px !important;
      margin-top: -2px !important;
    }

    .loop-p6-benefit-head-copy em {
      font-size: 13px !important;
      line-height: 1.24 !important;
      max-width: 280px !important;
      letter-spacing: -0.012em !important;
    }

    .loop-p6-benefit-head-copy em b {
      font-size: 18px !important;
      line-height: 1.06 !important;
      margin-bottom: 2px !important;
    }

    .loop-p6-benefits-list {
      gap: 8px 10px !important;
      margin-top: 0 !important;
    }

    .loop-p6-benefit-row {
      grid-template-columns: 40px minmax(0, 1fr) !important;
      gap: 10px !important;
      min-height: 68px !important;
      padding: 11px 13px !important;
      border-radius: 17px !important;
      border-width: 1px !important;
    }

    .loop-p6-benefit-row-whatsapp {
      grid-template-columns: 50px minmax(0, 1fr) !important;
      min-height: 78px !important;
      padding: 13px 18px !important;
      border-radius: 18px !important;
    }

    .loop-p6-benefit-row-whatsapp::after {
      right: 12px !important;
      top: 10px !important;
      width: 78px !important;
      height: 58px !important;
      opacity: 0.13 !important;
    }

    .loop-p6-benefit-icon,
    .loop-p6-feature-img {
      width: 38px !important;
      height: 38px !important;
      min-width: 38px !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
    .loop-p6-benefit-row-whatsapp .loop-p6-feature-img {
      width: 48px !important;
      height: 48px !important;
      min-width: 48px !important;
    }

    .loop-p6-benefit-copy {
      gap: 3px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 15px !important;
      line-height: 1.0 !important;
      letter-spacing: -0.028em !important;
      font-weight: 680 !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong {
      font-size: 16.5px !important;
      line-height: 1.02 !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 11.6px !important;
      line-height: 1.16 !important;
      letter-spacing: -0.006em !important;
    }

    .loop-p6-benefit-foot {
      margin-top: 14px !important;
      min-height: 22px !important;
      gap: 8px !important;
      font-size: 13.2px !important;
      line-height: 1.1 !important;
    }

    .loop-p6-benefit-foot-icon,
    .loop-p6-shield-img {
      width: 17px !important;
      height: 17px !important;
    }
  }

  @media (min-width: 900px) and (max-height: 820px) {
    .loop-p6-hero-overlay {
      grid-template-columns: minmax(0, 1fr) minmax(360px, 455px) !important;
    }

    .loop-p6-benefit-card {
      width: min(100%, 455px) !important;
      padding: 22px 25px 18px !important;
      border-radius: 30px !important;
    }

    .loop-p6-benefit-card::before {
      border-radius: 26px !important;
    }

    .loop-p6-benefit-head {
      grid-template-columns: 48px minmax(0, 1fr) !important;
      gap: 13px !important;
      padding-bottom: 12px !important;
    }

    .loop-p6-benefit-mark,
    .loop-p6-founder-sparkle-img {
      width: 46px !important;
      height: 46px !important;
      min-width: 46px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: 39px !important;
    }

    .loop-p6-benefit-head-copy em b {
      font-size: 16px !important;
    }

    .loop-p6-benefit-head-copy em {
      font-size: 12px !important;
    }

    .loop-p6-benefit-row {
      min-height: 60px !important;
      grid-template-columns: 34px minmax(0, 1fr) !important;
      padding: 9px 11px !important;
      border-radius: 15px !important;
    }

    .loop-p6-benefit-row-whatsapp {
      min-height: 68px !important;
      grid-template-columns: 42px minmax(0, 1fr) !important;
      padding: 10px 14px !important;
    }

    .loop-p6-benefit-icon,
    .loop-p6-feature-img {
      width: 32px !important;
      height: 32px !important;
      min-width: 32px !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
    .loop-p6-benefit-row-whatsapp .loop-p6-feature-img {
      width: 40px !important;
      height: 40px !important;
      min-width: 40px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 13.2px !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong {
      font-size: 14.5px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.6px !important;
    }

    .loop-p6-benefit-foot {
      margin-top: 10px !important;
      font-size: 12px !important;
    }
  }
`;


const phaseHomeFounderWhatsappPngIcon = `
  /* =========================================================
     LOOP HOME WHATSAPP PNG ICON
     Uses the high-quality PNG asset for WhatsApp instead of SVG.
     The PNG already includes the premium circular badge/shadow,
     so the wrapper is made transparent to avoid double circles.
     ========================================================= */

  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon {
    background: transparent !important;
    box-shadow: none !important;
    border-radius: 999px !important;
    overflow: visible !important;
  }

  .loop-p6-benefit-row-whatsapp .loop-p6-feature-img {
    width: 48px !important;
    height: 48px !important;
    min-width: 48px !important;
    object-fit: contain !important;
    display: block !important;
    border-radius: 999px !important;
  }

  @media (min-width: 900px) and (max-height: 820px) {
    .loop-p6-benefit-row-whatsapp .loop-p6-feature-img {
      width: 40px !important;
      height: 40px !important;
      min-width: 40px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-mobile-benefit-chip .loop-p6-feature-img {
      width: 16px !important;
      height: 16px !important;
      min-width: 16px !important;
      object-fit: contain !important;
      display: block !important;
    }
  }
`;



const phaseHomeResponsiveFitRevamp = `
  /* =========================================================
     LOOP HOME RESPONSIVE FIT REVAMP
     Better tablet fit + cleaner mobile benefit card.
     - Tablet: keeps founder card, but compresses typography so text stays inside.
     - Mobile: replaces ugly chips with a small premium benefit sheet.
     ========================================================= */

  @media (max-width: 1180px) {
    .loop-p6-title br {
      display: none !important;
    }

    .loop-p6-title {
      max-width: 680px !important;
      font-size: clamp(42px, 5.6vw, 64px) !important;
      line-height: 0.96 !important;
      letter-spacing: -0.07em !important;
      text-wrap: balance !important;
    }

    .loop-p6-offer-line {
      max-width: 640px !important;
      font-size: 14.5px !important;
      line-height: 1.34 !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-hero {
      min-height: 0 !important;
    }

    .loop-p6-hero-overlay {
      grid-template-columns: minmax(420px, 1fr) minmax(320px, 365px) !important;
      gap: clamp(18px, 2.4vw, 30px) !important;
      padding: clamp(22px, 3vw, 34px) clamp(20px, 3vw, 32px) !important;
      align-items: center !important;
    }

    .loop-p6-hero-copy {
      max-width: 100% !important;
      min-width: 0 !important;
    }

    .loop-p6-title {
      max-width: 600px !important;
      font-size: clamp(43px, 5.1vw, 58px) !important;
      line-height: 0.96 !important;
    }

    .loop-p6-primary {
      min-height: 48px !important;
      max-width: 360px !important;
      padding: 0 22px !important;
      font-size: 14px !important;
    }

    .loop-p6-benefit-card {
      width: min(100%, 365px) !important;
      padding: 18px 18px 16px !important;
      border-radius: 28px !important;
      transform: none !important;
    }

    .loop-p6-benefit-head {
      grid-template-columns: 40px minmax(0, 1fr) !important;
      gap: 13px !important;
      padding-bottom: 11px !important;
    }

    .loop-p6-benefit-mark {
      width: 38px !important;
      height: 38px !important;
      min-width: 38px !important;
    }

    .loop-p6-founder-sparkle-img {
      width: 38px !important;
      height: 38px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: clamp(30px, 3.4vw, 38px) !important;
      line-height: 0.86 !important;
      letter-spacing: -0.058em !important;
    }

    .loop-p6-benefit-head-copy em {
      max-width: 230px !important;
      font-size: 12.8px !important;
      line-height: 1.16 !important;
    }

    .loop-p6-benefit-head-copy em b {
      font-size: 15.4px !important;
      margin-bottom: 1px !important;
    }

    .loop-p6-benefits-list {
      gap: 8px !important;
      margin-top: 4px !important;
    }

    .loop-p6-benefit-row {
      grid-template-columns: 32px minmax(0, 1fr) !important;
      min-height: 68px !important;
      padding: 10px 10px !important;
      gap: 9px !important;
      border-radius: 16px !important;
      overflow: hidden !important;
    }

    .loop-p6-benefit-row-whatsapp {
      grid-template-columns: 42px minmax(0, 1fr) !important;
      min-height: 76px !important;
      padding: 11px 13px !important;
      border-radius: 18px !important;
    }

    .loop-p6-benefit-icon {
      width: 30px !important;
      height: 30px !important;
      min-width: 30px !important;
      border-radius: 12px !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon {
      width: 42px !important;
      height: 42px !important;
      min-width: 42px !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-feature-img {
      width: 42px !important;
      height: 42px !important;
      min-width: 42px !important;
    }

    .loop-p6-feature-img {
      width: 22px !important;
      height: 22px !important;
    }

    .loop-p6-benefit-copy {
      min-width: 0 !important;
      gap: 3px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 12.6px !important;
      line-height: 1.03 !important;
      letter-spacing: -0.025em !important;
      overflow-wrap: anywhere !important;
      hyphens: auto !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong {
      font-size: 15px !important;
      line-height: 1.05 !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.8px !important;
      line-height: 1.16 !important;
      overflow-wrap: anywhere !important;
    }

    .loop-p6-benefit-foot {
      margin-top: 12px !important;
      font-size: 11.5px !important;
      line-height: 1.1 !important;
      gap: 6px !important;
    }

    .loop-p6-shield-img {
      width: 14px !important;
      height: 14px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1010px) {
    .loop-p6-hero-overlay {
      grid-template-columns: minmax(360px, 1fr) minmax(300px, 335px) !important;
      gap: 16px !important;
    }

    .loop-p6-title {
      font-size: clamp(38px, 4.9vw, 50px) !important;
    }

    .loop-p6-benefit-card {
      width: min(100%, 335px) !important;
      padding: 16px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: clamp(27px, 3.2vw, 34px) !important;
    }

    .loop-p6-benefit-row {
      min-height: 62px !important;
      padding: 9px !important;
    }

    .loop-p6-benefit-row-whatsapp {
      min-height: 70px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 11.8px !important;
    }

    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong {
      font-size: 13.5px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-hero {
      border-radius: 0 !important;
      overflow: hidden !important;
    }

    .loop-p6-hero-overlay {
      padding: 14px 12px 14px !important;
    }

    .loop-p6-title br {
      display: none !important;
    }

    .loop-p6-title {
      max-width: 100% !important;
      font-size: clamp(31px, 8.7vw, 44px) !important;
      line-height: 0.98 !important;
      letter-spacing: -0.064em !important;
      text-wrap: balance !important;
    }

    .loop-p6-offer-line {
      max-width: 100% !important;
      margin-top: 9px !important;
      font-size: 12.8px !important;
      line-height: 1.33 !important;
      font-weight: 800 !important;
    }

    .loop-p6-hero-actions {
      margin-top: 14px !important;
    }

    .loop-p6-primary {
      min-height: 46px !important;
      font-size: 13.2px !important;
      border-radius: 18px !important;
    }

    .loop-p6-platform-block {
      margin-top: 11px !important;
    }

    .loop-p6-platform-copy {
      font-size: 12px !important;
      line-height: 1.1 !important;
    }

    .loop-p6-store-row-left {
      gap: 8px !important;
    }

    .loop-p6-store-btn {
      min-height: 34px !important;
      padding: 0 13px !important;
      font-size: 12px !important;
    }

    .loop-p6-mobile-benefit-rail {
      display: block !important;
      margin: 13px 0 0 !important;
      padding: 12px !important;
      border-radius: 20px !important;
      background:
        radial-gradient(circle at 10% 0%, rgba(255,255,255,0.58), transparent 34%),
        linear-gradient(180deg, rgba(255, 248, 238, 0.94), rgba(245, 238, 224, 0.84)) !important;
      border: 1px solid rgba(255, 248, 238, 0.55) !important;
      box-shadow: 0 16px 34px rgba(0, 0, 0, 0.16) !important;
      color: #073f37 !important;
      backdrop-filter: blur(14px) saturate(1.05) !important;
      -webkit-backdrop-filter: blur(14px) saturate(1.05) !important;
    }

    .loop-p6-mobile-benefit-title {
      display: grid !important;
      gap: 2px !important;
      color: #073f37 !important;
      text-shadow: none !important;
      font-size: unset !important;
      line-height: 1.1 !important;
      letter-spacing: -0.015em !important;
    }

    .loop-p6-mobile-benefit-title strong {
      display: block !important;
      font-size: 13.5px !important;
      line-height: 1.05 !important;
      font-weight: 950 !important;
      color: #073f37 !important;
    }

    .loop-p6-mobile-benefit-title span {
      display: block !important;
      color: rgba(7, 63, 55, 0.70) !important;
      font-size: 11.2px !important;
      line-height: 1.22 !important;
      font-weight: 720 !important;
    }

    .loop-p6-mobile-benefit-chips {
      display: none !important;
    }

    .loop-p6-mobile-benefit-stack {
      display: grid !important;
      gap: 7px !important;
      margin-top: 9px !important;
    }

    .loop-p6-mobile-benefit-card {
      display: grid !important;
      grid-template-columns: 32px minmax(0, 1fr) !important;
      align-items: center !important;
      gap: 9px !important;
      min-height: 48px !important;
      padding: 8px 10px !important;
      border-radius: 15px !important;
      background: rgba(255, 252, 246, 0.70) !important;
      border: 1px solid rgba(184, 143, 82, 0.18) !important;
      color: #073f37 !important;
      text-shadow: none !important;
      box-shadow: inset 0 1px 0 rgba(255,255,255,0.62) !important;
    }

    .loop-p6-mobile-benefit-card-whatsapp {
      background:
        radial-gradient(circle at 92% 30%, rgba(0, 103, 95, 0.10), transparent 28%),
        linear-gradient(135deg, rgba(222, 240, 229, 0.92), rgba(238, 248, 242, 0.80)) !important;
      border-color: rgba(0, 103, 95, 0.16) !important;
    }

    .loop-p6-mobile-benefit-card > .loop-p6-feature-img,
    .loop-p6-mobile-benefit-card .loop-p6-feature-img {
      width: 26px !important;
      height: 26px !important;
      min-width: 26px !important;
      object-fit: contain !important;
    }

    .loop-p6-mobile-benefit-card-whatsapp .loop-p6-feature-img {
      width: 32px !important;
      height: 32px !important;
      min-width: 32px !important;
      transform: translateX(-2px) !important;
    }

    .loop-p6-mobile-benefit-card span {
      min-width: 0 !important;
      display: grid !important;
      gap: 2px !important;
    }

    .loop-p6-mobile-benefit-card strong {
      color: #073f37 !important;
      font-size: 12.2px !important;
      line-height: 1.08 !important;
      font-weight: 950 !important;
      letter-spacing: -0.022em !important;
      overflow-wrap: anywhere !important;
    }

    .loop-p6-mobile-benefit-card em {
      color: rgba(7, 63, 55, 0.65) !important;
      font-style: normal !important;
      font-size: 10.6px !important;
      line-height: 1.18 !important;
      font-weight: 650 !important;
      overflow-wrap: anywhere !important;
    }

    .loop-p6-hero + #loop-services-section,
    #loop-services-section {
      padding-top: 14px !important;
    }
  }

  @media (max-width: 430px) {
    .loop-p6-title {
      font-size: clamp(29px, 8.35vw, 36px) !important;
      line-height: 1.0 !important;
      letter-spacing: -0.058em !important;
    }

    .loop-p6-offer-line {
      font-size: 11.8px !important;
      line-height: 1.25 !important;
    }

    .loop-p6-mobile-benefit-rail {
      padding: 11px !important;
      border-radius: 18px !important;
    }

    .loop-p6-mobile-benefit-card {
      min-height: 44px !important;
      grid-template-columns: 28px minmax(0, 1fr) !important;
      gap: 8px !important;
      padding: 7px 9px !important;
    }

    .loop-p6-mobile-benefit-card > .loop-p6-feature-img,
    .loop-p6-mobile-benefit-card .loop-p6-feature-img {
      width: 23px !important;
      height: 23px !important;
      min-width: 23px !important;
    }

    .loop-p6-mobile-benefit-card-whatsapp .loop-p6-feature-img {
      width: 29px !important;
      height: 29px !important;
      min-width: 29px !important;
    }

    .loop-p6-mobile-benefit-card strong {
      font-size: 11.3px !important;
    }

    .loop-p6-mobile-benefit-card em {
      font-size: 9.7px !important;
    }
  }
`;



const phaseHomeMidTabletBreakpointFix = `
  /* =========================================================
     LOOP HOME MID-TABLET BREAKPOINT FIX
     Fixes the single ugly in-between width where the founder card
     and headline compete. Desktop stays the same; mobile stays the same.
     ========================================================= */

  @media (min-width: 900px) and (max-width: 1080px) {
    .loop-p6-hero {
      min-height: 0 !important;
      height: auto !important;
      overflow: hidden !important;
    }

    .loop-p6-hero-overlay {
      display: block !important;
      min-height: 0 !important;
      height: auto !important;
      padding: 28px 34px 30px !important;
    }

    .loop-p6-hero-copy {
      width: 100% !important;
      max-width: 760px !important;
      min-width: 0 !important;
    }

    .loop-p6-title br {
      display: none !important;
    }

    .loop-p6-title {
      max-width: 760px !important;
      font-size: clamp(42px, 5.3vw, 56px) !important;
      line-height: 0.98 !important;
      letter-spacing: -0.066em !important;
      text-wrap: balance !important;
    }

    .loop-p6-offer-line {
      max-width: 720px !important;
      margin-top: 12px !important;
      font-size: 13.8px !important;
      line-height: 1.32 !important;
    }

    .loop-p6-hero-actions {
      display: flex !important;
      align-items: flex-end !important;
      justify-content: space-between !important;
      gap: 18px !important;
      margin-top: 17px !important;
      max-width: 720px !important;
    }

    .loop-p6-main-create {
      width: min(100%, 280px) !important;
      min-width: 230px !important;
      min-height: 50px !important;
      padding: 0 22px !important;
      border-radius: 20px !important;
      font-size: 13.8px !important;
      flex: 0 0 auto !important;
    }

    .loop-p6-platform-block {
      margin-top: 0 !important;
      min-width: 0 !important;
      flex: 1 1 auto !important;
    }

    .loop-p6-platform-copy {
      font-size: 12px !important;
      line-height: 1.1 !important;
      white-space: nowrap !important;
    }

    .loop-p6-store-row-left {
      gap: 8px !important;
    }

    .loop-p6-store-btn {
      min-height: 34px !important;
      padding: 0 14px !important;
      font-size: 12px !important;
      border-radius: 14px !important;
    }

    .loop-p6-benefit-card {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }

    .loop-p6-mobile-benefit-rail {
      display: block !important;
      width: 100% !important;
      max-width: 720px !important;
      margin: 16px 0 0 !important;
      padding: 12px !important;
      border-radius: 22px !important;
      background:
        radial-gradient(circle at 10% 0%, rgba(255,255,255,0.58), transparent 34%),
        linear-gradient(180deg, rgba(255, 248, 238, 0.94), rgba(245, 238, 224, 0.84)) !important;
      border: 1px solid rgba(255, 248, 238, 0.58) !important;
      box-shadow: 0 16px 34px rgba(0, 0, 0, 0.14) !important;
      color: #073f37 !important;
      text-shadow: none !important;
      backdrop-filter: blur(14px) saturate(1.05) !important;
      -webkit-backdrop-filter: blur(14px) saturate(1.05) !important;
    }

    .loop-p6-mobile-benefit-title {
      display: grid !important;
      gap: 2px !important;
      color: #073f37 !important;
      text-shadow: none !important;
      font-size: unset !important;
      line-height: 1.1 !important;
      letter-spacing: -0.015em !important;
    }

    .loop-p6-mobile-benefit-title strong {
      display: block !important;
      font-size: 13.6px !important;
      line-height: 1.05 !important;
      font-weight: 950 !important;
      color: #073f37 !important;
    }

    .loop-p6-mobile-benefit-title span {
      display: block !important;
      color: rgba(7, 63, 55, 0.70) !important;
      font-size: 11.2px !important;
      line-height: 1.22 !important;
      font-weight: 720 !important;
    }

    .loop-p6-mobile-benefit-chips {
      display: none !important;
    }

    .loop-p6-mobile-benefit-stack {
      display: grid !important;
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
      gap: 8px !important;
      margin-top: 9px !important;
    }

    .loop-p6-mobile-benefit-card {
      display: grid !important;
      grid-template-columns: 30px minmax(0, 1fr) !important;
      align-items: center !important;
      gap: 8px !important;
      min-height: 58px !important;
      padding: 8px 10px !important;
      border-radius: 15px !important;
      background: rgba(255, 252, 246, 0.70) !important;
      border: 1px solid rgba(184, 143, 82, 0.18) !important;
      color: #073f37 !important;
      text-shadow: none !important;
      box-shadow: inset 0 1px 0 rgba(255,255,255,0.62) !important;
    }

    .loop-p6-mobile-benefit-card-whatsapp {
      background:
        radial-gradient(circle at 92% 30%, rgba(0, 103, 95, 0.10), transparent 28%),
        linear-gradient(135deg, rgba(222, 240, 229, 0.92), rgba(238, 248, 242, 0.80)) !important;
      border-color: rgba(0, 103, 95, 0.16) !important;
    }

    .loop-p6-mobile-benefit-card .loop-p6-feature-img {
      width: 25px !important;
      height: 25px !important;
      min-width: 25px !important;
      object-fit: contain !important;
      display: block !important;
    }

    .loop-p6-mobile-benefit-card-whatsapp .loop-p6-feature-img {
      width: 31px !important;
      height: 31px !important;
      min-width: 31px !important;
      transform: translateX(-2px) !important;
    }

    .loop-p6-mobile-benefit-card span {
      min-width: 0 !important;
      display: grid !important;
      gap: 2px !important;
    }

    .loop-p6-mobile-benefit-card strong {
      color: #073f37 !important;
      font-size: 11.3px !important;
      line-height: 1.08 !important;
      font-weight: 950 !important;
      letter-spacing: -0.022em !important;
      overflow-wrap: anywhere !important;
    }

    .loop-p6-mobile-benefit-card em {
      color: rgba(7, 63, 55, 0.65) !important;
      font-style: normal !important;
      font-size: 9.6px !important;
      line-height: 1.16 !important;
      font-weight: 650 !important;
      overflow-wrap: anywhere !important;
    }

    .loop-p6-hero + #loop-services-section,
    #loop-services-section {
      padding-top: 14px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 980px) {
    .loop-p6-hero-actions {
      align-items: stretch !important;
      flex-direction: column !important;
      gap: 12px !important;
    }

    .loop-p6-main-create {
      width: min(100%, 360px) !important;
    }

    .loop-p6-platform-block {
      width: 100% !important;
    }

    .loop-p6-mobile-benefit-stack {
      grid-template-columns: 1fr !important;
    }

    .loop-p6-mobile-benefit-card {
      min-height: 50px !important;
    }
  }
`;

const phaseHomeTypographyTrialCopy = `
  /* =========================================================
     LOOP HOME TYPOGRAPHY + TRIAL COPY POLISH
     Uses the same application font stack across the hero and founder card.
     App font stack: Inter, ui-sans-serif, system-ui, -apple-system,
     BlinkMacSystemFont, "Segoe UI", sans-serif.
     ========================================================= */

  .loop-p6-hero,
  .loop-p6-hero *,
  .loop-p6-benefit-card,
  .loop-p6-benefit-card *,
  .loop-p6-mobile-benefit-rail,
  .loop-p6-mobile-benefit-rail * {
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  }

  .loop-p6-title {
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
    max-width: 790px !important;
    letter-spacing: -0.082em !important;
    font-weight: 950 !important;
    text-wrap: balance !important;
  }

  .loop-p6-offer-line {
    max-width: 660px !important;
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
    font-weight: 760 !important;
    letter-spacing: -0.018em !important;
  }

  .loop-p6-offer-line strong {
    font-weight: 950 !important;
    color: #fff8ee !important;
    text-decoration-thickness: 2px !important;
    text-underline-offset: 3px !important;
  }

  .loop-p6-main-create {
    min-width: 292px !important;
    padding-left: 28px !important;
    padding-right: 28px !important;
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
    font-weight: 950 !important;
    letter-spacing: -0.018em !important;
  }

  .loop-p6-benefit-head-copy strong,
  .loop-p6-benefit-head strong {
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
    font-weight: 900 !important;
    letter-spacing: -0.072em !important;
    line-height: 0.88 !important;
  }

  .loop-p6-benefit-head-copy em,
  .loop-p6-benefit-head-copy em b,
  .loop-p6-benefit-copy strong,
  .loop-p6-benefit-copy em,
  .loop-p6-benefit-foot {
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  }

  .loop-p6-benefit-head-copy em b {
    font-weight: 950 !important;
    letter-spacing: -0.026em !important;
  }

  .loop-p6-benefit-copy strong {
    font-weight: 880 !important;
    letter-spacing: -0.028em !important;
  }

  .loop-p6-benefit-copy em {
    font-weight: 620 !important;
    letter-spacing: -0.01em !important;
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-title {
      max-width: 640px !important;
    }

    .loop-p6-offer-line {
      max-width: 640px !important;
    }

    .loop-p6-main-create {
      min-width: 260px !important;
      width: auto !important;
      max-width: 380px !important;
      font-size: 13.6px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-title {
      letter-spacing: -0.07em !important;
    }

    .loop-p6-offer-line {
      font-weight: 760 !important;
    }

    .loop-p6-main-create {
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
      font-size: 13.6px !important;
    }
  }
`;

const phaseHomeCopyCtaStoreAssetsPolish = `
  /* =========================================================
     LOOP HOME — COPY, CTA ARROW + STORE ASSET POLISH
     Keeps the hero premium/clean while using imported SVG assets
     for iPhone and Android/Google Play-style marks.
     ========================================================= */

  .loop-p6-title {
    max-width: 840px !important;
    font-size: clamp(50px, 4.55vw, 72px) !important;
    line-height: 0.94 !important;
    letter-spacing: -0.072em !important;
    text-wrap: balance !important;
  }

  .loop-p6-offer-line {
    max-width: 560px !important;
    margin-top: 18px !important;
    font-size: clamp(14.5px, 1vw, 16px) !important;
    line-height: 1.46 !important;
    font-weight: 760 !important;
  }

  .loop-p6-main-create {
    min-width: 286px !important;
    min-height: 54px !important;
    padding: 0 18px 0 28px !important;
    gap: 14px !important;
  }

  .loop-p6-cta-arrow-premium {
    width: 34px !important;
    height: 34px !important;
    min-width: 34px !important;
    border-radius: 999px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    background:
      radial-gradient(circle at 30% 20%, rgba(255,255,255,0.34), transparent 36%),
      rgba(255,255,255,0.14) !important;
    border: 1px solid rgba(255,255,255,0.23) !important;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.22) !important;
    transition: transform 160ms ease, background 160ms ease, border-color 160ms ease !important;
  }

  .loop-p6-cta-arrow-premium svg {
    width: 18px !important;
    height: 18px !important;
    stroke: #ffffff !important;
    stroke-width: 2.15 !important;
    stroke-linecap: round !important;
    stroke-linejoin: round !important;
    fill: none !important;
  }

  .loop-p6-main-create:hover .loop-p6-cta-arrow-premium {
    transform: translateX(2px) !important;
    background: rgba(255,255,255,0.19) !important;
    border-color: rgba(255,255,255,0.34) !important;
  }

  .loop-p6-store-btn {
    min-height: 42px !important;
    padding: 0 16px !important;
    gap: 9px !important;
    border: 1px solid rgba(255,255,255,0.72) !important;
    background: rgba(255,255,255,0.16) !important;
    backdrop-filter: blur(10px) !important;
    -webkit-backdrop-filter: blur(10px) !important;
  }

  .loop-p6-store-btn span {
    font-weight: 900 !important;
    letter-spacing: -0.018em !important;
  }

  .loop-p6-platform-img {
    width: 18px !important;
    height: 18px !important;
    object-fit: contain !important;
    display: block !important;
    filter: none !important;
  }

  .loop-p6-platform-img-google-play {
    width: 19px !important;
    height: 19px !important;
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-title {
      max-width: 700px !important;
      font-size: clamp(44px, 4.55vw, 64px) !important;
      line-height: 0.95 !important;
    }

    .loop-p6-offer-line {
      max-width: 520px !important;
    }

    .loop-p6-main-create {
      min-width: 272px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-title {
      max-width: 100% !important;
      font-size: clamp(36px, 9.2vw, 48px) !important;
      line-height: 0.96 !important;
      letter-spacing: -0.066em !important;
    }

    .loop-p6-offer-line {
      max-width: 100% !important;
      margin-top: 14px !important;
      font-size: 14.5px !important;
      line-height: 1.45 !important;
    }

    .loop-p6-main-create {
      width: 100% !important;
      min-width: 0 !important;
      padding-left: 20px !important;
      padding-right: 12px !important;
      justify-content: space-between !important;
    }

    .loop-p6-cta-arrow-premium {
      width: 32px !important;
      height: 32px !important;
      min-width: 32px !important;
    }

    .loop-p6-store-row-left {
      width: 100% !important;
    }

    .loop-p6-store-btn {
      flex: 1 1 0 !important;
      justify-content: center !important;
    }
  }
`;

const phaseHomeRealStoreBadgesPng = `
  /* =========================================================
     LOOP HOME — REAL STORE BADGES PNG
     Uses the uploaded high-quality App Store / Google Play badge images
     instead of rebuilt icon pills.
     ========================================================= */

  .loop-p6-store-row-left {
    margin-top: 9px !important;
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
    flex-wrap: wrap !important;
  }

  .loop-p6-store-btn,
  .loop-p6-store-row-left .loop-p6-store-btn {
    width: auto !important;
    height: auto !important;
    min-width: 0 !important;
    min-height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    border: 0 !important;
    outline: none !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
    overflow: visible !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    appearance: none !important;
    -webkit-appearance: none !important;
    transition: transform 160ms ease, filter 160ms ease !important;
  }

  .loop-p6-store-btn:hover {
    transform: translateY(-1px) !important;
    filter: brightness(1.04) saturate(1.02) !important;
  }

  .loop-p6-store-btn:active {
    transform: scale(0.985) !important;
  }
  .loop-p6-store-btn:focus,
  .loop-p6-store-btn:focus-visible,
  .loop-p6-store-row-left .loop-p6-store-btn:focus,
  .loop-p6-store-row-left .loop-p6-store-btn:focus-visible {
    outline: none !important;
    border: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .loop-p6-store-btn span,
  .loop-p6-store-btn .loop-p6-platform-img,
  .loop-p6-store-btn .loop-p6-platform-img-apple,
  .loop-p6-store-btn .loop-p6-platform-img-google-play {
    display: none !important;
  }

  .loop-p6-store-badge-img {
    display: block !important;
    width: auto !important;
    height: 42px !important;
    max-width: 182px !important;
    object-fit: contain !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
    filter: drop-shadow(0 8px 18px rgba(0,0,0,0.16)) !important;
    user-select: none !important;
    -webkit-user-drag: none !important;
  }

  @media (min-width: 900px) and (max-height: 820px) {
    .loop-p6-store-badge-img {
      height: 38px !important;
      max-width: 166px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-store-row-left {
      width: 100% !important;
      gap: 10px !important;
      justify-content: flex-start !important;
    }

    .loop-p6-store-btn {
      flex: 0 0 auto !important;
    }

    .loop-p6-store-badge-img {
      height: 40px !important;
      max-width: 172px !important;
    }
  }

  @media (max-width: 420px) {
    .loop-p6-store-row-left {
      gap: 8px !important;
    }

    .loop-p6-store-badge-img {
      height: 37px !important;
      max-width: 158px !important;
    }
  }
`;

const phaseHomeEditorialHeadlineFinal = `
  /* =========================================================
     LOOP HOME — EDITORIAL HEADLINE FINAL
     Goal:
     - Two-line maximum desktop headline
     - Less "promo giant", more premium/editorial
     - Keep the approved copy and current store badges
     ========================================================= */

  .loop-p6-title {
    max-width: 980px !important;
    font-size: clamp(52px, 4.35vw, 74px) !important;
    line-height: 0.94 !important;
    letter-spacing: -0.074em !important;
    font-weight: 950 !important;
    text-wrap: balance !important;
  }

  .loop-p6-title br {
    display: block !important;
  }

  .loop-p6-offer-line {
    max-width: 520px !important;
    margin-top: 18px !important;
    font-size: clamp(14.5px, 0.96vw, 16px) !important;
    line-height: 1.46 !important;
    font-weight: 760 !important;
    letter-spacing: -0.018em !important;
  }

  @media (min-width: 1181px) {
    .loop-p6-title {
      max-width: 1030px !important;
      font-size: clamp(56px, 4.45vw, 78px) !important;
      line-height: 0.94 !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-title {
      max-width: 760px !important;
      font-size: clamp(46px, 4.25vw, 62px) !important;
      line-height: 0.96 !important;
      letter-spacing: -0.068em !important;
    }

    .loop-p6-offer-line {
      max-width: 500px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-title {
      max-width: 100% !important;
      font-size: clamp(36px, 9.4vw, 50px) !important;
      line-height: 0.98 !important;
      letter-spacing: -0.062em !important;
    }

    .loop-p6-offer-line {
      max-width: 100% !important;
      margin-top: 14px !important;
      font-size: 14.5px !important;
      line-height: 1.45 !important;
    }
  }
`;

const phaseHomeFounderCardTotalAccessFinal = `
  /* =========================================================
     LOOP HOME — FOUNDER CARD TOTAL ACCESS FINAL
     Turns the right card into a cleaner premium "Total acceso"
     founder card with six compact benefit bubbles.
     ========================================================= */

  .loop-p6-benefit-card {
    width: min(100%, 530px) !important;
    padding: 30px 32px 26px !important;
    border-radius: 38px !important;
    background:
      radial-gradient(circle at 0% 0%, rgba(255,255,255,0.95), transparent 34%),
      linear-gradient(180deg, rgba(255, 250, 241, 0.965) 0%, rgba(255, 246, 233, 0.935) 100%) !important;
    border: 1px solid rgba(249, 215, 174, 0.74) !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.88),
      0 28px 64px rgba(9, 18, 17, 0.17) !important;
    overflow: hidden !important;
  }

  .loop-p6-benefit-card::before {
    inset: 5px !important;
    border-radius: 33px !important;
    border: 1px solid rgba(255,255,255,0.78) !important;
    background:
      radial-gradient(circle at 10% 8%, rgba(0, 137, 127, 0.075), transparent 20%),
      transparent !important;
    opacity: 1 !important;
    pointer-events: none !important;
  }

  .loop-p6-benefit-head {
    position: relative !important;
    z-index: 1 !important;
    display: flex !important;
    align-items: flex-start !important;
    gap: 16px !important;
    padding: 0 0 20px !important;
    margin: 0 !important;
    border-bottom: 0 !important;
  }

  .loop-p6-benefit-mark {
    width: 48px !important;
    height: 48px !important;
    min-width: 48px !important;
    margin-top: 4px !important;
    border-radius: 17px !important;
    background:
      radial-gradient(circle at 30% 22%, rgba(255,255,255,0.34), transparent 38%),
      linear-gradient(135deg, #00675f 0%, #00897f 100%) !important;
    box-shadow:
      0 14px 28px rgba(0, 103, 95, 0.18),
      inset 0 1px 0 rgba(255,255,255,0.24) !important;
  }

  .loop-p6-founder-sparkle-img {
    width: 29px !important;
    height: 29px !important;
    object-fit: contain !important;
  }

  .loop-p6-benefit-head-copy {
    min-width: 0 !important;
    display: grid !important;
    gap: 8px !important;
    padding-top: 0 !important;
  }

  .loop-p6-benefit-head-copy strong,
  .loop-p6-benefit-head strong {
    display: grid !important;
    gap: 0 !important;
    margin: 0 !important;
    color: #073f37 !important;
    font-size: clamp(42px, 3.05vw, 56px) !important;
    line-height: 0.84 !important;
    letter-spacing: -0.078em !important;
    font-weight: 950 !important;
  }

  .loop-p6-benefit-head-copy em {
    display: block !important;
    max-width: 310px !important;
    margin: 0 !important;
    color: rgba(7, 63, 55, 0.76) !important;
    font-size: 14px !important;
    line-height: 1.28 !important;
    letter-spacing: -0.012em !important;
    font-style: normal !important;
    font-weight: 640 !important;
  }

  .loop-p6-benefit-head-copy em b {
    display: block !important;
    margin-bottom: 2px !important;
    color: #073f37 !important;
    font-size: 16px !important;
    line-height: 1.1 !important;
    font-weight: 950 !important;
    letter-spacing: -0.026em !important;
  }

  .loop-p6-benefits-list {
    position: relative !important;
    z-index: 1 !important;
    margin-top: 0 !important;
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 10px !important;
  }

  .loop-p6-benefit-row,
  .loop-p6-benefit-row-whatsapp {
    min-height: 82px !important;
    display: grid !important;
    grid-template-columns: 34px minmax(0, 1fr) !important;
    align-items: center !important;
    gap: 10px !important;
    padding: 13px 13px !important;
    border-radius: 19px !important;
    border: 1px solid rgba(232, 191, 140, 0.58) !important;
    background:
      linear-gradient(180deg, rgba(255,255,255,0.58) 0%, rgba(255,248,238,0.32) 100%) !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.74),
      0 10px 24px rgba(22, 34, 32, 0.045) !important;
    color: #123f39 !important;
    overflow: hidden !important;
    border-bottom: 1px solid rgba(232, 191, 140, 0.58) !important;
  }

  .loop-p6-benefit-row-whatsapp {
    background:
      radial-gradient(circle at 90% 20%, rgba(0, 137, 127, 0.13), transparent 34%),
      linear-gradient(180deg, rgba(231, 244, 235, 0.82) 0%, rgba(240, 248, 238, 0.66) 100%) !important;
    border-color: rgba(0, 137, 127, 0.18) !important;
  }

  .loop-p6-benefit-icon,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon {
    width: 34px !important;
    height: 34px !important;
    min-width: 34px !important;
    border-radius: 13px !important;
    display: grid !important;
    place-items: center !important;
    background: rgba(0, 103, 95, 0.085) !important;
    color: #00675f !important;
    box-shadow: none !important;
  }

  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon {
    background: #ffffff !important;
    border-radius: 999px !important;
  }

  .loop-p6-feature-img,
  .loop-p6-benefit-row-whatsapp .loop-p6-feature-img {
    width: 22px !important;
    height: 22px !important;
    object-fit: contain !important;
  }

  .loop-p6-benefit-copy {
    min-width: 0 !important;
    display: grid !important;
    gap: 4px !important;
  }

  .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong {
    color: #073f37 !important;
    font-size: 13.8px !important;
    line-height: 1.02 !important;
    letter-spacing: -0.035em !important;
    font-weight: 930 !important;
    overflow-wrap: anywhere !important;
  }

  .loop-p6-benefit-copy em {
    color: rgba(7, 63, 55, 0.70) !important;
    font-size: 11.8px !important;
    line-height: 1.18 !important;
    letter-spacing: -0.008em !important;
    font-style: normal !important;
    font-weight: 620 !important;
    overflow-wrap: anywhere !important;
  }

  .loop-p6-benefit-foot {
    position: relative !important;
    z-index: 1 !important;
    margin-top: 16px !important;
    padding-top: 1px !important;
    justify-content: center !important;
    color: rgba(7, 63, 55, 0.70) !important;
    font-size: 12.3px !important;
    font-weight: 650 !important;
    gap: 7px !important;
  }

  .loop-p6-benefit-foot-icon,
  .loop-p6-shield-img {
    width: 15px !important;
    height: 15px !important;
  }

  @media (min-width: 1181px) and (max-height: 820px) {
    .loop-p6-benefit-card {
      width: min(100%, 500px) !important;
      padding: 25px 28px 22px !important;
      border-radius: 34px !important;
    }

    .loop-p6-benefit-head {
      padding-bottom: 16px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: clamp(39px, 2.8vw, 50px) !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp {
      min-height: 72px !important;
      padding: 11px !important;
      border-radius: 17px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-benefit-card {
      width: min(100%, 455px) !important;
      padding: 22px 23px 19px !important;
      border-radius: 30px !important;
    }

    .loop-p6-benefit-head {
      gap: 13px !important;
      padding-bottom: 14px !important;
    }

    .loop-p6-benefit-mark {
      width: 40px !important;
      height: 40px !important;
      min-width: 40px !important;
      border-radius: 15px !important;
    }

    .loop-p6-founder-sparkle-img {
      width: 25px !important;
      height: 25px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: clamp(32px, 3.2vw, 42px) !important;
      line-height: 0.86 !important;
      letter-spacing: -0.064em !important;
    }

    .loop-p6-benefit-head-copy em {
      max-width: 265px !important;
      font-size: 12.6px !important;
      line-height: 1.22 !important;
    }

    .loop-p6-benefit-head-copy em b {
      font-size: 14.6px !important;
    }

    .loop-p6-benefits-list {
      gap: 8px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp {
      min-height: 68px !important;
      grid-template-columns: 30px minmax(0, 1fr) !important;
      gap: 8px !important;
      padding: 10px !important;
      border-radius: 16px !important;
    }

    .loop-p6-benefit-icon,
    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon {
      width: 30px !important;
      height: 30px !important;
      min-width: 30px !important;
      border-radius: 12px !important;
    }

    .loop-p6-feature-img,
    .loop-p6-benefit-row-whatsapp .loop-p6-feature-img {
      width: 20px !important;
      height: 20px !important;
    }

    .loop-p6-benefit-copy strong,
    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong {
      font-size: 12.4px !important;
      line-height: 1.02 !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.6px !important;
      line-height: 1.14 !important;
    }

    .loop-p6-benefit-foot {
      margin-top: 12px !important;
      font-size: 11.5px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-benefits-list {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 8px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp {
      min-height: 64px !important;
      padding: 9px !important;
      border-radius: 15px !important;
    }
  }
`;

const phaseHomeFounderCardV2BalancedGrid = `
  /* =========================================================
     LOOP HOME — FOUNDER CARD V2 BALANCED GRID
     Fixes:
     - neutral top icon
     - "Total acceso" one line
     - removes Panamá line/footer
     - six neutral bubbles in 3 + 3 grid
     - restores more balanced icon sizing
     ========================================================= */

  .loop-p6-benefit-card {
    width: min(100%, 560px) !important;
    padding: 30px 32px 28px !important;
    border-radius: 38px !important;
    background:
      radial-gradient(circle at 8% 0%, rgba(255,255,255,0.96), transparent 32%),
      linear-gradient(180deg, rgba(255, 250, 241, 0.972) 0%, rgba(255, 246, 233, 0.94) 100%) !important;
    border: 1px solid rgba(249, 215, 174, 0.70) !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.88),
      0 28px 64px rgba(9, 18, 17, 0.16) !important;
  }

  .loop-p6-benefit-card::before {
    inset: 5px !important;
    border-radius: 33px !important;
    border: 1px solid rgba(255,255,255,0.76) !important;
    background: transparent !important;
    opacity: 1 !important;
    pointer-events: none !important;
  }

  .loop-p6-benefit-head {
    display: flex !important;
    align-items: center !important;
    gap: 14px !important;
    padding: 0 0 22px !important;
    margin: 0 !important;
    border-bottom: 0 !important;
  }

  .loop-p6-benefit-mark {
    width: 42px !important;
    height: 42px !important;
    min-width: 42px !important;
    margin-top: 0 !important;
    border-radius: 15px !important;
    background:
      linear-gradient(180deg, rgba(255,255,255,0.78) 0%, rgba(248,241,230,0.72) 100%) !important;
    border: 1px solid rgba(232, 191, 140, 0.48) !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.80),
      0 10px 22px rgba(22, 34, 32, 0.07) !important;
    display: grid !important;
    place-items: center !important;
    position: relative !important;
    overflow: hidden !important;
  }

  .loop-p6-founder-sparkle-img {
    display: none !important;
  }

  .loop-p6-benefit-mark::before {
    content: "✦" !important;
    display: grid !important;
    place-items: center !important;
    width: 24px !important;
    height: 24px !important;
    border-radius: 999px !important;
    color: #00675f !important;
    background: rgba(0, 103, 95, 0.075) !important;
    font-size: 15px !important;
    line-height: 1 !important;
    font-weight: 900 !important;
  }

  .loop-p6-benefit-head-copy {
    min-width: 0 !important;
    display: grid !important;
    gap: 7px !important;
    padding-top: 0 !important;
  }

  .loop-p6-benefit-head-copy strong,
  .loop-p6-benefit-head strong {
    display: block !important;
    white-space: nowrap !important;
    margin: 0 !important;
    color: #073f37 !important;
    font-size: clamp(38px, 2.8vw, 48px) !important;
    line-height: 0.94 !important;
    letter-spacing: -0.074em !important;
    font-weight: 950 !important;
  }

  .loop-p6-benefit-head-copy strong span {
    display: inline !important;
  }

  .loop-p6-benefit-head-copy em {
    display: block !important;
    max-width: none !important;
    margin: 0 !important;
    color: rgba(7, 63, 55, 0.78) !important;
    font-size: 14px !important;
    line-height: 1.18 !important;
    letter-spacing: -0.012em !important;
    font-style: normal !important;
    font-weight: 700 !important;
  }

  .loop-p6-benefit-head-copy em b {
    display: inline !important;
    margin: 0 !important;
    color: #073f37 !important;
    font-size: 15.4px !important;
    line-height: 1.1 !important;
    font-weight: 950 !important;
    letter-spacing: -0.026em !important;
  }

  .loop-p6-benefits-list {
    position: relative !important;
    z-index: 1 !important;
    margin-top: 0 !important;
    display: grid !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 10px !important;
  }

  .loop-p6-benefit-row,
  .loop-p6-benefit-row-whatsapp,
  .loop-p6-benefit-row-marca,
  .loop-p6-benefit-row:nth-child(3),
  .loop-p6-benefit-row:last-child {
    grid-column: auto !important;
    min-height: 104px !important;
    display: grid !important;
    grid-template-columns: 36px minmax(0, 1fr) !important;
    align-items: center !important;
    gap: 9px !important;
    padding: 13px 11px !important;
    border-radius: 20px !important;
    border: 1px solid rgba(232, 191, 140, 0.54) !important;
    background:
      linear-gradient(180deg, rgba(255,255,255,0.58) 0%, rgba(255,248,238,0.32) 100%) !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.72),
      0 10px 24px rgba(22, 34, 32, 0.04) !important;
    color: #123f39 !important;
    overflow: hidden !important;
    position: relative !important;
    border-bottom: 1px solid rgba(232, 191, 140, 0.54) !important;
  }

  .loop-p6-benefit-row-whatsapp::after {
    display: none !important;
    content: none !important;
  }

  .loop-p6-benefit-icon,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
  .loop-p6-benefit-row-marca .loop-p6-benefit-icon {
    width: 36px !important;
    height: 36px !important;
    min-width: 36px !important;
    border-radius: 14px !important;
    display: grid !important;
    place-items: center !important;
    background: rgba(0, 103, 95, 0.07) !important;
    border: 1px solid rgba(0, 103, 95, 0.055) !important;
    color: #00675f !important;
    box-shadow: none !important;
  }

  .loop-p6-feature-img,
  .loop-p6-benefit-row-whatsapp .loop-p6-feature-img,
  .loop-p6-benefit-row-marca .loop-p6-feature-img {
    width: 24px !important;
    height: 24px !important;
    object-fit: contain !important;
    display: block !important;
  }

  .loop-p6-benefit-copy {
    min-width: 0 !important;
    display: grid !important;
    gap: 5px !important;
  }

  .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-marca .loop-p6-benefit-copy strong {
    color: #073f37 !important;
    font-size: 13.1px !important;
    line-height: 1.02 !important;
    letter-spacing: -0.034em !important;
    font-weight: 930 !important;
    overflow-wrap: normal !important;
    word-break: normal !important;
  }

  .loop-p6-benefit-copy em {
    color: rgba(7, 63, 55, 0.70) !important;
    font-size: 11.4px !important;
    line-height: 1.18 !important;
    letter-spacing: -0.008em !important;
    font-style: normal !important;
    font-weight: 620 !important;
  }

  .loop-p6-benefit-foot {
    display: none !important;
  }

  @media (min-width: 1181px) and (max-height: 820px) {
    .loop-p6-benefit-card {
      width: min(100%, 540px) !important;
      padding: 26px 28px 24px !important;
      border-radius: 34px !important;
    }

    .loop-p6-benefit-head {
      padding-bottom: 18px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: clamp(35px, 2.7vw, 44px) !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca {
      min-height: 92px !important;
      padding: 11px 10px !important;
      border-radius: 17px !important;
    }

    .loop-p6-benefit-copy strong,
    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong,
    .loop-p6-benefit-row-marca .loop-p6-benefit-copy strong {
      font-size: 12.1px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.6px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-benefit-card {
      width: min(100%, 470px) !important;
      padding: 22px 23px 20px !important;
      border-radius: 30px !important;
    }

    .loop-p6-benefit-head {
      gap: 12px !important;
      padding-bottom: 14px !important;
    }

    .loop-p6-benefit-mark {
      width: 36px !important;
      height: 36px !important;
      min-width: 36px !important;
      border-radius: 13px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: clamp(30px, 3vw, 38px) !important;
      line-height: 0.94 !important;
      letter-spacing: -0.064em !important;
    }

    .loop-p6-benefit-head-copy em b {
      font-size: 13.8px !important;
    }

    .loop-p6-benefits-list {
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
      gap: 8px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca {
      min-height: 84px !important;
      grid-template-columns: 30px minmax(0, 1fr) !important;
      gap: 7px !important;
      padding: 9px !important;
      border-radius: 15px !important;
    }

    .loop-p6-benefit-icon,
    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
    .loop-p6-benefit-row-marca .loop-p6-benefit-icon {
      width: 30px !important;
      height: 30px !important;
      min-width: 30px !important;
      border-radius: 12px !important;
    }

    .loop-p6-feature-img,
    .loop-p6-benefit-row-whatsapp .loop-p6-feature-img,
    .loop-p6-benefit-row-marca .loop-p6-feature-img {
      width: 20px !important;
      height: 20px !important;
    }

    .loop-p6-benefit-copy strong,
    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong,
    .loop-p6-benefit-row-marca .loop-p6-benefit-copy strong {
      font-size: 10.9px !important;
      line-height: 1.03 !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 9.6px !important;
      line-height: 1.13 !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      white-space: normal !important;
    }

    .loop-p6-benefits-list {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 8px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca {
      min-height: 64px !important;
      padding: 9px !important;
      border-radius: 15px !important;
    }
  }
`;

const phaseHomeFounderCardV3SimplifiedBubbles = `
  /* =========================================================
     LOOP HOME — FOUNDER CARD V3 SIMPLIFIED BUBBLES
     Fixes:
     - icons no longer sit inside visible bubbles
     - benefit copy is shorter
     - six cards stay 3 + 3 without text overflow
     - offer text updated
     ========================================================= */

  .loop-p6-benefit-card {
    width: min(100%, 560px) !important;
    padding: 30px 32px 28px !important;
  }

  .loop-p6-benefit-head {
    padding-bottom: 22px !important;
  }

  .loop-p6-benefit-head-copy em {
    max-width: 420px !important;
  }

  .loop-p6-benefit-head-copy em b {
    display: inline !important;
    font-size: 15.2px !important;
    line-height: 1.12 !important;
    letter-spacing: -0.024em !important;
  }

  .loop-p6-benefits-list {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 11px !important;
  }

  .loop-p6-benefit-row,
  .loop-p6-benefit-row-whatsapp,
  .loop-p6-benefit-row-marca {
    grid-column: auto !important;
    min-height: 104px !important;
    display: grid !important;
    grid-template-columns: 1fr !important;
    align-content: center !important;
    justify-items: start !important;
    gap: 9px !important;
    padding: 15px 14px !important;
    border-radius: 20px !important;
    background:
      linear-gradient(180deg, rgba(255,255,255,0.62) 0%, rgba(255,248,238,0.34) 100%) !important;
    border: 1px solid rgba(232, 191, 140, 0.52) !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.72),
      0 10px 24px rgba(22, 34, 32, 0.035) !important;
    overflow: hidden !important;
  }

  .loop-p6-benefit-icon,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
  .loop-p6-benefit-row-marca .loop-p6-benefit-icon {
    width: 27px !important;
    height: 27px !important;
    min-width: 27px !important;
    border-radius: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: flex-start !important;
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    color: #00675f !important;
    padding: 0 !important;
    margin: 0 !important;
    opacity: 0.92 !important;
  }

  .loop-p6-feature-img,
  .loop-p6-benefit-row-whatsapp .loop-p6-feature-img,
  .loop-p6-benefit-row-marca .loop-p6-feature-img {
    width: 25px !important;
    height: 25px !important;
    object-fit: contain !important;
    display: block !important;
    filter: none !important;
  }

  .loop-p6-benefit-copy {
    min-width: 0 !important;
    width: 100% !important;
    display: grid !important;
    gap: 4px !important;
  }

  .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-marca .loop-p6-benefit-copy strong {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    color: #073f37 !important;
    font-size: 14.2px !important;
    line-height: 1.02 !important;
    letter-spacing: -0.032em !important;
    font-weight: 930 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    overflow-wrap: normal !important;
    word-break: normal !important;
  }

  .loop-p6-benefit-copy em {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    color: rgba(7, 63, 55, 0.68) !important;
    font-size: 11.8px !important;
    line-height: 1.15 !important;
    letter-spacing: -0.006em !important;
    font-style: normal !important;
    font-weight: 620 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .loop-p6-benefit-foot {
    display: none !important;
  }

  @media (min-width: 1181px) and (max-height: 820px) {
    .loop-p6-benefit-card {
      width: min(100%, 540px) !important;
      padding: 26px 28px 24px !important;
    }

    .loop-p6-benefits-list {
      gap: 10px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca {
      min-height: 94px !important;
      padding: 13px 12px !important;
      border-radius: 18px !important;
    }

    .loop-p6-feature-img,
    .loop-p6-benefit-row-whatsapp .loop-p6-feature-img,
    .loop-p6-benefit-row-marca .loop-p6-feature-img {
      width: 23px !important;
      height: 23px !important;
    }

    .loop-p6-benefit-copy strong,
    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong,
    .loop-p6-benefit-row-marca .loop-p6-benefit-copy strong {
      font-size: 13.2px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 11px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-benefit-card {
      width: min(100%, 470px) !important;
      padding: 22px 23px 20px !important;
    }

    .loop-p6-benefits-list {
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
      gap: 8px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca {
      min-height: 86px !important;
      padding: 11px 10px !important;
      border-radius: 16px !important;
    }

    .loop-p6-feature-img,
    .loop-p6-benefit-row-whatsapp .loop-p6-feature-img,
    .loop-p6-benefit-row-marca .loop-p6-feature-img {
      width: 21px !important;
      height: 21px !important;
    }

    .loop-p6-benefit-copy strong,
    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong,
    .loop-p6-benefit-row-marca .loop-p6-benefit-copy strong {
      font-size: 11.8px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.2px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-benefits-list {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca {
      min-height: 82px !important;
      padding: 12px !important;
    }

    .loop-p6-benefit-copy strong,
    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong,
    .loop-p6-benefit-row-marca .loop-p6-benefit-copy strong {
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
    }

    .loop-p6-benefit-copy em {
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
    }
  }
`;











const phaseHomeFounderCardV4IconTitlePremium = `
  /* =========================================================
     LOOP HOME — FOUNDER CARD V4 ICON + TITLE PREMIUM
     Requested:
     - icon to the left, title to the right on all six cards
     - cleaner premium icon sizing
     - shorter / clearer content
     - finance and loyalty as bold-only cards
     ========================================================= */

  .loop-p6-benefit-card {
    width: min(100%, 590px) !important;
    padding: 30px 32px 30px !important;
  }

  .loop-p6-benefit-head {
    gap: 14px !important;
    align-items: center !important;
    padding-bottom: 22px !important;
  }

  .loop-p6-benefit-mark {
    width: 38px !important;
    height: 38px !important;
    min-width: 38px !important;
    border-radius: 14px !important;
  }

  .loop-p6-founder-sparkle-img {
    width: 22px !important;
    height: 22px !important;
    object-fit: contain !important;
    display: block !important;
  }

  .loop-p6-benefit-head-copy strong,
  .loop-p6-benefit-head strong {
    font-size: clamp(33px, 3vw, 40px) !important;
    line-height: 0.94 !important;
    letter-spacing: -0.065em !important;
    white-space: nowrap !important;
  }

  .loop-p6-benefit-head-copy em,
  .loop-p6-benefit-head-copy em b {
    font-size: 14.8px !important;
    line-height: 1.12 !important;
    letter-spacing: -0.018em !important;
  }

  .loop-p6-benefits-list {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 11px !important;
  }

  .loop-p6-benefit-row,
  .loop-p6-benefit-row-whatsapp,
  .loop-p6-benefit-row-marca {
    display: grid !important;
    grid-template-columns: 30px minmax(0, 1fr) !important;
    grid-template-areas:
      "icon title"
      "icon meta" !important;
    column-gap: 11px !important;
    row-gap: 4px !important;
    align-items: center !important;
    align-content: center !important;
    justify-items: start !important;
    min-height: 96px !important;
    padding: 14px 14px !important;
    border-radius: 20px !important;
    background:
      linear-gradient(180deg, rgba(255,255,255,0.64) 0%, rgba(255,248,238,0.34) 100%) !important;
    border: 1px solid rgba(232, 191, 140, 0.52) !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.72),
      0 10px 24px rgba(22, 34, 32, 0.035) !important;
    overflow: hidden !important;
  }

  .loop-p6-benefit-icon,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
  .loop-p6-benefit-row-marca .loop-p6-benefit-icon {
    grid-area: icon !important;
    width: 30px !important;
    height: 30px !important;
    min-width: 30px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    color: #00675f !important;
    opacity: 0.94 !important;
  }

  .loop-p6-feature-img,
  .loop-p6-benefit-row-whatsapp .loop-p6-feature-img,
  .loop-p6-benefit-row-marca .loop-p6-feature-img {
    width: 22px !important;
    height: 22px !important;
    object-fit: contain !important;
    display: block !important;
    filter: none !important;
  }

  .loop-p6-benefit-copy {
    min-width: 0 !important;
    width: 100% !important;
    display: contents !important;
  }

  .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-marca .loop-p6-benefit-copy strong {
    grid-area: title !important;
    display: block !important;
    width: 100% !important;
    align-self: end !important;
    color: #073f37 !important;
    font-size: 15px !important;
    line-height: 1.02 !important;
    letter-spacing: -0.032em !important;
    font-weight: 930 !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    overflow-wrap: anywhere !important;
    word-break: break-word !important;
  }

  .loop-p6-benefit-copy em {
    grid-area: meta !important;
    display: block !important;
    width: 100% !important;
    align-self: start !important;
    color: rgba(7, 63, 55, 0.72) !important;
    font-size: 11.6px !important;
    line-height: 1.15 !important;
    letter-spacing: -0.006em !important;
    font-style: normal !important;
    font-weight: 650 !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    overflow-wrap: anywhere !important;
    word-break: break-word !important;
  }

  .loop-p6-benefit-row-operacion,
  .loop-p6-benefit-row-loyalty {
    min-height: 88px !important;
  }

  .loop-p6-benefit-row-operacion .loop-p6-benefit-copy,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-copy {
    display: contents !important;
  }

  .loop-p6-benefit-row-operacion .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-copy strong {
    align-self: center !important;
  }

  .loop-p6-benefit-row-operacion .loop-p6-benefit-copy em,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-copy em {
    display: none !important;
  }

  .loop-p6-benefit-foot {
    display: none !important;
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-benefit-card {
      width: min(100%, 500px) !important;
      padding: 24px 24px 22px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: clamp(28px, 3.1vw, 34px) !important;
    }

    .loop-p6-benefits-list {
      gap: 9px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca {
      min-height: 92px !important;
      padding: 12px 12px !important;
      column-gap: 10px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 13px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.4px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-benefits-list {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 8px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca {
      min-height: 82px !important;
      padding: 11px !important;
      border-radius: 17px !important;
      grid-template-columns: 26px minmax(0, 1fr) !important;
      column-gap: 9px !important;
    }

    .loop-p6-benefit-icon,
    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
    .loop-p6-benefit-row-marca .loop-p6-benefit-icon {
      width: 26px !important;
      height: 26px !important;
      min-width: 26px !important;
    }

    .loop-p6-feature-img,
    .loop-p6-benefit-row-whatsapp .loop-p6-feature-img,
    .loop-p6-benefit-row-marca .loop-p6-feature-img {
      width: 19px !important;
      height: 19px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 12.2px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10px !important;
    }
  }
`;




const phaseHomeFounderCardV5FinalPremium = `
  /* =========================================================
     LOOP HOME — FOUNDER CARD V5 FINAL PREMIUM
     Final direction:
     - shorter copy
     - consistent inline icons
     - icon left + title right
     - 3 + 3 grid without broken words
     - premium neutral cards
     ========================================================= */

  .loop-p6-benefit-card {
    width: min(100%, 600px) !important;
    padding: 30px 34px 30px !important;
    border-radius: 38px !important;
  }

  .loop-p6-benefit-head {
    display: flex !important;
    align-items: center !important;
    gap: 14px !important;
    padding: 0 0 22px !important;
    margin: 0 !important;
  }

  .loop-p6-benefit-mark {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
    border-radius: 15px !important;
    background:
      linear-gradient(180deg, rgba(255,255,255,0.78), rgba(249,242,231,0.74)) !important;
    border: 1px solid rgba(232, 191, 140, 0.46) !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.82),
      0 10px 22px rgba(22, 34, 32, 0.06) !important;
    display: grid !important;
    place-items: center !important;
    overflow: hidden !important;
    margin: 0 !important;
  }

  .loop-p6-founder-sparkle-img {
    display: none !important;
  }

  .loop-p6-benefit-mark::before {
    content: "✦" !important;
    width: 22px !important;
    height: 22px !important;
    border-radius: 999px !important;
    display: grid !important;
    place-items: center !important;
    color: #00675f !important;
    background: rgba(0, 103, 95, 0.075) !important;
    font-size: 14px !important;
    line-height: 1 !important;
    font-weight: 900 !important;
  }

  .loop-p6-benefit-head-copy {
    display: grid !important;
    gap: 7px !important;
    min-width: 0 !important;
  }

  .loop-p6-benefit-head-copy strong,
  .loop-p6-benefit-head strong {
    display: block !important;
    margin: 0 !important;
    white-space: nowrap !important;
    color: #073f37 !important;
    font-size: clamp(35px, 2.9vw, 43px) !important;
    line-height: 0.94 !important;
    letter-spacing: -0.068em !important;
    font-weight: 950 !important;
  }

  .loop-p6-benefit-head-copy em,
  .loop-p6-benefit-head-copy em b {
    margin: 0 !important;
    color: #073f37 !important;
    font-size: 14.6px !important;
    line-height: 1.15 !important;
    letter-spacing: -0.018em !important;
    font-style: normal !important;
    font-weight: 900 !important;
  }

  .loop-p6-benefits-list {
    display: grid !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 12px !important;
    margin-top: 0 !important;
  }

  .loop-p6-benefit-row,
  .loop-p6-benefit-row-whatsapp,
  .loop-p6-benefit-row-marca,
  .loop-p6-benefit-row-operacion,
  .loop-p6-benefit-row-loyalty {
    grid-column: auto !important;
    min-height: 90px !important;
    display: grid !important;
    grid-template-columns: 24px minmax(0, 1fr) !important;
    grid-template-areas:
      "icon title"
      "icon meta" !important;
    column-gap: 11px !important;
    row-gap: 3px !important;
    align-items: center !important;
    align-content: center !important;
    justify-items: stretch !important;
    padding: 14px 14px !important;
    border-radius: 20px !important;
    border: 1px solid rgba(232, 191, 140, 0.52) !important;
    background:
      linear-gradient(180deg, rgba(255,255,255,0.66) 0%, rgba(255,248,238,0.32) 100%) !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.74),
      0 10px 24px rgba(22, 34, 32, 0.035) !important;
    overflow: hidden !important;
  }

  .loop-p6-benefit-icon,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
  .loop-p6-benefit-row-marca .loop-p6-benefit-icon {
    grid-area: icon !important;
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    align-self: center !important;
    background: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
    color: #00675f !important;
    opacity: 0.9 !important;
  }

  .loop-p6-benefit-icon svg,
  .loop-p6-benefit-icon img,
  .loop-p6-feature-img,
  .loop-p6-benefit-row-whatsapp .loop-p6-feature-img,
  .loop-p6-benefit-row-marca .loop-p6-feature-img {
    width: 18px !important;
    height: 18px !important;
    min-width: 18px !important;
    max-width: 18px !important;
    object-fit: contain !important;
    display: block !important;
    stroke: currentColor !important;
    color: #00675f !important;
    filter: none !important;
  }

  .loop-p6-benefit-copy {
    display: contents !important;
    min-width: 0 !important;
  }

  .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-marca .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-operacion .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-copy strong {
    grid-area: title !important;
    align-self: end !important;
    min-width: 0 !important;
    width: 100% !important;
    color: #073f37 !important;
    font-size: 15px !important;
    line-height: 1.03 !important;
    letter-spacing: -0.032em !important;
    font-weight: 930 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    word-break: normal !important;
    overflow-wrap: normal !important;
  }

  .loop-p6-benefit-copy em {
    grid-area: meta !important;
    align-self: start !important;
    min-width: 0 !important;
    width: 100% !important;
    color: rgba(7, 63, 55, 0.70) !important;
    font-size: 12px !important;
    line-height: 1.15 !important;
    letter-spacing: -0.006em !important;
    font-style: normal !important;
    font-weight: 650 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    word-break: normal !important;
    overflow-wrap: normal !important;
  }

  .loop-p6-benefit-foot {
    display: none !important;
  }

  @media (min-width: 1181px) and (max-height: 820px) {
    .loop-p6-benefit-card {
      width: min(100%, 580px) !important;
      padding: 26px 30px 26px !important;
    }

    .loop-p6-benefits-list {
      gap: 11px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca,
    .loop-p6-benefit-row-operacion,
    .loop-p6-benefit-row-loyalty {
      min-height: 82px !important;
      padding: 12px 13px !important;
      border-radius: 18px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 14.1px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 11.2px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-benefit-card {
      width: min(100%, 510px) !important;
      padding: 24px 24px 22px !important;
      border-radius: 32px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: clamp(30px, 3.1vw, 36px) !important;
    }

    .loop-p6-benefit-head-copy em,
    .loop-p6-benefit-head-copy em b {
      font-size: 13.4px !important;
    }

    .loop-p6-benefits-list {
      gap: 9px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca,
    .loop-p6-benefit-row-operacion,
    .loop-p6-benefit-row-loyalty {
      min-height: 78px !important;
      grid-template-columns: 20px minmax(0, 1fr) !important;
      column-gap: 8px !important;
      padding: 11px 10px !important;
      border-radius: 16px !important;
    }

    .loop-p6-benefit-icon,
    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
    .loop-p6-benefit-row-marca .loop-p6-benefit-icon {
      width: 20px !important;
      height: 20px !important;
      min-width: 20px !important;
    }

    .loop-p6-benefit-icon svg,
    .loop-p6-benefit-icon img,
    .loop-p6-feature-img {
      width: 16px !important;
      height: 16px !important;
      min-width: 16px !important;
      max-width: 16px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 12.2px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.2px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-benefits-list {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 8px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca,
    .loop-p6-benefit-row-operacion,
    .loop-p6-benefit-row-loyalty {
      min-height: 76px !important;
      grid-template-columns: 22px minmax(0, 1fr) !important;
      column-gap: 9px !important;
      padding: 11px !important;
      border-radius: 17px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 12.3px !important;
      white-space: nowrap !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.4px !important;
      white-space: nowrap !important;
    }
  }
`;




const phaseHomeFounderCardV7TwoColumns = `
  /* =========================================================
     LOOP HOME — FOUNDER CARD V7 TWO COLUMNS
     Direction:
     - 2 columns x 3 rows
     - wider / more horizontal bubbles
     - no chopped words
     - no ellipsis
     - top icon removed
     ========================================================= */

  .loop-p6-benefit-card {
    width: min(100%, 610px) !important;
    padding: 30px 34px 30px !important;
    border-radius: 38px !important;
  }

  .loop-p6-benefit-head {
    display: block !important;
    padding: 0 0 22px !important;
    margin: 0 !important;
  }

  .loop-p6-benefit-mark,
  .loop-p6-founder-sparkle-img,
  .loop-p6-benefit-mark::before {
    display: none !important;
    content: none !important;
  }

  .loop-p6-benefit-head-copy {
    display: grid !important;
    gap: 8px !important;
    min-width: 0 !important;
  }

  .loop-p6-benefit-head-copy strong,
  .loop-p6-benefit-head strong {
    display: block !important;
    margin: 0 !important;
    color: #073f37 !important;
    font-size: clamp(36px, 2.95vw, 44px) !important;
    line-height: 0.94 !important;
    letter-spacing: -0.068em !important;
    font-weight: 950 !important;
    white-space: nowrap !important;
  }

  .loop-p6-benefit-head-copy em,
  .loop-p6-benefit-head-copy em b {
    display: block !important;
    margin: 0 !important;
    color: #073f37 !important;
    font-size: 14.7px !important;
    line-height: 1.18 !important;
    letter-spacing: -0.016em !important;
    font-style: normal !important;
    font-weight: 900 !important;
  }

  .loop-p6-benefits-list {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 12px !important;
    margin-top: 0 !important;
  }

  .loop-p6-benefit-row,
  .loop-p6-benefit-row-whatsapp,
  .loop-p6-benefit-row-marca,
  .loop-p6-benefit-row-operacion,
  .loop-p6-benefit-row-loyalty {
    grid-column: auto !important;
    min-height: 76px !important;
    display: grid !important;
    grid-template-columns: 24px minmax(0, 1fr) !important;
    grid-template-areas:
      "icon title"
      "icon meta" !important;
    column-gap: 12px !important;
    row-gap: 3px !important;
    align-items: center !important;
    align-content: center !important;
    justify-items: stretch !important;
    padding: 13px 16px !important;
    border-radius: 19px !important;
    border: 1px solid rgba(232, 191, 140, 0.52) !important;
    background:
      linear-gradient(180deg, rgba(255,255,255,0.68) 0%, rgba(255,248,238,0.34) 100%) !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.74),
      0 10px 24px rgba(22, 34, 32, 0.032) !important;
    overflow: hidden !important;
  }

  .loop-p6-benefit-icon,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
  .loop-p6-benefit-row-marca .loop-p6-benefit-icon,
  .loop-p6-benefit-row-operacion .loop-p6-benefit-icon,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-icon {
    grid-area: icon !important;
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    align-self: center !important;
    background: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
    color: rgba(0, 103, 95, 0.88) !important;
    opacity: 1 !important;
  }

  .loop-p6-benefit-icon svg,
  .loop-p6-feature-img,
  .loop-p6-benefit-icon img,
  .loop-p6-benefit-row-whatsapp .loop-p6-feature-img,
  .loop-p6-benefit-row-marca .loop-p6-feature-img {
    width: 18px !important;
    height: 18px !important;
    min-width: 18px !important;
    max-width: 18px !important;
    object-fit: contain !important;
    display: block !important;
    stroke: currentColor !important;
    color: rgba(0, 103, 95, 0.88) !important;
    filter: none !important;
  }

  .loop-p6-benefit-copy {
    display: contents !important;
    min-width: 0 !important;
  }

  .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-marca .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-operacion .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-copy strong {
    grid-area: title !important;
    align-self: end !important;
    min-width: 0 !important;
    width: 100% !important;
    color: #073f37 !important;
    font-size: 15px !important;
    line-height: 1.08 !important;
    letter-spacing: -0.03em !important;
    font-weight: 930 !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    word-break: normal !important;
    overflow-wrap: normal !important;
    hyphens: none !important;
  }

  .loop-p6-benefit-copy em {
    grid-area: meta !important;
    align-self: start !important;
    min-width: 0 !important;
    width: 100% !important;
    color: rgba(7, 63, 55, 0.70) !important;
    font-size: 12px !important;
    line-height: 1.18 !important;
    letter-spacing: -0.006em !important;
    font-style: normal !important;
    font-weight: 650 !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    word-break: normal !important;
    overflow-wrap: normal !important;
    hyphens: none !important;
  }

  .loop-p6-benefit-row-operacion,
  .loop-p6-benefit-row-loyalty {
    grid-template-areas: "icon title" !important;
  }

  .loop-p6-benefit-row-operacion .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-copy strong {
    align-self: center !important;
  }

  .loop-p6-benefit-row-operacion .loop-p6-benefit-copy em,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-copy em {
    display: none !important;
  }

  .loop-p6-benefit-foot {
    display: none !important;
  }

  @media (min-width: 1181px) and (max-height: 820px) {
    .loop-p6-benefit-card {
      width: min(100%, 590px) !important;
      padding: 26px 30px 26px !important;
    }

    .loop-p6-benefit-head {
      padding-bottom: 18px !important;
    }

    .loop-p6-benefits-list {
      gap: 11px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca,
    .loop-p6-benefit-row-operacion,
    .loop-p6-benefit-row-loyalty {
      min-height: 72px !important;
      padding: 12px 15px !important;
      border-radius: 18px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 14.2px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 11.2px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-benefit-card {
      width: min(100%, 520px) !important;
      padding: 24px 24px 22px !important;
      border-radius: 32px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: clamp(30px, 3.1vw, 36px) !important;
    }

    .loop-p6-benefit-head-copy em,
    .loop-p6-benefit-head-copy em b {
      font-size: 13.2px !important;
    }

    .loop-p6-benefits-list {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 9px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca,
    .loop-p6-benefit-row-operacion,
    .loop-p6-benefit-row-loyalty {
      min-height: 72px !important;
      grid-template-columns: 20px minmax(0, 1fr) !important;
      column-gap: 9px !important;
      padding: 11px 12px !important;
      border-radius: 16px !important;
    }

    .loop-p6-benefit-icon,
    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
    .loop-p6-benefit-row-marca .loop-p6-benefit-icon {
      width: 20px !important;
      height: 20px !important;
      min-width: 20px !important;
    }

    .loop-p6-benefit-icon svg,
    .loop-p6-benefit-icon img,
    .loop-p6-feature-img {
      width: 15.5px !important;
      height: 15.5px !important;
      min-width: 15.5px !important;
      max-width: 15.5px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 12.5px !important;
      line-height: 1.08 !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.2px !important;
      line-height: 1.14 !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      white-space: normal !important;
    }

    .loop-p6-benefits-list {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 8px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca,
    .loop-p6-benefit-row-operacion,
    .loop-p6-benefit-row-loyalty {
      min-height: 74px !important;
      grid-template-columns: 20px minmax(0, 1fr) !important;
      column-gap: 8px !important;
      padding: 11px !important;
      border-radius: 17px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 12.2px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.4px !important;
    }
  }
`;




const phaseHomeFounderCardV8AssetsEqualCards = `
  /* =========================================================
     LOOP HOME — FOUNDER CARD V8 ASSETS + EQUAL CARDS
     Final polish:
     - uses the original founder asset icons again
     - equal-size 2 x 3 cards
     - stronger / cleaner title
     - centered premium header without top icon
     - no ellipsis, no chopped words
     ========================================================= */

  .loop-p6-benefit-card {
    width: min(100%, 612px) !important;
    padding: 31px 36px 32px !important;
    border-radius: 38px !important;
  }

  .loop-p6-benefit-head {
    display: block !important;
    padding: 0 0 24px !important;
    margin: 0 !important;
    text-align: center !important;
  }

  .loop-p6-benefit-mark,
  .loop-p6-founder-sparkle-img,
  .loop-p6-benefit-mark::before {
    display: none !important;
    content: none !important;
  }

  .loop-p6-benefit-head-copy {
    display: grid !important;
    justify-items: center !important;
    gap: 8px !important;
    min-width: 0 !important;
  }

  .loop-p6-benefit-head-copy strong,
  .loop-p6-benefit-head strong {
    display: block !important;
    margin: 0 !important;
    color: #073f37 !important;
    font-size: clamp(36px, 2.95vw, 44px) !important;
    line-height: 0.94 !important;
    letter-spacing: -0.068em !important;
    font-weight: 950 !important;
    white-space: nowrap !important;
    text-align: center !important;
  }

  .loop-p6-benefit-head-copy strong::after,
  .loop-p6-benefit-head strong::after {
    content: "" !important;
    display: block !important;
    width: 32px !important;
    height: 2px !important;
    margin: 9px auto 0 !important;
    border-radius: 999px !important;
    background: rgba(199, 141, 76, 0.62) !important;
  }

  .loop-p6-benefit-head-copy em,
  .loop-p6-benefit-head-copy em b {
    display: block !important;
    margin: 0 !important;
    color: #073f37 !important;
    font-size: 14.5px !important;
    line-height: 1.18 !important;
    letter-spacing: -0.016em !important;
    font-style: normal !important;
    font-weight: 900 !important;
    text-align: center !important;
  }

  .loop-p6-benefits-list {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    grid-auto-rows: 78px !important;
    gap: 12px !important;
    margin-top: 0 !important;
  }

  .loop-p6-benefit-row,
  .loop-p6-benefit-row-whatsapp,
  .loop-p6-benefit-row-marca,
  .loop-p6-benefit-row-operacion,
  .loop-p6-benefit-row-loyalty {
    grid-column: auto !important;
    height: 78px !important;
    min-height: 78px !important;
    max-height: 78px !important;
    display: grid !important;
    grid-template-columns: 32px minmax(0, 1fr) !important;
    grid-template-areas:
      "icon title"
      "icon meta" !important;
    column-gap: 13px !important;
    row-gap: 3px !important;
    align-items: center !important;
    align-content: center !important;
    justify-items: stretch !important;
    padding: 13px 17px !important;
    border-radius: 19px !important;
    border: 1px solid rgba(232, 191, 140, 0.52) !important;
    background:
      linear-gradient(180deg, rgba(255,255,255,0.70) 0%, rgba(255,248,238,0.36) 100%) !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.74),
      0 10px 24px rgba(22, 34, 32, 0.032) !important;
    overflow: hidden !important;
  }

  .loop-p6-benefit-icon,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
  .loop-p6-benefit-row-marca .loop-p6-benefit-icon,
  .loop-p6-benefit-row-operacion .loop-p6-benefit-icon,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-icon {
    grid-area: icon !important;
    width: 32px !important;
    height: 32px !important;
    min-width: 32px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    align-self: center !important;
    background: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
    color: rgba(0, 103, 95, 0.88) !important;
    opacity: 1 !important;
  }

  .loop-p6-feature-img,
  .loop-p6-benefit-icon img,
  .loop-p6-benefit-icon svg,
  .loop-p6-benefit-row-whatsapp .loop-p6-feature-img,
  .loop-p6-benefit-row-marca .loop-p6-feature-img {
    width: 26px !important;
    height: 26px !important;
    min-width: 26px !important;
    max-width: 26px !important;
    object-fit: contain !important;
    display: block !important;
    filter: none !important;
  }

  .loop-p6-benefit-copy {
    display: contents !important;
    min-width: 0 !important;
  }

  .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-marca .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-operacion .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-copy strong {
    grid-area: title !important;
    align-self: end !important;
    min-width: 0 !important;
    width: 100% !important;
    color: #073f37 !important;
    font-size: 15px !important;
    line-height: 1.08 !important;
    letter-spacing: -0.03em !important;
    font-weight: 930 !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    word-break: normal !important;
    overflow-wrap: normal !important;
    hyphens: none !important;
  }

  .loop-p6-benefit-copy em {
    grid-area: meta !important;
    align-self: start !important;
    min-width: 0 !important;
    width: 100% !important;
    color: rgba(7, 63, 55, 0.70) !important;
    font-size: 12px !important;
    line-height: 1.18 !important;
    letter-spacing: -0.006em !important;
    font-style: normal !important;
    font-weight: 650 !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    word-break: normal !important;
    overflow-wrap: normal !important;
    hyphens: none !important;
  }

  .loop-p6-benefit-row-operacion,
  .loop-p6-benefit-row-loyalty {
    grid-template-areas: "icon title" !important;
  }

  .loop-p6-benefit-row-operacion .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-copy strong {
    align-self: center !important;
  }

  .loop-p6-benefit-row-operacion .loop-p6-benefit-copy em,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-copy em {
    display: none !important;
  }

  .loop-p6-benefit-foot {
    display: none !important;
  }

  @media (min-width: 1181px) and (max-height: 820px) {
    .loop-p6-benefit-card {
      width: min(100%, 598px) !important;
      padding: 27px 32px 28px !important;
    }

    .loop-p6-benefit-head {
      padding-bottom: 19px !important;
    }

    .loop-p6-benefits-list {
      grid-auto-rows: 72px !important;
      gap: 11px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca,
    .loop-p6-benefit-row-operacion,
    .loop-p6-benefit-row-loyalty {
      height: 72px !important;
      min-height: 72px !important;
      max-height: 72px !important;
      padding: 12px 15px !important;
      border-radius: 18px !important;
    }

    .loop-p6-feature-img,
    .loop-p6-benefit-icon img,
    .loop-p6-benefit-icon svg {
      width: 24px !important;
      height: 24px !important;
      min-width: 24px !important;
      max-width: 24px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 14.1px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 11.2px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-benefit-card {
      width: min(100%, 520px) !important;
      padding: 24px 24px 22px !important;
      border-radius: 32px !important;
    }

    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      font-size: clamp(30px, 3.1vw, 36px) !important;
    }

    .loop-p6-benefit-head-copy em,
    .loop-p6-benefit-head-copy em b {
      font-size: 13.2px !important;
    }

    .loop-p6-benefits-list {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      grid-auto-rows: 72px !important;
      gap: 9px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca,
    .loop-p6-benefit-row-operacion,
    .loop-p6-benefit-row-loyalty {
      height: 72px !important;
      min-height: 72px !important;
      max-height: 72px !important;
      grid-template-columns: 26px minmax(0, 1fr) !important;
      column-gap: 9px !important;
      padding: 11px 12px !important;
      border-radius: 16px !important;
    }

    .loop-p6-benefit-icon,
    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
    .loop-p6-benefit-row-marca .loop-p6-benefit-icon {
      width: 26px !important;
      height: 26px !important;
      min-width: 26px !important;
    }

    .loop-p6-feature-img,
    .loop-p6-benefit-icon img,
    .loop-p6-benefit-icon svg {
      width: 21px !important;
      height: 21px !important;
      min-width: 21px !important;
      max-width: 21px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 12.5px !important;
      line-height: 1.08 !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.2px !important;
      line-height: 1.14 !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-benefit-head-copy strong,
    .loop-p6-benefit-head strong {
      white-space: normal !important;
    }

    .loop-p6-benefits-list {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      grid-auto-rows: 74px !important;
      gap: 8px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca,
    .loop-p6-benefit-row-operacion,
    .loop-p6-benefit-row-loyalty {
      height: 74px !important;
      min-height: 74px !important;
      max-height: 74px !important;
      grid-template-columns: 24px minmax(0, 1fr) !important;
      column-gap: 8px !important;
      padding: 11px !important;
      border-radius: 17px !important;
    }

    .loop-p6-feature-img,
    .loop-p6-benefit-icon img,
    .loop-p6-benefit-icon svg {
      width: 20px !important;
      height: 20px !important;
      min-width: 20px !important;
      max-width: 20px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 12.2px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.4px !important;
    }
  }
`;




const phaseHomeFounderCardV9EqualAgendaCards = `
  /* =========================================================
     LOOP HOME — FOUNDER CARD V9 EQUAL AGENDA CARDS
     Goal:
     - all six bubbles exactly match the Agenda card size
     - keep 2 columns x 3 rows
     - keep original founder asset icons
     - CRM -> Cliente CRM
     ========================================================= */

  .loop-p6-benefit-card {
    width: min(100%, 612px) !important;
    padding: 31px 36px 32px !important;
    border-radius: 38px !important;
  }

  .loop-p6-benefits-list {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    grid-template-rows: repeat(3, 78px) !important;
    grid-auto-rows: 78px !important;
    align-items: stretch !important;
    gap: 12px !important;
    margin-top: 0 !important;
  }

  .loop-p6-benefit-row,
  .loop-p6-benefit-row-whatsapp,
  .loop-p6-benefit-row-marca,
  .loop-p6-benefit-row-operacion,
  .loop-p6-benefit-row-loyalty {
    width: 100% !important;
    height: 78px !important;
    min-height: 78px !important;
    max-height: 78px !important;
    box-sizing: border-box !important;
    display: grid !important;
    grid-template-columns: 32px minmax(0, 1fr) !important;
    grid-template-areas:
      "icon title"
      "icon meta" !important;
    column-gap: 13px !important;
    row-gap: 3px !important;
    align-items: center !important;
    align-content: center !important;
    justify-items: stretch !important;
    padding: 13px 17px !important;
    border-radius: 19px !important;
    border: 1px solid rgba(232, 191, 140, 0.52) !important;
    background:
      linear-gradient(180deg, rgba(255,255,255,0.70) 0%, rgba(255,248,238,0.36) 100%) !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.74),
      0 10px 24px rgba(22, 34, 32, 0.032) !important;
    overflow: hidden !important;
  }

  .loop-p6-benefit-icon,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
  .loop-p6-benefit-row-marca .loop-p6-benefit-icon,
  .loop-p6-benefit-row-operacion .loop-p6-benefit-icon,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-icon {
    grid-area: icon !important;
    width: 32px !important;
    height: 32px !important;
    min-width: 32px !important;
    align-self: center !important;
    justify-self: center !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .loop-p6-feature-img,
  .loop-p6-benefit-icon img,
  .loop-p6-benefit-icon svg,
  .loop-p6-benefit-row-whatsapp .loop-p6-feature-img,
  .loop-p6-benefit-row-marca .loop-p6-feature-img {
    width: 25px !important;
    height: 25px !important;
    min-width: 25px !important;
    max-width: 25px !important;
    object-fit: contain !important;
    display: block !important;
    filter: none !important;
  }

  .loop-p6-benefit-copy {
    display: contents !important;
    min-width: 0 !important;
  }

  .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-whatsapp .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-marca .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-operacion .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-copy strong {
    grid-area: title !important;
    align-self: end !important;
    min-width: 0 !important;
    width: 100% !important;
    color: #073f37 !important;
    font-size: 15px !important;
    line-height: 1.08 !important;
    letter-spacing: -0.03em !important;
    font-weight: 930 !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    word-break: normal !important;
    overflow-wrap: normal !important;
    hyphens: none !important;
  }

  .loop-p6-benefit-copy em {
    grid-area: meta !important;
    align-self: start !important;
    min-width: 0 !important;
    width: 100% !important;
    color: rgba(7, 63, 55, 0.70) !important;
    font-size: 12px !important;
    line-height: 1.18 !important;
    letter-spacing: -0.006em !important;
    font-style: normal !important;
    font-weight: 650 !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    word-break: normal !important;
    overflow-wrap: normal !important;
    hyphens: none !important;
  }

  .loop-p6-benefit-row-operacion,
  .loop-p6-benefit-row-loyalty {
    grid-template-areas: "icon title" !important;
  }

  .loop-p6-benefit-row-operacion .loop-p6-benefit-copy strong,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-copy strong {
    align-self: center !important;
  }

  .loop-p6-benefit-row-operacion .loop-p6-benefit-copy em,
  .loop-p6-benefit-row-loyalty .loop-p6-benefit-copy em {
    display: none !important;
  }

  @media (min-width: 1181px) and (max-height: 820px) {
    .loop-p6-benefits-list {
      grid-template-rows: repeat(3, 72px) !important;
      grid-auto-rows: 72px !important;
      gap: 11px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca,
    .loop-p6-benefit-row-operacion,
    .loop-p6-benefit-row-loyalty {
      height: 72px !important;
      min-height: 72px !important;
      max-height: 72px !important;
      padding: 12px 15px !important;
      border-radius: 18px !important;
    }

    .loop-p6-feature-img,
    .loop-p6-benefit-icon img,
    .loop-p6-benefit-icon svg {
      width: 24px !important;
      height: 24px !important;
      min-width: 24px !important;
      max-width: 24px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-benefits-list {
      grid-template-rows: repeat(3, 72px) !important;
      grid-auto-rows: 72px !important;
      gap: 9px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row-whatsapp,
    .loop-p6-benefit-row-marca,
    .loop-p6-benefit-row-operacion,
    .loop-p6-benefit-row-loyalty {
      height: 72px !important;
      min-height: 72px !important;
      max-height: 72px !important;
      grid-template-columns: 26px minmax(0, 1fr) !important;
      column-gap: 9px !important;
      padding: 11px 12px !important;
      border-radius: 16px !important;
    }

    .loop-p6-benefit-icon,
    .loop-p6-benefit-row-whatsapp .loop-p6-benefit-icon,
    .loop-p6-benefit-row-marca .loop-p6-benefit-icon {
      width: 26px !important;
      height: 26px !important;
      min-width: 26px !important;
    }

    .loop-p6-feature-img,
    .loop-p6-benefit-icon img,
    .loop-p6-benefit-icon svg {
      width: 21px !important;
      height: 21px !important;
      min-width: 21px !important;
      max-width: 21px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 12.5px !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.2px !important;
    }
  }
`;




const phaseHomeFounderCardV10ForceEqualHeights = `
  /* =========================================================
     LOOP HOME — FOUNDER CARD V10 FORCE EQUAL HEIGHTS
     Fixes the remaining issue where Perfil online and Fidelidad
     still looked taller because older nth-child / last-child rules
     had higher specificity with !important.
     ========================================================= */

  .loop-p6-benefits-list {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    grid-template-rows: repeat(3, 78px) !important;
    grid-auto-rows: 78px !important;
    align-items: stretch !important;
    gap: 12px !important;
  }

  .loop-p6-benefits-list > .loop-p6-benefit-row,
  .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(1),
  .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(2),
  .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(3),
  .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(4),
  .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(5),
  .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(6),
  .loop-p6-benefits-list > .loop-p6-benefit-row:first-child,
  .loop-p6-benefits-list > .loop-p6-benefit-row:last-child,
  .loop-p6-benefits-list > .loop-p6-benefit-row-marca,
  .loop-p6-benefits-list > .loop-p6-benefit-row-loyalty,
  .loop-p6-benefits-list > .loop-p6-benefit-row-operacion,
  .loop-p6-benefits-list > .loop-p6-benefit-row-whatsapp {
    height: 78px !important;
    min-height: 78px !important;
    max-height: 78px !important;
    align-self: stretch !important;
    box-sizing: border-box !important;
    grid-column: auto !important;
    padding: 13px 17px !important;
    border-radius: 19px !important;
    overflow: hidden !important;
  }

  .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(3),
  .loop-p6-benefits-list > .loop-p6-benefit-row:last-child {
    height: 78px !important;
    min-height: 78px !important;
    max-height: 78px !important;
  }

  .loop-p6-benefits-list > .loop-p6-benefit-row .loop-p6-benefit-copy strong {
    font-size: 15px !important;
    line-height: 1.08 !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
  }

  .loop-p6-benefits-list > .loop-p6-benefit-row .loop-p6-benefit-copy em {
    font-size: 12px !important;
    line-height: 1.16 !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
  }

  @media (min-width: 1181px) and (max-height: 820px) {
    .loop-p6-benefits-list {
      grid-template-rows: repeat(3, 72px) !important;
      grid-auto-rows: 72px !important;
      gap: 11px !important;
    }

    .loop-p6-benefits-list > .loop-p6-benefit-row,
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(1),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(2),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(3),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(4),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(5),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(6),
    .loop-p6-benefits-list > .loop-p6-benefit-row:first-child,
    .loop-p6-benefits-list > .loop-p6-benefit-row:last-child,
    .loop-p6-benefits-list > .loop-p6-benefit-row-marca,
    .loop-p6-benefits-list > .loop-p6-benefit-row-loyalty,
    .loop-p6-benefits-list > .loop-p6-benefit-row-operacion,
    .loop-p6-benefits-list > .loop-p6-benefit-row-whatsapp {
      height: 72px !important;
      min-height: 72px !important;
      max-height: 72px !important;
      padding: 12px 15px !important;
      border-radius: 18px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-benefits-list {
      grid-template-rows: repeat(3, 72px) !important;
      grid-auto-rows: 72px !important;
      gap: 9px !important;
    }

    .loop-p6-benefits-list > .loop-p6-benefit-row,
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(1),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(2),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(3),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(4),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(5),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(6),
    .loop-p6-benefits-list > .loop-p6-benefit-row:first-child,
    .loop-p6-benefits-list > .loop-p6-benefit-row:last-child,
    .loop-p6-benefits-list > .loop-p6-benefit-row-marca,
    .loop-p6-benefits-list > .loop-p6-benefit-row-loyalty,
    .loop-p6-benefits-list > .loop-p6-benefit-row-operacion,
    .loop-p6-benefits-list > .loop-p6-benefit-row-whatsapp {
      height: 72px !important;
      min-height: 72px !important;
      max-height: 72px !important;
      padding: 11px 12px !important;
      border-radius: 16px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-benefits-list {
      grid-template-rows: repeat(3, 74px) !important;
      grid-auto-rows: 74px !important;
      gap: 8px !important;
    }

    .loop-p6-benefits-list > .loop-p6-benefit-row,
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(1),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(2),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(3),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(4),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(5),
    .loop-p6-benefits-list > .loop-p6-benefit-row:nth-child(6),
    .loop-p6-benefits-list > .loop-p6-benefit-row:first-child,
    .loop-p6-benefits-list > .loop-p6-benefit-row:last-child,
    .loop-p6-benefits-list > .loop-p6-benefit-row-marca,
    .loop-p6-benefits-list > .loop-p6-benefit-row-loyalty,
    .loop-p6-benefits-list > .loop-p6-benefit-row-operacion,
    .loop-p6-benefits-list > .loop-p6-benefit-row-whatsapp {
      height: 74px !important;
      min-height: 74px !important;
      max-height: 74px !important;
      padding: 11px !important;
      border-radius: 17px !important;
    }
  }
`;




const phaseHomeMobilePremiumPolishV11 = `
  /* =========================================================
     LOOP HOME — MOBILE PREMIUM POLISH V11
     Mobile should sell fast:
     - slightly smaller headline
     - slimmer CTA
     - store badges with better breathing room
     - simplified 3-card benefit rail
     - no heavy WhatsApp highlight
     ========================================================= */

  @media (max-width: 899px) {
    .loop-p6-hero {
      background-position: center top !important;
    }

    .loop-p6-hero-overlay {
      padding: 18px 13px 17px !important;
    }

    .loop-p6-title {
      margin-top: 10px !important;
      max-width: 100% !important;
      font-size: clamp(38px, 10.4vw, 51px) !important;
      line-height: 0.94 !important;
      letter-spacing: -0.074em !important;
    }

    .loop-p6-offer-line {
      margin-top: 12px !important;
      font-size: 12.6px !important;
      line-height: 1.32 !important;
      max-width: 94% !important;
    }

    .loop-p6-hero-actions {
      margin-top: 17px !important;
    }

    .loop-p6-main-create,
    .loop-p6-primary {
      width: 100% !important;
      min-height: 51px !important;
      max-height: 51px !important;
      border-radius: 19px !important;
      padding: 0 17px 0 20px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      font-size: 13.3px !important;
      letter-spacing: -0.018em !important;
    }

    .loop-p6-cta-arrow-premium {
      width: 33px !important;
      height: 33px !important;
      min-width: 33px !important;
      border-radius: 999px !important;
    }

    .loop-p6-cta-arrow-premium svg {
      width: 17px !important;
      height: 17px !important;
    }

    .loop-p6-platform-block {
      margin-top: 17px !important;
    }

    .loop-p6-platform-copy {
      margin-bottom: 8px !important;
      font-size: 12px !important;
      line-height: 1.1 !important;
      font-weight: 850 !important;
    }

    .loop-p6-store-row-left {
      gap: 9px !important;
      align-items: center !important;
    }

    .loop-p6-store-badge-img {
      height: 37px !important;
      max-width: 166px !important;
      filter: drop-shadow(0 7px 14px rgba(0,0,0,0.15)) !important;
    }

    .loop-p6-mobile-benefit-rail {
      margin: 15px 0 0 !important;
      padding: 12px !important;
      border-radius: 21px !important;
      background:
        radial-gradient(circle at 8% 0%, rgba(255,255,255,0.70), transparent 34%),
        linear-gradient(180deg, rgba(255, 248, 238, 0.95), rgba(246, 239, 226, 0.88)) !important;
      border: 1px solid rgba(255, 248, 238, 0.62) !important;
      box-shadow: 0 16px 32px rgba(0, 0, 0, 0.15) !important;
      backdrop-filter: blur(14px) saturate(1.04) !important;
      -webkit-backdrop-filter: blur(14px) saturate(1.04) !important;
    }

    .loop-p6-mobile-benefit-title {
      padding: 0 1px 1px !important;
      display: grid !important;
      gap: 2px !important;
    }

    .loop-p6-mobile-benefit-title strong {
      font-size: 13.2px !important;
      line-height: 1.05 !important;
      font-weight: 950 !important;
      letter-spacing: -0.024em !important;
    }

    .loop-p6-mobile-benefit-title span {
      max-width: 94% !important;
      font-size: 11.1px !important;
      line-height: 1.2 !important;
      font-weight: 690 !important;
      color: rgba(7, 63, 55, 0.68) !important;
    }

    .loop-p6-mobile-benefit-stack {
      display: grid !important;
      grid-template-columns: 1fr !important;
      gap: 7px !important;
      margin-top: 10px !important;
    }

    .loop-p6-mobile-benefit-card,
    .loop-p6-mobile-benefit-card-whatsapp {
      min-height: 50px !important;
      display: grid !important;
      grid-template-columns: 34px minmax(0, 1fr) !important;
      align-items: center !important;
      gap: 9px !important;
      padding: 8px 10px !important;
      border-radius: 15px !important;
      background:
        linear-gradient(180deg, rgba(255,255,255,0.66) 0%, rgba(255,250,242,0.46) 100%) !important;
      border: 1px solid rgba(184, 143, 82, 0.17) !important;
      color: #073f37 !important;
      box-shadow: inset 0 1px 0 rgba(255,255,255,0.66) !important;
    }

    .loop-p6-mobile-benefit-card-whatsapp {
      background:
        linear-gradient(180deg, rgba(255,255,255,0.66) 0%, rgba(255,250,242,0.46) 100%) !important;
      border-color: rgba(184, 143, 82, 0.17) !important;
    }

    .loop-p6-mobile-benefit-card > .loop-p6-feature-img,
    .loop-p6-mobile-benefit-card .loop-p6-feature-img,
    .loop-p6-mobile-benefit-card-whatsapp .loop-p6-feature-img {
      width: 26px !important;
      height: 26px !important;
      min-width: 26px !important;
      max-width: 26px !important;
      object-fit: contain !important;
      transform: none !important;
      filter: none !important;
    }

    .loop-p6-mobile-benefit-card span {
      min-width: 0 !important;
      display: grid !important;
      gap: 2px !important;
    }

    .loop-p6-mobile-benefit-card strong {
      font-size: 12.1px !important;
      line-height: 1.08 !important;
      font-weight: 950 !important;
      letter-spacing: -0.022em !important;
      white-space: normal !important;
      overflow-wrap: normal !important;
      word-break: normal !important;
    }

    .loop-p6-mobile-benefit-card em {
      font-size: 10.4px !important;
      line-height: 1.17 !important;
      font-weight: 650 !important;
      color: rgba(7, 63, 55, 0.66) !important;
      white-space: normal !important;
      overflow-wrap: normal !important;
      word-break: normal !important;
    }
  }

  @media (max-width: 430px) {
    .loop-p6-hero-overlay {
      padding: 16px 12px 16px !important;
    }

    .loop-p6-title {
      font-size: clamp(36px, 10vw, 47px) !important;
      line-height: 0.95 !important;
    }

    .loop-p6-offer-line {
      font-size: 12px !important;
      line-height: 1.28 !important;
    }

    .loop-p6-main-create,
    .loop-p6-primary {
      min-height: 49px !important;
      max-height: 49px !important;
      font-size: 12.8px !important;
    }

    .loop-p6-store-badge-img {
      height: 35px !important;
      max-width: 156px !important;
    }

    .loop-p6-mobile-benefit-rail {
      margin-top: 14px !important;
      padding: 11px !important;
      border-radius: 19px !important;
    }

    .loop-p6-mobile-benefit-title strong {
      font-size: 12.8px !important;
    }

    .loop-p6-mobile-benefit-title span {
      font-size: 10.6px !important;
    }

    .loop-p6-mobile-benefit-card,
    .loop-p6-mobile-benefit-card-whatsapp {
      min-height: 48px !important;
      grid-template-columns: 31px minmax(0, 1fr) !important;
      padding: 7px 9px !important;
    }

    .loop-p6-mobile-benefit-card > .loop-p6-feature-img,
    .loop-p6-mobile-benefit-card .loop-p6-feature-img,
    .loop-p6-mobile-benefit-card-whatsapp .loop-p6-feature-img {
      width: 24px !important;
      height: 24px !important;
      min-width: 24px !important;
      max-width: 24px !important;
    }

    .loop-p6-mobile-benefit-card strong {
      font-size: 11.4px !important;
    }

    .loop-p6-mobile-benefit-card em {
      font-size: 9.8px !important;
    }
  }
`;




const phaseHomeHeroFlushNoBubbleV12 = `
  /* =========================================================
     LOOP HOME — HERO FLUSH / NO BUBBLE V12
     Goal:
     - Hero always behaves like a full image band, not a rounded bubble.
     - No white/cream seam between header and hero.
     - Override older tablet/mobile rules that set:
       width: calc(...), max-width, margin, border-radius.
     ========================================================= */

  .mainmenu-root.has-full-content,
  .mainmenu-root,
  .mainmenu-root.has-full-content .loop-pro-shell,
  .mainmenu-root.has-full-content main.loop-pro-main,
  .loop-pro-shell,
  main.loop-pro-main,
  .loop-pro-main {
    margin-top: 0 !important;
    padding-top: 0 !important;
    border-top: 0 !important;
  }

  .mainmenu-header-only-root {
    margin: 0 !important;
    padding: 0 !important;
    background: #fff8ee !important;
  }

  .loop-mobile-spacer-v2,
  #app-main-header + .loop-mobile-spacer-v2,
  #app-main-header.loop-mobile-header-v2 + .loop-mobile-spacer-v2 {
    display: none !important;
    height: 0 !important;
    min-height: 0 !important;
    max-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
  }

  .loop-p6-hero,
  .mainmenu-root .loop-p6-hero,
  .mainmenu-root.has-full-content .loop-p6-hero,
  main.loop-pro-main > .loop-p6-hero,
  .loop-pro-main > .loop-p6-hero {
    width: 100% !important;
    max-width: none !important;
    margin: -1px 0 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    border-radius: 0 !important;
    border-top: 0 !important;
    border-left: 0 !important;
    border-right: 0 !important;
    box-shadow: none !important;
    outline: 0 !important;
    transform: none !important;
    overflow: hidden !important;
  }

  .loop-p6-hero::before,
  .loop-p6-hero:before {
    border-radius: 0 !important;
  }

  .loop-p6-hero-overlay,
  .mainmenu-root .loop-p6-hero-overlay,
  .mainmenu-root.has-full-content .loop-p6-hero-overlay {
    width: min(100%, 1540px) !important;
    max-width: 1540px !important;
    margin: 0 auto !important;
    border-radius: 0 !important;
    transform: none !important;
  }

  /* Kill the old tablet "rounded hero card" rules. */
  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-hero,
    .mainmenu-root .loop-p6-hero,
    .mainmenu-root.has-full-content .loop-p6-hero,
    main.loop-pro-main > .loop-p6-hero,
    .loop-pro-main > .loop-p6-hero {
      width: 100% !important;
      max-width: none !important;
      margin: -1px 0 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      overflow: hidden !important;
    }

    .loop-p6-hero-overlay {
      width: min(100%, 1540px) !important;
      max-width: 1540px !important;
      margin: 0 auto !important;
      border-radius: 0 !important;
    }
  }

  @media (min-width: 1181px) {
    .loop-p6-hero,
    .mainmenu-root .loop-p6-hero,
    .mainmenu-root.has-full-content .loop-p6-hero,
    main.loop-pro-main > .loop-p6-hero,
    .loop-pro-main > .loop-p6-hero {
      width: 100% !important;
      max-width: none !important;
      margin: -1px 0 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      overflow: hidden !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-hero,
    .mainmenu-root .loop-p6-hero,
    .mainmenu-root.has-full-content .loop-p6-hero,
    main.loop-pro-main > .loop-p6-hero,
    .loop-pro-main > .loop-p6-hero {
      width: 100% !important;
      max-width: none !important;
      margin: -1px 0 0 !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      overflow: hidden !important;
    }

    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      width: 100% !important;
      max-width: none !important;
      margin: 0 !important;
      border-radius: 0 !important;
    }
  }

  @media (max-width: 520px) {
    .loop-p6-hero,
    .mainmenu-root .loop-p6-hero,
    .mainmenu-root.has-full-content .loop-p6-hero,
    main.loop-pro-main > .loop-p6-hero,
    .loop-pro-main > .loop-p6-hero {
      width: 100% !important;
      max-width: none !important;
      margin: -1px 0 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
    }
  }
`;




const phaseHomeHeroPreciseTopByWidthV15 = `
  /* =========================================================
     LOOP HOME — HERO PRECISE TOP BY WIDTH V15
     Diagnosis from Console:
     - header bottom = 64
     - main top = 64
     - hero top = 64
     So there is no DOM gap.
     The visible strip comes from .loop-p6-hero-overlay padding-top.

     This phase makes the hero flush AND controls that top padding
     by width buckets instead of relying only on height.
     ========================================================= */

  .mainmenu-root.has-full-content,
  .mainmenu-root,
  .mainmenu-header-only-root,
  .loop-pro-main,
  main.loop-pro-main {
    margin-top: 0 !important;
    padding-top: 0 !important;
    border-top: 0 !important;
  }

  .loop-p6-hero,
  .mainmenu-root .loop-p6-hero,
  .mainmenu-root.has-full-content .loop-p6-hero,
  main.loop-pro-main > .loop-p6-hero,
  .loop-pro-main > .loop-p6-hero {
    width: 100% !important;
    max-width: none !important;
    margin: -2px 0 0 !important;
    border-radius: 0 !important;
    border-top: 0 !important;
    box-shadow: none !important;
    overflow: hidden !important;
    background-position: center top !important;
  }

  .loop-p6-hero-overlay,
  .mainmenu-root .loop-p6-hero-overlay,
  .mainmenu-root.has-full-content .loop-p6-hero-overlay {
    margin: 0 auto !important;
    border-radius: 0 !important;
    align-items: start !important;
    align-content: start !important;
    transform: none !important;
  }

  .loop-p6-hero-copy,
  .loop-p6-title {
    margin-top: 0 !important;
  }

  /* Large tablet / compact desktop: exact zone where the strip remains. */
  @media (min-width: 1181px) and (max-width: 1240px) {
    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      padding-top: 6px !important;
      padding-bottom: 28px !important;
    }
  }

  /* Mid desktop, slightly wider: keep a little more breathing room. */
  @media (min-width: 1241px) and (max-width: 1320px) {
    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      padding-top: 8px !important;
      padding-bottom: 30px !important;
    }
  }

  /* Wide-ish desktop but still before the full layout breathes naturally. */
  @media (min-width: 1321px) and (max-width: 1380px) {
    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      padding-top: 12px !important;
      padding-bottom: 32px !important;
    }
  }

  /* Tablet web / narrow desktop. */
  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      padding-top: 8px !important;
      padding-bottom: 24px !important;
    }

    .loop-p6-hero,
    .mainmenu-root .loop-p6-hero,
    .mainmenu-root.has-full-content .loop-p6-hero {
      margin-top: -2px !important;
      border-radius: 0 !important;
    }
  }

  /* Short screens need even less vertical air. */
  @media (min-width: 900px) and (max-width: 1380px) and (max-height: 820px) {
    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      padding-top: 4px !important;
      padding-bottom: 22px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-hero,
    .mainmenu-root .loop-p6-hero,
    .mainmenu-root.has-full-content .loop-p6-hero {
      width: 100% !important;
      max-width: none !important;
      margin: -2px 0 0 !important;
      border-radius: 0 !important;
    }
  }
`;




const phaseHomeHeroZeroTopV16 = `
  /* =========================================================
     LOOP HOME — HERO ZERO TOP V16
     Final hard correction after console measurement:
     - header/main/hero all start at the same Y.
     - remaining visible strip is not outside the hero.
     - it is the overlay top padding.

     This phase removes that internal top padding in the affected
     desktop/tablet widths, without restoring the old rounded bubble.
     ========================================================= */

  @media (min-width: 900px) and (max-width: 1380px) {
    .mainmenu-root.has-full-content,
    .mainmenu-root.has-full-content .loop-pro-main,
    main.loop-pro-main,
    .loop-pro-main {
      margin-top: 0 !important;
      padding-top: 0 !important;
      border-top: 0 !important;
    }

    .loop-p6-hero,
    .mainmenu-root .loop-p6-hero,
    .mainmenu-root.has-full-content .loop-p6-hero,
    main.loop-pro-main > .loop-p6-hero,
    .loop-pro-main > .loop-p6-hero {
      width: 100% !important;
      max-width: none !important;
      margin: -3px 0 0 !important;
      border-radius: 0 !important;
      border-top: 0 !important;
      box-shadow: none !important;
      overflow: hidden !important;
      background-position: center top !important;
    }

    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      padding-top: 0 !important;
      margin-top: 0 !important;
      border-radius: 0 !important;
      align-items: start !important;
      align-content: start !important;
      transform: none !important;
    }

    .loop-p6-hero-copy,
    .loop-p6-title,
    .loop-p6-benefit-card {
      margin-top: 0 !important;
      padding-top: 0 !important;
      align-self: start !important;
    }
  }

  /* The exact zone from the latest console: 1201px wide.
     Keep this even stricter because it is the problematic size. */
  @media (min-width: 1181px) and (max-width: 1240px) {
    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      padding-top: 0 !important;
      padding-bottom: 26px !important;
    }

    .loop-p6-title {
      transform: translateY(-1px) !important;
    }

    .loop-p6-benefit-card {
      transform: translateY(-1px) !important;
    }
  }

  /* If a browser still exposes a 1px boundary at the header edge,
     pull only the hero background under it without moving content wildly. */
  @media (min-width: 900px) and (max-width: 1380px) {
    .loop-p6-hero::before,
    .loop-p6-hero:before {
      top: -2px !important;
      inset: -2px 0 0 0 !important;
      border-radius: 0 !important;
    }
  }
`;




const phaseHomeHeaderSeamHeightLockV17 = `
  /* =========================================================
     LOOP HOME — HEADER SEAM + HERO HEIGHT LOCK V17

     The remaining visible line is now the header edge/shadow/border,
     not a real DOM gap:
     - header, main and hero all start/touch correctly.
     - V16 already brought overlay padding-top to 0.

     This phase:
     1) removes the header bottom seam/pseudo-line on the home hero;
     2) locks a smoother hero min-height for the problematic desktop
        widths so the hero does not suddenly feel cropped/short.
     ========================================================= */

  @media (min-width: 900px) and (max-width: 1380px) {
    #app-main-header,
    #app-main-header.loop-ref-header,
    header#app-main-header,
    .loop-ref-header {
      border-bottom: 0 !important;
      box-shadow: none !important;
      outline: 0 !important;
    }

    #app-main-header::before,
    #app-main-header::after,
    #app-main-header.loop-ref-header::before,
    #app-main-header.loop-ref-header::after,
    header#app-main-header::before,
    header#app-main-header::after,
    .loop-ref-header::before,
    .loop-ref-header::after {
      content: none !important;
      display: none !important;
      opacity: 0 !important;
      height: 0 !important;
      min-height: 0 !important;
      max-height: 0 !important;
      border: 0 !important;
      box-shadow: none !important;
      background: transparent !important;
    }

    .mainmenu-root.has-full-content,
    .mainmenu-root.has-full-content .loop-pro-main,
    main.loop-pro-main,
    .loop-pro-main {
      margin-top: 0 !important;
      padding-top: 0 !important;
      border-top: 0 !important;
      background-clip: border-box !important;
    }

    .loop-p6-hero,
    .mainmenu-root .loop-p6-hero,
    .mainmenu-root.has-full-content .loop-p6-hero,
    main.loop-pro-main > .loop-p6-hero,
    .loop-pro-main > .loop-p6-hero {
      width: 100% !important;
      max-width: none !important;
      margin: -4px 0 0 !important;
      border-radius: 0 !important;
      border-top: 0 !important;
      box-shadow: none !important;
      overflow: hidden !important;
      background-position: center top !important;
    }

    .loop-p6-hero::before,
    .loop-p6-hero:before {
      top: -4px !important;
      inset: -4px 0 0 0 !important;
      border-radius: 0 !important;
    }

    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      padding-top: 0 !important;
      margin-top: 0 !important;
      border-radius: 0 !important;
      align-items: start !important;
      align-content: start !important;
      transform: none !important;
    }

    .loop-p6-hero-copy,
    .loop-p6-title,
    .loop-p6-benefit-card {
      margin-top: 0 !important;
      padding-top: 0 !important;
      align-self: start !important;
    }
  }

  /* Problematic range from screenshots/logs: around 1200px wide.
     Keep the hero tall enough so it doesn't suddenly feel cropped. */
  @media (min-width: 1181px) and (max-width: 1240px) {
    .loop-p6-hero,
    .mainmenu-root .loop-p6-hero,
    .mainmenu-root.has-full-content .loop-p6-hero,
    main.loop-pro-main > .loop-p6-hero,
    .loop-pro-main > .loop-p6-hero {
      min-height: clamp(520px, 44vw, 560px) !important;
    }

    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      min-height: inherit !important;
      padding-bottom: 34px !important;
    }
  }

  /* Smooth nearby widths so there is no sudden jump entering/leaving 1200px. */
  @media (min-width: 1241px) and (max-width: 1320px) {
    .loop-p6-hero,
    .mainmenu-root .loop-p6-hero,
    .mainmenu-root.has-full-content .loop-p6-hero,
    main.loop-pro-main > .loop-p6-hero,
    .loop-pro-main > .loop-p6-hero {
      min-height: clamp(500px, 40vw, 545px) !important;
    }

    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      min-height: inherit !important;
      padding-bottom: 34px !important;
    }
  }

  @media (min-width: 1321px) and (max-width: 1380px) {
    .loop-p6-hero,
    .mainmenu-root .loop-p6-hero,
    .mainmenu-root.has-full-content .loop-p6-hero,
    main.loop-pro-main > .loop-p6-hero,
    .loop-pro-main > .loop-p6-hero {
      min-height: clamp(490px, 37vw, 530px) !important;
    }

    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      min-height: inherit !important;
      padding-bottom: 32px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-p6-hero,
    .mainmenu-root .loop-p6-hero,
    .mainmenu-root.has-full-content .loop-p6-hero,
    main.loop-pro-main > .loop-p6-hero,
    .loop-pro-main > .loop-p6-hero {
      min-height: clamp(500px, 48vw, 560px) !important;
    }

    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      min-height: inherit !important;
      padding-bottom: 30px !important;
    }
  }
`;




const phaseHomeHeroSourceOfTruthV18 = `
  /* =========================================================
     LOOP HOME — HERO SOURCE OF TRUTH V18

     Why this exists:
     The hero has accumulated many historic phases with overlapping
     breakpoints. That is why some widths suddenly switch height,
     spacing, card size, or two-column behavior.

     This final layer creates ONE stable responsive system:
     - Mobile / tablet / compact desktop: one-column hero + 3-benefit rail.
     - Full desktop: two-column hero + founder card.
     - No rounded hero bubble.
     - No sudden right-card clipping around 1100–1279px.
     - No top padding seam between header and hero.
     ========================================================= */

  .mainmenu-root.has-full-content,
  .mainmenu-root.has-full-content .loop-pro-main,
  main.loop-pro-main,
  .loop-pro-main {
    margin-top: 0 !important;
    padding-top: 0 !important;
    border-top: 0 !important;
  }

  #app-main-header,
  #app-main-header.loop-ref-header,
  header#app-main-header,
  .loop-ref-header {
    border-bottom: 0 !important;
    box-shadow: none !important;
    outline: 0 !important;
  }

  #app-main-header::before,
  #app-main-header::after,
  #app-main-header.loop-ref-header::before,
  #app-main-header.loop-ref-header::after,
  header#app-main-header::before,
  header#app-main-header::after,
  .loop-ref-header::before,
  .loop-ref-header::after {
    content: none !important;
    display: none !important;
    opacity: 0 !important;
    height: 0 !important;
    border: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .loop-p6-hero,
  .mainmenu-root .loop-p6-hero,
  .mainmenu-root.has-full-content .loop-p6-hero,
  main.loop-pro-main > .loop-p6-hero,
  .loop-pro-main > .loop-p6-hero {
    width: 100% !important;
    max-width: none !important;
    margin: -2px 0 0 !important;
    border-radius: 0 !important;
    border-top: 0 !important;
    border-left: 0 !important;
    border-right: 0 !important;
    box-shadow: none !important;
    overflow: hidden !important;
    background-position: center top !important;
  }

  .loop-p6-hero::before,
  .loop-p6-hero:before {
    inset: -2px 0 0 0 !important;
    border-radius: 0 !important;
  }

  .loop-p6-hero-overlay,
  .mainmenu-root .loop-p6-hero-overlay,
  .mainmenu-root.has-full-content .loop-p6-hero-overlay {
    width: min(100%, 1540px) !important;
    max-width: 1540px !important;
    margin: 0 auto !important;
    border-radius: 0 !important;
    transform: none !important;
    box-sizing: border-box !important;
  }

  .loop-p6-hero-copy,
  .loop-p6-title {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }

  /* ---------------------------------------------------------
     COMPACT DESKTOP / TABLET WEB
     900px–1279px
     Do NOT force the desktop founder card here. It is the source
     of the clipped/crowded state. Use the mobile rail instead.
     --------------------------------------------------------- */
  @media (min-width: 900px) and (max-width: 1279px) {
    .loop-p6-hero,
    .mainmenu-root .loop-p6-hero,
    .mainmenu-root.has-full-content .loop-p6-hero,
    main.loop-pro-main > .loop-p6-hero,
    .loop-pro-main > .loop-p6-hero {
      min-height: auto !important;
      height: auto !important;
      background-position: center top !important;
    }

    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      display: block !important;
      min-height: 0 !important;
      height: auto !important;
      padding: 0 clamp(28px, 5vw, 64px) 30px !important;
    }

    .loop-p6-hero-copy {
      width: min(100%, 780px) !important;
      max-width: 780px !important;
      min-width: 0 !important;
      padding-top: 0 !important;
    }

    .loop-p6-title {
      max-width: 760px !important;
      font-size: clamp(46px, 6.2vw, 70px) !important;
      line-height: 0.94 !important;
      letter-spacing: -0.072em !important;
      text-wrap: balance !important;
    }

    .loop-p6-offer-line {
      margin-top: 16px !important;
      max-width: 680px !important;
      font-size: 14px !important;
      line-height: 1.35 !important;
    }

    .loop-p6-hero-actions {
      margin-top: 18px !important;
      display: flex !important;
      align-items: flex-end !important;
      gap: 18px !important;
      flex-wrap: wrap !important;
      max-width: 760px !important;
    }

    .loop-p6-main-create,
    .loop-p6-primary {
      width: min(100%, 318px) !important;
      min-height: 54px !important;
      max-height: 54px !important;
      padding: 0 18px 0 24px !important;
    }

    .loop-p6-platform-block {
      margin-top: 0 !important;
    }

    .loop-p6-store-row-left {
      display: flex !important;
      gap: 10px !important;
      flex-wrap: nowrap !important;
      align-items: center !important;
    }

    .loop-p6-store-badge-img {
      height: 40px !important;
      max-width: 178px !important;
    }

    .loop-p6-benefit-card {
      display: none !important;
    }

    .loop-p6-mobile-benefit-rail {
      display: block !important;
      width: min(100%, 780px) !important;
      max-width: 780px !important;
      margin: 18px 0 0 !important;
      padding: 12px !important;
      border-radius: 22px !important;
      background:
        radial-gradient(circle at 10% 0%, rgba(255,255,255,0.62), transparent 34%),
        linear-gradient(180deg, rgba(255, 248, 238, 0.95), rgba(246, 239, 226, 0.88)) !important;
      border: 1px solid rgba(255, 248, 238, 0.64) !important;
      box-shadow: 0 16px 34px rgba(0, 0, 0, 0.14) !important;
      color: #073f37 !important;
      text-shadow: none !important;
      backdrop-filter: blur(14px) saturate(1.05) !important;
      -webkit-backdrop-filter: blur(14px) saturate(1.05) !important;
    }

    .loop-p6-mobile-benefit-title {
      display: grid !important;
      gap: 2px !important;
      padding: 0 1px 1px !important;
    }

    .loop-p6-mobile-benefit-title strong {
      color: #073f37 !important;
      font-size: 14px !important;
      line-height: 1.05 !important;
      font-weight: 950 !important;
      letter-spacing: -0.024em !important;
    }

    .loop-p6-mobile-benefit-title span {
      max-width: 94% !important;
      color: rgba(7, 63, 55, 0.68) !important;
      font-size: 11.2px !important;
      line-height: 1.2 !important;
      font-weight: 700 !important;
    }

    .loop-p6-mobile-benefit-stack {
      display: grid !important;
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
      gap: 8px !important;
      margin-top: 10px !important;
    }

    .loop-p6-mobile-benefit-card,
    .loop-p6-mobile-benefit-card-whatsapp {
      min-height: 56px !important;
      display: grid !important;
      grid-template-columns: 30px minmax(0, 1fr) !important;
      align-items: center !important;
      gap: 8px !important;
      padding: 8px 10px !important;
      border-radius: 15px !important;
      background: linear-gradient(180deg, rgba(255,255,255,0.66), rgba(255,250,242,0.48)) !important;
      border: 1px solid rgba(184, 143, 82, 0.17) !important;
      box-shadow: inset 0 1px 0 rgba(255,255,255,0.66) !important;
    }

    .loop-p6-mobile-benefit-card .loop-p6-feature-img,
    .loop-p6-mobile-benefit-card-whatsapp .loop-p6-feature-img {
      width: 25px !important;
      height: 25px !important;
      min-width: 25px !important;
      max-width: 25px !important;
      object-fit: contain !important;
      transform: none !important;
      filter: none !important;
    }

    .loop-p6-mobile-benefit-card span {
      min-width: 0 !important;
      display: grid !important;
      gap: 2px !important;
    }

    .loop-p6-mobile-benefit-card strong {
      color: #073f37 !important;
      font-size: 11.5px !important;
      line-height: 1.08 !important;
      font-weight: 950 !important;
      letter-spacing: -0.018em !important;
      white-space: normal !important;
      overflow-wrap: normal !important;
      word-break: normal !important;
    }

    .loop-p6-mobile-benefit-card em {
      color: rgba(7, 63, 55, 0.66) !important;
      font-size: 9.8px !important;
      line-height: 1.16 !important;
      font-weight: 650 !important;
      white-space: normal !important;
      overflow-wrap: normal !important;
      word-break: normal !important;
    }
  }

  /* ---------------------------------------------------------
     FULL DESKTOP
     1280px+
     Stable two-column layout. The founder card only appears when
     there is enough horizontal space for it.
     --------------------------------------------------------- */
  @media (min-width: 1280px) {
    .loop-p6-hero,
    .mainmenu-root .loop-p6-hero,
    .mainmenu-root.has-full-content .loop-p6-hero,
    main.loop-pro-main > .loop-p6-hero,
    .loop-pro-main > .loop-p6-hero {
      min-height: clamp(545px, 42vw, 650px) !important;
      height: auto !important;
      background-position: center top !important;
    }

    .loop-p6-hero-overlay,
    .mainmenu-root .loop-p6-hero-overlay,
    .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      min-height: inherit !important;
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) minmax(390px, min(34vw, 500px)) !important;
      gap: clamp(34px, 5vw, 90px) !important;
      align-items: center !important;
      align-content: center !important;
      padding: clamp(24px, 3.2vw, 46px) clamp(28px, 5vw, 72px) clamp(34px, 4vw, 58px) !important;
    }

    .loop-p6-hero-copy {
      width: 100% !important;
      max-width: 820px !important;
      min-width: 0 !important;
      align-self: center !important;
    }

    .loop-p6-title {
      max-width: 900px !important;
      font-size: clamp(54px, 5.5vw, 88px) !important;
      line-height: 0.92 !important;
      letter-spacing: -0.078em !important;
      text-wrap: balance !important;
    }

    .loop-p6-offer-line {
      margin-top: 18px !important;
      max-width: 690px !important;
      font-size: 14px !important;
      line-height: 1.36 !important;
    }

    .loop-p6-hero-actions {
      margin-top: 22px !important;
      display: grid !important;
      gap: 16px !important;
      justify-items: start !important;
    }

    .loop-p6-mobile-benefit-rail {
      display: none !important;
    }

    .loop-p6-benefit-card {
      display: grid !important;
      width: 100% !important;
      max-width: 500px !important;
      min-width: 0 !important;
      justify-self: end !important;
      align-self: center !important;
      transform: none !important;
      margin: 0 !important;
      overflow: hidden !important;
    }
  }

  /* ---------------------------------------------------------
     MID DESKTOP: 1280–1439px
     Keep card and typography slightly more compact to avoid any
     clipping at browser widths close to tablet.
     --------------------------------------------------------- */
  @media (min-width: 1280px) and (max-width: 1439px) {
    .loop-p6-hero {
      min-height: clamp(520px, 40vw, 590px) !important;
    }

    .loop-p6-hero-overlay {
      grid-template-columns: minmax(0, 1fr) minmax(360px, 420px) !important;
      gap: clamp(28px, 4vw, 54px) !important;
      padding-left: clamp(32px, 4vw, 56px) !important;
      padding-right: clamp(24px, 3vw, 44px) !important;
    }

    .loop-p6-title {
      max-width: 760px !important;
      font-size: clamp(50px, 5.1vw, 72px) !important;
      line-height: 0.93 !important;
    }

    .loop-p6-benefit-card {
      max-width: 420px !important;
      border-radius: 30px !important;
      padding: 24px !important;
    }

    .loop-p6-benefit-head-copy strong {
      font-size: clamp(31px, 3vw, 40px) !important;
      line-height: 0.95 !important;
    }

    .loop-p6-benefits-list {
      grid-template-rows: repeat(3, 70px) !important;
      grid-auto-rows: 70px !important;
      gap: 10px !important;
    }

    .loop-p6-benefit-row,
    .loop-p6-benefit-row:nth-child(1),
    .loop-p6-benefit-row:nth-child(2),
    .loop-p6-benefit-row:nth-child(3),
    .loop-p6-benefit-row:nth-child(4),
    .loop-p6-benefit-row:nth-child(5),
    .loop-p6-benefit-row:nth-child(6) {
      height: 70px !important;
      min-height: 70px !important;
      max-height: 70px !important;
      padding: 11px 13px !important;
      grid-template-columns: 28px minmax(0, 1fr) !important;
      gap: 9px !important;
    }

    .loop-p6-benefit-copy strong {
      font-size: 13.3px !important;
      line-height: 1.06 !important;
    }

    .loop-p6-benefit-copy em {
      font-size: 10.5px !important;
      line-height: 1.12 !important;
    }
  }

  /* ---------------------------------------------------------
     MOBILE
     Keep the polished mobile direction from V11, but avoid layout
     drift from desktop rules.
     --------------------------------------------------------- */
  @media (max-width: 899px) {
    .loop-p6-hero {
      min-height: auto !important;
      height: auto !important;
      margin-top: -2px !important;
      border-radius: 0 !important;
      background-position: center top !important;
    }

    .loop-p6-hero-overlay {
      display: block !important;
      width: 100% !important;
      max-width: none !important;
      min-height: 0 !important;
      height: auto !important;
      margin: 0 !important;
      padding-top: 16px !important;
      border-radius: 0 !important;
    }

    .loop-p6-benefit-card {
      display: none !important;
    }
  }
`;




const phaseHomeBodyPaddingSeamFixV20 = `
  /* =========================================================
     LOOP HOME — BODY PADDING SEAM FIX V20

     Console diagnosis at 1027px:
     - header bottom = 64px
     - body padding-top = 66px
     - root/main start = 66px
     - at y=64 the top element is BODY

     So the white strip is not coming from the hero card.
     It is a 2px global body/header offset.

     This phase aligns the home page body offset with the actual
     fixed header height and removes the hero negative-margin hack.
     ========================================================= */

  @media (min-width: 900px) {
    html:has(.mainmenu-root.has-full-content),
    body:has(.mainmenu-root.has-full-content) {
      padding-top: 64px !important;
      margin-top: 0 !important;
      background: #fff8ee !important;
    }

    body:has(.mainmenu-root.has-full-content) .mainmenu-root.has-full-content,
    body:has(.mainmenu-root.has-full-content) .loop-pro-main,
    body:has(.mainmenu-root.has-full-content) main.loop-pro-main {
      margin-top: 0 !important;
      padding-top: 0 !important;
      border-top: 0 !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-hero,
    body:has(.mainmenu-root.has-full-content) main.loop-pro-main > .loop-p6-hero,
    body:has(.mainmenu-root.has-full-content) .loop-pro-main > .loop-p6-hero {
      margin-top: 0 !important;
      top: 0 !important;
      border-top: 0 !important;
      border-bottom: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      outline: 0 !important;
      background-position: center top !important;
      transform: none !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-hero::before,
    body:has(.mainmenu-root.has-full-content) .loop-p6-hero:before {
      inset: 0 !important;
      top: 0 !important;
      border-radius: 0 !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-hero-overlay {
      padding-top: 0 !important;
      margin-top: 0 !important;
      border-top: 0 !important;
      border-radius: 0 !important;
    }

    body:has(.mainmenu-root.has-full-content) #app-main-header,
    body:has(.mainmenu-root.has-full-content) #app-main-header.loop-ref-header,
    body:has(.mainmenu-root.has-full-content) header#app-main-header,
    body:has(.mainmenu-root.has-full-content) .loop-ref-header {
      height: 64px !important;
      min-height: 64px !important;
      max-height: 64px !important;
      border-bottom: 0 !important;
      box-shadow: none !important;
      outline: 0 !important;
      overflow: visible !important;
    }

    /* Remove the previous seam guard pseudo-line from V19.
       Once body/header are aligned, the pseudo-line can itself
       create an artificial strip. */
    body:has(.mainmenu-root.has-full-content) #app-main-header::before,
    body:has(.mainmenu-root.has-full-content) #app-main-header::after,
    body:has(.mainmenu-root.has-full-content) #app-main-header.loop-ref-header::before,
    body:has(.mainmenu-root.has-full-content) #app-main-header.loop-ref-header::after,
    body:has(.mainmenu-root.has-full-content) header#app-main-header::before,
    body:has(.mainmenu-root.has-full-content) header#app-main-header::after,
    body:has(.mainmenu-root.has-full-content) .loop-ref-header::before,
    body:has(.mainmenu-root.has-full-content) .loop-ref-header::after {
      content: none !important;
      display: none !important;
      height: 0 !important;
      opacity: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      border: 0 !important;
    }
  }

  /* Mobile keeps the native/mobile header behavior. */
  @media (max-width: 899px) {
    body:has(.mainmenu-root.has-full-content) .loop-p6-hero {
      margin-top: -2px !important;
    }
  }
`;




const phaseHomeHeaderOffsetLayoutV21 = `
  /* =========================================================
     LOOP HOME — HEADER OFFSET LAYOUT V21

     Why:
     V20 proved the white line came from BODY padding/header offset.
     But setting body padding-top to 64px can create a double reserve
     on wider desktop states: header + body reserved space.

     New model:
     - Body has no top padding on home.
     - The home root owns the fixed-header offset with padding-top.
     - Header covers that root padding because it is fixed above it.
     - Hero starts exactly below the header, with no extra blank band.
     ========================================================= */

  @media (min-width: 900px) {
    html:has(.mainmenu-root.has-full-content),
    body:has(.mainmenu-root.has-full-content) {
      padding-top: 0 !important;
      margin-top: 0 !important;
      background: #fff8ee !important;
      overflow-x: hidden !important;
    }

    body:has(.mainmenu-root.has-full-content) .mainmenu-root.has-full-content {
      margin-top: 0 !important;
      padding-top: 64px !important;
      border-top: 0 !important;
      position: relative !important;
      background: #fff8ee !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-pro-main,
    body:has(.mainmenu-root.has-full-content) main.loop-pro-main {
      margin-top: 0 !important;
      padding-top: 0 !important;
      border-top: 0 !important;
      background: transparent !important;
    }

    body:has(.mainmenu-root.has-full-content) #app-main-header,
    body:has(.mainmenu-root.has-full-content) #app-main-header.loop-ref-header,
    body:has(.mainmenu-root.has-full-content) header#app-main-header,
    body:has(.mainmenu-root.has-full-content) .loop-ref-header {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      height: 64px !important;
      min-height: 64px !important;
      max-height: 64px !important;
      margin: 0 !important;
      border-bottom: 0 !important;
      box-shadow: none !important;
      outline: 0 !important;
      z-index: 2147483640 !important;
      overflow: visible !important;
    }

    body:has(.mainmenu-root.has-full-content) #app-main-header::before,
    body:has(.mainmenu-root.has-full-content) #app-main-header::after,
    body:has(.mainmenu-root.has-full-content) #app-main-header.loop-ref-header::before,
    body:has(.mainmenu-root.has-full-content) #app-main-header.loop-ref-header::after,
    body:has(.mainmenu-root.has-full-content) header#app-main-header::before,
    body:has(.mainmenu-root.has-full-content) header#app-main-header::after,
    body:has(.mainmenu-root.has-full-content) .loop-ref-header::before,
    body:has(.mainmenu-root.has-full-content) .loop-ref-header::after {
      content: none !important;
      display: none !important;
      height: 0 !important;
      opacity: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      border: 0 !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-hero,
    body:has(.mainmenu-root.has-full-content) main.loop-pro-main > .loop-p6-hero,
    body:has(.mainmenu-root.has-full-content) .loop-pro-main > .loop-p6-hero {
      margin-top: 0 !important;
      top: 0 !important;
      width: 100% !important;
      max-width: none !important;
      border-radius: 0 !important;
      border-top: 0 !important;
      border-bottom: 0 !important;
      box-shadow: none !important;
      outline: 0 !important;
      transform: none !important;
      overflow: hidden !important;
      background-position: center top !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-hero::before,
    body:has(.mainmenu-root.has-full-content) .loop-p6-hero:before {
      inset: 0 !important;
      top: 0 !important;
      border-radius: 0 !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-hero-overlay {
      margin-top: 0 !important;
      padding-top: 0 !important;
      border-top: 0 !important;
      border-radius: 0 !important;
    }
  }

  /* Keep mobile on the existing header behavior. */
  @media (max-width: 899px) {
    body:has(.mainmenu-root.has-full-content) .mainmenu-root.has-full-content {
      padding-top: 0 !important;
    }
  }
`;




const phaseHomeWebHeroCroppedV22 = `
  /* =========================================================
     LOOP HOME — WEB HERO CROPPED V22

     Goal:
     Shorten the desktop/web hero vertically from the top and bottom,
     using the red guide lines as reference.

     Important:
     - Mobile stays untouched.
     - Keeps the V18/V21 stability.
     - Keeps hero full-width, no bubble, no seam.
     - Crops the image by reducing fixed hero height on web.
     ========================================================= */

  /* Compact web/tablet keeps the stable one-column rail, but slightly tighter. */
  @media (min-width: 900px) and (max-width: 1279px) {
    body:has(.mainmenu-root.has-full-content) .loop-p6-hero,
    body:has(.mainmenu-root.has-full-content) main.loop-pro-main > .loop-p6-hero,
    body:has(.mainmenu-root.has-full-content) .loop-pro-main > .loop-p6-hero {
      min-height: auto !important;
      height: auto !important;
      max-height: none !important;
      margin-top: 0 !important;
      border-radius: 0 !important;
      border-top: 0 !important;
      border-bottom: 0 !important;
      background-position: center center !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-hero-overlay {
      padding-top: 0 !important;
      padding-bottom: 16px !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-mobile-benefit-rail {
      margin-top: 12px !important;
    }
  }

  /* Desktop: the actual crop. */
  @media (min-width: 1280px) {
    body:has(.mainmenu-root.has-full-content) .loop-p6-hero,
    body:has(.mainmenu-root.has-full-content) main.loop-pro-main > .loop-p6-hero,
    body:has(.mainmenu-root.has-full-content) .loop-pro-main > .loop-p6-hero {
      height: clamp(500px, 30.6vw, 585px) !important;
      min-height: clamp(500px, 30.6vw, 585px) !important;
      max-height: clamp(500px, 30.6vw, 585px) !important;
      margin-top: 0 !important;
      border-radius: 0 !important;
      border-top: 0 !important;
      border-bottom: 0 !important;
      box-shadow: none !important;
      overflow: hidden !important;
      background-position: center center !important;
      background-size: cover !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-hero::before,
    body:has(.mainmenu-root.has-full-content) .loop-p6-hero:before {
      inset: 0 !important;
      top: 0 !important;
      border-radius: 0 !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-hero-overlay {
      height: 100% !important;
      min-height: 100% !important;
      max-height: 100% !important;
      padding-top: clamp(18px, 2vw, 28px) !important;
      padding-bottom: clamp(18px, 2vw, 28px) !important;
      align-items: center !important;
      align-content: center !important;
      box-sizing: border-box !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-title {
      font-size: clamp(50px, 4.95vw, 82px) !important;
      line-height: 0.91 !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-offer-line {
      margin-top: 13px !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-hero-actions {
      margin-top: 17px !important;
    }

    body:has(.mainmenu-root.has-full-content) #loop-services-section {
      padding-top: 20px !important;
    }
  }

  /* Desktop compacto con card: shorter without clipping. */
  @media (min-width: 1280px) and (max-width: 1439px) {
    body:has(.mainmenu-root.has-full-content) .loop-p6-hero,
    body:has(.mainmenu-root.has-full-content) main.loop-pro-main > .loop-p6-hero,
    body:has(.mainmenu-root.has-full-content) .loop-pro-main > .loop-p6-hero {
      height: clamp(470px, 34.5vw, 520px) !important;
      min-height: clamp(470px, 34.5vw, 520px) !important;
      max-height: clamp(470px, 34.5vw, 520px) !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-hero-overlay {
      grid-template-columns: minmax(0, 1fr) minmax(350px, 405px) !important;
      gap: clamp(24px, 3vw, 44px) !important;
      padding-top: 14px !important;
      padding-bottom: 18px !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-benefit-card {
      max-width: 405px !important;
      padding: 21px !important;
      border-radius: 29px !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-benefits-list {
      grid-template-rows: repeat(3, 64px) !important;
      grid-auto-rows: 64px !important;
      gap: 8px !important;
      margin-top: 16px !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-benefit-row,
    body:has(.mainmenu-root.has-full-content) .loop-p6-benefit-row:nth-child(1),
    body:has(.mainmenu-root.has-full-content) .loop-p6-benefit-row:nth-child(2),
    body:has(.mainmenu-root.has-full-content) .loop-p6-benefit-row:nth-child(3),
    body:has(.mainmenu-root.has-full-content) .loop-p6-benefit-row:nth-child(4),
    body:has(.mainmenu-root.has-full-content) .loop-p6-benefit-row:nth-child(5),
    body:has(.mainmenu-root.has-full-content) .loop-p6-benefit-row:nth-child(6),
    body:has(.mainmenu-root.has-full-content) .loop-p6-benefit-row:first-child,
    body:has(.mainmenu-root.has-full-content) .loop-p6-benefit-row:last-child {
      height: 64px !important;
      min-height: 64px !important;
      max-height: 64px !important;
    }
  }

  /* Large web: closer to your red-line reference. */
  @media (min-width: 1440px) {
    body:has(.mainmenu-root.has-full-content) .loop-p6-hero,
    body:has(.mainmenu-root.has-full-content) main.loop-pro-main > .loop-p6-hero,
    body:has(.mainmenu-root.has-full-content) .loop-pro-main > .loop-p6-hero {
      height: clamp(535px, 30.4vw, 585px) !important;
      min-height: clamp(535px, 30.4vw, 585px) !important;
      max-height: clamp(535px, 30.4vw, 585px) !important;
    }

    body:has(.mainmenu-root.has-full-content) .loop-p6-hero-overlay {
      padding-top: clamp(20px, 2vw, 30px) !important;
      padding-bottom: clamp(20px, 2vw, 30px) !important;
    }
  }

  /* Very wide screens should not keep growing vertically. */
  @media (min-width: 1760px) {
    body:has(.mainmenu-root.has-full-content) .loop-p6-hero,
    body:has(.mainmenu-root.has-full-content) main.loop-pro-main > .loop-p6-hero,
    body:has(.mainmenu-root.has-full-content) .loop-pro-main > .loop-p6-hero {
      height: 585px !important;
      min-height: 585px !important;
      max-height: 585px !important;
    }
  }

  /* Mobile untouched. */
  @media (max-width: 899px) {
    body:has(.mainmenu-root.has-full-content) .loop-p6-hero {
      max-height: none !important;
    }
  }
`;




const phaseBusinessRailViewportParityV48 = `
  /* =========================================================
     LOOP MAIN MENU — BUSINESS RAIL VIEWPORT PARITY V48
     Goal:
     Chrome mobile and native app must render the same business-card rhythm.
     Root cause found:
     - Render path is already unified: <=899px uses RecommendedScroller/FavoritesScroller.
     - V43 then forced a large "one card per rail" size:
       --loop-mobile-business-card-w: min(322px, calc(100vw - 44px));
       --loop-mobile-business-card-h: 208px;
     - Native app visually works better with compact two-card rails.
     V48 overrides the card contract for BOTH web mobile and native app.
     ========================================================= */

  @media (max-width: 899px) {
    .loop-web-mobile-app-rail-v42,
    .loop-mobile-section-pad.loop-web-mobile-app-rail-v42,
    body.is-mobile-app .loop-web-mobile-app-rail-v42,
    body.is-mobile-app .loop-mobile-section-pad.loop-web-mobile-app-rail-v42 {
      --loop-mobile-business-card-w: clamp(158px, calc((100vw - 58px) / 2), 188px) !important;
      --loop-mobile-business-card-h: clamp(116px, 31vw, 138px) !important;
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 !important;
      margin: 0 !important;
      overflow: visible !important;
      box-sizing: border-box !important;
    }

    .loop-web-mobile-app-rail-v42 > *,
    .loop-web-mobile-app-rail-v42 [class*="scroller"],
    .loop-web-mobile-app-rail-v42 [class*="Scroller"],
    .loop-web-mobile-app-rail-v42 [class*="carousel"],
    .loop-web-mobile-app-rail-v42 [class*="Carousel"],
    .loop-web-mobile-app-rail-v42 [class*="rail"],
    .loop-web-mobile-app-rail-v42 [class*="Rail"],
    .loop-web-mobile-app-rail-v42 [class*="list"],
    .loop-web-mobile-app-rail-v42 [class*="List"],
    .loop-web-mobile-app-rail-v42 [style*="overflow-x"] {
      display: flex !important;
      flex-wrap: nowrap !important;
      align-items: stretch !important;
      gap: 12px !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 0 8px 0 !important;
      margin: 0 !important;
      scroll-snap-type: x proximity !important;
      scroll-padding-inline: 0 !important;
      -webkit-overflow-scrolling: touch !important;
      scrollbar-width: none !important;
      box-sizing: border-box !important;
    }

    .loop-web-mobile-app-rail-v42 > *::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="scroller"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="Scroller"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="carousel"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="Carousel"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="rail"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="Rail"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="list"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="List"]::-webkit-scrollbar {
      display: none !important;
    }

    .loop-web-mobile-app-rail-v42 > * > *,
    .loop-web-mobile-app-rail-v42 [class*="scroller"] > *,
    .loop-web-mobile-app-rail-v42 [class*="Scroller"] > *,
    .loop-web-mobile-app-rail-v42 [class*="carousel"] > *,
    .loop-web-mobile-app-rail-v42 [class*="Carousel"] > *,
    .loop-web-mobile-app-rail-v42 [class*="rail"] > *,
    .loop-web-mobile-app-rail-v42 [class*="Rail"] > *,
    .loop-web-mobile-app-rail-v42 [class*="list"] > *,
    .loop-web-mobile-app-rail-v42 [class*="List"] > * {
      flex: 0 0 var(--loop-mobile-business-card-w) !important;
      width: var(--loop-mobile-business-card-w) !important;
      min-width: var(--loop-mobile-business-card-w) !important;
      max-width: var(--loop-mobile-business-card-w) !important;
      scroll-snap-align: start !important;
      box-sizing: border-box !important;
    }

    .loop-web-mobile-app-rail-v42 article,
    .loop-web-mobile-app-rail-v42 a[class*="card"],
    .loop-web-mobile-app-rail-v42 a[class*="Card"],
    .loop-web-mobile-app-rail-v42 button[class*="card"],
    .loop-web-mobile-app-rail-v42 button[class*="Card"],
    .loop-web-mobile-app-rail-v42 [class*="business-card"],
    .loop-web-mobile-app-rail-v42 [class*="BusinessCard"],
    .loop-web-mobile-app-rail-v42 [class*="recommended-card"],
    .loop-web-mobile-app-rail-v42 [class*="RecommendedCard"],
    .loop-web-mobile-app-rail-v42 [class*="favorite-card"],
    .loop-web-mobile-app-rail-v42 [class*="FavoriteCard"] {
      width: var(--loop-mobile-business-card-w) !important;
      min-width: var(--loop-mobile-business-card-w) !important;
      max-width: var(--loop-mobile-business-card-w) !important;
      height: var(--loop-mobile-business-card-h) !important;
      min-height: var(--loop-mobile-business-card-h) !important;
      max-height: var(--loop-mobile-business-card-h) !important;
      border-radius: 18px !important;
      overflow: hidden !important;
      box-sizing: border-box !important;
      scroll-snap-align: start !important;
    }

    .loop-web-mobile-app-rail-v42 article img,
    .loop-web-mobile-app-rail-v42 a[class*="card"] img,
    .loop-web-mobile-app-rail-v42 a[class*="Card"] img,
    .loop-web-mobile-app-rail-v42 button[class*="card"] img,
    .loop-web-mobile-app-rail-v42 button[class*="Card"] img,
    .loop-web-mobile-app-rail-v42 [class*="business-card"] img,
    .loop-web-mobile-app-rail-v42 [class*="BusinessCard"] img,
    .loop-web-mobile-app-rail-v42 [class*="recommended-card"] img,
    .loop-web-mobile-app-rail-v42 [class*="RecommendedCard"] img,
    .loop-web-mobile-app-rail-v42 [class*="favorite-card"] img,
    .loop-web-mobile-app-rail-v42 [class*="FavoriteCard"] img {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      object-position: center !important;
      display: block !important;
    }

    .loop-web-mobile-app-rail-v42 article h3,
    .loop-web-mobile-app-rail-v42 article h4,
    .loop-web-mobile-app-rail-v42 article strong,
    .loop-web-mobile-app-rail-v42 [class*="business-card"] h3,
    .loop-web-mobile-app-rail-v42 [class*="business-card"] h4,
    .loop-web-mobile-app-rail-v42 [class*="business-card"] strong,
    .loop-web-mobile-app-rail-v42 [class*="recommended-card"] h3,
    .loop-web-mobile-app-rail-v42 [class*="recommended-card"] h4,
    .loop-web-mobile-app-rail-v42 [class*="recommended-card"] strong,
    .loop-web-mobile-app-rail-v42 [class*="favorite-card"] h3,
    .loop-web-mobile-app-rail-v42 [class*="favorite-card"] h4,
    .loop-web-mobile-app-rail-v42 [class*="favorite-card"] strong {
      font-size: clamp(13px, 3.7vw, 16px) !important;
      line-height: 1.04 !important;
      letter-spacing: -.045em !important;
    }

    .loop-web-mobile-app-rail-v42 article p,
    .loop-web-mobile-app-rail-v42 article span,
    .loop-web-mobile-app-rail-v42 [class*="business-card"] p,
    .loop-web-mobile-app-rail-v42 [class*="business-card"] span,
    .loop-web-mobile-app-rail-v42 [class*="recommended-card"] p,
    .loop-web-mobile-app-rail-v42 [class*="recommended-card"] span,
    .loop-web-mobile-app-rail-v42 [class*="favorite-card"] p,
    .loop-web-mobile-app-rail-v42 [class*="favorite-card"] span {
      font-size: clamp(10px, 2.8vw, 12px) !important;
      line-height: 1.15 !important;
    }
  }

  @media (max-width: 380px) {
    .loop-web-mobile-app-rail-v42,
    .loop-mobile-section-pad.loop-web-mobile-app-rail-v42 {
      --loop-mobile-business-card-w: clamp(150px, calc((100vw - 50px) / 2), 174px) !important;
      --loop-mobile-business-card-h: clamp(108px, 30vw, 126px) !important;
    }
  }
`;




const phaseBusinessRailViewportParityV49 = `
  /* =========================================================
     LOOP MAIN MENU — BUSINESS RAIL REAL PARITY V49
     Fixes V48 overreach:
     - V48/V43 sized generic children, so carousel arrow controls became giant pills.
     - V49 resets wrappers/buttons first, hides only rail navigation arrows,
       then sizes only real business cards that contain images.
     ========================================================= */

  @media (max-width: 899px) {
    .loop-web-mobile-app-rail-v42,
    .loop-mobile-section-pad.loop-web-mobile-app-rail-v42,
    body.is-mobile-app .loop-web-mobile-app-rail-v42,
    body.is-mobile-app .loop-mobile-section-pad.loop-web-mobile-app-rail-v42 {
      --loop-mobile-business-card-w: clamp(156px, calc((100vw - 56px) / 2), 184px) !important;
      --loop-mobile-business-card-h: clamp(116px, 31vw, 136px) !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      overflow: visible !important;
      padding: 0 !important;
      margin: 0 !important;
      box-sizing: border-box !important;
    }

    /* Reset V48/V43 generic child sizing. These children are often wrappers or arrow controls, not cards. */
    .loop-web-mobile-app-rail-v42 > *,
    .loop-web-mobile-app-rail-v42 > * > *,
    .loop-web-mobile-app-rail-v42 [class*="scroller"],
    .loop-web-mobile-app-rail-v42 [class*="Scroller"],
    .loop-web-mobile-app-rail-v42 [class*="carousel"],
    .loop-web-mobile-app-rail-v42 [class*="Carousel"],
    .loop-web-mobile-app-rail-v42 [class*="rail"],
    .loop-web-mobile-app-rail-v42 [class*="Rail"],
    .loop-web-mobile-app-rail-v42 [class*="list"],
    .loop-web-mobile-app-rail-v42 [class*="List"] {
      min-width: 0 !important;
      max-width: 100% !important;
      width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      box-sizing: border-box !important;
    }

    /* The actual horizontal viewport/track. */
    .loop-web-mobile-app-rail-v42 [class*="scroller"],
    .loop-web-mobile-app-rail-v42 [class*="Scroller"],
    .loop-web-mobile-app-rail-v42 [class*="carousel"],
    .loop-web-mobile-app-rail-v42 [class*="Carousel"],
    .loop-web-mobile-app-rail-v42 [class*="rail"],
    .loop-web-mobile-app-rail-v42 [class*="Rail"],
    .loop-web-mobile-app-rail-v42 [class*="list"],
    .loop-web-mobile-app-rail-v42 [class*="List"],
    .loop-web-mobile-app-rail-v42 [style*="overflow-x"] {
      display: flex !important;
      flex-wrap: nowrap !important;
      align-items: stretch !important;
      gap: 12px !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      padding: 0 0 8px 0 !important;
      margin: 0 !important;
      scroll-snap-type: x proximity !important;
      scroll-padding-inline: 0 !important;
      -webkit-overflow-scrolling: touch !important;
      scrollbar-width: none !important;
    }

    .loop-web-mobile-app-rail-v42 [class*="scroller"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="Scroller"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="carousel"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="Carousel"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="rail"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="Rail"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="list"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="List"]::-webkit-scrollbar {
      display: none !important;
    }

    /* Hide carousel arrow controls only. Do not hide favorite buttons inside cards. */
    .loop-web-mobile-app-rail-v42 > button:not(:has(img)),
    .loop-web-mobile-app-rail-v42 > * > button:not(:has(img)),
    .loop-web-mobile-app-rail-v42 button[aria-label*="siguiente" i],
    .loop-web-mobile-app-rail-v42 button[aria-label*="anterior" i],
    .loop-web-mobile-app-rail-v42 button[aria-label*="next" i],
    .loop-web-mobile-app-rail-v42 button[aria-label*="prev" i],
    .loop-web-mobile-app-rail-v42 button[class*="arrow" i],
    .loop-web-mobile-app-rail-v42 button[class*="chevron" i],
    .loop-web-mobile-app-rail-v42 button[class*="carousel-control" i],
    .loop-web-mobile-app-rail-v42 button[class*="nav" i] {
      display: none !important;
      visibility: hidden !important;
      pointer-events: none !important;
      width: 0 !important;
      min-width: 0 !important;
      height: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
    }

    /* Size only real business cards. A real card has an image. */
    .loop-web-mobile-app-rail-v42 article:has(img),
    .loop-web-mobile-app-rail-v42 a:has(img),
    .loop-web-mobile-app-rail-v42 button:has(img),
    .loop-web-mobile-app-rail-v42 [class*="business-card" i]:has(img),
    .loop-web-mobile-app-rail-v42 [class*="recommended" i]:has(img),
    .loop-web-mobile-app-rail-v42 [class*="favorite" i]:has(img) {
      flex: 0 0 var(--loop-mobile-business-card-w) !important;
      width: var(--loop-mobile-business-card-w) !important;
      min-width: var(--loop-mobile-business-card-w) !important;
      max-width: var(--loop-mobile-business-card-w) !important;
      height: var(--loop-mobile-business-card-h) !important;
      min-height: var(--loop-mobile-business-card-h) !important;
      max-height: var(--loop-mobile-business-card-h) !important;
      border-radius: 18px !important;
      overflow: hidden !important;
      scroll-snap-align: start !important;
      box-sizing: border-box !important;
      position: relative !important;
    }

    .loop-web-mobile-app-rail-v42 article:has(img) img,
    .loop-web-mobile-app-rail-v42 a:has(img) img,
    .loop-web-mobile-app-rail-v42 button:has(img) img,
    .loop-web-mobile-app-rail-v42 [class*="business-card" i]:has(img) img,
    .loop-web-mobile-app-rail-v42 [class*="recommended" i]:has(img) img,
    .loop-web-mobile-app-rail-v42 [class*="favorite" i]:has(img) img {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      object-position: center !important;
      display: block !important;
    }

    .loop-web-mobile-app-rail-v42 article:has(img) h3,
    .loop-web-mobile-app-rail-v42 article:has(img) h4,
    .loop-web-mobile-app-rail-v42 article:has(img) strong,
    .loop-web-mobile-app-rail-v42 a:has(img) h3,
    .loop-web-mobile-app-rail-v42 a:has(img) h4,
    .loop-web-mobile-app-rail-v42 a:has(img) strong,
    .loop-web-mobile-app-rail-v42 button:has(img) h3,
    .loop-web-mobile-app-rail-v42 button:has(img) h4,
    .loop-web-mobile-app-rail-v42 button:has(img) strong {
      font-size: clamp(13px, 3.7vw, 16px) !important;
      line-height: 1.04 !important;
      letter-spacing: -.045em !important;
      max-width: 100% !important;
    }

    .loop-web-mobile-app-rail-v42 article:has(img) p,
    .loop-web-mobile-app-rail-v42 article:has(img) span,
    .loop-web-mobile-app-rail-v42 a:has(img) p,
    .loop-web-mobile-app-rail-v42 a:has(img) span,
    .loop-web-mobile-app-rail-v42 button:has(img) p,
    .loop-web-mobile-app-rail-v42 button:has(img) span {
      font-size: clamp(10px, 2.8vw, 12px) !important;
      line-height: 1.12 !important;
    }
  }

  @media (max-width: 380px) {
    .loop-web-mobile-app-rail-v42,
    .loop-mobile-section-pad.loop-web-mobile-app-rail-v42 {
      --loop-mobile-business-card-w: clamp(148px, calc((100vw - 50px) / 2), 174px) !important;
      --loop-mobile-business-card-h: clamp(108px, 30vw, 126px) !important;
    }
  }
`;




const phaseBusinessRailTrueTrackV50 = `
  /* =========================================================
     LOOP MAIN MENU — TRUE MOBILE BUSINESS TRACK V50
     Console confirmed:
     - 6 .loop-discover-card articles exist.
     - Cards are 184x136 and positioned at 28,224,420...
     - BUT rail.scrollWidth stays 488, so the carousel wrapper is not
       exposing a real horizontal scroll track.
     This turns the card parent into the actual scroll container and
     prevents carousel arrows/masks from covering the rail.
     ========================================================= */

  @media (max-width: 899px) {
    .loop-web-mobile-app-rail-v42,
    body.is-mobile-app .loop-web-mobile-app-rail-v42 {
      --loop-mobile-business-card-w: clamp(156px, calc((100vw - 56px) / 2), 184px) !important;
      --loop-mobile-business-card-h: clamp(116px, 31vw, 136px) !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      overflow: visible !important;
      padding: 0 !important;
      margin: 0 !important;
      box-sizing: border-box !important;
    }

    .loop-web-mobile-app-rail-v42 .loop-carousel-shell,
    .loop-web-mobile-app-rail-v42 [class*="carousel-shell" i],
    .loop-web-mobile-app-rail-v42 [class*="CarouselShell"] {
      --loop-carousel-edge: 0px !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      overflow: visible !important;
      padding: 0 !important;
      margin: 0 !important;
      position: relative !important;
      box-sizing: border-box !important;
    }

    .loop-web-mobile-app-rail-v42 .loop-carousel-shell::before,
    .loop-web-mobile-app-rail-v42 .loop-carousel-shell::after,
    .loop-web-mobile-app-rail-v42 [class*="carousel-shell" i]::before,
    .loop-web-mobile-app-rail-v42 [class*="carousel-shell" i]::after {
      content: none !important;
      display: none !important;
      opacity: 0 !important;
      visibility: hidden !important;
    }

    /* Hide only external carousel navigation. Card heart/favorite buttons are restored below. */
    .loop-web-mobile-app-rail-v42 .loop-carousel-arrow,
    .loop-web-mobile-app-rail-v42 .loop-carousel-control,
    .loop-web-mobile-app-rail-v42 .loop-carousel-nav,
    .loop-web-mobile-app-rail-v42 [class*="carousel-arrow" i],
    .loop-web-mobile-app-rail-v42 [class*="carousel-control" i],
    .loop-web-mobile-app-rail-v42 [class*="carousel-nav" i],
    .loop-web-mobile-app-rail-v42 [class*="rail-arrow" i],
    .loop-web-mobile-app-rail-v42 [class*="rail-nav" i],
    .loop-web-mobile-app-rail-v42 > button:not(:has(img)),
    .loop-web-mobile-app-rail-v42 .loop-carousel-shell > button:not(:has(img)) {
      display: none !important;
      visibility: hidden !important;
      pointer-events: none !important;
      width: 0 !important;
      min-width: 0 !important;
      height: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
    }

    /* The exact real track: any parent whose direct children are business cards. */
    .loop-web-mobile-app-rail-v42 :is(div, section, ul, nav):has(> article.loop-discover-card),
    .loop-web-mobile-app-rail-v42 :is(div, section, ul, nav):has(> .loop-discover-card),
    .loop-web-mobile-app-rail-v42 .loop-carousel-track,
    .loop-web-mobile-app-rail-v42 [class*="carousel-track" i],
    .loop-web-mobile-app-rail-v42 [class*="CarouselTrack"],
    .loop-web-mobile-app-rail-v42 [class*="discover-track" i],
    .loop-web-mobile-app-rail-v42 [class*="business-track" i],
    .loop-web-mobile-app-rail-v42 [class*="recommended-track" i],
    .loop-web-mobile-app-rail-v42 [class*="favorites-track" i] {
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      align-items: stretch !important;
      justify-content: flex-start !important;
      gap: 12px !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      padding: 0 0 8px 0 !important;
      margin: 0 !important;
      scroll-snap-type: x proximity !important;
      scroll-padding-inline: 0 !important;
      -webkit-overflow-scrolling: touch !important;
      scrollbar-width: none !important;
      transform: none !important;
      box-sizing: border-box !important;
    }

    .loop-web-mobile-app-rail-v42 :is(div, section, ul, nav):has(> article.loop-discover-card)::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 :is(div, section, ul, nav):has(> .loop-discover-card)::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 .loop-carousel-track::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="carousel-track" i]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="discover-track" i]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="business-track" i]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="recommended-track" i]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="favorites-track" i]::-webkit-scrollbar {
      display: none !important;
    }

    /* Real cards only. */
    .loop-web-mobile-app-rail-v42 article.loop-discover-card,
    .loop-web-mobile-app-rail-v42 .loop-discover-card {
      flex: 0 0 var(--loop-mobile-business-card-w) !important;
      width: var(--loop-mobile-business-card-w) !important;
      min-width: var(--loop-mobile-business-card-w) !important;
      max-width: var(--loop-mobile-business-card-w) !important;
      height: var(--loop-mobile-business-card-h) !important;
      min-height: var(--loop-mobile-business-card-h) !important;
      max-height: var(--loop-mobile-business-card-h) !important;
      border-radius: 18px !important;
      overflow: hidden !important;
      position: relative !important;
      inset: auto !important;
      left: auto !important;
      right: auto !important;
      top: auto !important;
      bottom: auto !important;
      transform: none !important;
      opacity: 1 !important;
      visibility: visible !important;
      scroll-snap-align: start !important;
      box-sizing: border-box !important;
    }

    .loop-web-mobile-app-rail-v42 .loop-discover-card img,
    .loop-web-mobile-app-rail-v42 article.loop-discover-card img,
    .loop-web-mobile-app-rail-v42 .loop-card-bg,
    .loop-web-mobile-app-rail-v42 [class*="card-bg" i] {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      object-position: center !important;
      background-size: cover !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
    }

    /* Restore internal card buttons, especially favorite/heart. */
    .loop-web-mobile-app-rail-v42 article.loop-discover-card button,
    .loop-web-mobile-app-rail-v42 .loop-discover-card button {
      display: inline-flex !important;
      visibility: visible !important;
      pointer-events: auto !important;
      width: auto !important;
      min-width: 0 !important;
      height: auto !important;
      min-height: 0 !important;
      opacity: 1 !important;
    }

    .loop-web-mobile-app-rail-v42 .loop-discover-card h3,
    .loop-web-mobile-app-rail-v42 .loop-discover-card h4,
    .loop-web-mobile-app-rail-v42 .loop-discover-card strong {
      font-size: clamp(13px, 3.7vw, 16px) !important;
      line-height: 1.04 !important;
      letter-spacing: -.045em !important;
      max-width: 100% !important;
    }

    .loop-web-mobile-app-rail-v42 .loop-discover-card p,
    .loop-web-mobile-app-rail-v42 .loop-discover-card span {
      font-size: clamp(10px, 2.8vw, 12px) !important;
      line-height: 1.12 !important;
    }
  }

  @media (max-width: 380px) {
    .loop-web-mobile-app-rail-v42,
    body.is-mobile-app .loop-web-mobile-app-rail-v42 {
      --loop-mobile-business-card-w: clamp(148px, calc((100vw - 50px) / 2), 174px) !important;
      --loop-mobile-business-card-h: clamp(108px, 30vw, 126px) !important;
    }
  }
`;




const phaseBusinessRailShellWidthFixV51 = `
  /* =========================================================
     LOOP MAIN MENU — CAROUSEL SHELL WIDTH FIX V51
     Console diagnosis after V50:
     - .loop-carousel-rail is the correct track and has scrollWidth 1164.
     - BUT .loop-carousel-shell is only 184px wide.
     - That shell is being treated like a card by older broad mobile rules.
     Fix:
     - Make the section and shell full-width.
     - Keep only .loop-carousel-rail as the horizontal scroll container.
     - Keep cards compact at 184x136.
     ========================================================= */

  @media (max-width: 899px) {
    .loop-web-mobile-app-rail-v42 > section,
    .loop-web-mobile-app-rail-v42 section:has(.loop-carousel-shell),
    body.is-mobile-app .loop-web-mobile-app-rail-v42 > section,
    body.is-mobile-app .loop-web-mobile-app-rail-v42 section:has(.loop-carousel-shell) {
      display: block !important;
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      overflow: visible !important;
      padding: 0 !important;
      margin: 0 !important;
      flex: 0 0 100% !important;
      transform: none !important;
      box-sizing: border-box !important;
    }

    .loop-web-mobile-app-rail-v42 .loop-carousel-shell,
    body.is-mobile-app .loop-web-mobile-app-rail-v42 .loop-carousel-shell {
      display: block !important;
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      overflow: visible !important;
      padding: 0 !important;
      margin: 0 !important;
      flex: 0 0 100% !important;
      transform: none !important;
      box-sizing: border-box !important;
    }

    .loop-web-mobile-app-rail-v42 .loop-carousel-rail,
    body.is-mobile-app .loop-web-mobile-app-rail-v42 .loop-carousel-rail {
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      align-items: stretch !important;
      justify-content: flex-start !important;
      gap: 12px !important;
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      padding: 0 0 8px 0 !important;
      margin: 0 !important;
      scroll-snap-type: x proximity !important;
      scroll-padding-inline: 0 !important;
      -webkit-overflow-scrolling: touch !important;
      scrollbar-width: none !important;
      transform: none !important;
      box-sizing: border-box !important;
    }

    .loop-web-mobile-app-rail-v42 .loop-carousel-rail::-webkit-scrollbar,
    body.is-mobile-app .loop-web-mobile-app-rail-v42 .loop-carousel-rail::-webkit-scrollbar {
      display: none !important;
    }

    .loop-web-mobile-app-rail-v42 .loop-carousel-rail > .loop-discover-card,
    .loop-web-mobile-app-rail-v42 .loop-carousel-rail > article.loop-discover-card,
    body.is-mobile-app .loop-web-mobile-app-rail-v42 .loop-carousel-rail > .loop-discover-card,
    body.is-mobile-app .loop-web-mobile-app-rail-v42 .loop-carousel-rail > article.loop-discover-card {
      flex: 0 0 var(--loop-mobile-business-card-w, 184px) !important;
      width: var(--loop-mobile-business-card-w, 184px) !important;
      min-width: var(--loop-mobile-business-card-w, 184px) !important;
      max-width: var(--loop-mobile-business-card-w, 184px) !important;
      height: var(--loop-mobile-business-card-h, 136px) !important;
      min-height: var(--loop-mobile-business-card-h, 136px) !important;
      max-height: var(--loop-mobile-business-card-h, 136px) !important;
      position: relative !important;
      inset: auto !important;
      transform: none !important;
      opacity: 1 !important;
      visibility: visible !important;
      scroll-snap-align: start !important;
      box-sizing: border-box !important;
    }

    /* External carousel controls stay hidden; card favorite button stays visible. */
    .loop-web-mobile-app-rail-v42 .loop-carousel-shell > button:not(.loop-favorite-btn):not(:has(img)),
    .loop-web-mobile-app-rail-v42 .loop-carousel-shell > .loop-carousel-arrow,
    .loop-web-mobile-app-rail-v42 .loop-carousel-shell > [class*="arrow" i],
    .loop-web-mobile-app-rail-v42 .loop-carousel-shell > [class*="control" i],
    body.is-mobile-app .loop-web-mobile-app-rail-v42 .loop-carousel-shell > button:not(.loop-favorite-btn):not(:has(img)),
    body.is-mobile-app .loop-web-mobile-app-rail-v42 .loop-carousel-shell > .loop-carousel-arrow,
    body.is-mobile-app .loop-web-mobile-app-rail-v42 .loop-carousel-shell > [class*="arrow" i],
    body.is-mobile-app .loop-web-mobile-app-rail-v42 .loop-carousel-shell > [class*="control" i] {
      display: none !important;
      visibility: hidden !important;
      pointer-events: none !important;
      width: 0 !important;
      min-width: 0 !important;
      height: 0 !important;
      min-height: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      overflow: hidden !important;
    }
  }
`;


const phaseNativeTabletHeroParityV52 = `
  /* =========================================================
     LOOP MAIN MENU — NATIVE TABLET HERO PARITY V52

     Root cause:
     Android/iPad native tablets can report a CSS viewport >= 900px
     or even desktop-like widths inside Capacitor/WebView. The previous
     native hero safety layer only applied at <=899px, so tablets could
     fall into the desktop hero: oversized title + right access card +
     mobile benefit rail competing in the same fold.

     Native app only. Web stays untouched.
     ========================================================= */

  @media (min-width: 900px) and (max-width: 1368px),
         (pointer: coarse) and (min-width: 900px) and (max-width: 1600px) {
    body.is-mobile-app .mainmenu-root.has-full-content,
    body.is-mobile-app .loop-pro-shell,
    body.is-mobile-app .loop-pro-main {
      overflow-x: hidden !important;
      background: #fff5e8 !important;
    }

    body.is-mobile-app .mainmenu-root.has-full-content {
      padding-top: var(--loop-native-header-h, 94px) !important;
      margin-top: 0 !important;
    }

    body.is-mobile-app .mainmenu-root.has-full-content > main.loop-pro-main,
    body.is-mobile-app .mainmenu-root.has-full-content .loop-pro-main,
    body.is-mobile-app main.loop-pro-main,
    body.is-mobile-app .loop-pro-main {
      padding-top: 0 !important;
      margin-top: 0 !important;
    }

    body.is-mobile-app .loop-p6-hero,
    body.is-mobile-app .mainmenu-root.has-full-content .loop-p6-hero,
    body.is-mobile-app main.loop-pro-main > .loop-p6-hero,
    body.is-mobile-app .loop-pro-main > .loop-p6-hero {
      width: 100% !important;
      max-width: none !important;
      min-height: auto !important;
      height: auto !important;
      max-height: none !important;
      margin: 0 !important;
      border-radius: 0 !important;
      border-top: 0 !important;
      border-bottom: 0 !important;
      box-shadow: none !important;
      overflow: hidden !important;
      background-position: center top !important;
      background-size: cover !important;
      transform: none !important;
      translate: none !important;
    }

    body.is-mobile-app .loop-p6-hero::before,
    body.is-mobile-app .loop-p6-hero:before {
      inset: 0 !important;
      top: 0 !important;
      border-radius: 0 !important;
      transform: none !important;
      translate: none !important;
    }

    body.is-mobile-app .loop-p6-hero-overlay,
    body.is-mobile-app .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      display: block !important;
      width: min(100%, 1000px) !important;
      max-width: 1000px !important;
      min-height: 0 !important;
      height: auto !important;
      max-height: none !important;
      margin: 0 auto !important;
      padding: 22px clamp(28px, 5vw, 54px) 24px !important;
      box-sizing: border-box !important;
      transform: none !important;
      translate: none !important;
      overflow: visible !important;
    }

    body.is-mobile-app .loop-p6-hero-copy {
      width: 100% !important;
      max-width: 840px !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    body.is-mobile-app .loop-p6-title {
      margin: 0 !important;
      max-width: 840px !important;
      color: #fff8ee !important;
      font-size: clamp(48px, 6.2vw, 70px) !important;
      line-height: 0.91 !important;
      letter-spacing: -0.078em !important;
      text-shadow: 0 4px 18px rgba(0,0,0,.28) !important;
      transform: none !important;
      translate: none !important;
    }

    body.is-mobile-app .loop-p6-offer-line {
      margin-top: 12px !important;
      max-width: 620px !important;
      color: rgba(255,248,238,.95) !important;
      font-size: clamp(13.5px, 1.55vw, 16px) !important;
      line-height: 1.34 !important;
      font-weight: 780 !important;
      text-shadow: 0 3px 14px rgba(0,0,0,.22) !important;
    }

    body.is-mobile-app .loop-p6-hero-actions {
      margin-top: 18px !important;
      display: flex !important;
      align-items: flex-end !important;
      gap: 16px !important;
      flex-wrap: wrap !important;
      max-width: 820px !important;
    }

    body.is-mobile-app .loop-p6-primary,
    body.is-mobile-app .loop-p6-main-create {
      width: min(100%, 320px) !important;
      min-height: 52px !important;
      max-height: 52px !important;
      padding: 0 18px 0 24px !important;
      border-radius: 999px !important;
      font-size: 14.5px !important;
      margin: 0 !important;
    }

    body.is-mobile-app .loop-p6-platform-block {
      margin-top: 0 !important;
      max-width: 360px !important;
    }

    body.is-mobile-app .loop-p6-platform-copy {
      color: rgba(255,248,238,.92) !important;
      font-size: 11.5px !important;
      font-weight: 900 !important;
      text-shadow: 0 2px 10px rgba(0,0,0,.22) !important;
    }

    body.is-mobile-app .loop-p6-store-row-left,
    body.is-mobile-app .loop-p6-store-row {
      display: flex !important;
      grid-template-columns: none !important;
      flex-wrap: nowrap !important;
      gap: 9px !important;
      margin-top: 7px !important;
      align-items: center !important;
    }

    body.is-mobile-app .loop-p6-store-btn {
      min-height: 38px !important;
      border-radius: 999px !important;
      padding: 0 12px !important;
      font-size: 11.5px !important;
      gap: 6px !important;
    }

    body.is-mobile-app .loop-p6-store-badge-img {
      height: 26px !important;
      max-width: 118px !important;
      object-fit: contain !important;
    }

    /* In native tablets, avoid the desktop founder/access card competing
       with the compact benefit rail. This matches the web tablet rhythm. */
    body.is-mobile-app .loop-p6-benefit-card,
    body.is-mobile-app .loop-p6-cta-card.loop-p6-benefit-card {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      height: 0 !important;
      min-height: 0 !important;
      max-height: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      overflow: hidden !important;
      pointer-events: none !important;
    }

    body.is-mobile-app .loop-p6-mobile-benefit-rail {
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      width: 100% !important;
      max-width: 840px !important;
      margin: 16px 0 0 !important;
      padding: 12px !important;
      border-radius: 22px !important;
      background:
        radial-gradient(circle at 10% 0%, rgba(255,255,255,0.62), transparent 34%),
        linear-gradient(180deg, rgba(255, 248, 238, 0.95), rgba(246, 239, 226, 0.88)) !important;
      border: 1px solid rgba(255, 248, 238, 0.64) !important;
      box-shadow: 0 16px 34px rgba(0, 0, 0, 0.14) !important;
      color: #073f37 !important;
      text-shadow: none !important;
      backdrop-filter: blur(14px) saturate(1.05) !important;
      -webkit-backdrop-filter: blur(14px) saturate(1.05) !important;
      transform: none !important;
      translate: none !important;
    }

    body.is-mobile-app .loop-p6-mobile-benefit-stack {
      display: grid !important;
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
      gap: 8px !important;
      margin-top: 10px !important;
    }

    body.is-mobile-app .loop-p6-mobile-benefit-card,
    body.is-mobile-app .loop-p6-mobile-benefit-card-whatsapp {
      min-height: 54px !important;
      display: grid !important;
      grid-template-columns: 30px minmax(0, 1fr) !important;
      align-items: center !important;
      gap: 8px !important;
      padding: 8px 10px !important;
      border-radius: 15px !important;
    }

    body.is-mobile-app .loop-p6-mobile-benefit-card strong {
      font-size: 11.5px !important;
      line-height: 1.08 !important;
    }

    body.is-mobile-app .loop-p6-mobile-benefit-card em {
      font-size: 9.8px !important;
      line-height: 1.14 !important;
    }

    body.is-mobile-app #loop-services-section {
      padding-top: 22px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1060px),
         (pointer: coarse) and (min-width: 900px) and (max-width: 1060px) {
    body.is-mobile-app .loop-p6-hero-overlay,
    body.is-mobile-app .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      padding-left: 30px !important;
      padding-right: 30px !important;
    }

    body.is-mobile-app .loop-p6-title {
      font-size: clamp(46px, 7.1vw, 64px) !important;
    }

    body.is-mobile-app .loop-p6-mobile-benefit-stack {
      grid-template-columns: 1fr !important;
    }

    body.is-mobile-app .loop-p6-mobile-benefit-card,
    body.is-mobile-app .loop-p6-mobile-benefit-card-whatsapp {
      min-height: 50px !important;
    }
  }
`;

const phaseMainMenuHeroPlatformContractV69 = `
  /* =========================================================
     LOOP MAIN MENU — HERO PLATFORM CONTRACT V69
     Goals:
     1) Native Android/iOS app: no App Store / Google Play prompt.
     2) Native tablets: title never clips under the header.
     3) Web responsive: remove the gray/blank hero seam under header.
     ========================================================= */

  /* Runtime app contract: installed app already exists, so hide store acquisition UI. */
  body.is-mobile-app .loop-p6-platform-block,
  html.is-mobile-app .loop-p6-platform-block,
  body.is-mobile-app .loop-p6-platform-copy,
  html.is-mobile-app .loop-p6-platform-copy,
  body.is-mobile-app .loop-p6-store-row,
  html.is-mobile-app .loop-p6-store-row,
  body.is-mobile-app .loop-p6-store-btn,
  html.is-mobile-app .loop-p6-store-btn,
  body.is-mobile-app .loop-web-hero-carousel.loop-web-hero-final::before,
  html.is-mobile-app .loop-web-hero-carousel.loop-web-hero-final::before {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    width: 0 !important;
    height: 0 !important;
    min-width: 0 !important;
    min-height: 0 !important;
    max-width: 0 !important;
    max-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
    pointer-events: none !important;
    content: none !important;
  }

  body.is-mobile-app .loop-p6-hero-actions,
  html.is-mobile-app .loop-p6-hero-actions {
    display: flex !important;
    align-items: center !important;
    gap: 0 !important;
    margin-top: 16px !important;
  }

  /* Web/mobile browser still shows the store badges correctly. */
  body:not(.is-mobile-app) .loop-p6-platform-block {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  body:not(.is-mobile-app) .loop-p6-store-row,
  body:not(.is-mobile-app) .loop-p6-store-row-left {
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
    flex-wrap: wrap !important;
  }

  body:not(.is-mobile-app) .loop-p6-store-btn {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  /* Universal seam lock under the fixed header. */
  .mainmenu-root.has-full-content,
  .mainmenu-root.has-full-content .loop-pro-main,
  .mainmenu-root.has-full-content > main.loop-pro-main,
  main.loop-pro-main {
    margin-top: 0 !important;
    padding-top: 0 !important;
    border-top: 0 !important;
  }

  .mainmenu-root.has-full-content .loop-p6-hero,
  .loop-pro-main > .loop-p6-hero,
  main.loop-pro-main > .loop-p6-hero {
    margin-top: -1px !important;
    border-top: 0 !important;
    background-position: center top !important;
    overflow: hidden !important;
  }

  /* Web responsive/tablet: avoid the gray strip without clipping the title. */
  @media (min-width: 900px) and (max-width: 1280px) {
    body:not(.is-mobile-app) .mainmenu-root.has-full-content .loop-p6-hero-overlay,
    body:not(.is-mobile-app) .loop-pro-main > .loop-p6-hero .loop-p6-hero-overlay {
      padding-top: clamp(10px, 1.35vw, 18px) !important;
      align-items: start !important;
      align-content: start !important;
    }

    body:not(.is-mobile-app) .loop-p6-title {
      margin-top: 0 !important;
      line-height: 0.93 !important;
      overflow: visible !important;
    }
  }

  /* Native tablet: enough top breathing room + less aggressive line-height. */
  @media (min-width: 768px) and (max-width: 1368px),
         (pointer: coarse) and (min-width: 768px) and (max-width: 1600px) {
    body.is-mobile-app .mainmenu-root.has-full-content {
      padding-top: var(--loop-native-header-h, var(--loop-mobile-header-total, 94px)) !important;
      margin-top: 0 !important;
      overflow-x: hidden !important;
      background: #fff5e8 !important;
    }

    body.is-mobile-app .loop-p6-hero,
    html.is-mobile-app .loop-p6-hero {
      margin-top: 0 !important;
      overflow: hidden !important;
      background-position: center top !important;
    }

    body.is-mobile-app .loop-p6-hero-overlay,
    html.is-mobile-app .loop-p6-hero-overlay {
      padding-top: clamp(30px, 4.2vw, 48px) !important;
      padding-bottom: clamp(24px, 3.4vw, 38px) !important;
      overflow: visible !important;
      align-items: start !important;
      align-content: start !important;
    }

    body.is-mobile-app .loop-p6-title,
    html.is-mobile-app .loop-p6-title {
      margin-top: 0 !important;
      padding-top: 2px !important;
      font-size: clamp(48px, 6vw, 72px) !important;
      line-height: 0.96 !important;
      letter-spacing: -0.074em !important;
      overflow: visible !important;
      text-wrap: balance !important;
    }
  }

  /* Native phone: hero remains compact and store labels stay hidden. */
  @media (max-width: 767px) {
    body.is-mobile-app .loop-p6-hero-overlay,
    html.is-mobile-app .loop-p6-hero-overlay {
      padding-top: 28px !important;
      padding-bottom: 20px !important;
    }

    body.is-mobile-app .loop-p6-title,
    html.is-mobile-app .loop-p6-title {
      line-height: 0.95 !important;
      padding-top: 1px !important;
    }
  }
`;


const phaseHomeHeroPremiumBalanceV73 = `
  /* =========================================================
     LOOP HOME — PREMIUM BALANCE V73
     Goals:
     1) Prevent the right founder/benefits card from clipping on desktop/tablet.
     2) Make the hero headline slightly smaller and less heavy for a more premium feel.
     3) Keep mobile/native behavior safe.
     ========================================================= */

  @media (min-width: 900px) {
    body:not(.is-mobile-app) .mainmenu-root.has-full-content .loop-p6-hero-overlay,
    body:not(.is-mobile-app) .loop-pro-main > .loop-p6-hero .loop-p6-hero-overlay {
      padding-left: clamp(28px, 4vw, 56px) !important;
      padding-right: clamp(28px, 4vw, 56px) !important;
      overflow: visible !important;
    }

    body:not(.is-mobile-app) .loop-p6-hero-copy {
      width: 100% !important;
      max-width: 1380px !important;
      margin: 0 auto !important;
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) minmax(360px, 520px) !important;
      align-items: center !important;
      column-gap: clamp(28px, 4vw, 56px) !important;
      row-gap: 18px !important;
    }

    body:not(.is-mobile-app) .loop-p6-title {
      max-width: 700px !important;
      margin-top: 8px !important;
      font-size: clamp(46px, 4.45vw, 68px) !important;
      line-height: 0.96 !important;
      letter-spacing: -0.064em !important;
      font-weight: 880 !important;
      text-shadow: 0 3px 14px rgba(0,0,0,.16) !important;
      text-wrap: balance !important;
    }

    body:not(.is-mobile-app) .loop-p6-offer-line {
      max-width: 560px !important;
      margin-top: 16px !important;
      font-size: clamp(14.5px, 1.04vw, 16px) !important;
      line-height: 1.48 !important;
      font-weight: 720 !important;
    }

    body:not(.is-mobile-app) .loop-p6-benefit-card,
    body:not(.is-mobile-app) .loop-p6-cta-card.loop-p6-benefit-card {
      width: 100% !important;
      max-width: 520px !important;
      min-width: 0 !important;
      justify-self: end !important;
      padding: 28px 26px 24px !important;
      border-radius: 34px !important;
      overflow: hidden !important;
      box-sizing: border-box !important;
    }

    body:not(.is-mobile-app) .loop-p6-benefit-head {
      padding-bottom: 18px !important;
    }

    body:not(.is-mobile-app) .loop-p6-benefit-head-copy strong,
    body:not(.is-mobile-app) .loop-p6-benefit-head strong {
      font-size: clamp(28px, 2.35vw, 38px) !important;
      line-height: 0.99 !important;
      letter-spacing: -0.05em !important;
      white-space: normal !important;
      text-wrap: balance !important;
    }

    body:not(.is-mobile-app) .loop-p6-benefit-head-copy em,
    body:not(.is-mobile-app) .loop-p6-benefit-head-copy em b {
      font-size: 13px !important;
      line-height: 1.28 !important;
      letter-spacing: -0.01em !important;
    }

    body:not(.is-mobile-app) .loop-p6-benefits-list {
      width: 100% !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      grid-template-rows: repeat(3, minmax(74px, auto)) !important;
      grid-auto-rows: minmax(74px, auto) !important;
      gap: 10px !important;
    }

    body:not(.is-mobile-app) .loop-p6-benefit-row,
    body:not(.is-mobile-app) .loop-p6-benefit-row-whatsapp,
    body:not(.is-mobile-app) .loop-p6-benefit-row-marca,
    body:not(.is-mobile-app) .loop-p6-benefit-row-operacion,
    body:not(.is-mobile-app) .loop-p6-benefit-row-loyalty {
      height: auto !important;
      min-height: 74px !important;
      max-height: none !important;
      grid-template-columns: 26px minmax(0, 1fr) !important;
      column-gap: 10px !important;
      padding: 11px 12px !important;
      border-radius: 17px !important;
    }

    body:not(.is-mobile-app) .loop-p6-feature-img,
    body:not(.is-mobile-app) .loop-p6-benefit-icon img,
    body:not(.is-mobile-app) .loop-p6-benefit-icon svg {
      width: 21px !important;
      height: 21px !important;
      min-width: 21px !important;
      max-width: 21px !important;
    }

    body:not(.is-mobile-app) .loop-p6-benefit-copy strong {
      font-size: 12.9px !important;
      line-height: 1.12 !important;
      letter-spacing: -0.018em !important;
      overflow-wrap: anywhere !important;
    }

    body:not(.is-mobile-app) .loop-p6-benefit-copy em {
      font-size: 10.7px !important;
      line-height: 1.18 !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    body:not(.is-mobile-app) .loop-p6-hero-copy {
      grid-template-columns: 1fr !important;
      row-gap: 24px !important;
    }

    body:not(.is-mobile-app) .loop-p6-title {
      max-width: 760px !important;
      font-size: clamp(44px, 4.3vw, 60px) !important;
    }

    body:not(.is-mobile-app) .loop-p6-benefit-card,
    body:not(.is-mobile-app) .loop-p6-cta-card.loop-p6-benefit-card {
      justify-self: start !important;
      max-width: 620px !important;
    }
  }

  @media (min-width: 1181px) and (max-width: 1440px) {
    body:not(.is-mobile-app) .loop-p6-title {
      font-size: clamp(44px, 4.1vw, 62px) !important;
    }

    body:not(.is-mobile-app) .loop-p6-benefit-card,
    body:not(.is-mobile-app) .loop-p6-cta-card.loop-p6-benefit-card {
      max-width: 500px !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-title {
      font-size: clamp(34px, 8.8vw, 46px) !important;
      line-height: 0.97 !important;
      letter-spacing: -0.058em !important;
      font-weight: 880 !important;
      text-shadow: 0 3px 12px rgba(0,0,0,.14) !important;
    }
  }
`;


const phaseHomeHeroLeftLayoutRepairV74 = `
  /* =========================================================
     LOOP HOME — LEFT LAYOUT REPAIR V74
     Surgical follow-up to V73:
     - explicitly places every hero element in the intended grid cell
     - prevents the headline, paragraph and CTA from auto-flowing
       into separate columns
     - preserves the corrected premium benefits card
     ========================================================= */

  .loop-p6-hero-copy > * {
    min-width: 0 !important;
  }

  @media (min-width: 1181px) {
    body:not(.is-mobile-app) .loop-p6-hero-copy {
      width: 100% !important;
      max-width: 1500px !important;
      margin: 0 auto !important;
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) minmax(440px, 520px) !important;
      grid-template-rows: auto auto auto auto !important;
      column-gap: clamp(36px, 4vw, 64px) !important;
      row-gap: 0 !important;
      align-items: center !important;
    }

    body:not(.is-mobile-app) .loop-p6-title {
      grid-column: 1 !important;
      grid-row: 1 !important;
      width: 100% !important;
      max-width: 900px !important;
      margin: 0 !important;
      font-size: clamp(48px, 3.75vw, 66px) !important;
      line-height: 0.98 !important;
      letter-spacing: -0.06em !important;
      font-weight: 860 !important;
      text-wrap: balance !important;
      overflow: visible !important;
    }

    body:not(.is-mobile-app) .loop-p6-offer-line {
      grid-column: 1 !important;
      grid-row: 2 !important;
      width: 100% !important;
      max-width: 680px !important;
      margin: 20px 0 0 !important;
    }

    body:not(.is-mobile-app) .loop-p6-hero-actions {
      grid-column: 1 !important;
      grid-row: 3 !important;
      width: 100% !important;
      max-width: 700px !important;
      margin-top: 24px !important;
      align-self: start !important;
    }

    body:not(.is-mobile-app) .loop-p6-mobile-benefit-rail {
      grid-column: 1 !important;
      grid-row: 4 !important;
    }

    body:not(.is-mobile-app) .loop-p6-benefit-card,
    body:not(.is-mobile-app) .loop-p6-cta-card.loop-p6-benefit-card {
      grid-column: 2 !important;
      grid-row: 1 / span 4 !important;
      align-self: center !important;
      justify-self: end !important;
      margin: 0 !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    body:not(.is-mobile-app) .loop-p6-hero-copy {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) !important;
      grid-template-rows: auto !important;
      row-gap: 0 !important;
    }

    body:not(.is-mobile-app) .loop-p6-title {
      grid-column: 1 !important;
      grid-row: 1 !important;
      width: 100% !important;
      max-width: 820px !important;
      margin: 0 !important;
      font-size: clamp(42px, 5vw, 58px) !important;
      line-height: 0.99 !important;
      letter-spacing: -0.058em !important;
      font-weight: 860 !important;
    }

    body:not(.is-mobile-app) .loop-p6-offer-line {
      grid-column: 1 !important;
      grid-row: 2 !important;
      max-width: 680px !important;
      margin-top: 18px !important;
    }

    body:not(.is-mobile-app) .loop-p6-hero-actions {
      grid-column: 1 !important;
      grid-row: 3 !important;
      margin-top: 22px !important;
    }

    body:not(.is-mobile-app) .loop-p6-mobile-benefit-rail {
      grid-column: 1 !important;
      grid-row: 4 !important;
    }

    body:not(.is-mobile-app) .loop-p6-benefit-card,
    body:not(.is-mobile-app) .loop-p6-cta-card.loop-p6-benefit-card {
      grid-column: 1 !important;
      grid-row: 5 !important;
      width: min(100%, 620px) !important;
      max-width: 620px !important;
      margin-top: 28px !important;
      justify-self: start !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-title,
    body.is-mobile-app .loop-p6-title,
    html.is-mobile-app .loop-p6-title {
      width: 100% !important;
      max-width: 100% !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      font-size: clamp(34px, 9vw, 46px) !important;
      line-height: 0.99 !important;
      letter-spacing: -0.055em !important;
      font-weight: 860 !important;
      text-wrap: balance !important;
    }
  }
`;


const phaseHomeHeroTrueTwoColumnV75 = `
  /* =========================================================
     LOOP HOME — TRUE TWO-COLUMN HERO V75
     Root fix:
     - the right benefits card is a sibling of .loop-p6-hero-copy,
       so the two-column grid belongs on .loop-p6-hero-overlay
     - .loop-p6-hero-copy must remain a normal vertical content block
     - desktop headline is intentionally two editorial lines
     ========================================================= */

  @media (min-width: 1181px) {
    body:not(.is-mobile-app) .loop-p6-hero-overlay,
    body:not(.is-mobile-app) .mainmenu-root.has-full-content .loop-p6-hero-overlay,
    body:not(.is-mobile-app) .loop-pro-main > .loop-p6-hero .loop-p6-hero-overlay {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) minmax(440px, 520px) !important;
      column-gap: clamp(42px, 4.2vw, 72px) !important;
      align-items: center !important;
      align-content: center !important;
      padding: clamp(34px, 3vw, 48px) clamp(34px, 4.2vw, 64px) clamp(30px, 2.8vw, 44px) !important;
      overflow: hidden !important;
      box-sizing: border-box !important;
    }

    body:not(.is-mobile-app) .loop-p6-hero-copy {
      grid-column: 1 !important;
      grid-row: 1 !important;
      display: block !important;
      width: 100% !important;
      max-width: 900px !important;
      min-width: 0 !important;
      margin: 0 !important;
      align-self: center !important;
    }

    body:not(.is-mobile-app) .loop-p6-title,
    body:not(.is-mobile-app) .loop-p6-offer-line,
    body:not(.is-mobile-app) .loop-p6-hero-actions,
    body:not(.is-mobile-app) .loop-p6-mobile-benefit-rail {
      grid-column: auto !important;
      grid-row: auto !important;
    }

    body:not(.is-mobile-app) .loop-p6-title {
      width: 100% !important;
      max-width: 900px !important;
      margin: 0 !important;
      font-size: clamp(50px, 3.45vw, 64px) !important;
      line-height: 0.99 !important;
      letter-spacing: -0.056em !important;
      font-weight: 820 !important;
      text-wrap: balance !important;
      overflow: visible !important;
      text-shadow: 0 3px 14px rgba(0,0,0,.15) !important;
    }

    body:not(.is-mobile-app) .loop-p6-title br {
      display: block !important;
    }

    body:not(.is-mobile-app) .loop-p6-offer-line {
      width: 100% !important;
      max-width: 670px !important;
      margin: 20px 0 0 !important;
      font-size: clamp(14.5px, 1vw, 16px) !important;
      line-height: 1.5 !important;
      font-weight: 700 !important;
    }

    body:not(.is-mobile-app) .loop-p6-hero-actions {
      width: 100% !important;
      max-width: 720px !important;
      margin-top: 24px !important;
    }

    body:not(.is-mobile-app) .loop-p6-benefit-card,
    body:not(.is-mobile-app) .loop-p6-cta-card.loop-p6-benefit-card {
      grid-column: 2 !important;
      grid-row: 1 !important;
      align-self: center !important;
      justify-self: end !important;
      width: 100% !important;
      max-width: 520px !important;
      min-width: 0 !important;
      margin: 0 !important;
    }
  }

  @media (min-width: 1181px) and (max-width: 1380px) {
    body:not(.is-mobile-app) .loop-p6-hero-overlay,
    body:not(.is-mobile-app) .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      grid-template-columns: minmax(0, 1fr) minmax(420px, 485px) !important;
      column-gap: 38px !important;
      padding-left: 38px !important;
      padding-right: 38px !important;
    }

    body:not(.is-mobile-app) .loop-p6-title {
      font-size: clamp(46px, 3.7vw, 56px) !important;
      max-width: 790px !important;
    }
  }

  @media (min-width: 900px) and (max-width: 1180px) {
    body:not(.is-mobile-app) .loop-p6-hero-overlay,
    body:not(.is-mobile-app) .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) !important;
      row-gap: 28px !important;
      align-items: start !important;
      padding: 34px clamp(28px, 4vw, 48px) 38px !important;
    }

    body:not(.is-mobile-app) .loop-p6-hero-copy {
      display: block !important;
      width: 100% !important;
      max-width: 860px !important;
      margin: 0 !important;
    }

    body:not(.is-mobile-app) .loop-p6-title {
      width: 100% !important;
      max-width: 820px !important;
      margin: 0 !important;
      font-size: clamp(43px, 5vw, 58px) !important;
      line-height: 1 !important;
      letter-spacing: -0.054em !important;
      font-weight: 820 !important;
    }

    body:not(.is-mobile-app) .loop-p6-offer-line {
      max-width: 680px !important;
      margin-top: 18px !important;
    }

    body:not(.is-mobile-app) .loop-p6-benefit-card,
    body:not(.is-mobile-app) .loop-p6-cta-card.loop-p6-benefit-card {
      width: min(100%, 620px) !important;
      max-width: 620px !important;
      margin: 0 !important;
      justify-self: start !important;
    }
  }

  @media (max-width: 899px) {
    .loop-p6-hero-copy {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
    }

    .loop-p6-title,
    body.is-mobile-app .loop-p6-title,
    html.is-mobile-app .loop-p6-title {
      width: 100% !important;
      max-width: 100% !important;
      font-size: clamp(34px, 8.7vw, 45px) !important;
      line-height: 1 !important;
      letter-spacing: -0.052em !important;
      font-weight: 820 !important;
    }
  }
`;


const phaseHomeDiscoveryHeroV76 = `
  /* =========================================================
     LOOP HOME — DISCOVERY HERO V76
     Scope: hero only. Header, categories and the rest of MainMenu
     remain unchanged.

     Visual direction:
     - editorial discovery-first message
     - existing Loop hero image
     - deep green left fade, open image on the right
     - Cormorant Garamond headline + Inter UI copy
     - one primary discovery CTA
     - secondary business CTA as a text link
     - App Store / Google Play badges retained on web
     ========================================================= */

  .loop-discovery-hero-v76 {
    width: 100% !important;
    max-width: none !important;
    height: clamp(500px, 36.8vw, 630px) !important;
    min-height: clamp(500px, 36.8vw, 630px) !important;
    max-height: 630px !important;
    margin: -2px 0 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    overflow: hidden !important;
    position: relative !important;
    background-image:
      linear-gradient(
        90deg,
        rgba(0, 48, 42, 0.98) 0%,
        rgba(0, 48, 42, 0.95) 22%,
        rgba(0, 48, 42, 0.88) 33%,
        rgba(0, 48, 42, 0.63) 44%,
        rgba(0, 48, 42, 0.30) 54%,
        rgba(0, 48, 42, 0.08) 67%,
        rgba(0, 48, 42, 0.02) 100%
      ),
      var(--loop-hero-image, url("/assets/images/loop-wellness-lounge-hero.png")) !important;
    background-size: cover, cover !important;
    background-position: center center, center center !important;
    background-repeat: no-repeat, no-repeat !important;
    background-color: #003b35 !important;
    box-shadow: none !important;
  }

  .loop-discovery-hero-v76::before,
  .loop-discovery-hero-v76::after {
    display: none !important;
    content: none !important;
  }

  .loop-discovery-hero-v76 .loop-discovery-hero-overlay-v76 {
    width: 100% !important;
    max-width: 1700px !important;
    height: 100% !important;
    min-height: 100% !important;
    margin: 0 auto !important;
    padding:
      clamp(54px, 5.2vw, 88px)
      clamp(28px, 8.9vw, 154px)
      clamp(46px, 4.8vw, 78px) !important;
    box-sizing: border-box !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-start !important;
    overflow: visible !important;
  }

  .loop-discovery-copy-v76 {
    width: min(680px, 48vw) !important;
    max-width: 680px !important;
    min-width: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    display: block !important;
    color: #fff8ee !important;
    position: relative !important;
    z-index: 2 !important;
  }

  .loop-discovery-eyebrow-v76 {
    margin: 0 0 22px !important;
    color: rgba(255, 248, 238, 0.90) !important;
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
    font-size: 13px !important;
    line-height: 1 !important;
    font-weight: 800 !important;
    letter-spacing: 0.16em !important;
    text-transform: uppercase !important;
  }

  .loop-discovery-title-v76 {
    width: 100% !important;
    max-width: 680px !important;
    margin: 0 !important;
    color: #fff8ee !important;
    font-family: "Cormorant Garamond", "Playfair Display", Georgia, "Times New Roman", serif !important;
    font-size: clamp(66px, 4.9vw, 86px) !important;
    line-height: 0.91 !important;
    letter-spacing: -0.038em !important;
    font-weight: 500 !important;
    text-wrap: balance !important;
    text-shadow: 0 3px 20px rgba(0, 0, 0, 0.16) !important;
  }

  .loop-discovery-title-v76 br {
    display: block !important;
  }

  .loop-discovery-subtitle-v76 {
    width: min(100%, 590px) !important;
    max-width: 590px !important;
    margin: 24px 0 0 !important;
    color: rgba(255, 248, 238, 0.94) !important;
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
    font-size: clamp(16px, 1.12vw, 19px) !important;
    line-height: 1.48 !important;
    letter-spacing: -0.018em !important;
    font-weight: 500 !important;
    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.14) !important;
  }

  .loop-discovery-actions-v76 {
    margin-top: 30px !important;
    display: grid !important;
    justify-items: start !important;
    gap: 17px !important;
  }

  .loop-discovery-primary-v76 {
    min-width: 300px !important;
    min-height: 60px !important;
    padding: 0 24px 0 28px !important;
    border: 1px solid rgba(255, 255, 255, 0.34) !important;
    border-radius: 999px !important;
    background: #fff8ee !important;
    color: #004c44 !important;
    box-shadow: 0 18px 42px rgba(0, 0, 0, 0.16) !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 28px !important;
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
    font-size: 16px !important;
    line-height: 1 !important;
    font-weight: 800 !important;
    letter-spacing: -0.02em !important;
    cursor: pointer !important;
    transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease !important;
  }

  .loop-discovery-primary-v76:hover {
    transform: translateY(-1px) !important;
    background: #ffffff !important;
    box-shadow: 0 22px 48px rgba(0, 0, 0, 0.20) !important;
  }

  .loop-discovery-primary-v76:active {
    transform: scale(0.987) !important;
  }

  .loop-discovery-primary-arrow-v76 {
    font-size: 25px !important;
    line-height: 1 !important;
    font-weight: 500 !important;
    transform: translateY(-1px) !important;
  }

  .loop-discovery-business-link-v76 {
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    background: transparent !important;
    color: rgba(255, 248, 238, 0.90) !important;
    box-shadow: none !important;
    appearance: none !important;
    -webkit-appearance: none !important;
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
    font-size: 13.5px !important;
    line-height: 1.35 !important;
    font-weight: 600 !important;
    letter-spacing: -0.012em !important;
    text-decoration: underline !important;
    text-decoration-color: rgba(255, 248, 238, 0.54) !important;
    text-decoration-thickness: 1px !important;
    text-underline-offset: 4px !important;
    cursor: pointer !important;
    transition: color 160ms ease, opacity 160ms ease !important;
  }

  .loop-discovery-business-link-v76:hover {
    color: #ffffff !important;
  }

  .loop-discovery-platform-v76 {
    width: fit-content !important;
    margin-top: 24px !important;
  }

  .loop-discovery-platform-v76 .loop-p6-platform-copy {
    margin: 0 0 7px !important;
    color: rgba(255, 248, 238, 0.82) !important;
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
    font-size: 11.5px !important;
    line-height: 1 !important;
    font-weight: 600 !important;
    letter-spacing: 0 !important;
  }

  .loop-discovery-platform-v76 .loop-p6-store-row-left {
    margin-top: 0 !important;
    gap: 10px !important;
    justify-content: flex-start !important;
  }

  .loop-discovery-platform-v76 .loop-p6-store-badge-img {
    height: 38px !important;
    max-width: 165px !important;
    filter: drop-shadow(0 8px 18px rgba(0,0,0,0.16)) !important;
  }

  body:not(.is-mobile-app) .loop-discovery-hero-v76 .loop-discovery-platform-v76,
  body:not(.is-mobile-app) .loop-discovery-hero-v76 .loop-p6-store-row-left,
  body:not(.is-mobile-app) .loop-discovery-hero-v76 .loop-p6-store-btn {
    visibility: visible !important;
    opacity: 1 !important;
  }

  /* Mid desktop / web tablet */
  @media (min-width: 900px) and (max-width: 1180px) {
    .loop-discovery-hero-v76 {
      height: clamp(500px, 52vw, 580px) !important;
      min-height: clamp(500px, 52vw, 580px) !important;
      max-height: 580px !important;
      background-position: center center, 56% center !important;
    }

    .loop-discovery-hero-v76 .loop-discovery-hero-overlay-v76 {
      display: flex !important;
      padding: 52px clamp(30px, 6vw, 66px) 48px !important;
    }

    .loop-discovery-copy-v76 {
      width: min(640px, 64vw) !important;
      max-width: 640px !important;
    }

    .loop-discovery-title-v76 {
      max-width: 620px !important;
      font-size: clamp(61px, 7vw, 76px) !important;
    }

    .loop-discovery-subtitle-v76 {
      max-width: 520px !important;
      font-size: 16px !important;
    }
  }

  /* Browser mobile + native phone/tablet compact layout */
  @media (max-width: 899px) {
    .loop-discovery-hero-v76,
    body.is-mobile-app .loop-discovery-hero-v76,
    html.is-mobile-app .loop-discovery-hero-v76 {
      height: auto !important;
      min-height: 500px !important;
      max-height: none !important;
      margin-top: -2px !important;
      overflow: hidden !important;
      background-image:
        linear-gradient(
          180deg,
          rgba(0, 48, 42, 0.91) 0%,
          rgba(0, 48, 42, 0.86) 46%,
          rgba(0, 48, 42, 0.68) 72%,
          rgba(0, 48, 42, 0.50) 100%
        ),
        var(--loop-hero-image, url("/assets/images/loop-wellness-lounge-hero.png")) !important;
      background-size: cover, cover !important;
      background-position: center center, 58% center !important;
    }

    .loop-discovery-hero-v76 .loop-discovery-hero-overlay-v76,
    body.is-mobile-app .loop-discovery-hero-v76 .loop-discovery-hero-overlay-v76,
    html.is-mobile-app .loop-discovery-hero-v76 .loop-discovery-hero-overlay-v76 {
      width: 100% !important;
      height: auto !important;
      min-height: 500px !important;
      display: flex !important;
      align-items: center !important;
      padding: 42px 18px 34px !important;
    }

    .loop-discovery-copy-v76 {
      width: 100% !important;
      max-width: 620px !important;
    }

    .loop-discovery-eyebrow-v76 {
      margin-bottom: 18px !important;
      font-size: 11px !important;
      letter-spacing: 0.15em !important;
    }

    .loop-discovery-title-v76,
    body.is-mobile-app .loop-discovery-title-v76,
    html.is-mobile-app .loop-discovery-title-v76 {
      width: 100% !important;
      max-width: 560px !important;
      font-size: clamp(48px, 13vw, 64px) !important;
      line-height: 0.92 !important;
      letter-spacing: -0.036em !important;
      font-weight: 500 !important;
    }

    .loop-discovery-subtitle-v76 {
      width: 100% !important;
      max-width: 520px !important;
      margin-top: 19px !important;
      font-size: 14.5px !important;
      line-height: 1.45 !important;
    }

    .loop-discovery-actions-v76 {
      width: 100% !important;
      margin-top: 25px !important;
      gap: 15px !important;
    }

    .loop-discovery-primary-v76 {
      width: min(100%, 360px) !important;
      min-width: 0 !important;
      min-height: 54px !important;
      padding: 0 20px 0 23px !important;
      font-size: 14.5px !important;
    }

    .loop-discovery-business-link-v76 {
      max-width: 100% !important;
      text-align: left !important;
      font-size: 12.5px !important;
    }

    body:not(.is-mobile-app) .loop-discovery-platform-v76 {
      display: block !important;
      width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      margin-top: 21px !important;
      padding: 0 !important;
      overflow: visible !important;
    }

    body:not(.is-mobile-app) .loop-discovery-platform-v76 .loop-p6-platform-copy {
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
    }

    body:not(.is-mobile-app) .loop-discovery-platform-v76 .loop-p6-store-row-left {
      display: flex !important;
      width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      gap: 8px !important;
      align-items: center !important;
      justify-content: flex-start !important;
      overflow: visible !important;
    }

    body:not(.is-mobile-app) .loop-discovery-platform-v76 .loop-p6-store-btn {
      display: inline-flex !important;
      width: auto !important;
      height: auto !important;
      min-width: 0 !important;
      min-height: 0 !important;
      flex: 0 0 auto !important;
    }

    .loop-discovery-platform-v76 .loop-p6-store-badge-img {
      height: 36px !important;
      max-width: 154px !important;
    }

    .loop-discovery-hero-v76 + #loop-services-section {
      padding-top: 14px !important;
    }
  }

  @media (max-width: 430px) {
    .loop-discovery-hero-v76 {
      min-height: 520px !important;
    }

    .loop-discovery-hero-v76 .loop-discovery-hero-overlay-v76 {
      min-height: 520px !important;
      padding-top: 36px !important;
      padding-bottom: 30px !important;
    }

    .loop-discovery-title-v76 {
      font-size: clamp(45px, 12.8vw, 56px) !important;
    }

    .loop-discovery-platform-v76 .loop-p6-store-badge-img {
      height: 34px !important;
      max-width: 146px !important;
    }
  }
`;

const phaseMainMenuHeroTabletSeamV72 = `
  /* =========================================================
     LOOP MAIN MENU — TABLET WEB SEAM V72
     Surgical fix only for the 900–1024px web breakpoint.

     Console audit at 903px showed:
     - header bottom: 58px
     - hero top: 64px
     - gap: 6px
     - seam element: .mainmenu-root.has-full-content

     Cause: older V21 reserves 64px on .mainmenu-root while
     the actual header in this breakpoint is 58px. This corrects
     only that reservation and does not redesign the hero.
     ========================================================= */
  @media (min-width: 900px) and (max-width: 1024px) {
    body:not(.is-mobile-app):has(.mainmenu-root.has-full-content) .mainmenu-root.has-full-content,
    body:not(.is-mobile-app) .mainmenu-root.has-full-content {
      padding-top: 58px !important;
      margin-top: 0 !important;
      border-top: 0 !important;
    }

    body:not(.is-mobile-app):has(.mainmenu-root.has-full-content) .mainmenu-root.has-full-content > main.loop-pro-main,
    body:not(.is-mobile-app) .mainmenu-root.has-full-content > main.loop-pro-main,
    body:not(.is-mobile-app) .mainmenu-root.has-full-content .loop-pro-main {
      margin-top: 0 !important;
      padding-top: 0 !important;
      border-top: 0 !important;
      background: transparent !important;
    }

    body:not(.is-mobile-app):has(.mainmenu-root.has-full-content) .mainmenu-root.has-full-content .loop-p6-hero,
    body:not(.is-mobile-app) .mainmenu-root.has-full-content .loop-p6-hero,
    body:not(.is-mobile-app) .loop-pro-main > .loop-p6-hero {
      margin-top: 0 !important;
      border-top: 0 !important;
      border-radius: 0 !important;
      width: 100% !important;
      max-width: none !important;
      background-position: center top !important;
    }

    body:not(.is-mobile-app):has(.mainmenu-root.has-full-content) .mainmenu-root.has-full-content .loop-p6-hero-overlay,
    body:not(.is-mobile-app) .mainmenu-root.has-full-content .loop-p6-hero-overlay {
      margin-top: 0 !important;
      border-top: 0 !important;
    }
  }
`;



function MainMenu(props) {
  useLanguage();
  const canAdminPlatform = useMenuAdminAccess();
  const {
    userEmail,
    userName,
    isLoggedIn = false,
    authReady = true,
    businessTypes = [],
    recommendedBusinesses = [],
    favoritesBusinesses = [],
    favoritesSet = undefined,
    onToggleFavorite = undefined,
    onSearch,
    onOpenCalendar,
    onOpenBooking,
    onOpenBusinessCalendar,
    onShowMyBookings,
    onShowMyLoyalty,
    onShowUserProfile,
    onAdminManage,
    onCreateBusiness,
    onLogout,
    db = defaultDb,
    showHeaderOnly = false,
    showRecommended = true,
    onSelectService,
    onSearchNearby,
  } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const isHome = Boolean(
    location && (location.pathname === "/" || location.pathname === "" || location.pathname === "/index.html" || location.pathname === "/negocios")
  );

  const mainMenuCacheIdentity = useMemo(() => ({
    uid: props?.user?.uid || null,
    email: userEmail || "",
  }), [props?.user?.uid, userEmail]);
  const calendarAccessCacheKey = useMemo(
    () => mainMenuUserScopedCacheKey(MAINMENU_CALENDAR_ACCESS_CACHE_KEY, mainMenuCacheIdentity),
    [mainMenuCacheIdentity]
  );
  const favoritesDocsCacheKey = useMemo(
    () => mainMenuUserScopedCacheKey(MAINMENU_FAVORITES_CACHE_KEY, mainMenuCacheIdentity),
    [mainMenuCacheIdentity]
  );

  useEffect(() => {
    if (!isHome || showHeaderOnly) return;
    const sessionKey = "loop_main_menu_viewed";
    try {
      if (typeof window !== "undefined" && window.sessionStorage && window.sessionStorage.getItem(sessionKey)) return;
      if (typeof window !== "undefined" && window.sessionStorage) window.sessionStorage.setItem(sessionKey, "1");
    } catch (_) {}
    trackPlatformAnalyticsEventSafe({
      db,
      type: "main_menu_view",
      payload: { sourceArea: "main_menu", userEmail: userEmail || null, isLoggedIn: Boolean(isLoggedIn || auth.currentUser?.uid) },
    });
  }, [db, isHome, showHeaderOnly, userEmail, userName, isLoggedIn]);

  const [isMobileApp, setIsMobileApp] = useState(() => {
    try {
      return (
        typeof document !== "undefined" &&
        document.body &&
        document.body.classList &&
        document.body.classList.contains("is-mobile-app")
      );
    } catch (e) {
      return false;
    }
  });

  useEffect(() => {
    if (typeof document === "undefined") return;
    const sync = () => {
      try {
        setIsMobileApp(document.body.classList.contains("is-mobile-app"));
      } catch (_) {
        setIsMobileApp(false);
      }
    };
    sync();
    let obs = null;
    try {
      obs = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.type === "attributes" && m.attributeName === "class") sync();
        }
      });
      obs.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    } catch (e) {}
    const onLoad = () => sync();
    window.addEventListener && window.addEventListener("load", onLoad);
    return () => {
      try {
        obs && obs.disconnect();
      } catch (_) {}
      window.removeEventListener && window.removeEventListener("load", onLoad);
    };
  }, []);

  const [isMobileViewportForBusinessRails, setIsMobileViewportForBusinessRails] = useState(() => {
    try {
      return typeof window !== "undefined" && window.matchMedia && window.matchMedia("(max-width: 899px)").matches;
    } catch (_) {
      return false;
    }
  });

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const syncMobileViewportForBusinessRails = () => {
      try {
        const compact = window.matchMedia
          ? window.matchMedia("(max-width: 899px)").matches
          : (window.innerWidth || 0) <= 899;
        setIsMobileViewportForBusinessRails(Boolean(compact));
      } catch (_) {
        setIsMobileViewportForBusinessRails(false);
      }
    };

    syncMobileViewportForBusinessRails();
    window.addEventListener("resize", syncMobileViewportForBusinessRails);
    window.addEventListener("orientationchange", syncMobileViewportForBusinessRails);
    return () => {
      window.removeEventListener("resize", syncMobileViewportForBusinessRails);
      window.removeEventListener("orientationchange", syncMobileViewportForBusinessRails);
    };
  }, []);

  const useMobileBusinessRails = isMobileApp || isMobileViewportForBusinessRails;

  const [heroSlideIndex, setHeroSlideIndex] = useState(0);
  // LOOP_FORCE_HERO_START_PHASE_21

  const heroSlides = useMemo(() => {
    const base = [
      {
        key: "panama",
        eyebrow: "Comunidad Loop · Panamá",
        title: <>{translateInterface("Negocios y clientes")}<br />{translateInterface("crecen mejor en Loop")}<span className="loop-title-dot">.</span></>,
        subtitle: "Crea tu negocio, organiza tus reservas y forma parte de una comunidad que crece contigo.",
        type: "early",
      },
    ];

    if (!isMobileApp) {
      base.push({
        key: "mobile",
        eyebrow: "Nuevo · App móvil",
        title: <>{translateInterface("Ahora también")}<br />{translateInterface("en nuestra app móvil")}<span className="loop-title-dot">.</span></>,
        subtitle: "Reserva donde estés, cuando quieras. Tu agenda, favoritos y reservas siempre contigo.",
        type: "mobile",
      });
    }

    return base;
  }, [isMobileApp]);

  useEffect(() => {
    // Premium launch UX: keep the first hero fixed as the main brand message.
    // Users can still use the dots manually, but the landing impact should always be "Loop está llegando a Panamá".
    if (heroSlideIndex !== 0) return undefined;
    return undefined;
  }, [heroSlideIndex]);

  useEffect(() => {
    if (heroSlideIndex >= heroSlides.length) setHeroSlideIndex(0);
  }, [heroSlideIndex, heroSlides.length]);

  const openLoopStore = useCallback((store) => {
    const url = store === "ios" ? LOOP_APP_STORE_URL : LOOP_GOOGLE_PLAY_URL;
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }
    navigate("/support");
  }, [navigate]);

  // Startup-safe mode:
  // avoid eager pending hooks here to reduce blank-screen risk on Android startup.
  const pendingRatingCount = 0;
  const calendarPendingTotal = Number(props.calendarPendingCount || 0);
  const calendarPendingByBusiness = props.calendarPendingByBusiness || {};
  const calendarPendingLoading = Boolean(props.calendarPendingLoading);

  const initialRecommendedNormalized =
    Array.isArray(recommendedBusinesses) && recommendedBusinesses.length > 0
      ? recommendedBusinesses.filter(isPublicBusiness).filter(b=>matchesMarket(b)).map(normalizeBusinessForMenu)
      : [];

  const cachedRecommendedInitial = useMemo(() => {
    const cached = readJsonCache(MAINMENU_RECOMMENDED_CACHE_KEY + marketCacheKey(), []);
    return Array.isArray(cached) ? cached.filter(isPublicBusiness).map(normalizeBusinessForMenu) : [];
  }, []);

  const [localRecommended, setLocalRecommended] = useState(
    initialRecommendedNormalized.length > 0 ? initialRecommendedNormalized : cachedRecommendedInitial
  );
  const [loadingRecommended, setLoadingRecommended] = useState(false);
  const [recommendedLoadError, setRecommendedLoadError] = useState(null);

  const recommendedLoadedRef = useRef((initialRecommendedNormalized && initialRecommendedNormalized.length >= RECOMMENDED_MIN_DESIRED) || (cachedRecommendedInitial && cachedRecommendedInitial.length >= RECOMMENDED_MIN_DESIRED));

  const fetchRecommendedOnce = useCallback(
    async (mountedFlag = { mounted: true }, options = {}) => {
      const force = Boolean(options && options.force);
      if (!showRecommended) return;
      if (recommendedLoadedRef.current && !force) return;

      setLoadingRecommended(true);
      setRecommendedLoadError(null);

      try {
        const seedList = Array.isArray(recommendedBusinesses) && recommendedBusinesses.length > 0
          ? recommendedBusinesses.map(normalizeBusinessForMenu)
          : [];

        let fetchedList = [];

        fetchedList = (await listMarketBusinesses(db, RECOMMENDED_BUSINESSES_LIMIT)).filter(isPublicBusiness).map(normalizeBusinessForMenu);

        const list = dedupeBusinessesForMenu([...fetchedList, ...seedList]).filter(b => matchesMarket(b));

        if (mountedFlag.mounted) {
          setLocalRecommended(list);
          writeJsonCache(MAINMENU_RECOMMENDED_CACHE_KEY + marketCacheKey(), list);
          recommendedLoadedRef.current = true;
          setRecommendedLoadError(null);
        }
      } catch (err) {
        console.warn("[MainMenu] fetchRecommendedOnce failed", err);
        if (mountedFlag.mounted) setRecommendedLoadError(err);
      } finally {
        if (mountedFlag.mounted) setLoadingRecommended(false);
      }
    },
    [db, recommendedBusinesses, showRecommended]
  );

  useEffect(() => {
    let mountedFlag = { mounted: true };
    if (isHome && showRecommended) {
      fetchRecommendedOnce(mountedFlag);
    }
    return () => {
      mountedFlag.mounted = false;
    };
  }, [fetchRecommendedOnce, isHome, showRecommended]);

  useEffect(() => {
    if (Array.isArray(recommendedBusinesses) && recommendedBusinesses.length > 0) {
      const normalized = recommendedBusinesses.filter(isPublicBusiness).filter(b=>matchesMarket(b)).map(normalizeBusinessForMenu);
      setLocalRecommended(normalized);
      writeJsonCache(MAINMENU_RECOMMENDED_CACHE_KEY + marketCacheKey(), normalized);
      recommendedLoadedRef.current = normalized.length >= RECOMMENDED_MIN_DESIRED;
      setRecommendedLoadError(null);
    }
  }, [recommendedBusinesses]);

  useEffect(() => {
    const onManualAuth = () => {
      try {
        recommendedLoadedRef.current = false;
        setRecommendedLoadError(null);
        fetchRecommendedOnce({ mounted: true }, { force: true });
      } catch (err) {
        console.warn("[MainMenu] manual-auth handler failed", err);
      }
    };

    const onOnline = () => {
      try {
        recommendedLoadedRef.current = false;
        setRecommendedLoadError(null);
        fetchRecommendedOnce({ mounted: true }, { force: true });
      } catch (err) {
        console.warn("[MainMenu] online handler failed", err);
      }
    };

    const onVisible = () => {
      try {
        if (typeof document !== "undefined" && document.visibilityState === "visible" && isHome && showRecommended) {
          const shouldForce = !Array.isArray(localRecommended) || localRecommended.length < RECOMMENDED_MIN_DESIRED || Boolean(recommendedLoadError);
          fetchRecommendedOnce({ mounted: true }, { force: shouldForce });
        }
      } catch (err) {
        console.warn("[MainMenu] visibility handler failed", err);
      }
    };

    try {
      window.addEventListener && window.addEventListener("manual-auth-changed", onManualAuth);
      window.addEventListener && window.addEventListener("manual-auth-detected", onManualAuth);
      window.addEventListener && window.addEventListener("online", onOnline);
      document.addEventListener && document.addEventListener("visibilitychange", onVisible);
    } catch (e) {}

    return () => {
      try {
        window.removeEventListener && window.removeEventListener("manual-auth-changed", onManualAuth);
        window.removeEventListener && window.removeEventListener("manual-auth-detected", onManualAuth);
        window.removeEventListener && window.removeEventListener("online", onOnline);
        document.removeEventListener && document.removeEventListener("visibilitychange", onVisible);
      } catch (e) {}
    };
  }, [fetchRecommendedOnce, isHome, showRecommended, localRecommended, recommendedLoadError]);

  const [q, setQ] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [bizSelectorOpen, setBizSelectorOpen] = useState(false);

  const [openAvatar, setOpenAvatar] = useState(false);
  const [mobileProfileOpen, setMobileProfileOpen] = useState(false);

  const [calendarAccessBusinesses, setCalendarAccessBusinesses] = useState(() => {
    const cached = readJsonCache(calendarAccessCacheKey, []);
    return normalizeCalendarAccessList(Array.isArray(cached) ? cached : []);
  });
  const [calendarAccessHydrated, setCalendarAccessHydrated] = useState(false);
  const [calendarAccessLoading, setCalendarAccessLoading] = useState(false);

  const calendarAccessRequest = useRef(0);
  const preloadCalendarAccess = useCallback(async ({ force = false } = {}) => {
    const requestId = ++calendarAccessRequest.current;
    try {
      const cached = readJsonCache(calendarAccessCacheKey, []);
      if (Array.isArray(cached) && cached.length > 0) {
        const normalizedCached = normalizeCalendarAccessList(cached);
        setCalendarAccessBusinesses(normalizedCached);
        setCalendarAccessHydrated(true);
        if (!force) {
          // Show cached instantly; still refresh below, but without blocking the modal.
        }
      }

      let effectiveUser = auth && auth.currentUser ? auth.currentUser : await waitForAuthUser(450);
      if ((!effectiveUser || (!effectiveUser.uid && !effectiveUser.email)) && isIosCapacitor()) {
        const manualAuth = getManualAuth();
        if (manualAuth && isManualAuthLikelyValid(manualAuth)) {
          effectiveUser = { uid: manualAuth.uid || null, email: manualAuth.email || userEmail || "" };
        }
      }
      if (requestId !== calendarAccessRequest.current) return [];
      if (!effectiveUser || (!effectiveUser.uid && !effectiveUser.email)) {
        setCalendarAccessHydrated(true);
        return [];
      }

      const serviceCached = getCachedUserBusinesses(effectiveUser);
      if (Array.isArray(serviceCached) && serviceCached.length > 0) {
        const normalizedServiceCached = normalizeCalendarAccessList(serviceCached);
        setCalendarAccessBusinesses(normalizedServiceCached);
        setCalendarAccessHydrated(true);
        writeJsonCache(calendarAccessCacheKey, normalizedServiceCached);
      }

      setCalendarAccessLoading(true);
      const fresh = await getUserBusinessesAndRoles(db, effectiveUser, {
        preferOwnerFast: true,
        scanWorkers: true,
        iosBusinessTimeoutMs: isIosCapacitor() ? 5200 : 4500,
      });
      const list = normalizeCalendarAccessList(Array.isArray(fresh) ? fresh : []);
      if (requestId !== calendarAccessRequest.current) return list;
      setCalendarAccessBusinesses(list);
      hydrateCalendarAccessNames(list, db).then((hydrated) => {
        if (requestId !== calendarAccessRequest.current) return;
        setCalendarAccessBusinesses(hydrated);
        writeJsonCache(calendarAccessCacheKey, hydrated);
      }).catch(() => {});
      setCalendarAccessHydrated(true);
      writeJsonCache(calendarAccessCacheKey, list);
      return list;
    } catch (err) {
      console.warn("[MainMenu] preload calendar access failed", err);
      setCalendarAccessHydrated(true);
      return [];
    } finally {
      if (requestId === calendarAccessRequest.current) setCalendarAccessLoading(false);
    }
  }, [db, userEmail, calendarAccessCacheKey]);

  useEffect(() => {
    calendarAccessRequest.current++;
    setCalendarAccessBusinesses(normalizeCalendarAccessList(readJsonCache(calendarAccessCacheKey, [])));
    const hasSession = Boolean(userEmail) || Boolean(auth && auth.currentUser) || (isIosCapacitor() && Boolean(getManualAuth()));
    if (!hasSession) {
      setCalendarAccessHydrated(false);
      setCalendarAccessBusinesses([]);
      return;
    }

    const timer = setTimeout(() => {
      preloadCalendarAccess({ force: false });
    }, 350);

    return () => { clearTimeout(timer); calendarAccessRequest.current++; };
  }, [userEmail, preloadCalendarAccess, calendarAccessCacheKey]);

  const openFastCalendarSelector = useCallback(() => {
    setBizSelectorOpen(true);
    preloadCalendarAccess({ force: true });
  }, [preloadCalendarAccess]);

  // favorites state (used for UI)
  const [favoritesArray, setFavoritesArray] = useState(
    Array.isArray(favoritesBusinesses) ? favoritesBusinesses.map((x) => String(x?.id || x)).filter(x => x && x !== "[object Object]") : []
  );
  const [favoritesSetState, setFavoritesSetState] = useState(
    new Set(Array.isArray(favoritesBusinesses) ? favoritesBusinesses.map((x) => String(x?.id || x)).filter(x => x && x !== "[object Object]") : [])
  );
  const [localFavBusinesses, setLocalFavBusinesses] = useState(() => {
    const cached = readJsonCache(favoritesDocsCacheKey, []);
    return Array.isArray(cached) ? cached.filter(isPublicBusiness).map(normalizeBusinessForMenu) : [];
  });

  useEffect(() => {
    setLocalFavBusinesses([]);
    setFavoritesArray([]);
    setFavoritesSetState(new Set());
  }, [favoritesDocsCacheKey]);

  // App owns the authoritative subscription when it supplies favoritesSet.
  useEffect(() => {
    if (!(props.favoritesSet instanceof Set)) return;
    const values = Array.from(props.favoritesSet, String);
    setFavoritesArray(values);
    setFavoritesSetState(new Set(values));
  }, [props.favoritesSet, favoritesDocsCacheKey]);

  // FAVORITES SUBSCRIBE (Web) / ONE-TIME LOAD (iOS via REST)
  useEffect(() => {
    if (showHeaderOnly || !isHome || props.favoritesSet instanceof Set) return;

    let unsub = null;
    let mounted = true;

    async function loadFavoritesOnceIOS(uid) {
      try {
        const userDoc = await fsClient.getDocByPath(`users/${uid}`, { db });
        const data = userDoc || {};
        const favs = Array.isArray(data.favorites) ? data.favorites.map((x) => x) : [];
        if (!mounted) return;
        setFavoritesArray(favs);
        setFavoritesSetState(new Set(Array.isArray(favs) ? favs.map((x) => String(x)) : []));
      } catch (e) {
        console.warn("[MainMenu] iOS favorites load failed", e);
        if (!mounted) return;
        setFavoritesArray(Array.isArray(favoritesBusinesses) ? favoritesBusinesses.map((x) => String(x?.id || x)).filter(x => x && x !== "[object Object]") : []);
        setFavoritesSetState(new Set(Array.isArray(favoritesBusinesses) ? favoritesBusinesses.map((x) => String(x?.id || x)).filter(x => x && x !== "[object Object]") : []));
      }
    }

    async function startSub() {
      try {
        const user = auth && auth.currentUser ? auth.currentUser : await waitForAuthUser(2000);
        let uid = user && user.uid ? user.uid : null;

        if (!uid && isIosCapacitor()) {
          const ma2 = getManualAuth();
          uid = ma2 && ma2.uid ? ma2.uid : null;
        }

        if (!uid) {
          if (mounted) {
            setFavoritesArray(Array.isArray(favoritesBusinesses) ? favoritesBusinesses.map((x) => String(x?.id || x)).filter(x => x && x !== "[object Object]") : []);
            setFavoritesSetState(new Set(Array.isArray(favoritesBusinesses) ? favoritesBusinesses.map((x) => String(x?.id || x)).filter(x => x && x !== "[object Object]") : []));
          }
          return;
        }

        if (isIosCapacitor()) {
          await loadFavoritesOnceIOS(uid);
          return;
        }

        if (!mounted) return;
        const uRef = docRef(db, "users", uid);
        unsub = onSnapshot(uRef, (snap) => {
          if (!mounted) return;
          const data = snap.exists() ? snap.data() || {} : {};
          const favs = Array.isArray(data.favorites) ? data.favorites.map((x) => x) : [];
          setFavoritesArray(favs);
          setFavoritesSetState(new Set(Array.isArray(favs) ? favs.map((x) => String(x)) : []));
        });
      } catch (e) {
        console.error("[MainMenu] favorites subscribe start failed", e);
      }
    }

    startSub();
    return () => {
      mounted = false;
      if (typeof unsub === "function") unsub();
    };
  }, [db, favoritesBusinesses, showHeaderOnly, isHome, userEmail, mainMenuCacheIdentity.uid, props.favoritesSet]);

  // LOAD FAVORITE BUSINESS DOCS (iOS via REST)
  useEffect(() => {
    if (showHeaderOnly || !isHome) return;

    let mounted = true;
    async function loadFavDocs() {
      if (!Array.isArray(favoritesArray) || favoritesArray.length === 0) {
        if (mounted) setLocalFavBusinesses([]);
        return;
      }

      const ids = favoritesArray.slice(0, 50);
      const bizs = [];

      await Promise.all(
        ids.map(async (bid) => {
          const id = String(bid);
          try {
            if (isIosCapacitor()) {
              const b = await fsClient.getDocByPath(`businesses/${id}`, { db });
              if (isPublicBusiness(b)) bizs.push(normalizeBusinessForMenu(b));
              return;
            }

            const snap = await getDoc(docRef(db, "businesses", id));
            if (snap && snap.exists()) {
              const data = snap.data() || {};
              const currentUser = auth && auth.currentUser ? auth.currentUser : null;
              const isOwner = currentUser && data.ownerUid && currentUser.uid === data.ownerUid;
              const fullBiz = { id: snap.id, ...(data || {}) };
              if ((data.status === "active" || isOwner) && isPublicBusiness(fullBiz)) {
                bizs.push(normalizeBusinessForMenu(fullBiz));
              }
            }
          } catch (e) {
            console.warn("[MainMenu] loadFavDocs: cannot read business", id, e && e.message ? e.message : e);
          }
        })
      );

      if (mounted) {
        setLocalFavBusinesses(bizs);
        writeJsonCache(favoritesDocsCacheKey, bizs);
      }
    }
    loadFavDocs();
    return () => {
      mounted = false;
    };
  }, [favoritesArray, db, showHeaderOnly, isHome, favoritesDocsCacheKey]);

  useEffect(() => {
    if (showHeaderOnly || !isHome) return;

    const onVisible = () => {
      try {
        if (typeof document !== "undefined" && document.visibilityState !== "visible") return;
        if (favoritesArray && favoritesArray.length > 0) {
          setLocalFavBusinesses((prev) => (Array.isArray(prev) && prev.length > 0 ? prev : readJsonCache(favoritesDocsCacheKey, [])));
        }
      } catch (_) {}
    };

    try {
      document.addEventListener("visibilitychange", onVisible);
      window.addEventListener("focus", onVisible);
    } catch (_) {}

    return () => {
      try {
        document.removeEventListener("visibilitychange", onVisible);
        window.removeEventListener("focus", onVisible);
      } catch (_) {}
    };
  }, [favoritesArray, showHeaderOnly, isHome, favoritesDocsCacheKey]);

  const favoriteSession = isIosCapacitor() ? getManualAuth() : null;
  const toggleFavoriteHandler = useFavoriteActions({
    uid: auth.currentUser?.uid || (favoriteSession && isManualAuthLikelyValid(favoriteSession) ? favoriteSession.uid : null),
    favorites: favoritesSetState, db,
    onChange: updater => {
      setFavoritesSetState(updater);
      setFavoritesArray(previous => Array.from(updater(new Set(previous))));
    },
    onLogin: () => navigate("/login?from=" + encodeURIComponent(location.pathname + location.search)),
    onError: () => alert("No se pudo guardar el favorito. Intenta nuevamente."),
  });

  const effectiveToggleFavorite = typeof onToggleFavorite === "function" ? onToggleFavorite : toggleFavoriteHandler;

  const favoritesCanonicalSet = useMemo(() => {
    return buildFavCanonicalSet(favoritesArray, favoritesSetState);
  }, [favoritesArray, favoritesSetState]);

  const dedupBusinessTypes = useMemo(() => {
    const seen = new Set();
    const out = [];
    (Array.isArray(businessTypes) ? businessTypes : []).forEach((b, idx) => {
      if (!b) return;
      const id = b.id || "";
      const nameKey = normalizeName(b.name || id || `service_${idx}`);
      const key = id ? `id:${id}` : `name:${nameKey}

/* =========================================================
   LOOP MAIN MENU — PHASE 1 FOUNDATION CLEANUP
   Goal:
   - Cleaner spacing rhythm
   - Better mobile hero sizing
   - Fix categories carousel on mobile
   - Reduce visual noise without touching data logic
   ========================================================= */

  .loop-pro-shell {
    --loop-page-max: 1460px;
    --loop-side-pad: clamp(18px, 5vw, 72px);
    --loop-mobile-pad: 16px;
    --loop-brand: #00675f;
    --loop-brand-2: #00897f;
    --loop-text: #0b1220;
    --loop-muted: #667085;
    background:
      radial-gradient(circle at 12% 4%, rgba(0, 137, 127, 0.065), transparent 26%),
      linear-gradient(180deg, #ffffff 0%, #fbfdfd 42%, #ffffff 100%) !important;
  }

  .loop-pro-main {
    overflow-x: hidden !important;
  }

  /* HERO: less giant, more marketplace/editorial */
  .loop-hero.loop-hero-minimal {
    max-width: var(--loop-page-max) !important;
    padding: clamp(28px, 3.4vw, 46px) var(--loop-side-pad) clamp(24px, 3vw, 38px) !important;
  }

  .loop-hero-title-minimal {
    font-size: clamp(48px, 4.8vw, 76px) !important;
    line-height: .92 !important;
    letter-spacing: -0.078em !important;
    max-width: 720px !important;
  }

  .loop-hero-subtitle-minimal {
    margin-top: 14px !important;
    max-width: 620px !important;
    font-size: clamp(15.5px, 1.05vw, 18px) !important;
    line-height: 1.48 !important;
  }

  .loop-hero-actions-minimal {
    margin-top: 22px !important;
  }

  .loop-primary-cta-minimal {
    min-height: 52px !important;
    padding: 0 26px !important;
    font-size: 15px !important;
  }

  .loop-hero-access-note {
    margin-top: 20px !important;
  }

  /* SECTIONS: consistent rhythm */
  .loop-section {
    max-width: var(--loop-page-max) !important;
    padding: 36px var(--loop-side-pad) 38px !important;
  }

  .loop-section-head {
    margin-bottom: 24px !important;
  }

  .loop-section-title {
    font-size: clamp(32px, 3vw, 46px) !important;
    line-height: .99 !important;
    letter-spacing: -0.066em !important;
  }

  .loop-section-copy {
    font-size: 14.5px !important;
    line-height: 1.48 !important;
  }

  /* Categories: stable desktop distribution */
  #loop-services-section {
    padding-top: 40px !important;
    padding-bottom: 42px !important;
  }

  #loop-services-section .loop-section-head {
    margin-bottom: 26px !important;
  }


  /* MOBILE-FIRST FIXES */
  @media (max-width: 899px) {
    .loop-pro-main {
      padding-bottom: calc(var(--loop-mobile-nav-height, 72px) + 10px) !important;
    }

    .loop-hero.loop-hero-minimal {
      padding: 18px var(--loop-mobile-pad) 18px !important;
    }

    .loop-eyebrow-minimal {
      margin-bottom: 12px !important;
      padding: 6px 10px !important;
      font-size: 10.5px !important;
      letter-spacing: .1em !important;
    }

    .loop-hero-title-minimal {
      font-size: clamp(34px, 10.4vw, 46px) !important;
      line-height: .96 !important;
      letter-spacing: -0.066em !important;
      max-width: 100% !important;
    }

    .loop-hero-subtitle-minimal {
      margin-top: 12px !important;
      font-size: 14px !important;
      line-height: 1.44 !important;
      font-weight: 600 !important;
    }

    .loop-hero-actions-minimal {
      margin-top: 16px !important;
    }

    .loop-primary-cta-minimal {
      width: 100% !important;
      min-height: 48px !important;
      padding: 0 16px !important;
      font-size: 14px !important;
      box-shadow: 0 12px 26px rgba(0,103,95,.16) !important;
    }

    .loop-hero-access-note {
      margin-top: 14px !important;
      gap: 10px !important;
    }

    .loop-hero-lock {
      width: 36px !important;
      height: 36px !important;
    }

    .loop-hero-access-copy {
      font-size: 12.5px !important;
      line-height: 1.28 !important;
    }

    .loop-section {
      padding: 24px var(--loop-mobile-pad) 26px !important;
    }

    .loop-section-head {
      margin-bottom: 16px !important;
      display: block !important;
    }

    .loop-section-kicker {
      font-size: 10.5px !important;
      margin-bottom: 8px !important;
    }

    .loop-section-title {
      font-size: clamp(26px, 8vw, 34px) !important;
      line-height: 1.02 !important;
      letter-spacing: -0.055em !important;
    }

    .loop-section-copy {
      font-size: 13.5px !important;
      line-height: 1.43 !important;
      margin-top: 8px !important;
    }

    /* MOBILE CATEGORIES CAROUSEL FIX */
    #loop-services-section {
      padding-top: 24px !important;
      padding-bottom: 26px !important;
    }

    #loop-services-section .loop-section-head {
      margin-bottom: 16px !important;
    }

  }

  @media (max-width: 420px) {
    .loop-hero.loop-hero-minimal {
      padding-top: 14px !important;
    }

    .loop-hero-title-minimal {
      font-size: clamp(32px, 10.8vw, 42px) !important;
    }

    .loop-section {
      padding-left: 14px !important;
      padding-right: 14px !important;
    }

  }





/* =========================================================
   LOOP MAIN MENU — PHASE 2B MOBILE HERO + CATEGORIES HARD FIX
   Fix:
   - Early access hero too large on mobile
   - Categories carousel not scrolling because inner component fights wrapper
   ========================================================= */

  @media (max-width: 899px) {
    /* HERO HARD COMPACT */
    .loop-hero.loop-hero-minimal {
      padding: 12px 14px 14px !important;
      min-height: auto !important;
    }

    .loop-web-hero-slide,
    .loop-web-hero-card,
    .loop-web-hero-content,
    .loop-hero-card-minimal,
    .loop-hero-content-minimal {
      min-height: 0 !important;
    }

    .loop-eyebrow-minimal,
    .loop-web-hero-eyebrow,
    .loop-eyebrow {
      margin-bottom: 9px !important;
      padding: 5px 9px !important;
      font-size: 9.5px !important;
      letter-spacing: .085em !important;
      min-height: 0 !important;
    }

    .loop-hero-title-minimal,
    .loop-web-hero-title {
      font-size: clamp(30px, 9.2vw, 39px) !important;
      line-height: .96 !important;
      letter-spacing: -0.058em !important;
      margin: 0 !important;
      max-width: 100% !important;
    }

    .loop-hero-subtitle-minimal,
    .loop-web-hero-subtitle {
      margin-top: 9px !important;
      font-size: 13px !important;
      line-height: 1.36 !important;
      font-weight: 600 !important;
      max-width: 100% !important;
    }

    .loop-hero-actions-minimal,
    .loop-web-hero-actions {
      margin-top: 12px !important;
      gap: 8px !important;
    }

    .loop-primary-cta-minimal,
    .loop-web-primary-cta {
      min-height: 44px !important;
      height: 44px !important;
      width: 100% !important;
      padding: 0 14px !important;
      font-size: 13.5px !important;
      box-shadow: 0 10px 22px rgba(0,103,95,.15) !important;
    }

    .loop-hero-access-note,
    .loop-web-access-note {
      margin-top: 10px !important;
      gap: 9px !important;
    }

    .loop-hero-lock,
    .loop-web-access-icon {
      width: 32px !important;
      height: 32px !important;
      min-width: 32px !important;
    }

    .loop-hero-access-copy,
    .loop-web-access-copy {
      font-size: 11.5px !important;
      line-height: 1.24 !important;
    }

    .loop-carousel-dots {
      margin-top: 8px !important;
    }

    /* CATEGORIES HARD CAROUSEL FIX */
    #loop-services-section {
      padding-top: 20px !important;
      padding-bottom: 20px !important;
      overflow: hidden !important;
    }

    #loop-services-section .loop-section-card {
      overflow: visible !important;
    }

    #loop-services-section .loop-section-head {
      margin-bottom: 12px !important;
    }

  }

  @media (max-width: 420px) {
    .loop-hero.loop-hero-minimal {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }

    .loop-hero-title-minimal,
    .loop-web-hero-title {
      font-size: clamp(28px, 9.6vw, 37px) !important;
    }

  }


  @media (max-width: 420px) {
    .loop-web-hero-card,
    .loop-hero-card-minimal {
      padding: 16px !important;
    }

    .loop-hero-title-minimal,
    .loop-web-hero-title {
      font-size: clamp(28px, 9.4vw, 36px) !important;
    }

  }



  @media (max-width: 899px) {
    #loop-services-section {
      overflow: visible !important;
    }

    #loop-services-section .loop-section-card {
      overflow: visible !important;
    }

  }


  /* =========================================================
     LOOP MAIN MENU — WEB MOBILE BUSINESS RAILS MATCH APP V42
     Chrome mobile was rendering RecommendedGrid/FavoritesGrid (2 cards per row),
     while the native app rendered RecommendedScroller/FavoritesScroller
     (single wide horizontal cards). The render logic now uses the same scroller
     for any <=899px viewport, not only body.is-mobile-app.
     These rules make the Chrome mobile rails visually match the app rails.
     ========================================================= */
  @media (max-width: 899px) {
    .loop-web-mobile-app-rail-v42,
    .loop-mobile-section-pad.loop-web-mobile-app-rail-v42 {
      width: 100% !important;
      max-width: 100% !important;
      overflow: visible !important;
      padding: 0 !important;
      margin: 0 !important;
    }

    .loop-web-mobile-app-rail-v42 [class*="scroller"],
    .loop-web-mobile-app-rail-v42 [class*="Scroller"],
    .loop-web-mobile-app-rail-v42 [class*="carousel"],
    .loop-web-mobile-app-rail-v42 [class*="Carousel"],
    .loop-web-mobile-app-rail-v42 [style*="overflow-x"] {
      -webkit-overflow-scrolling: touch !important;
      scroll-snap-type: x proximity !important;
    }

    .loop-web-mobile-app-rail-v42 [class*="grid"],
    .loop-web-mobile-app-rail-v42 [class*="Grid"] {
      display: flex !important;
      overflow-x: auto !important;
      gap: 12px !important;
      grid-template-columns: none !important;
    }

    .loop-web-mobile-app-rail-v42 article,
    .loop-web-mobile-app-rail-v42 button,
    .loop-web-mobile-app-rail-v42 a {
      scroll-snap-align: start !important;
    }
  }



  /* =========================================================
     LOOP MAIN MENU — WEB MOBILE CARD SIZE PARITY V43
     V42 unified the render path so Chrome mobile also uses the app scrollers.
     V43 makes the visual size match the app: one large card per rail,
     same width/height rhythm for Destacados and Favoritos.
     ========================================================= */
  @media (max-width: 899px) {
    .loop-web-mobile-app-rail-v42,
    .loop-mobile-section-pad.loop-web-mobile-app-rail-v42 {
      --loop-mobile-business-card-w: min(322px, calc(100vw - 44px));
      --loop-mobile-business-card-h: 208px;
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 !important;
      margin: 0 !important;
      overflow: visible !important;
      box-sizing: border-box !important;
    }

    .loop-web-mobile-app-rail-v42 > *,
    .loop-web-mobile-app-rail-v42 [class*="scroller"],
    .loop-web-mobile-app-rail-v42 [class*="Scroller"],
    .loop-web-mobile-app-rail-v42 [class*="carousel"],
    .loop-web-mobile-app-rail-v42 [class*="Carousel"],
    .loop-web-mobile-app-rail-v42 [class*="rail"],
    .loop-web-mobile-app-rail-v42 [class*="Rail"],
    .loop-web-mobile-app-rail-v42 [class*="list"],
    .loop-web-mobile-app-rail-v42 [class*="List"],
    .loop-web-mobile-app-rail-v42 [style*="overflow-x"] {
      display: flex !important;
      flex-wrap: nowrap !important;
      align-items: stretch !important;
      gap: 12px !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 0 8px 0 !important;
      margin: 0 !important;
      scroll-snap-type: x proximity !important;
      scroll-padding-inline: 0 !important;
      -webkit-overflow-scrolling: touch !important;
      scrollbar-width: none !important;
      box-sizing: border-box !important;
    }

    .loop-web-mobile-app-rail-v42 > *::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="scroller"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="Scroller"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="carousel"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="Carousel"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="rail"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="Rail"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="list"]::-webkit-scrollbar,
    .loop-web-mobile-app-rail-v42 [class*="List"]::-webkit-scrollbar {
      display: none !important;
    }

    .loop-web-mobile-app-rail-v42 > * > *,
    .loop-web-mobile-app-rail-v42 [class*="scroller"] > *,
    .loop-web-mobile-app-rail-v42 [class*="Scroller"] > *,
    .loop-web-mobile-app-rail-v42 [class*="carousel"] > *,
    .loop-web-mobile-app-rail-v42 [class*="Carousel"] > *,
    .loop-web-mobile-app-rail-v42 [class*="rail"] > *,
    .loop-web-mobile-app-rail-v42 [class*="Rail"] > *,
    .loop-web-mobile-app-rail-v42 [class*="list"] > *,
    .loop-web-mobile-app-rail-v42 [class*="List"] > * {
      flex: 0 0 var(--loop-mobile-business-card-w) !important;
      width: var(--loop-mobile-business-card-w) !important;
      min-width: var(--loop-mobile-business-card-w) !important;
      max-width: var(--loop-mobile-business-card-w) !important;
      scroll-snap-align: start !important;
      box-sizing: border-box !important;
    }

    .loop-web-mobile-app-rail-v42 article,
    .loop-web-mobile-app-rail-v42 a[class*="card"],
    .loop-web-mobile-app-rail-v42 a[class*="Card"],
    .loop-web-mobile-app-rail-v42 button[class*="card"],
    .loop-web-mobile-app-rail-v42 button[class*="Card"],
    .loop-web-mobile-app-rail-v42 [class*="business-card"],
    .loop-web-mobile-app-rail-v42 [class*="BusinessCard"],
    .loop-web-mobile-app-rail-v42 [class*="recommended-card"],
    .loop-web-mobile-app-rail-v42 [class*="RecommendedCard"],
    .loop-web-mobile-app-rail-v42 [class*="favorite-card"],
    .loop-web-mobile-app-rail-v42 [class*="FavoriteCard"] {
      width: var(--loop-mobile-business-card-w) !important;
      min-width: var(--loop-mobile-business-card-w) !important;
      max-width: var(--loop-mobile-business-card-w) !important;
      height: var(--loop-mobile-business-card-h) !important;
      min-height: var(--loop-mobile-business-card-h) !important;
      max-height: var(--loop-mobile-business-card-h) !important;
      border-radius: 22px !important;
      overflow: hidden !important;
      box-sizing: border-box !important;
      scroll-snap-align: start !important;
    }

    .loop-web-mobile-app-rail-v42 article img,
    .loop-web-mobile-app-rail-v42 a[class*="card"] img,
    .loop-web-mobile-app-rail-v42 a[class*="Card"] img,
    .loop-web-mobile-app-rail-v42 button[class*="card"] img,
    .loop-web-mobile-app-rail-v42 button[class*="Card"] img,
    .loop-web-mobile-app-rail-v42 [class*="business-card"] img,
    .loop-web-mobile-app-rail-v42 [class*="BusinessCard"] img,
    .loop-web-mobile-app-rail-v42 [class*="recommended-card"] img,
    .loop-web-mobile-app-rail-v42 [class*="RecommendedCard"] img,
    .loop-web-mobile-app-rail-v42 [class*="favorite-card"] img,
    .loop-web-mobile-app-rail-v42 [class*="FavoriteCard"] img {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      object-position: center !important;
      display: block !important;
    }
  }

  @media (max-width: 380px) {
    .loop-web-mobile-app-rail-v42,
    .loop-mobile-section-pad.loop-web-mobile-app-rail-v42 {
      --loop-mobile-business-card-w: min(318px, calc(100vw - 40px));
      --loop-mobile-business-card-h: 204px;
    }
  }


`;
      if (seen.has(key)) return;
      seen.add(key);
      out.push(b);
    });
    return out;
  }, [businessTypes]);

  const [derivedBusinessTypes, setDerivedBusinessTypes] = useState([]);
  useEffect(() => {
    let mounted = true;
    async function deriveOrFetch() {
      try {
        if (!isMobileApp && dedupBusinessTypes && dedupBusinessTypes.length > 0) return;
        if (dedupBusinessTypes && dedupBusinessTypes.length > 0) return;
        const seen = new Set();
        const byRec = [];
        (localRecommended || []).filter(isPublicBusiness).forEach((b) => {
          const t = b && (b.type || b.businessType || b.category || b.serviceType);
          if (!t) return;
          const key = String(t).trim();
          if (!key) return;
          if (seen.has(key)) return;
          seen.add(key);
          byRec.push({ id: key, name: key, icon: b && b.icon ? b.icon : "" });
        });
        if (byRec.length > 0) {
          if (mounted) setDerivedBusinessTypes(byRec);
          return;
        }
      } catch (err) {}
    }
    deriveOrFetch();
    return () => {
      mounted = false;
    };
  }, [isMobileApp, dedupBusinessTypes, localRecommended]);

  const distances = useMemo(() => {
    const map = {};
    (localRecommended || []).filter(isPublicBusiness).forEach((b) => {
      if (!b || !b.id) return;
      if (typeof b.distanceKm === "number" && Number.isFinite(b.distanceKm)) {
        map[String(b.id)] = b.distanceKm;
        return;
      }
    });
    return map;
  }, [localRecommended]);

  const DEFAULT_SERVICES_VISIBLE = 5;
  const [showAllServices, setShowAllServices] = useState(false);

  const finalBusinessTypes =
    Array.isArray(businessTypes) && businessTypes.length > DEFAULT_SERVICES_VISIBLE
      ? businessTypes
      : dedupBusinessTypes && dedupBusinessTypes.length > 0
        ? dedupBusinessTypes
        : derivedBusinessTypes;

  const visibleBusinessTypes = showAllServices
    ? finalBusinessTypes
    : Array.isArray(finalBusinessTypes)
      ? finalBusinessTypes.slice(0, DEFAULT_SERVICES_VISIBLE)
      : [];

  const mobileInlineStyles = isMobileApp ? (
    <style>{`
      :root,
      body.is-mobile-app {
        --loop-native-header-h: var(--loop-native-measured-header-h, 64px);
        --loop-native-safe-bottom: env(safe-area-inset-bottom, 0px);
      }

      body.is-mobile-app {
        padding-top: 0 !important;
        margin-top: 0 !important;
        overflow-x: hidden !important;
        background: #fff8ee !important;
      }

      body.is-mobile-app header#app-main-header,
      body.is-mobile-app #app-main-header.loop-mobile-header-v2,
      body.is-mobile-app #app-main-header.loop-ref-header {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        width: 100% !important;
        z-index: 2147483640 !important;
        margin: 0 !important;
        transform: none !important;
      }

      body.is-mobile-app .mainmenu-root.has-full-content {
        padding-top: var(--loop-native-header-h, 64px) !important;
        margin-top: 0 !important;
      }

      body.is-mobile-app .mainmenu-root.has-full-content > main.loop-pro-main,
      body.is-mobile-app .mainmenu-root.has-full-content .loop-pro-main {
        margin-top: 0 !important;
        padding-top: 0 !important;
      }

      /* LOOP_HEADER_ONLY_WEB_SINGLE_OFFSET_V2
   Chrome/mobile-web uses the global fixed header + body reservation too.
   Unlike Capacitor, it does not receive body.is-mobile-app, so the old
   generic headerOnly min-height:auto could still preserve one header row
   in flow. headerOnly is only a mount point and must be 0px on narrow web
   viewports as well. The page itself owns its normal internal padding. */
@media (max-width: 920px) {
  body:not(.is-mobile-app) .mainmenu-header-only-root {
    height: 0 !important;
    min-height: 0 !important;
    max-height: 0 !important;
    flex: 0 0 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    background: transparent !important;
  }
}
/* LOOP_HEADER_ONLY_SINGLE_OFFSET_V1
   Native body already reserves the fixed header. headerOnly must not
   reserve the same header height a second time. Keep only the normal
   route content-gap rule that follows later in the stylesheet. */
body.is-mobile-app .mainmenu-header-only-root {
  height: 0 !important;
  min-height: 0 !important;
  max-height: 0 !important;
  flex: 0 0 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible !important;
  background: transparent !important;
}

      body.is-mobile-app .mainmenu-header-only-root + *,
      body.is-mobile-app .mainmenu-header-only-root ~ * {
        margin-top: 0 !important;
      }

      header#app-main-header button[title="Calendario"],
      header#app-main-header button[title="Mis Reservas"],
      header#app-main-header button[title="Conectarse"] {
        padding: 8px 12px !important;
        font-size: 14px !important;
        border-radius: 16px !important;
        min-width: 88px !important;
      }
      header#app-main-header button[aria-label="Usuario"] { width: 40px !important; height: 40px !important; }


/* =========================================================
   LOOP NATIVE CONTENT CLEARANCE V26
   Diagnosis from real Android WebView:
   - V25 is present and active.
   - Header bottom = 94px.
   - body padding-top = 94px.
   - root starts at y=94px.
   So the native safe-area/header offset is working.

   Remaining issue:
   Some route internals start exactly at the header edge or use tiny negative
   margins, so visually they still feel "eaten" by the fixed header.
   V26 adds a small native content clearance for normal routes, while keeping
   full-screen calendar routes tight and controlled.
   ========================================================= */

html.is-mobile-app,
body.is-mobile-app {
  --loop-native-statusbar-fallback: 30px !important;
  --loop-safe-top: max(env(safe-area-inset-top, 0px), var(--loop-native-statusbar-fallback)) !important;
  --loop-mobile-header-row-h: 64px !important;
  --loop-mobile-header-total: calc(var(--loop-safe-top) + var(--loop-mobile-header-row-h)) !important;
  --loop-native-header-h: var(--loop-mobile-header-total) !important;
  --loop-native-content-gap: 14px !important;
}

/* Keep the V25 model: body reserves the fixed header. */
body.is-mobile-app {
  padding-top: var(--loop-mobile-header-total) !important;
  margin-top: 0 !important;
}

body.is-mobile-app #app-main-header,
body.is-mobile-app header#app-main-header,
body.is-mobile-app #app-main-header.loop-mobile-header-v2,
body.is-mobile-app #app-main-header.loop-ref-header {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: var(--loop-mobile-header-total) !important;
  min-height: var(--loop-mobile-header-total) !important;
  max-height: var(--loop-mobile-header-total) !important;
  padding-top: var(--loop-safe-top) !important;
  margin: 0 !important;
  z-index: 2147483640 !important;
  transform: none !important;
}

/* Header-only mount point should not reserve extra height.
   Body already reserves the header. */
body.is-mobile-app .mainmenu-header-only-root {
  height: 0 !important;
  min-height: 0 !important;
  max-height: 0 !important;
  flex: 0 0 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: visible !important;
  background: transparent !important;
}

/* Home: V25 made the math correct, but the hero had a -2px visual start.
   Give native home a small breathing gap under the fixed header. */
body.is-mobile-app .mainmenu-root.has-full-content > main.loop-pro-main,
body.is-mobile-app .mainmenu-root.has-full-content .loop-pro-main {
  padding-top: var(--loop-native-content-gap) !important;
  margin-top: 0 !important;
}

body.is-mobile-app .mainmenu-root.has-full-content .loop-p6-hero {
  margin-top: 0 !important;
}

/* Normal headerOnly routes: add a small top clearance, but do not affect
   full-screen calendar or public business pages. */
body.is-mobile-app .mainmenu-header-only-root + :not(.calendar-page-wrap):not(.business-page):not(.business-public-page):not(.events-page),
body.is-mobile-app .mainmenu-header-only-root ~ :not(.calendar-page-wrap):not(.business-page):not(.business-public-page):not(.events-page) {
  margin-top: var(--loop-native-content-gap) !important;
}

/* EVENTS H2 — the Events landing hero is intentionally flush with the fixed
   native header, matching mobile web. Do not add the generic 14px route gap. */
body.is-mobile-app .mainmenu-header-only-root + .events-page,
body.is-mobile-app .mainmenu-header-only-root ~ .events-page {
  margin-top: 0 !important;
}

/* Common app pages that sometimes use internal negative margins. */
body.is-mobile-app .owner-businesses-page,
body.is-mobile-app .owner-businesses-shell,
body.is-mobile-app .ob-page,
body.is-mobile-app .my-bookings-page,
body.is-mobile-app .bookings-page,
body.is-mobile-app .my-reservations-page,
body.is-mobile-app .business-edit-page,
body.is-mobile-app .business-edit-shell {
  padding-top: var(--loop-native-content-gap) !important;
  box-sizing: border-box !important;
}

/* Avoid double-gap if a page is also the direct sibling of headerOnly. */
body.is-mobile-app .mainmenu-header-only-root + .owner-businesses-page,
body.is-mobile-app .mainmenu-header-only-root + .owner-businesses-shell,
body.is-mobile-app .mainmenu-header-only-root + .ob-page,
body.is-mobile-app .mainmenu-header-only-root + .my-bookings-page,
body.is-mobile-app .mainmenu-header-only-root + .bookings-page,
body.is-mobile-app .mainmenu-header-only-root + .my-reservations-page,
body.is-mobile-app .mainmenu-header-only-root + .business-edit-page,
body.is-mobile-app .mainmenu-header-only-root + .business-edit-shell {
  margin-top: 0 !important;
}

/* Public business page was already correct. Keep it without extra clearance. */
body.is-mobile-app .business-page,
body.is-mobile-app .business-public-page {
  margin-top: 0 !important;
}

/* Full-screen calendar: do not add the normal route gap. */
body.is-mobile-app .mainmenu-header-only-root + .calendar-page-wrap,
body.is-mobile-app .mainmenu-header-only-root ~ .calendar-page-wrap,
body.is-mobile-app .calendar-page-wrap:has(.admin-calendar-root.phase23-clean),
body.is-mobile-app .calendar-page-wrap {
  margin-top: 0 !important;
  padding-top: 0 !important;
}



/* =========================================================
   LOOP MAIN MENU — NATIVE HERO PARITY V28
   Chrome mobile is correct. Native Android was starting the hero visually
   around the CTA/store badges, so the title looked eaten by the header.
   This native-only layer restores a full visible hero top and prevents
   historic negative-margin phases from affecting the installed app.
   ========================================================= */

@media (max-width: 899px) {
  html.is-mobile-app,
  body.is-mobile-app {
    scroll-padding-top: var(--loop-mobile-header-total, 94px) !important;
  }

  body.is-mobile-app .mainmenu-root.has-full-content,
  body.is-mobile-app .mainmenu-root.has-full-content .loop-pro-main,
  body.is-mobile-app main.loop-pro-main,
  body.is-mobile-app .loop-pro-main {
    padding-top: 0 !important;
    margin-top: 0 !important;
    overflow: visible !important;
  }

  body.is-mobile-app .mainmenu-root.has-full-content .loop-p6-hero,
  body.is-mobile-app .loop-pro-main > .loop-p6-hero,
  body.is-mobile-app .loop-p6-hero {
    margin: 0 !important;
    min-height: auto !important;
    height: auto !important;
    max-height: none !important;
    overflow: hidden !important;
    background-position: center top !important;
    border-radius: 0 !important;
    transform: none !important;
    translate: none !important;
  }

  body.is-mobile-app .loop-p6-hero::before,
  body.is-mobile-app .loop-p6-hero:before {
    inset: 0 !important;
    top: 0 !important;
    transform: none !important;
  }

  body.is-mobile-app .loop-p6-hero-overlay,
  body.is-mobile-app .mainmenu-root.has-full-content .loop-p6-hero-overlay {
    display: block !important;
    min-height: 0 !important;
    height: auto !important;
    max-height: none !important;
    padding: 24px 12px 16px !important;
    margin: 0 auto !important;
    transform: none !important;
    translate: none !important;
    overflow: visible !important;
    box-sizing: border-box !important;
  }

  body.is-mobile-app .loop-p6-hero-copy,
  body.is-mobile-app .loop-p6-title,
  body.is-mobile-app .loop-p6-offer-line,
  body.is-mobile-app .loop-p6-hero-actions,
  body.is-mobile-app .loop-p6-platform-block,
  body.is-mobile-app .loop-p6-mobile-benefit-rail {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    transform: none !important;
    translate: none !important;
    margin-top: 0 !important;
  }

  body.is-mobile-app .loop-p6-title {
    font-size: clamp(42px, 12vw, 54px) !important;
    line-height: 0.92 !important;
    letter-spacing: -0.074em !important;
    margin: 0 !important;
    max-width: 100% !important;
    color: #fff8ee !important;
    text-shadow: 0 4px 18px rgba(0,0,0,.28) !important;
  }

  body.is-mobile-app .loop-p6-offer-line {
    margin-top: 10px !important;
    font-size: 13.5px !important;
    line-height: 1.28 !important;
    max-width: 100% !important;
  }

  body.is-mobile-app .loop-p6-hero-actions {
    margin-top: 18px !important;
  }

  body.is-mobile-app .loop-p6-platform-block {
    margin-top: 14px !important;
  }

  body.is-mobile-app .loop-p6-mobile-benefit-rail {
    margin-top: 16px !important;
  }

  body.is-mobile-app #loop-services-section {
    padding-top: 22px !important;
  }
}

    `}</style>
  ) : null;

  const handleSearchNearby = (locSuggestionOrLabel) => {
    try {
      if (typeof onSearchNearby === "function") onSearchNearby(locSuggestionOrLabel);
    } catch (e) {}

    let label = "";
    if (typeof locSuggestionOrLabel === "string") label = locSuggestionOrLabel;
    else if (locSuggestionOrLabel && typeof locSuggestionOrLabel === "object") label = locSuggestionOrLabel.label || "";

    if (!label) {
      try {
        label = readUserLocation()?.label || "";
      } catch (_) {}
    }
    if (!label) return;

    trackPlatformAnalyticsEventSafe({
      db,
      type: "location_search",
      payload: { sourceArea: "main_menu", locationLabel: label },
    });

    navigate(`/location-results?loc=${encodeURIComponent(String(label))}`);
  };

  const ma = isIosCapacitor() ? getManualAuth() : null;
  const effectiveIsLoggedIn = Boolean(isLoggedIn || auth.currentUser?.uid) || (isIosCapacitor() && Boolean(ma && isManualAuthLikelyValid(ma)));

  const fastCalendarAccessAvailable = Boolean(
    normalizeCalendarAccessList(calendarAccessBusinesses).length > 0
  );

  const allowCalendarButton = Boolean(
    typeof onOpenCalendar === "function" &&
    effectiveIsLoggedIn &&
    fastCalendarAccessAvailable
  );

  // MainMenu already has the resolved business-role list used by the calendar.
  // Only pass a positive owner override to Header; null keeps Header's own
  // resolver active for worker-only / unresolved sessions and avoids forcing false.
  const ownsBusinessOverrideForHeader = normalizeCalendarAccessList(calendarAccessBusinesses)
    .some((item) => item && item.role === "owner")
    ? true
    : null;

  const handleHeaderSearchTracked = (...args) => {
    const term = String(args && args[0] ? args[0] : q || "").trim();
    if (term) {
      trackPlatformAnalyticsEventSafe({ db, type: "business_search", payload: { sourceArea: "header", query: term } });
    }
    if (typeof onSearch === "function") return onSearch(...args);
  };

  const handleCategorySelectTracked = (categoryValue, category = null) => {
    trackPlatformAnalyticsEventSafe({
      db,
      type: "category_click",
      payload: { sourceArea: "main_menu_categories", category: categoryValue, categoryLabel: category?.label || categoryValue || null },
    });
    if (typeof onSelectService === "function") return onSelectService(categoryValue);
  };

  const trackBusinessCardClick = (business, sourceArea = "business_card") => {
    if (!business) return;
    trackPlatformAnalyticsEventSafe({
      db,
      type: "business_card_click",
      payload: {
        sourceArea,
        businessId: business.id || business.businessId || null,
        businessName: business.name || business.businessName || business.displayName || null,
        businessType: business.type || business.category || business.businessType || null,
        slug: business.slug || business.publicSlug || null,
      },
    });
  };

  const openBusinessFullPageTracked = (business, sourceArea = "recommended") => {
    if (!business || !business.id) return;
    trackBusinessCardClick(business, sourceArea);
    navigate(businessPublicPath(business));
  };

  if (showHeaderOnly || !isHome) {
    return (
      <div className="mainmenu-header-only-root" style={{ position: "relative" }}>
        {mobileInlineStyles}
        <Header
          db={db}
          logoWidth={130}
          logoHeight={44}
          q={q}
          setQ={setQ}
          onSearch={handleHeaderSearchTracked}
          onSearchNearby={handleSearchNearby}
          showSuggestions={showSuggestions}
          setShowSuggestions={setShowSuggestions}
          openAvatar={openAvatar}
          setOpenAvatar={setOpenAvatar}
          pendingCount={pendingRatingCount}
          calendarPendingCount={calendarPendingTotal}
          calendarPendingLoading={calendarPendingLoading}
          onHomeClick={() => navigate("/")}
          onOpenBusinessSelector={() => setBizSelectorOpen(true)}
          onShowUserProfile={() => { if (typeof onShowUserProfile === "function") return onShowUserProfile(); navigate("/profile"); }}
          onAdminManage={() => { if (typeof onAdminManage === "function") return onAdminManage(); navigate("/owner-businesses"); }}
          onShowMyBookings={() => { if (typeof onShowMyBookings === "function") return onShowMyBookings(); navigate("/my-bookings"); }}
          onShowMyLoyalty={() => { if (typeof onShowMyLoyalty === "function") return onShowMyLoyalty(); navigate("/my-benefits"); }}
          onShowPending={() => navigate("/calificar-servicios")}
          onCreateBusiness={() => { if (typeof onCreateBusiness === "function") return onCreateBusiness(); navigate("/new-business"); }}
          onLogout={() => { if (typeof onLogout === "function") return onLogout(); navigate("/login"); }}
          userName={userName}
          userEmail={userEmail}
          isLoggedIn={effectiveIsLoggedIn}
          authReady={authReady}
          forceNativeLayout={isMobileApp}
          ownsBusinessOverride={ownsBusinessOverrideForHeader}
          onOpenCalendar={allowCalendarButton ? openFastCalendarSelector : undefined}
        />
        {/* Phase 1M: global mobile bottom nav removed. Header is the single mobile navigation. */}
        {isMobileApp ? (
          <MobileProfileSheet
          canManageBusinesses={effectiveIsLoggedIn && (ownsBusinessOverrideForHeader === true || canAdminPlatform)}
          canOpenCalendar={allowCalendarButton}
          canAdminPlatform={canAdminPlatform}
            open={mobileProfileOpen}
            onClose={() => setMobileProfileOpen(false)}
            userName={userName}
            userEmail={userEmail}
            navigate={navigate}
            onShowMyBookings={() => { if (typeof onShowMyBookings === "function") return onShowMyBookings(); navigate("/my-bookings"); }}
            onShowMyLoyalty={() => { if (typeof onShowMyLoyalty === "function") return onShowMyLoyalty(); navigate("/my-benefits"); }}
            onOpenCalendar={() => { if (typeof onOpenCalendar === "function") return onOpenCalendar(); navigate("/open-calendar"); }}
            onShowUserProfile={() => { if (typeof onShowUserProfile === "function") return onShowUserProfile(); navigate("/profile"); }}
            onAdminManage={() => { if (typeof onAdminManage === "function") return onAdminManage(); navigate("/owner-businesses"); }}
            onShowPending={() => navigate("/calificar-servicios")}
            onCreateBusiness={() => { if (typeof onCreateBusiness === "function") return onCreateBusiness(); navigate("/new-business"); }}
            onLogout={() => { if (typeof onLogout === "function") return onLogout(); navigate("/login"); }}
          />
        ) : null}

      </div>
    );
  }

  return (
    <div className="mainmenu-root has-full-content" style={{ position: "relative" }}>
      {mobileInlineStyles}
      <Header
        db={db}
        logoWidth={130}
        logoHeight={44}
        q={q}
        setQ={setQ}
        onSearch={handleHeaderSearchTracked}
        onSearchNearby={handleSearchNearby}
        showSuggestions={showSuggestions}
        setShowSuggestions={setShowSuggestions}
        openAvatar={openAvatar}
        setOpenAvatar={setOpenAvatar}
        pendingCount={pendingRatingCount}
        calendarPendingCount={calendarPendingTotal}
        calendarPendingLoading={calendarPendingLoading}
        onHomeClick={() => navigate("/")}
        onOpenBusinessSelector={() => setBizSelectorOpen(true)}
        onShowUserProfile={() => { if (typeof onShowUserProfile === "function") return onShowUserProfile(); navigate("/profile"); }}
        onAdminManage={() => { if (typeof onAdminManage === "function") return onAdminManage(); navigate("/owner-businesses"); }}
        onShowMyBookings={() => { if (typeof onShowMyBookings === "function") return onShowMyBookings(); navigate("/my-bookings"); }}
        onShowMyLoyalty={() => { if (typeof onShowMyLoyalty === "function") return onShowMyLoyalty(); navigate("/my-benefits"); }}
        onShowPending={() => navigate("/calificar-servicios")}
        onCreateBusiness={() => { if (typeof onCreateBusiness === "function") return onCreateBusiness(); navigate("/new-business"); }}
        onLogout={() => { if (typeof onLogout === "function") return onLogout(); navigate("/login"); }}
        userName={userName}
        userEmail={userEmail}
        isLoggedIn={effectiveIsLoggedIn}
        forceNativeLayout={isMobileApp}
        ownsBusinessOverride={ownsBusinessOverrideForHeader}
        onOpenCalendar={allowCalendarButton ? openFastCalendarSelector : undefined}
      />

      <style>{phaseHomeDiscoveryFontImportsV76 + mainMenuProVisualStyles + categoryTextClipFix + phase6dHeroConnectedToImage + phase6jTightCategoriesAndCards + phase6mMobileCarouselRestore + phase6nMobileHeroHalfAndCards + phase7MobileOnlyFinalPolish + phase7cCategoryNoWhiteFrameSafety + phase7dMobileOnlyVisualPush + phase7fMobileCategoryFitAndHeroTweak + phase7gMobileCategoriesAndHeroRefine + phase8MainMenuTabletIpadPolish + phase1QMobileHeaderHeroSeamFix + phase1SMobileHeaderSeamFinal + phase1VHeroTopPaddingFix + phaseBusinessHeroV2 + phaseMobileHeroBenefitsAndUnifiedCategories + phaseHomeBenefitsCardV3 + phaseMobileBenefitRailV2 + phaseHomeFounderCardFinal + phaseHomeFounderAssetCardFinal + phaseHomeFounderCardRedLineFit + phaseHomeFounderWhatsappPngIcon + phaseHomeResponsiveFitRevamp + phaseHomeMidTabletBreakpointFix + phaseHomeTypographyTrialCopy + phaseHomeCopyCtaStoreAssetsPolish + phaseHomeRealStoreBadgesPng + phaseHomeEditorialHeadlineFinal + phaseHomeFounderCardTotalAccessFinal + phaseHomeFounderCardV2BalancedGrid + phaseHomeFounderCardV3SimplifiedBubbles + phaseHomeFounderCardV4IconTitlePremium + phaseHomeFounderCardV5FinalPremium + phaseHomeFounderCardV7TwoColumns + phaseHomeFounderCardV8AssetsEqualCards + phaseHomeFounderCardV9EqualAgendaCards + phaseHomeFounderCardV10ForceEqualHeights + phaseHomeMobilePremiumPolishV11 + phaseHomeHeroFlushNoBubbleV12 + phaseHomeHeroPreciseTopByWidthV15 + phaseHomeHeroZeroTopV16 + phaseHomeHeaderSeamHeightLockV17 + phaseHomeHeroSourceOfTruthV18 + phaseHomeBodyPaddingSeamFixV20 + phaseHomeHeaderOffsetLayoutV21 + phaseHomeWebHeroCroppedV22 + phaseBusinessRailViewportParityV48 + phaseBusinessRailViewportParityV49 + phaseBusinessRailTrueTrackV50 + phaseBusinessRailShellWidthFixV51 + phaseNativeTabletHeroParityV52 + phaseMainMenuHeroPlatformContractV69 + phaseMainMenuHeroTabletSeamV72 + phaseHomeHeroPremiumBalanceV73 + phaseHomeHeroLeftLayoutRepairV74 + phaseHomeHeroTrueTwoColumnV75 + phaseHomeDiscoveryHeroV76}</style>

      <main className="loop-pro-main loop-home-refined loop-home-discovery" style={{ paddingTop: isMobileApp ? 0 : undefined }}>
        <HomeAudience onCreateBusiness={() => { if (typeof onCreateBusiness === "function") return onCreateBusiness(); navigate("/new-business"); }}>

        <HomeDiscoveryHero image={loopWellnessHeroImage} query={q} onQueryChange={setQ} onSearch={handleHeaderSearchTracked} />

        <nav className="discovery-categories" aria-label={translateInterface("Explorar por categoría")}><LoopMainMenuCategories onSelect={handleCategorySelectTracked} /></nav>

        <AppDownloadInvite native={isMobileApp} onStore={openLoopStore}/>
        <HomeBusinessDiscovery items={(localRecommended || []).filter(b => matchesMarket(b))} favorites={(localFavBusinesses || []).filter(b => matchesMarket(b))} favoriteIds={favoritesCanonicalSet} loggedIn={effectiveIsLoggedIn} onOpen={openBusinessFullPageTracked} onToggle={effectiveToggleFavorite} loading={loadingRecommended} error={recommendedLoadError}/>

        </HomeAudience>
        <LoopNaturalFooter navigate={navigate} />
      </main>

      {/* Phase 1M: global mobile bottom nav removed. Header is the single mobile navigation. */}

      {isMobileApp ? (
        <MobileProfileSheet
          canManageBusinesses={effectiveIsLoggedIn && (ownsBusinessOverrideForHeader === true || canAdminPlatform)}
          canOpenCalendar={allowCalendarButton}
          canAdminPlatform={canAdminPlatform}
          onShowMyLoyalty={onShowMyLoyalty}
          open={mobileProfileOpen}
          onClose={() => setMobileProfileOpen(false)}
          userName={userName}
          userEmail={userEmail}
          navigate={navigate}
          onShowMyBookings={() => {
            if (typeof onShowMyBookings === "function") return onShowMyBookings();
            navigate("/my-bookings");
          }}
          onOpenCalendar={openFastCalendarSelector}
          onShowUserProfile={() => {
            if (typeof onShowUserProfile === "function") return onShowUserProfile();
            navigate("/profile");
          }}
          onAdminManage={() => {
            if (typeof onAdminManage === "function") return onAdminManage();
            navigate("/owner-businesses");
          }}
          onShowPending={() => navigate("/calificar-servicios")}
          onCreateBusiness={() => {
            if (typeof onCreateBusiness === "function") return onCreateBusiness();
            navigate("/new-business");
          }}
          onLogout={() => {
            if (typeof onLogout === "function") return onLogout();
            navigate("/login");
          }}
        />
      ) : null}

      <WorkerBusinessesModal
        open={bizSelectorOpen}
        businesses={calendarAccessHydrated ? calendarAccessBusinesses : undefined}
        loading={calendarAccessLoading}
        onClose={() => setBizSelectorOpen(false)}
        onSelect={(it) => {
          try {
            if (!it) return;
            setBizSelectorOpen(false);

            const businessId = it.businessId || it.id || null;
            if (!businessId) return;

            const enriched = normalizeCalendarAccessEntry({
              ...it,
              id: businessId,
              businessId,
              pendingCount:
                calendarPendingByBusiness && calendarPendingByBusiness[businessId]
                  ? calendarPendingByBusiness[businessId]
                  : 0,
            });

            if (typeof onOpenBusinessCalendar === "function") {
              return onOpenBusinessCalendar(enriched);
            }

            const path = buildCalendarPathFromAccess(enriched);
            if (path) {
              navigate(path, { state: buildCalendarNavigateState(enriched) });
            }
          } catch (e) {
            console.warn("select business calendar failed", e);
          }
        }}
      />
    </div>
  );
}

/* MOBILE CATEGORIES WIDTH FIX CSS WAS NOT INJECTED INSIDE STYLE STRING */

export default MainMenu;
